function onYouTubeIframeAPIReady(){$.fn.anythingSliderVideo.youTubeReady=!0}!function(e,t){function i(e){var t=fe[e]={};return J.each(e.split(te),function(e,i){t[i]=!0}),t}function n(e,i,n){if(n===t&&1===e.nodeType){var s="data-"+i.replace(ge,"-$1").toLowerCase();n=e.getAttribute(s);if("string"==typeof n){try{n="true"===n||"false"!==n&&("null"===n?null:+n+""===n?+n:me.test(n)?J.parseJSON(n):n)}catch(e){}J.data(e,i,n)}else n=t}return n}function s(e){var t;for(t in e)if(("data"!==t||!J.isEmptyObject(e[t]))&&"toJSON"!==t)return!1;return!0}function a(){return!1}function o(){return!0}function r(e){return!e||!e.parentNode||11===e.parentNode.nodeType}function l(e,t){do e=e[t];while(e&&1!==e.nodeType);return e}function c(e,t,i){t=t||0;if(J.isFunction(t))return J.grep(e,function(e,n){var s=!!t.call(e,n,e);return s===i});if(t.nodeType)return J.grep(e,function(e,n){return e===t===i});if("string"==typeof t){var n=J.grep(e,function(e){return 1===e.nodeType});if(Fe.test(t))return J.filter(t,n,!i);t=J.filter(t,n)}return J.grep(e,function(e,n){return J.inArray(e,t)>=0===i})}function h(e){var t=Re.split("|"),i=e.createDocumentFragment();if(i.createElement)for(;t.length;)i.createElement(t.pop());return i}function u(e,t){return e.getElementsByTagName(t)[0]||e.appendChild(e.ownerDocument.createElement(t))}function d(e,t){if(1===t.nodeType&&J.hasData(e)){var i,n,s,a=J._data(e),o=J._data(t,a),r=a.events;if(r){delete o.handle,o.events={};for(i in r)for(n=0,s=r[i].length;n<s;n++)J.event.add(t,i,r[i][n])}o.data&&(o.data=J.extend({},o.data))}}function p(e,t){var i;1===t.nodeType&&(t.clearAttributes&&t.clearAttributes(),t.mergeAttributes&&t.mergeAttributes(e),i=t.nodeName.toLowerCase(),"object"===i?(t.parentNode&&(t.outerHTML=e.outerHTML),J.support.html5Clone&&e.innerHTML&&!J.trim(t.innerHTML)&&(t.innerHTML=e.innerHTML)):"input"===i&&Qe.test(e.type)?(t.defaultChecked=t.checked=e.checked,t.value!==e.value&&(t.value=e.value)):"option"===i?t.selected=e.defaultSelected:"input"===i||"textarea"===i?t.defaultValue=e.defaultValue:"script"===i&&t.text!==e.text&&(t.text=e.text),t.removeAttribute(J.expando))}function f(e){return"undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName("*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll("*"):[]}function m(e){Qe.test(e.type)&&(e.defaultChecked=e.checked)}function g(e,t){if(t in e)return t;for(var i=t.charAt(0).toUpperCase()+t.slice(1),n=t,s=vt.length;s--;){t=vt[s]+i;if(t in e)return t}return n}function v(e,t){return e=t||e,"none"===J.css(e,"display")||!J.contains(e.ownerDocument,e)}function b(e,t){for(var i,n,s=[],a=0,o=e.length;a<o;a++){i=e[a];i.style&&(s[a]=J._data(i,"olddisplay"),t?(!s[a]&&"none"===i.style.display&&(i.style.display=""),""===i.style.display&&v(i)&&(s[a]=J._data(i,"olddisplay",k(i.nodeName)))):(n=it(i,"display"),!s[a]&&"none"!==n&&J._data(i,"olddisplay",n)))}for(a=0;a<o;a++){i=e[a];i.style&&(t&&"none"!==i.style.display&&""!==i.style.display||(i.style.display=t?s[a]||"":"none"))}return e}function y(e,t,i){var n=ht.exec(t);return n?Math.max(0,n[1]-(i||0))+(n[2]||"px"):t}function w(e,t,i,n){for(var s=i===(n?"border":"content")?4:"width"===t?1:0,a=0;s<4;s+=2)"margin"===i&&(a+=J.css(e,i+gt[s],!0)),n?("content"===i&&(a-=parseFloat(it(e,"padding"+gt[s]))||0),"margin"!==i&&(a-=parseFloat(it(e,"border"+gt[s]+"Width"))||0)):(a+=parseFloat(it(e,"padding"+gt[s]))||0,"padding"!==i&&(a+=parseFloat(it(e,"border"+gt[s]+"Width"))||0));return a}function x(e,t,i){var n="width"===t?e.offsetWidth:e.offsetHeight,s=!0,a=J.support.boxSizing&&"border-box"===J.css(e,"boxSizing");if(n<=0||null==n){n=it(e,t);(n<0||null==n)&&(n=e.style[t]);if(ut.test(n))return n;s=a&&(J.support.boxSizingReliable||n===e.style[t]),n=parseFloat(n)||0}return n+w(e,t,i||(a?"border":"content"),s)+"px"}function k(e){if(pt[e])return pt[e];var t=J("<"+e+">").appendTo($.body),i=t.css("display");t.remove();if("none"===i||""===i){nt=$.body.appendChild(nt||J.extend($.createElement("iframe"),{frameBorder:0,width:0,height:0}));st&&nt.createElement||(st=(nt.contentWindow||nt.contentDocument).document,st.write("<!doctype html><html><body>"),st.close());t=st.body.appendChild(st.createElement(e)),i=it(t,"display"),$.body.removeChild(nt)}return pt[e]=i,i}function _(e,t,i,n){var s;if(J.isArray(t))J.each(t,function(t,s){i||wt.test(e)?n(e,s):_(e+"["+("object"==typeof s?t:"")+"]",s,i,n)});else if(i||"object"!==J.type(t))n(e,t);else for(s in t)_(e+"["+s+"]",t[s],i,n)}function C(e){return function(t,i){"string"!=typeof t&&(i=t,t="*");var n,s,a,o=t.toLowerCase().split(te),r=0,l=o.length;if(J.isFunction(i))for(;r<l;r++)n=o[r],a=/^\+/.test(n),a&&(n=n.substr(1)||"*"),s=e[n]=e[n]||[],s[a?"unshift":"push"](i)}}function T(e,i,n,s,a,o){a=a||i.dataTypes[0],o=o||{},o[a]=!0;for(var r,l=e[a],c=0,h=l?l.length:0,u=e===Ft;c<h&&(u||!r);c++)r=l[c](i,n,s),"string"==typeof r&&(!u||o[r]?r=t:(i.dataTypes.unshift(r),r=T(e,i,n,s,r,o)));return(u||!r)&&!o["*"]&&(r=T(e,i,n,s,"*",o)),r}function S(e,i){var n,s,a=J.ajaxSettings.flatOptions||{};for(n in i)i[n]!==t&&((a[n]?e:s||(s={}))[n]=i[n]);s&&J.extend(!0,e,s)}function E(e,i,n){var s,a,o,r,l=e.contents,c=e.dataTypes,h=e.responseFields;for(a in h)a in n&&(i[h[a]]=n[a]);for(;"*"===c[0];)c.shift(),s===t&&(s=e.mimeType||i.getResponseHeader("content-type"));if(s)for(a in l)if(l[a]&&l[a].test(s)){c.unshift(a);break}if(c[0]in n)o=c[0];else{for(a in n){if(!c[0]||e.converters[a+" "+c[0]]){o=a;break}r||(r=a)}o=o||r}if(o)return o!==c[0]&&c.unshift(o),n[o]}function D(e,t){var i,n,s,a,o=e.dataTypes.slice(),r=o[0],l={},c=0;e.dataFilter&&(t=e.dataFilter(t,e.dataType));if(o[1])for(i in e.converters)l[i.toLowerCase()]=e.converters[i];for(;s=o[++c];)if("*"!==s){if("*"!==r&&r!==s){i=l[r+" "+s]||l["* "+s];if(!i)for(n in l){a=n.split(" ");if(a[1]===s){i=l[r+" "+a[0]]||l["* "+a[0]];if(i){i===!0?i=l[n]:l[n]!==!0&&(s=a[0],o.splice(c--,0,s));break}}}if(i!==!0)if(i&&e.throws)t=i(t);else try{t=i(t)}catch(e){return{state:"parsererror",error:i?e:"No conversion from "+r+" to "+s}}}r=s}return{state:"success",data:t}}function P(){try{return new e.XMLHttpRequest}catch(e){}}function M(){try{return new e.ActiveXObject("Microsoft.XMLHTTP")}catch(e){}}function N(){return setTimeout(function(){Yt=t},0),Yt=J.now()}function I(e,t){J.each(t,function(t,i){for(var n=(Jt[t]||[]).concat(Jt["*"]),s=0,a=n.length;s<a;s++)if(n[s].call(e,t,i))return})}function O(e,t,i){var n,s=0,a=Gt.length,o=J.Deferred().always(function(){delete r.elem}),r=function(){for(var t=Yt||N(),i=Math.max(0,l.startTime+l.duration-t),n=i/l.duration||0,s=1-n,a=0,r=l.tweens.length;a<r;a++)l.tweens[a].run(s);return o.notifyWith(e,[l,s,i]),s<1&&r?i:(o.resolveWith(e,[l]),!1)},l=o.promise({elem:e,props:J.extend({},t),opts:J.extend(!0,{specialEasing:{}},i),originalProperties:t,originalOptions:i,startTime:Yt||N(),duration:i.duration,tweens:[],createTween:function(t,i,n){var s=J.Tween(e,l.opts,t,i,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(s),s},stop:function(t){for(var i=0,n=t?l.tweens.length:0;i<n;i++)l.tweens[i].run(1);return t?o.resolveWith(e,[l,t]):o.rejectWith(e,[l,t]),this}}),c=l.props;j(c,l.opts.specialEasing);for(;s<a;s++){n=Gt[s].call(l,e,c,l.opts);if(n)return n}return I(l,c),J.isFunction(l.opts.start)&&l.opts.start.call(e,l),J.fx.timer(J.extend(r,{anim:l,queue:l.opts.queue,elem:e})),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always)}function j(e,t){var i,n,s,a,o;for(i in e){n=J.camelCase(i),s=t[n],a=e[i],J.isArray(a)&&(s=a[1],a=e[i]=a[0]),i!==n&&(e[n]=a,delete e[i]),o=J.cssHooks[n];if(o&&"expand"in o){a=o.expand(a),delete e[n];for(i in a)i in e||(e[i]=a[i],t[i]=s)}else t[n]=s}}function A(e,t,i){var n,s,a,o,r,l,c,h,u,d=this,p=e.style,f={},m=[],g=e.nodeType&&v(e);i.queue||(h=J._queueHooks(e,"fx"),null==h.unqueued&&(h.unqueued=0,u=h.empty.fire,h.empty.fire=function(){h.unqueued||u()}),h.unqueued++,d.always(function(){d.always(function(){h.unqueued--,J.queue(e,"fx").length||h.empty.fire()})})),1===e.nodeType&&("height"in t||"width"in t)&&(i.overflow=[p.overflow,p.overflowX,p.overflowY],"inline"===J.css(e,"display")&&"none"===J.css(e,"float")&&(J.support.inlineBlockNeedsLayout&&"inline"!==k(e.nodeName)?p.zoom=1:p.display="inline-block")),i.overflow&&(p.overflow="hidden",J.support.shrinkWrapBlocks||d.done(function(){p.overflow=i.overflow[0],p.overflowX=i.overflow[1],p.overflowY=i.overflow[2]}));for(n in t){a=t[n];if(Kt.exec(a)){delete t[n],l=l||"toggle"===a;if(a===(g?"hide":"show"))continue;m.push(n)}}o=m.length;if(o){r=J._data(e,"fxshow")||J._data(e,"fxshow",{}),"hidden"in r&&(g=r.hidden),l&&(r.hidden=!g),g?J(e).show():d.done(function(){J(e).hide()}),d.done(function(){var t;J.removeData(e,"fxshow",!0);for(t in f)J.style(e,t,f[t])});for(n=0;n<o;n++)s=m[n],c=d.createTween(s,g?r[s]:0),f[s]=r[s]||J.style(e,s),s in r||(r[s]=c.start,g&&(c.end=c.start,c.start="width"===s||"height"===s?1:0))}}function F(e,t,i,n,s){return new F.prototype.init(e,t,i,n,s)}function L(e,t){var i,n={height:e},s=0;t=t?1:0;for(;s<4;s+=2-t)i=gt[s],n["margin"+i]=n["padding"+i]=e;return t&&(n.opacity=n.width=e),n}function H(e){return J.isWindow(e)?e:9===e.nodeType&&(e.defaultView||e.parentWindow)}var R,z,$=e.document,W=e.location,q=e.navigator,B=e.jQuery,U=e.$,Y=Array.prototype.push,V=Array.prototype.slice,K=Array.prototype.indexOf,Q=Object.prototype.toString,X=Object.prototype.hasOwnProperty,G=String.prototype.trim,J=function(e,t){return new J.fn.init(e,t,R)},Z=/[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source,ee=/\S/,te=/\s+/,ie=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,ne=/^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,se=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,ae=/^[\],:{}\s]*$/,oe=/(?:^|:|,)(?:\s*\[)+/g,re=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,le=/"[^"\\\r\n]*"|true|false|null|-?(?:\d\d*\.|)\d+(?:[eE][\-+]?\d+|)/g,ce=/^-ms-/,he=/-([\da-z])/gi,ue=function(e,t){return(t+"").toUpperCase()},de=function(){$.addEventListener?($.removeEventListener("DOMContentLoaded",de,!1),J.ready()):"complete"===$.readyState&&($.detachEvent("onreadystatechange",de),J.ready())},pe={};J.fn=J.prototype={constructor:J,init:function(e,i,n){var s,a,o;if(!e)return this;if(e.nodeType)return this.context=this[0]=e,this.length=1,this;if("string"==typeof e){s="<"===e.charAt(0)&&">"===e.charAt(e.length-1)&&e.length>=3?[null,e,null]:ne.exec(e);if(s&&(s[1]||!i)){if(s[1])return i=i instanceof J?i[0]:i,o=i&&i.nodeType?i.ownerDocument||i:$,e=J.parseHTML(s[1],o,!0),se.test(s[1])&&J.isPlainObject(i)&&this.attr.call(e,i,!0),J.merge(this,e);a=$.getElementById(s[2]);if(a&&a.parentNode){if(a.id!==s[2])return n.find(e);this.length=1,this[0]=a}return this.context=$,this.selector=e,this}return!i||i.jquery?(i||n).find(e):this.constructor(i).find(e)}return J.isFunction(e)?n.ready(e):(e.selector!==t&&(this.selector=e.selector,this.context=e.context),J.makeArray(e,this))},selector:"",jquery:"1.8.3",length:0,size:function(){return this.length},toArray:function(){return V.call(this)},get:function(e){return null==e?this.toArray():e<0?this[this.length+e]:this[e]},pushStack:function(e,t,i){var n=J.merge(this.constructor(),e);return n.prevObject=this,n.context=this.context,"find"===t?n.selector=this.selector+(this.selector?" ":"")+i:t&&(n.selector=this.selector+"."+t+"("+i+")"),n},each:function(e,t){return J.each(this,e,t)},ready:function(e){return J.ready.promise().done(e),this},eq:function(e){return e=+e,e===-1?this.slice(e):this.slice(e,e+1)},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},slice:function(){return this.pushStack(V.apply(this,arguments),"slice",V.call(arguments).join(","))},map:function(e){return this.pushStack(J.map(this,function(t,i){return e.call(t,i,t)}))},end:function(){return this.prevObject||this.constructor(null)},push:Y,sort:[].sort,splice:[].splice},J.fn.init.prototype=J.fn,J.extend=J.fn.extend=function(){var e,i,n,s,a,o,r=arguments[0]||{},l=1,c=arguments.length,h=!1;"boolean"==typeof r&&(h=r,r=arguments[1]||{},l=2),"object"!=typeof r&&!J.isFunction(r)&&(r={}),c===l&&(r=this,--l);for(;l<c;l++)if(null!=(e=arguments[l]))for(i in e){n=r[i],s=e[i];r!==s&&(h&&s&&(J.isPlainObject(s)||(a=J.isArray(s)))?(a?(a=!1,o=n&&J.isArray(n)?n:[]):o=n&&J.isPlainObject(n)?n:{},r[i]=J.extend(h,o,s)):s!==t&&(r[i]=s))}return r},J.extend({noConflict:function(t){return e.$===J&&(e.$=U),t&&e.jQuery===J&&(e.jQuery=B),J},isReady:!1,readyWait:1,holdReady:function(e){e?J.readyWait++:J.ready(!0)},ready:function(e){if(e===!0?!--J.readyWait:!J.isReady){if(!$.body)return setTimeout(J.ready,1);J.isReady=!0;e!==!0&&--J.readyWait>0||(z.resolveWith($,[J]),J.fn.trigger&&J($).trigger("ready").off("ready"))}},isFunction:function(e){return"function"===J.type(e)},isArray:Array.isArray||function(e){return"array"===J.type(e)},isWindow:function(e){return null!=e&&e==e.window},isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},type:function(e){return null==e?String(e):pe[Q.call(e)]||"object"},isPlainObject:function(e){if(!e||"object"!==J.type(e)||e.nodeType||J.isWindow(e))return!1;try{if(e.constructor&&!X.call(e,"constructor")&&!X.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(e){return!1}var i;for(i in e);return i===t||X.call(e,i)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},error:function(e){throw new Error(e)},parseHTML:function(e,t,i){var n;return e&&"string"==typeof e?("boolean"==typeof t&&(i=t,t=0),t=t||$,(n=se.exec(e))?[t.createElement(n[1])]:(n=J.buildFragment([e],t,i?null:[]),J.merge([],(n.cacheable?J.clone(n.fragment):n.fragment).childNodes))):null},parseJSON:function(t){if(!t||"string"!=typeof t)return null;t=J.trim(t);if(e.JSON&&e.JSON.parse)return e.JSON.parse(t);if(ae.test(t.replace(re,"@").replace(le,"]").replace(oe,"")))return new Function("return "+t)();J.error("Invalid JSON: "+t)},parseXML:function(i){var n,s;if(!i||"string"!=typeof i)return null;try{e.DOMParser?(s=new DOMParser,n=s.parseFromString(i,"text/xml")):(n=new ActiveXObject("Microsoft.XMLDOM"),n.async="false",n.loadXML(i))}catch(e){n=t}return(!n||!n.documentElement||n.getElementsByTagName("parsererror").length)&&J.error("Invalid XML: "+i),n},noop:function(){},globalEval:function(t){t&&ee.test(t)&&(e.execScript||function(t){e.eval.call(e,t)})(t)},camelCase:function(e){return e.replace(ce,"ms-").replace(he,ue)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,i,n){var s,a=0,o=e.length,r=o===t||J.isFunction(e);if(n)if(r){for(s in e)if(i.apply(e[s],n)===!1)break}else for(;a<o&&i.apply(e[a++],n)!==!1;);else if(r){for(s in e)if(i.call(e[s],s,e[s])===!1)break}else for(;a<o&&i.call(e[a],a,e[a++])!==!1;);return e},trim:G&&!G.call("\ufeff ")?function(e){return null==e?"":G.call(e)}:function(e){return null==e?"":(e+"").replace(ie,"")},makeArray:function(e,t){var i,n=t||[];return null!=e&&(i=J.type(e),null==e.length||"string"===i||"function"===i||"regexp"===i||J.isWindow(e)?Y.call(n,e):J.merge(n,e)),n},inArray:function(e,t,i){var n;if(t){if(K)return K.call(t,e,i);n=t.length,i=i?i<0?Math.max(0,n+i):i:0;for(;i<n;i++)if(i in t&&t[i]===e)return i}return-1},merge:function(e,i){var n=i.length,s=e.length,a=0;if("number"==typeof n)for(;a<n;a++)e[s++]=i[a];else for(;i[a]!==t;)e[s++]=i[a++];return e.length=s,e},grep:function(e,t,i){var n,s=[],a=0,o=e.length;i=!!i;for(;a<o;a++)n=!!t(e[a],a),i!==n&&s.push(e[a]);return s},map:function(e,i,n){var s,a,o=[],r=0,l=e.length,c=e instanceof J||l!==t&&"number"==typeof l&&(l>0&&e[0]&&e[l-1]||0===l||J.isArray(e));if(c)for(;r<l;r++)s=i(e[r],r,n),null!=s&&(o[o.length]=s);else for(a in e)s=i(e[a],a,n),null!=s&&(o[o.length]=s);return o.concat.apply([],o)},guid:1,proxy:function(e,i){var n,s,a;return"string"==typeof i&&(n=e[i],i=e,e=n),J.isFunction(e)?(s=V.call(arguments,2),a=function(){return e.apply(i,s.concat(V.call(arguments)))},a.guid=e.guid=e.guid||J.guid++,a):t},access:function(e,i,n,s,a,o,r){var l,c=null==n,h=0,u=e.length;if(n&&"object"==typeof n){for(h in n)J.access(e,i,h,n[h],1,o,s);a=1}else if(s!==t){l=r===t&&J.isFunction(s),c&&(l?(l=i,i=function(e,t,i){return l.call(J(e),i)}):(i.call(e,s),i=null));if(i)for(;h<u;h++)i(e[h],n,l?s.call(e[h],h,i(e[h],n)):s,r);a=1}return a?e:c?i.call(e):u?i(e[0],n):o},now:function(){return(new Date).getTime()}}),J.ready.promise=function(t){if(!z){z=J.Deferred();if("complete"===$.readyState)setTimeout(J.ready,1);else if($.addEventListener)$.addEventListener("DOMContentLoaded",de,!1),e.addEventListener("load",J.ready,!1);else{$.attachEvent("onreadystatechange",de),e.attachEvent("onload",J.ready);var i=!1;try{i=null==e.frameElement&&$.documentElement}catch(e){}i&&i.doScroll&&function e(){if(!J.isReady){try{i.doScroll("left")}catch(t){return setTimeout(e,50)}J.ready()}}()}}return z.promise(t)},J.each("Boolean Number String Function Array Date RegExp Object".split(" "),function(e,t){pe["[object "+t+"]"]=t.toLowerCase()}),R=J($);var fe={};J.Callbacks=function(e){e="string"==typeof e?fe[e]||i(e):J.extend({},e);var n,s,a,o,r,l,c=[],h=!e.once&&[],u=function(t){n=e.memory&&t,s=!0,l=o||0,o=0,r=c.length,a=!0;for(;c&&l<r;l++)if(c[l].apply(t[0],t[1])===!1&&e.stopOnFalse){n=!1;break}a=!1,c&&(h?h.length&&u(h.shift()):n?c=[]:d.disable())},d={add:function(){if(c){var t=c.length;!function t(i){J.each(i,function(i,n){var s=J.type(n);"function"===s?(!e.unique||!d.has(n))&&c.push(n):n&&n.length&&"string"!==s&&t(n)})}(arguments),a?r=c.length:n&&(o=t,u(n))}return this},remove:function(){return c&&J.each(arguments,function(e,t){for(var i;(i=J.inArray(t,c,i))>-1;)c.splice(i,1),a&&(i<=r&&r--,i<=l&&l--)}),this},has:function(e){return J.inArray(e,c)>-1},empty:function(){return c=[],this},disable:function(){return c=h=n=t,this},disabled:function(){return!c},lock:function(){return h=t,n||d.disable(),this},locked:function(){return!h},fireWith:function(e,t){return t=t||[],t=[e,t.slice?t.slice():t],c&&(!s||h)&&(a?h.push(t):u(t)),this},fire:function(){return d.fireWith(this,arguments),this},fired:function(){return!!s}};return d},J.extend({Deferred:function(e){var t=[["resolve","done",J.Callbacks("once memory"),"resolved"],["reject","fail",J.Callbacks("once memory"),"rejected"],["notify","progress",J.Callbacks("memory")]],i="pending",n={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},then:function(){var e=arguments;return J.Deferred(function(i){J.each(t,function(t,n){var a=n[0],o=e[t];s[n[1]](J.isFunction(o)?function(){var e=o.apply(this,arguments);e&&J.isFunction(e.promise)?e.promise().done(i.resolve).fail(i.reject).progress(i.notify):i[a+"With"](this===s?i:this,[e])}:i[a])}),e=null}).promise()},promise:function(e){return null!=e?J.extend(e,n):n}},s={};return n.pipe=n.then,J.each(t,function(e,a){var o=a[2],r=a[3];n[a[1]]=o.add,r&&o.add(function(){i=r},t[1^e][2].disable,t[2][2].lock),s[a[0]]=o.fire,s[a[0]+"With"]=o.fireWith}),n.promise(s),e&&e.call(s,s),s},when:function(e){var t,i,n,s=0,a=V.call(arguments),o=a.length,r=1!==o||e&&J.isFunction(e.promise)?o:0,l=1===r?e:J.Deferred(),c=function(e,i,n){return function(s){i[e]=this,n[e]=arguments.length>1?V.call(arguments):s,n===t?l.notifyWith(i,n):--r||l.resolveWith(i,n)}};if(o>1){t=new Array(o),i=new Array(o),n=new Array(o);for(;s<o;s++)a[s]&&J.isFunction(a[s].promise)?a[s].promise().done(c(s,n,a)).fail(l.reject).progress(c(s,i,t)):--r}return r||l.resolveWith(n,a),l.promise()}}),J.support=function(){var t,i,n,s,a,o,r,l,c,h,u,d=$.createElement("div");d.setAttribute("className","t"),d.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",i=d.getElementsByTagName("*"),n=d.getElementsByTagName("a")[0];if(!i||!n||!i.length)return{};s=$.createElement("select"),a=s.appendChild($.createElement("option")),o=d.getElementsByTagName("input")[0],n.style.cssText="top:1px;float:left;opacity:.5",t={leadingWhitespace:3===d.firstChild.nodeType,tbody:!d.getElementsByTagName("tbody").length,htmlSerialize:!!d.getElementsByTagName("link").length,style:/top/.test(n.getAttribute("style")),hrefNormalized:"/a"===n.getAttribute("href"),opacity:/^0.5/.test(n.style.opacity),cssFloat:!!n.style.cssFloat,checkOn:"on"===o.value,optSelected:a.selected,getSetAttribute:"t"!==d.className,enctype:!!$.createElement("form").enctype,html5Clone:"<:nav></:nav>"!==$.createElement("nav").cloneNode(!0).outerHTML,boxModel:"CSS1Compat"===$.compatMode,submitBubbles:!0,changeBubbles:!0,focusinBubbles:!1,deleteExpando:!0,noCloneEvent:!0,inlineBlockNeedsLayout:!1,shrinkWrapBlocks:!1,reliableMarginRight:!0,boxSizingReliable:!0,pixelPosition:!1},o.checked=!0,t.noCloneChecked=o.cloneNode(!0).checked,s.disabled=!0,t.optDisabled=!a.disabled;try{delete d.test}catch(e){t.deleteExpando=!1}!d.addEventListener&&d.attachEvent&&d.fireEvent&&(d.attachEvent("onclick",u=function(){t.noCloneEvent=!1}),d.cloneNode(!0).fireEvent("onclick"),d.detachEvent("onclick",u)),o=$.createElement("input"),o.value="t",o.setAttribute("type","radio"),t.radioValue="t"===o.value,o.setAttribute("checked","checked"),o.setAttribute("name","t"),d.appendChild(o),r=$.createDocumentFragment(),r.appendChild(d.lastChild),t.checkClone=r.cloneNode(!0).cloneNode(!0).lastChild.checked,t.appendChecked=o.checked,r.removeChild(o),r.appendChild(d);if(d.attachEvent)for(c in{submit:!0,change:!0,focusin:!0})l="on"+c,h=l in d,h||(d.setAttribute(l,"return;"),h="function"==typeof d[l]),t[c+"Bubbles"]=h;return J(function(){var i,n,s,a,o="padding:0;margin:0;border:0;display:block;overflow:hidden;",r=$.getElementsByTagName("body")[0];r&&(i=$.createElement("div"),i.style.cssText="visibility:hidden;border:0;width:0;height:0;position:static;top:0;margin-top:1px",r.insertBefore(i,r.firstChild),n=$.createElement("div"),i.appendChild(n),n.innerHTML="<table><tr><td></td><td>t</td></tr></table>",s=n.getElementsByTagName("td"),s[0].style.cssText="padding:0;margin:0;border:0;display:none",h=0===s[0].offsetHeight,s[0].style.display="",s[1].style.display="none",t.reliableHiddenOffsets=h&&0===s[0].offsetHeight,n.innerHTML="",n.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;",t.boxSizing=4===n.offsetWidth,t.doesNotIncludeMarginInBodyOffset=1!==r.offsetTop,e.getComputedStyle&&(t.pixelPosition="1%"!==(e.getComputedStyle(n,null)||{}).top,t.boxSizingReliable="4px"===(e.getComputedStyle(n,null)||{width:"4px"}).width,a=$.createElement("div"),a.style.cssText=n.style.cssText=o,a.style.marginRight=a.style.width="0",n.style.width="1px",n.appendChild(a),t.reliableMarginRight=!parseFloat((e.getComputedStyle(a,null)||{}).marginRight)),"undefined"!=typeof n.style.zoom&&(n.innerHTML="",n.style.cssText=o+"width:1px;padding:1px;display:inline;zoom:1",t.inlineBlockNeedsLayout=3===n.offsetWidth,n.style.display="block",n.style.overflow="visible",n.innerHTML="<div></div>",n.firstChild.style.width="5px",t.shrinkWrapBlocks=3!==n.offsetWidth,i.style.zoom=1),r.removeChild(i),i=n=s=a=null)}),r.removeChild(d),i=n=s=a=o=r=d=null,t}();var me=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,ge=/([A-Z])/g;J.extend({cache:{},deletedIds:[],uuid:0,expando:"jQuery"+(J.fn.jquery+Math.random()).replace(/\D/g,""),noData:{embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",applet:!0},hasData:function(e){return e=e.nodeType?J.cache[e[J.expando]]:e[J.expando],!!e&&!s(e)},data:function(e,i,n,s){if(J.acceptData(e)){var a,o,r=J.expando,l="string"==typeof i,c=e.nodeType,h=c?J.cache:e,u=c?e[r]:e[r]&&r;if(u&&h[u]&&(s||h[u].data)||!l||n!==t){u||(c?e[r]=u=J.deletedIds.pop()||J.guid++:u=r),h[u]||(h[u]={},c||(h[u].toJSON=J.noop));"object"!=typeof i&&"function"!=typeof i||(s?h[u]=J.extend(h[u],i):h[u].data=J.extend(h[u].data,i));return a=h[u],s||(a.data||(a.data={}),a=a.data),n!==t&&(a[J.camelCase(i)]=n),l?(o=a[i],null==o&&(o=a[J.camelCase(i)])):o=a,o}}},removeData:function(e,t,i){if(J.acceptData(e)){var n,a,o,r=e.nodeType,l=r?J.cache:e,c=r?e[J.expando]:J.expando;if(l[c]){if(t){n=i?l[c]:l[c].data;if(n){J.isArray(t)||(t in n?t=[t]:(t=J.camelCase(t),t=t in n?[t]:t.split(" ")));for(a=0,o=t.length;a<o;a++)delete n[t[a]];if(!(i?s:J.isEmptyObject)(n))return}}if(!i){delete l[c].data;if(!s(l[c]))return}r?J.cleanData([e],!0):J.support.deleteExpando||l!=l.window?delete l[c]:l[c]=null}}},_data:function(e,t,i){return J.data(e,t,i,!0)},acceptData:function(e){var t=e.nodeName&&J.noData[e.nodeName.toLowerCase()];return!t||t!==!0&&e.getAttribute("classid")===t}}),J.fn.extend({data:function(e,i){var s,a,o,r,l,c=this[0],h=0,u=null;if(e===t){if(this.length){u=J.data(c);if(1===c.nodeType&&!J._data(c,"parsedAttrs")){o=c.attributes;for(l=o.length;h<l;h++)r=o[h].name,r.indexOf("data-")||(r=J.camelCase(r.substring(5)),n(c,r,u[r]));J._data(c,"parsedAttrs",!0)}}return u}return"object"==typeof e?this.each(function(){J.data(this,e)}):(s=e.split(".",2),s[1]=s[1]?"."+s[1]:"",a=s[1]+"!",J.access(this,function(i){if(i===t)return u=this.triggerHandler("getData"+a,[s[0]]),u===t&&c&&(u=J.data(c,e),u=n(c,e,u)),u===t&&s[1]?this.data(s[0]):u;s[1]=i,this.each(function(){var t=J(this);t.triggerHandler("setData"+a,s),J.data(this,e,i),t.triggerHandler("changeData"+a,s)})},null,i,arguments.length>1,null,!1))},removeData:function(e){return this.each(function(){J.removeData(this,e)})}}),J.extend({queue:function(e,t,i){var n;if(e)return t=(t||"fx")+"queue",n=J._data(e,t),i&&(!n||J.isArray(i)?n=J._data(e,t,J.makeArray(i)):n.push(i)),n||[]},dequeue:function(e,t){t=t||"fx";var i=J.queue(e,t),n=i.length,s=i.shift(),a=J._queueHooks(e,t),o=function(){J.dequeue(e,t)};"inprogress"===s&&(s=i.shift(),n--),s&&("fx"===t&&i.unshift("inprogress"),delete a.stop,s.call(e,o,a)),!n&&a&&a.empty.fire()},_queueHooks:function(e,t){var i=t+"queueHooks";return J._data(e,i)||J._data(e,i,{empty:J.Callbacks("once memory").add(function(){J.removeData(e,t+"queue",!0),J.removeData(e,i,!0)})})}}),J.fn.extend({queue:function(e,i){var n=2;return"string"!=typeof e&&(i=e,e="fx",n--),arguments.length<n?J.queue(this[0],e):i===t?this:this.each(function(){var t=J.queue(this,e,i);J._queueHooks(this,e),"fx"===e&&"inprogress"!==t[0]&&J.dequeue(this,e)})},dequeue:function(e){return this.each(function(){J.dequeue(this,e)})},delay:function(e,t){return e=J.fx?J.fx.speeds[e]||e:e,t=t||"fx",this.queue(t,function(t,i){var n=setTimeout(t,e);i.stop=function(){clearTimeout(n)}})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,i){var n,s=1,a=J.Deferred(),o=this,r=this.length,l=function(){--s||a.resolveWith(o,[o])};"string"!=typeof e&&(i=e,e=t),e=e||"fx";for(;r--;)n=J._data(o[r],e+"queueHooks"),n&&n.empty&&(s++,n.empty.add(l));return l(),a.promise(i)}});var ve,be,ye,we=/[\t\r\n]/g,xe=/\r/g,ke=/^(?:button|input)$/i,_e=/^(?:button|input|object|select|textarea)$/i,Ce=/^a(?:rea|)$/i,Te=/^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,Se=J.support.getSetAttribute;J.fn.extend({attr:function(e,t){return J.access(this,J.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){J.removeAttr(this,e)})},prop:function(e,t){return J.access(this,J.prop,e,t,arguments.length>1)},removeProp:function(e){return e=J.propFix[e]||e,this.each(function(){try{this[e]=t,delete this[e]}catch(e){}})},addClass:function(e){var t,i,n,s,a,o,r;if(J.isFunction(e))return this.each(function(t){J(this).addClass(e.call(this,t,this.className))});if(e&&"string"==typeof e){t=e.split(te);for(i=0,n=this.length;i<n;i++){s=this[i];if(1===s.nodeType)if(s.className||1!==t.length){a=" "+s.className+" ";for(o=0,r=t.length;o<r;o++)a.indexOf(" "+t[o]+" ")<0&&(a+=t[o]+" ");s.className=J.trim(a)}else s.className=e}}return this},removeClass:function(e){var i,n,s,a,o,r,l;if(J.isFunction(e))return this.each(function(t){J(this).removeClass(e.call(this,t,this.className))});if(e&&"string"==typeof e||e===t){i=(e||"").split(te);for(r=0,l=this.length;r<l;r++){s=this[r];if(1===s.nodeType&&s.className){n=(" "+s.className+" ").replace(we," ");for(a=0,o=i.length;a<o;a++)for(;n.indexOf(" "+i[a]+" ")>=0;)n=n.replace(" "+i[a]+" "," ");s.className=e?J.trim(n):""}}}return this},toggleClass:function(e,t){var i=typeof e,n="boolean"==typeof t;return J.isFunction(e)?this.each(function(i){J(this).toggleClass(e.call(this,i,this.className,t),t)}):this.each(function(){if("string"===i)for(var s,a=0,o=J(this),r=t,l=e.split(te);s=l[a++];)r=n?r:!o.hasClass(s),o[r?"addClass":"removeClass"](s);else"undefined"!==i&&"boolean"!==i||(this.className&&J._data(this,"__className__",this.className),this.className=this.className||e===!1?"":J._data(this,"__className__")||"")})},hasClass:function(e){for(var t=" "+e+" ",i=0,n=this.length;i<n;i++)if(1===this[i].nodeType&&(" "+this[i].className+" ").replace(we," ").indexOf(t)>=0)return!0;return!1},val:function(e){var i,n,s,a=this[0];return arguments.length?(s=J.isFunction(e),this.each(function(n){var a,o=J(this);if(1===this.nodeType){a=s?e.call(this,n,o.val()):e,null==a?a="":"number"==typeof a?a+="":J.isArray(a)&&(a=J.map(a,function(e){return null==e?"":e+""})),i=J.valHooks[this.type]||J.valHooks[this.nodeName.toLowerCase()];i&&"set"in i&&i.set(this,a,"value")!==t||(this.value=a)}})):a?(i=J.valHooks[a.type]||J.valHooks[a.nodeName.toLowerCase()],i&&"get"in i&&(n=i.get(a,"value"))!==t?n:(n=a.value,"string"==typeof n?n.replace(xe,""):null==n?"":n)):void 0}}),J.extend({valHooks:{option:{get:function(e){var t=e.attributes.value;return!t||t.specified?e.value:e.text}},select:{get:function(e){for(var t,i,n=e.options,s=e.selectedIndex,a="select-one"===e.type||s<0,o=a?null:[],r=a?s+1:n.length,l=s<0?r:a?s:0;l<r;l++){i=n[l];if((i.selected||l===s)&&(J.support.optDisabled?!i.disabled:null===i.getAttribute("disabled"))&&(!i.parentNode.disabled||!J.nodeName(i.parentNode,"optgroup"))){t=J(i).val();if(a)return t;o.push(t)}}return o},set:function(e,t){var i=J.makeArray(t);return J(e).find("option").each(function(){this.selected=J.inArray(J(this).val(),i)>=0}),i.length||(e.selectedIndex=-1),i}}},attrFn:{},attr:function(e,i,n,s){var a,o,r,l=e.nodeType;if(e&&3!==l&&8!==l&&2!==l){if(s&&J.isFunction(J.fn[i]))return J(e)[i](n);if("undefined"==typeof e.getAttribute)return J.prop(e,i,n);r=1!==l||!J.isXMLDoc(e),r&&(i=i.toLowerCase(),o=J.attrHooks[i]||(Te.test(i)?be:ve));if(n!==t){if(null===n){J.removeAttr(e,i);return}return o&&"set"in o&&r&&(a=o.set(e,n,i))!==t?a:(e.setAttribute(i,n+""),n)}return o&&"get"in o&&r&&null!==(a=o.get(e,i))?a:(a=e.getAttribute(i),null===a?t:a)}},removeAttr:function(e,t){var i,n,s,a,o=0;if(t&&1===e.nodeType){n=t.split(te);for(;o<n.length;o++)s=n[o],s&&(i=J.propFix[s]||s,a=Te.test(s),a||J.attr(e,s,""),e.removeAttribute(Se?s:i),a&&i in e&&(e[i]=!1))}},attrHooks:{type:{set:function(e,t){if(ke.test(e.nodeName)&&e.parentNode)J.error("type property can't be changed");else if(!J.support.radioValue&&"radio"===t&&J.nodeName(e,"input")){var i=e.value;return e.setAttribute("type",t),i&&(e.value=i),t}}},value:{get:function(e,t){return ve&&J.nodeName(e,"button")?ve.get(e,t):t in e?e.value:null},set:function(e,t,i){if(ve&&J.nodeName(e,"button"))return ve.set(e,t,i);e.value=t}}},propFix:{tabindex:"tabIndex",readonly:"readOnly",for:"htmlFor",class:"className",maxlength:"maxLength",cellspacing:"cellSpacing",cellpadding:"cellPadding",rowspan:"rowSpan",colspan:"colSpan",usemap:"useMap",frameborder:"frameBorder",contenteditable:"contentEditable"},prop:function(e,i,n){var s,a,o,r=e.nodeType;if(e&&3!==r&&8!==r&&2!==r)return o=1!==r||!J.isXMLDoc(e),o&&(i=J.propFix[i]||i,a=J.propHooks[i]),n!==t?a&&"set"in a&&(s=a.set(e,n,i))!==t?s:e[i]=n:a&&"get"in a&&null!==(s=a.get(e,i))?s:e[i]},propHooks:{tabIndex:{get:function(e){var i=e.getAttributeNode("tabindex");return i&&i.specified?parseInt(i.value,10):_e.test(e.nodeName)||Ce.test(e.nodeName)&&e.href?0:t}}}}),be={get:function(e,i){var n,s=J.prop(e,i);return s===!0||"boolean"!=typeof s&&(n=e.getAttributeNode(i))&&n.nodeValue!==!1?i.toLowerCase():t},set:function(e,t,i){var n;return t===!1?J.removeAttr(e,i):(n=J.propFix[i]||i,n in e&&(e[n]=!0),e.setAttribute(i,i.toLowerCase())),i}},Se||(ye={name:!0,id:!0,coords:!0},ve=J.valHooks.button={get:function(e,i){var n;return n=e.getAttributeNode(i),n&&(ye[i]?""!==n.value:n.specified)?n.value:t},set:function(e,t,i){
var n=e.getAttributeNode(i);return n||(n=$.createAttribute(i),e.setAttributeNode(n)),n.value=t+""}},J.each(["width","height"],function(e,t){J.attrHooks[t]=J.extend(J.attrHooks[t],{set:function(e,i){if(""===i)return e.setAttribute(t,"auto"),i}})}),J.attrHooks.contenteditable={get:ve.get,set:function(e,t,i){""===t&&(t="false"),ve.set(e,t,i)}}),J.support.hrefNormalized||J.each(["href","src","width","height"],function(e,i){J.attrHooks[i]=J.extend(J.attrHooks[i],{get:function(e){var n=e.getAttribute(i,2);return null===n?t:n}})}),J.support.style||(J.attrHooks.style={get:function(e){return e.style.cssText.toLowerCase()||t},set:function(e,t){return e.style.cssText=t+""}}),J.support.optSelected||(J.propHooks.selected=J.extend(J.propHooks.selected,{get:function(e){var t=e.parentNode;return t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex),null}})),J.support.enctype||(J.propFix.enctype="encoding"),J.support.checkOn||J.each(["radio","checkbox"],function(){J.valHooks[this]={get:function(e){return null===e.getAttribute("value")?"on":e.value}}}),J.each(["radio","checkbox"],function(){J.valHooks[this]=J.extend(J.valHooks[this],{set:function(e,t){if(J.isArray(t))return e.checked=J.inArray(J(e).val(),t)>=0}})});var Ee=/^(?:textarea|input|select)$/i,De=/^([^\.]*|)(?:\.(.+)|)$/,Pe=/(?:^|\s)hover(\.\S+|)\b/,Me=/^key/,Ne=/^(?:mouse|contextmenu)|click/,Ie=/^(?:focusinfocus|focusoutblur)$/,Oe=function(e){return J.event.special.hover?e:e.replace(Pe,"mouseenter$1 mouseleave$1")};J.event={add:function(e,i,n,s,a){var o,r,l,c,h,u,d,p,f,m,g;if(3!==e.nodeType&&8!==e.nodeType&&i&&n&&(o=J._data(e))){n.handler&&(f=n,n=f.handler,a=f.selector),n.guid||(n.guid=J.guid++),l=o.events,l||(o.events=l={}),r=o.handle,r||(o.handle=r=function(e){return"undefined"==typeof J||e&&J.event.triggered===e.type?t:J.event.dispatch.apply(r.elem,arguments)},r.elem=e),i=J.trim(Oe(i)).split(" ");for(c=0;c<i.length;c++){h=De.exec(i[c])||[],u=h[1],d=(h[2]||"").split(".").sort(),g=J.event.special[u]||{},u=(a?g.delegateType:g.bindType)||u,g=J.event.special[u]||{},p=J.extend({type:u,origType:h[1],data:s,handler:n,guid:n.guid,selector:a,needsContext:a&&J.expr.match.needsContext.test(a),namespace:d.join(".")},f),m=l[u];if(!m){m=l[u]=[],m.delegateCount=0;g.setup&&g.setup.call(e,s,d,r)!==!1||(e.addEventListener?e.addEventListener(u,r,!1):e.attachEvent&&e.attachEvent("on"+u,r))}g.add&&(g.add.call(e,p),p.handler.guid||(p.handler.guid=n.guid)),a?m.splice(m.delegateCount++,0,p):m.push(p),J.event.global[u]=!0}e=null}},global:{},remove:function(e,t,i,n,s){var a,o,r,l,c,h,u,d,p,f,m,g=J.hasData(e)&&J._data(e);if(g&&(d=g.events)){t=J.trim(Oe(t||"")).split(" ");for(a=0;a<t.length;a++){o=De.exec(t[a])||[],r=l=o[1],c=o[2];if(r){p=J.event.special[r]||{},r=(n?p.delegateType:p.bindType)||r,f=d[r]||[],h=f.length,c=c?new RegExp("(^|\\.)"+c.split(".").sort().join("\\.(?:.*\\.|)")+"(\\.|$)"):null;for(u=0;u<f.length;u++)m=f[u],(s||l===m.origType)&&(!i||i.guid===m.guid)&&(!c||c.test(m.namespace))&&(!n||n===m.selector||"**"===n&&m.selector)&&(f.splice(u--,1),m.selector&&f.delegateCount--,p.remove&&p.remove.call(e,m));0===f.length&&h!==f.length&&((!p.teardown||p.teardown.call(e,c,g.handle)===!1)&&J.removeEvent(e,r,g.handle),delete d[r])}else for(r in d)J.event.remove(e,r+t[a],i,n,!0)}J.isEmptyObject(d)&&(delete g.handle,J.removeData(e,"events",!0))}},customEvent:{getData:!0,setData:!0,changeData:!0},trigger:function(i,n,s,a){if(!s||3!==s.nodeType&&8!==s.nodeType){var o,r,l,c,h,u,d,p,f,m,g=i.type||i,v=[];if(Ie.test(g+J.event.triggered))return;g.indexOf("!")>=0&&(g=g.slice(0,-1),r=!0),g.indexOf(".")>=0&&(v=g.split("."),g=v.shift(),v.sort());if((!s||J.event.customEvent[g])&&!J.event.global[g])return;i="object"==typeof i?i[J.expando]?i:new J.Event(g,i):new J.Event(g),i.type=g,i.isTrigger=!0,i.exclusive=r,i.namespace=v.join("."),i.namespace_re=i.namespace?new RegExp("(^|\\.)"+v.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,u=g.indexOf(":")<0?"on"+g:"";if(!s){o=J.cache;for(l in o)o[l].events&&o[l].events[g]&&J.event.trigger(i,n,o[l].handle.elem,!0);return}i.result=t,i.target||(i.target=s),n=null!=n?J.makeArray(n):[],n.unshift(i),d=J.event.special[g]||{};if(d.trigger&&d.trigger.apply(s,n)===!1)return;f=[[s,d.bindType||g]];if(!a&&!d.noBubble&&!J.isWindow(s)){m=d.delegateType||g,c=Ie.test(m+g)?s:s.parentNode;for(h=s;c;c=c.parentNode)f.push([c,m]),h=c;h===(s.ownerDocument||$)&&f.push([h.defaultView||h.parentWindow||e,m])}for(l=0;l<f.length&&!i.isPropagationStopped();l++)c=f[l][0],i.type=f[l][1],p=(J._data(c,"events")||{})[i.type]&&J._data(c,"handle"),p&&p.apply(c,n),p=u&&c[u],p&&J.acceptData(c)&&p.apply&&p.apply(c,n)===!1&&i.preventDefault();return i.type=g,!a&&!i.isDefaultPrevented()&&(!d._default||d._default.apply(s.ownerDocument,n)===!1)&&("click"!==g||!J.nodeName(s,"a"))&&J.acceptData(s)&&u&&s[g]&&("focus"!==g&&"blur"!==g||0!==i.target.offsetWidth)&&!J.isWindow(s)&&(h=s[u],h&&(s[u]=null),J.event.triggered=g,s[g](),J.event.triggered=t,h&&(s[u]=h)),i.result}},dispatch:function(i){i=J.event.fix(i||e.event);var n,s,a,o,r,l,c,h,u,d=(J._data(this,"events")||{})[i.type]||[],p=d.delegateCount,f=V.call(arguments),m=!i.exclusive&&!i.namespace,g=J.event.special[i.type]||{},v=[];f[0]=i,i.delegateTarget=this;if(!g.preDispatch||g.preDispatch.call(this,i)!==!1){if(p&&(!i.button||"click"!==i.type))for(a=i.target;a!=this;a=a.parentNode||this)if(a.disabled!==!0||"click"!==i.type){r={},c=[];for(n=0;n<p;n++)h=d[n],u=h.selector,r[u]===t&&(r[u]=h.needsContext?J(u,this).index(a)>=0:J.find(u,this,null,[a]).length),r[u]&&c.push(h);c.length&&v.push({elem:a,matches:c})}d.length>p&&v.push({elem:this,matches:d.slice(p)});for(n=0;n<v.length&&!i.isPropagationStopped();n++){l=v[n],i.currentTarget=l.elem;for(s=0;s<l.matches.length&&!i.isImmediatePropagationStopped();s++){h=l.matches[s];(m||!i.namespace&&!h.namespace||i.namespace_re&&i.namespace_re.test(h.namespace))&&(i.data=h.data,i.handleObj=h,o=((J.event.special[h.origType]||{}).handle||h.handler).apply(l.elem,f),o!==t&&(i.result=o,o===!1&&(i.preventDefault(),i.stopPropagation())))}}return g.postDispatch&&g.postDispatch.call(this,i),i.result}},props:"attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(e,t){return null==e.which&&(e.which=null!=t.charCode?t.charCode:t.keyCode),e}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(e,i){var n,s,a,o=i.button,r=i.fromElement;return null==e.pageX&&null!=i.clientX&&(n=e.target.ownerDocument||$,s=n.documentElement,a=n.body,e.pageX=i.clientX+(s&&s.scrollLeft||a&&a.scrollLeft||0)-(s&&s.clientLeft||a&&a.clientLeft||0),e.pageY=i.clientY+(s&&s.scrollTop||a&&a.scrollTop||0)-(s&&s.clientTop||a&&a.clientTop||0)),!e.relatedTarget&&r&&(e.relatedTarget=r===e.target?i.toElement:r),!e.which&&o!==t&&(e.which=1&o?1:2&o?3:4&o?2:0),e}},fix:function(e){if(e[J.expando])return e;var t,i,n=e,s=J.event.fixHooks[e.type]||{},a=s.props?this.props.concat(s.props):this.props;e=J.Event(n);for(t=a.length;t;)i=a[--t],e[i]=n[i];return e.target||(e.target=n.srcElement||$),3===e.target.nodeType&&(e.target=e.target.parentNode),e.metaKey=!!e.metaKey,s.filter?s.filter(e,n):e},special:{load:{noBubble:!0},focus:{delegateType:"focusin"},blur:{delegateType:"focusout"},beforeunload:{setup:function(e,t,i){J.isWindow(this)&&(this.onbeforeunload=i)},teardown:function(e,t){this.onbeforeunload===t&&(this.onbeforeunload=null)}}},simulate:function(e,t,i,n){var s=J.extend(new J.Event,i,{type:e,isSimulated:!0,originalEvent:{}});n?J.event.trigger(s,null,t):J.event.dispatch.call(t,s),s.isDefaultPrevented()&&i.preventDefault()}},J.event.handle=J.event.dispatch,J.removeEvent=$.removeEventListener?function(e,t,i){e.removeEventListener&&e.removeEventListener(t,i,!1)}:function(e,t,i){var n="on"+t;e.detachEvent&&("undefined"==typeof e[n]&&(e[n]=null),e.detachEvent(n,i))},J.Event=function(e,t){if(!(this instanceof J.Event))return new J.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||e.returnValue===!1||e.getPreventDefault&&e.getPreventDefault()?o:a):this.type=e,t&&J.extend(this,t),this.timeStamp=e&&e.timeStamp||J.now(),this[J.expando]=!0},J.Event.prototype={preventDefault:function(){this.isDefaultPrevented=o;var e=this.originalEvent;e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},stopPropagation:function(){this.isPropagationStopped=o;var e=this.originalEvent;e&&(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=o,this.stopPropagation()},isDefaultPrevented:a,isPropagationStopped:a,isImmediatePropagationStopped:a},J.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(e,t){J.event.special[e]={delegateType:t,bindType:t,handle:function(e){var i,n=this,s=e.relatedTarget,a=e.handleObj;a.selector;s&&(s===n||J.contains(n,s))||(e.type=a.origType,i=a.handler.apply(this,arguments),e.type=t);return i}}}),J.support.submitBubbles||(J.event.special.submit={setup:function(){if(J.nodeName(this,"form"))return!1;J.event.add(this,"click._submit keypress._submit",function(e){var i=e.target,n=J.nodeName(i,"input")||J.nodeName(i,"button")?i.form:t;n&&!J._data(n,"_submit_attached")&&(J.event.add(n,"submit._submit",function(e){e._submit_bubble=!0}),J._data(n,"_submit_attached",!0))})},postDispatch:function(e){e._submit_bubble&&(delete e._submit_bubble,this.parentNode&&!e.isTrigger&&J.event.simulate("submit",this.parentNode,e,!0))},teardown:function(){if(J.nodeName(this,"form"))return!1;J.event.remove(this,"._submit")}}),J.support.changeBubbles||(J.event.special.change={setup:function(){if(Ee.test(this.nodeName)){"checkbox"!==this.type&&"radio"!==this.type||(J.event.add(this,"propertychange._change",function(e){"checked"===e.originalEvent.propertyName&&(this._just_changed=!0)}),J.event.add(this,"click._change",function(e){this._just_changed&&!e.isTrigger&&(this._just_changed=!1),J.event.simulate("change",this,e,!0)}));return!1}J.event.add(this,"beforeactivate._change",function(e){var t=e.target;Ee.test(t.nodeName)&&!J._data(t,"_change_attached")&&(J.event.add(t,"change._change",function(e){this.parentNode&&!e.isSimulated&&!e.isTrigger&&J.event.simulate("change",this.parentNode,e,!0)}),J._data(t,"_change_attached",!0))})},handle:function(e){var t=e.target;if(this!==t||e.isSimulated||e.isTrigger||"radio"!==t.type&&"checkbox"!==t.type)return e.handleObj.handler.apply(this,arguments)},teardown:function(){return J.event.remove(this,"._change"),!Ee.test(this.nodeName)}}),J.support.focusinBubbles||J.each({focus:"focusin",blur:"focusout"},function(e,t){var i=0,n=function(e){J.event.simulate(t,e.target,J.event.fix(e),!0)};J.event.special[t]={setup:function(){0===i++&&$.addEventListener(e,n,!0)},teardown:function(){0===--i&&$.removeEventListener(e,n,!0)}}}),J.fn.extend({on:function(e,i,n,s,o){var r,l;if("object"==typeof e){"string"!=typeof i&&(n=n||i,i=t);for(l in e)this.on(l,i,n,e[l],o);return this}null==n&&null==s?(s=i,n=i=t):null==s&&("string"==typeof i?(s=n,n=t):(s=n,n=i,i=t));if(s===!1)s=a;else if(!s)return this;return 1===o&&(r=s,s=function(e){return J().off(e),r.apply(this,arguments)},s.guid=r.guid||(r.guid=J.guid++)),this.each(function(){J.event.add(this,e,s,n,i)})},one:function(e,t,i,n){return this.on(e,t,i,n,1)},off:function(e,i,n){var s,o;if(e&&e.preventDefault&&e.handleObj)return s=e.handleObj,J(e.delegateTarget).off(s.namespace?s.origType+"."+s.namespace:s.origType,s.selector,s.handler),this;if("object"==typeof e){for(o in e)this.off(o,i,e[o]);return this}i!==!1&&"function"!=typeof i||(n=i,i=t);return n===!1&&(n=a),this.each(function(){J.event.remove(this,e,n,i)})},bind:function(e,t,i){return this.on(e,null,t,i)},unbind:function(e,t){return this.off(e,null,t)},live:function(e,t,i){return J(this.context).on(e,this.selector,t,i),this},die:function(e,t){return J(this.context).off(e,this.selector||"**",t),this},delegate:function(e,t,i,n){return this.on(t,e,i,n)},undelegate:function(e,t,i){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",i)},trigger:function(e,t){return this.each(function(){J.event.trigger(e,t,this)})},triggerHandler:function(e,t){if(this[0])return J.event.trigger(e,t,this[0],!0)},toggle:function(e){var t=arguments,i=e.guid||J.guid++,n=0,s=function(i){var s=(J._data(this,"lastToggle"+e.guid)||0)%n;return J._data(this,"lastToggle"+e.guid,s+1),i.preventDefault(),t[s].apply(this,arguments)||!1};s.guid=i;for(;n<t.length;)t[n++].guid=i;return this.click(s)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),J.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(e,t){J.fn[t]=function(e,i){return null==i&&(i=e,e=null),arguments.length>0?this.on(t,null,e,i):this.trigger(t)},Me.test(t)&&(J.event.fixHooks[t]=J.event.keyHooks),Ne.test(t)&&(J.event.fixHooks[t]=J.event.mouseHooks)}),function(e,t){function i(e,t,i,n){i=i||[],t=t||N;var s,a,o,r,l=t.nodeType;if(!e||"string"!=typeof e)return i;if(1!==l&&9!==l)return[];o=x(t);if(!o&&!n&&(s=ie.exec(e)))if(r=s[1]){if(9===l){a=t.getElementById(r);if(!a||!a.parentNode)return i;if(a.id===r)return i.push(a),i}else if(t.ownerDocument&&(a=t.ownerDocument.getElementById(r))&&k(t,a)&&a.id===r)return i.push(a),i}else{if(s[2])return F.apply(i,L.call(t.getElementsByTagName(e),0)),i;if((r=s[3])&&de&&t.getElementsByClassName)return F.apply(i,L.call(t.getElementsByClassName(r),0)),i}return m(e.replace(G,"$1"),t,i,n,o)}function n(e){return function(t){var i=t.nodeName.toLowerCase();return"input"===i&&t.type===e}}function s(e){return function(t){var i=t.nodeName.toLowerCase();return("input"===i||"button"===i)&&t.type===e}}function a(e){return R(function(t){return t=+t,R(function(i,n){for(var s,a=e([],i.length,t),o=a.length;o--;)i[s=a[o]]&&(i[s]=!(n[s]=i[s]))})})}function o(e,t,i){if(e===t)return i;for(var n=e.nextSibling;n;){if(n===t)return-1;n=n.nextSibling}return 1}function r(e,t){var n,s,a,o,r,l,c,h=W[P][e+" "];if(h)return t?0:h.slice(0);r=e,l=[],c=y.preFilter;for(;r;){n&&!(s=Z.exec(r))||(s&&(r=r.slice(s[0].length)||r),l.push(a=[]));n=!1;(s=ee.exec(r))&&(a.push(n=new M(s.shift())),r=r.slice(n.length),n.type=s[0].replace(G," "));for(o in y.filter)(s=re[o].exec(r))&&(!c[o]||(s=c[o](s)))&&(a.push(n=new M(s.shift())),r=r.slice(n.length),n.type=o,n.matches=s);if(!n)break}return t?r.length:r?i.error(e):W(e,l).slice(0)}function l(e,t,i){var n=t.dir,s=i&&"parentNode"===t.dir,a=j++;return t.first?function(t,i,a){for(;t=t[n];)if(s||1===t.nodeType)return e(t,i,a)}:function(t,i,o){if(o){for(;t=t[n];)if((s||1===t.nodeType)&&e(t,i,o))return t}else for(var r,l=O+" "+a+" ",c=l+v;t=t[n];)if(s||1===t.nodeType){if((r=t[P])===c)return t.sizset;if("string"==typeof r&&0===r.indexOf(l)){if(t.sizset)return t}else{t[P]=c;if(e(t,i,o))return t.sizset=!0,t;t.sizset=!1}}}}function c(e){return e.length>1?function(t,i,n){for(var s=e.length;s--;)if(!e[s](t,i,n))return!1;return!0}:e[0]}function h(e,t,i,n,s){for(var a,o=[],r=0,l=e.length,c=null!=t;r<l;r++)(a=e[r])&&(i&&!i(a,n,s)||(o.push(a),c&&t.push(r)));return o}function u(e,t,i,n,s,a){return n&&!n[P]&&(n=u(n)),s&&!s[P]&&(s=u(s,a)),R(function(a,o,r,l){var c,u,d,p=[],m=[],g=o.length,v=a||f(t||"*",r.nodeType?[r]:r,[]),b=!e||!a&&t?v:h(v,p,e,r,l),y=i?s||(a?e:g||n)?[]:o:b;i&&i(b,y,r,l);if(n){c=h(y,m),n(c,[],r,l),u=c.length;for(;u--;)(d=c[u])&&(y[m[u]]=!(b[m[u]]=d))}if(a){if(s||e){if(s){c=[],u=y.length;for(;u--;)(d=y[u])&&c.push(b[u]=d);s(null,y=[],c,l)}u=y.length;for(;u--;)(d=y[u])&&(c=s?H.call(a,d):p[u])>-1&&(a[c]=!(o[c]=d))}}else y=h(y===o?y.splice(g,y.length):y),s?s(null,o,y,l):F.apply(o,y)})}function d(e){for(var t,i,n,s=e.length,a=y.relative[e[0].type],o=a||y.relative[" "],r=a?1:0,h=l(function(e){return e===t},o,!0),p=l(function(e){return H.call(t,e)>-1},o,!0),f=[function(e,i,n){return!a&&(n||i!==S)||((t=i).nodeType?h(e,i,n):p(e,i,n))}];r<s;r++)if(i=y.relative[e[r].type])f=[l(c(f),i)];else{i=y.filter[e[r].type].apply(null,e[r].matches);if(i[P]){n=++r;for(;n<s&&!y.relative[e[n].type];n++);return u(r>1&&c(f),r>1&&e.slice(0,r-1).join("").replace(G,"$1"),i,r<n&&d(e.slice(r,n)),n<s&&d(e=e.slice(n)),n<s&&e.join(""))}f.push(i)}return c(f)}function p(e,t){var n=t.length>0,s=e.length>0,a=function(o,r,l,c,u){var d,p,f,m=[],g=0,b="0",w=o&&[],x=null!=u,k=S,_=o||s&&y.find.TAG("*",u&&r.parentNode||r),C=O+=null==k?1:Math.E;x&&(S=r!==N&&r,v=a.el);for(;null!=(d=_[b]);b++){if(s&&d){for(p=0;f=e[p];p++)if(f(d,r,l)){c.push(d);break}x&&(O=C,v=++a.el)}n&&((d=!f&&d)&&g--,o&&w.push(d))}g+=b;if(n&&b!==g){for(p=0;f=t[p];p++)f(w,m,r,l);if(o){if(g>0)for(;b--;)!w[b]&&!m[b]&&(m[b]=A.call(c));m=h(m)}F.apply(c,m),x&&!o&&m.length>0&&g+t.length>1&&i.uniqueSort(c)}return x&&(O=C,S=k),w};return a.el=0,n?R(a):a}function f(e,t,n){for(var s=0,a=t.length;s<a;s++)i(e,t[s],n);return n}function m(e,t,i,n,s){var a,o,l,c,h,u=r(e);u.length;if(!n&&1===u.length){o=u[0]=u[0].slice(0);if(o.length>2&&"ID"===(l=o[0]).type&&9===t.nodeType&&!s&&y.relative[o[1].type]){t=y.find.ID(l.matches[0].replace(oe,""),t,s)[0];if(!t)return i;e=e.slice(o.shift().length)}for(a=re.POS.test(e)?-1:o.length-1;a>=0;a--){l=o[a];if(y.relative[c=l.type])break;if((h=y.find[c])&&(n=h(l.matches[0].replace(oe,""),ne.test(o[0].type)&&t.parentNode||t,s))){o.splice(a,1),e=n.length&&o.join("");if(!e)return F.apply(i,L.call(n,0)),i;break}}}return _(e,u)(n,t,s,i,ne.test(e)),i}function g(){}var v,b,y,w,x,k,_,C,T,S,E=!0,D="undefined",P=("sizcache"+Math.random()).replace(".",""),M=String,N=e.document,I=N.documentElement,O=0,j=0,A=[].pop,F=[].push,L=[].slice,H=[].indexOf||function(e){for(var t=0,i=this.length;t<i;t++)if(this[t]===e)return t;return-1},R=function(e,t){return e[P]=null==t||t,e},z=function(){var e={},t=[];return R(function(i,n){return t.push(i)>y.cacheLength&&delete e[t.shift()],e[i+" "]=n},e)},$=z(),W=z(),q=z(),B="[\\x20\\t\\r\\n\\f]",U="(?:\\\\.|[-\\w]|[^\\x00-\\xa0])+",Y=U.replace("w","w#"),V="([*^$|!~]?=)",K="\\["+B+"*("+U+")"+B+"*(?:"+V+B+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+Y+")|)|)"+B+"*\\]",Q=":("+U+")(?:\\((?:(['\"])((?:\\\\.|[^\\\\])*?)\\2|([^()[\\]]*|(?:(?:"+K+")|[^:]|\\\\.)*|.*))\\)|)",X=":(even|odd|eq|gt|lt|nth|first|last)(?:\\("+B+"*((?:-\\d)?\\d*)"+B+"*\\)|)(?=[^-]|$)",G=new RegExp("^"+B+"+|((?:^|[^\\\\])(?:\\\\.)*)"+B+"+$","g"),Z=new RegExp("^"+B+"*,"+B+"*"),ee=new RegExp("^"+B+"*([\\x20\\t\\r\\n\\f>+~])"+B+"*"),te=new RegExp(Q),ie=/^(?:#([\w\-]+)|(\w+)|\.([\w\-]+))$/,ne=/[\x20\t\r\n\f]*[+~]/,se=/h\d/i,ae=/input|select|textarea|button/i,oe=/\\(?!\\)/g,re={ID:new RegExp("^#("+U+")"),CLASS:new RegExp("^\\.("+U+")"),NAME:new RegExp("^\\[name=['\"]?("+U+")['\"]?\\]"),TAG:new RegExp("^("+U.replace("w","w*")+")"),ATTR:new RegExp("^"+K),PSEUDO:new RegExp("^"+Q),POS:new RegExp(X,"i"),CHILD:new RegExp("^:(only|nth|first|last)-child(?:\\("+B+"*(even|odd|(([+-]|)(\\d*)n|)"+B+"*(?:([+-]|)"+B+"*(\\d+)|))"+B+"*\\)|)","i"),needsContext:new RegExp("^"+B+"*[>+~]|"+X,"i")},le=function(e){var t=N.createElement("div");try{return e(t)}catch(e){return!1}finally{t=null}},ce=le(function(e){return e.appendChild(N.createComment("")),!e.getElementsByTagName("*").length}),he=le(function(e){return e.innerHTML="<a href='#'></a>",e.firstChild&&typeof e.firstChild.getAttribute!==D&&"#"===e.firstChild.getAttribute("href")}),ue=le(function(e){e.innerHTML="<select></select>";var t=typeof e.lastChild.getAttribute("multiple");return"boolean"!==t&&"string"!==t}),de=le(function(e){return e.innerHTML="<div class='hidden e'></div><div class='hidden'></div>",!(!e.getElementsByClassName||!e.getElementsByClassName("e").length)&&(e.lastChild.className="e",2===e.getElementsByClassName("e").length)}),pe=le(function(e){e.id=P+0,e.innerHTML="<a name='"+P+"'></a><div name='"+P+"'></div>",I.insertBefore(e,I.firstChild);var t=N.getElementsByName&&N.getElementsByName(P).length===2+N.getElementsByName(P+0).length;return b=!N.getElementById(P),I.removeChild(e),t});try{L.call(I.childNodes,0)[0].nodeType}catch(e){L=function(e){for(var t,i=[];t=this[e];e++)i.push(t);return i}}i.matches=function(e,t){return i(e,null,null,t)},i.matchesSelector=function(e,t){return i(t,null,null,[e]).length>0},w=i.getText=function(e){var t,i="",n=0,s=e.nodeType;if(s){if(1===s||9===s||11===s){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)i+=w(e)}else if(3===s||4===s)return e.nodeValue}else for(;t=e[n];n++)i+=w(t);return i},x=i.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&"HTML"!==t.nodeName},k=i.contains=I.contains?function(e,t){var i=9===e.nodeType?e.documentElement:e,n=t&&t.parentNode;return e===n||!!(n&&1===n.nodeType&&i.contains&&i.contains(n))}:I.compareDocumentPosition?function(e,t){return t&&!!(16&e.compareDocumentPosition(t))}:function(e,t){for(;t=t.parentNode;)if(t===e)return!0;return!1},i.attr=function(e,t){var i,n=x(e);return n||(t=t.toLowerCase()),(i=y.attrHandle[t])?i(e):n||ue?e.getAttribute(t):(i=e.getAttributeNode(t),i?"boolean"==typeof e[t]?e[t]?t:null:i.specified?i.value:null:null)},y=i.selectors={cacheLength:50,createPseudo:R,match:re,attrHandle:he?{}:{href:function(e){return e.getAttribute("href",2)},type:function(e){return e.getAttribute("type")}},find:{ID:b?function(e,t,i){if(typeof t.getElementById!==D&&!i){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}}:function(e,i,n){if(typeof i.getElementById!==D&&!n){var s=i.getElementById(e);return s?s.id===e||typeof s.getAttributeNode!==D&&s.getAttributeNode("id").value===e?[s]:t:[]}},TAG:ce?function(e,t){if(typeof t.getElementsByTagName!==D)return t.getElementsByTagName(e)}:function(e,t){var i=t.getElementsByTagName(e);if("*"===e){for(var n,s=[],a=0;n=i[a];a++)1===n.nodeType&&s.push(n);return s}return i},NAME:pe&&function(e,t){if(typeof t.getElementsByName!==D)return t.getElementsByName(name)},CLASS:de&&function(e,t,i){if(typeof t.getElementsByClassName!==D&&!i)return t.getElementsByClassName(e)}},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(oe,""),e[3]=(e[4]||e[5]||"").replace(oe,""),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1]?(e[2]||i.error(e[0]),e[3]=+(e[3]?e[4]+(e[5]||1):2*("even"===e[2]||"odd"===e[2])),e[4]=+(e[6]+e[7]||"odd"===e[2])):e[2]&&i.error(e[0]),e},PSEUDO:function(e){var t,i;if(re.CHILD.test(e[0]))return null;e[3]?e[2]=e[3]:(t=e[4])&&(te.test(t)&&(i=r(t,!0))&&(i=t.indexOf(")",t.length-i)-t.length)&&(t=t.slice(0,i),e[0]=e[0].slice(0,i)),e[2]=t);return e.slice(0,3)}},filter:{ID:b?function(e){return e=e.replace(oe,""),function(t){return t.getAttribute("id")===e}}:function(e){return e=e.replace(oe,""),function(t){var i=typeof t.getAttributeNode!==D&&t.getAttributeNode("id");return i&&i.value===e}},TAG:function(e){return"*"===e?function(){return!0}:(e=e.replace(oe,"").toLowerCase(),function(t){return t.nodeName&&t.nodeName.toLowerCase()===e})},CLASS:function(e){var t=$[P][e+" "];return t||(t=new RegExp("(^|"+B+")"+e+"("+B+"|$)"))&&$(e,function(e){return t.test(e.className||typeof e.getAttribute!==D&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(s,a){var o=i.attr(s,e);return null==o?"!="===t:!t||(o+="","="===t?o===n:"!="===t?o!==n:"^="===t?n&&0===o.indexOf(n):"*="===t?n&&o.indexOf(n)>-1:"$="===t?n&&o.substr(o.length-n.length)===n:"~="===t?(" "+o+" ").indexOf(n)>-1:"|="===t&&(o===n||o.substr(0,n.length+1)===n+"-"))}},CHILD:function(e,t,i,n){return"nth"===e?function(e){var t,s,a=e.parentNode;if(1===i&&0===n)return!0;if(a){s=0;for(t=a.firstChild;t;t=t.nextSibling)if(1===t.nodeType){s++;if(e===t)break}}return s-=n,s===i||s%i===0&&s/i>=0}:function(t){var i=t;switch(e){case"only":case"first":for(;i=i.previousSibling;)if(1===i.nodeType)return!1;if("first"===e)return!0;i=t;case"last":for(;i=i.nextSibling;)if(1===i.nodeType)return!1;return!0}}},PSEUDO:function(e,t){var n,s=y.pseudos[e]||y.setFilters[e.toLowerCase()]||i.error("unsupported pseudo: "+e);return s[P]?s(t):s.length>1?(n=[e,e,"",t],y.setFilters.hasOwnProperty(e.toLowerCase())?R(function(e,i){for(var n,a=s(e,t),o=a.length;o--;)n=H.call(e,a[o]),e[n]=!(i[n]=a[o])}):function(e){return s(e,0,n)}):s}},pseudos:{not:R(function(e){var t=[],i=[],n=_(e.replace(G,"$1"));return n[P]?R(function(e,t,i,s){for(var a,o=n(e,null,s,[]),r=e.length;r--;)(a=o[r])&&(e[r]=!(t[r]=a))}):function(e,s,a){return t[0]=e,n(t,null,a,i),!i.pop()}}),has:R(function(e){return function(t){return i(e,t).length>0}}),contains:R(function(e){return function(t){return(t.textContent||t.innerText||w(t)).indexOf(e)>-1}}),enabled:function(e){return e.disabled===!1},disabled:function(e){return e.disabled===!0},checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,e.selected===!0},parent:function(e){return!y.pseudos.empty(e)},empty:function(e){var t;e=e.firstChild;for(;e;){if(e.nodeName>"@"||3===(t=e.nodeType)||4===t)return!1;e=e.nextSibling}return!0},header:function(e){return se.test(e.nodeName)},text:function(e){var t,i;return"input"===e.nodeName.toLowerCase()&&"text"===(t=e.type)&&(null==(i=e.getAttribute("type"))||i.toLowerCase()===t)},radio:n("radio"),checkbox:n("checkbox"),file:n("file"),password:n("password"),image:n("image"),submit:s("submit"),reset:s("reset"),button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},input:function(e){return ae.test(e.nodeName)},focus:function(e){var t=e.ownerDocument;return e===t.activeElement&&(!t.hasFocus||t.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},active:function(e){return e===e.ownerDocument.activeElement},first:a(function(){return[0]}),last:a(function(e,t){return[t-1]}),eq:a(function(e,t,i){return[i<0?i+t:i]}),even:a(function(e,t){for(var i=0;i<t;i+=2)e.push(i);return e}),odd:a(function(e,t){for(var i=1;i<t;i+=2)e.push(i);return e}),lt:a(function(e,t,i){for(var n=i<0?i+t:i;--n>=0;)e.push(n);return e}),gt:a(function(e,t,i){for(var n=i<0?i+t:i;++n<t;)e.push(n);return e})}},C=I.compareDocumentPosition?function(e,t){return e===t?(T=!0,0):(e.compareDocumentPosition&&t.compareDocumentPosition?4&e.compareDocumentPosition(t):e.compareDocumentPosition)?-1:1}:function(e,t){if(e===t)return T=!0,0;if(e.sourceIndex&&t.sourceIndex)return e.sourceIndex-t.sourceIndex;var i,n,s=[],a=[],r=e.parentNode,l=t.parentNode,c=r;if(r===l)return o(e,t);if(!r)return-1;if(!l)return 1;for(;c;)s.unshift(c),c=c.parentNode;c=l;for(;c;)a.unshift(c),c=c.parentNode;i=s.length,n=a.length;for(var h=0;h<i&&h<n;h++)if(s[h]!==a[h])return o(s[h],a[h]);return h===i?o(e,a[h],-1):o(s[h],t,1)},[0,0].sort(C),E=!T,i.uniqueSort=function(e){var t,i=[],n=1,s=0;T=E,e.sort(C);if(T){for(;t=e[n];n++)t===e[n-1]&&(s=i.push(n));for(;s--;)e.splice(i[s],1)}return e},i.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},_=i.compile=function(e,t){var i,n=[],s=[],a=q[P][e+" "];if(!a){t||(t=r(e)),i=t.length;for(;i--;)a=d(t[i]),a[P]?n.push(a):s.push(a);a=q(e,p(s,n))}return a},N.querySelectorAll&&function(){var e,t=m,n=/'|\\/g,s=/\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,a=[":focus"],o=[":active"],l=I.matchesSelector||I.mozMatchesSelector||I.webkitMatchesSelector||I.oMatchesSelector||I.msMatchesSelector;le(function(e){e.innerHTML="<select><option selected=''></option></select>",e.querySelectorAll("[selected]").length||a.push("\\["+B+"*(?:checked|disabled|ismap|multiple|readonly|selected|value)"),e.querySelectorAll(":checked").length||a.push(":checked")}),le(function(e){e.innerHTML="<p test=''></p>",e.querySelectorAll("[test^='']").length&&a.push("[*^$]="+B+"*(?:\"\"|'')"),e.innerHTML="<input type='hidden'/>",e.querySelectorAll(":enabled").length||a.push(":enabled",":disabled")}),a=new RegExp(a.join("|")),m=function(e,i,s,o,l){if(!o&&!l&&!a.test(e)){var c,h,u=!0,d=P,p=i,f=9===i.nodeType&&e;if(1===i.nodeType&&"object"!==i.nodeName.toLowerCase()){c=r(e),(u=i.getAttribute("id"))?d=u.replace(n,"\\$&"):i.setAttribute("id",d),d="[id='"+d+"'] ",h=c.length;for(;h--;)c[h]=d+c[h].join("");p=ne.test(e)&&i.parentNode||i,f=c.join(",")}if(f)try{return F.apply(s,L.call(p.querySelectorAll(f),0)),s}catch(e){}finally{u||i.removeAttribute("id")}}return t(e,i,s,o,l)},l&&(le(function(t){e=l.call(t,"div");try{l.call(t,"[test!='']:sizzle"),o.push("!=",Q)}catch(e){}}),o=new RegExp(o.join("|")),i.matchesSelector=function(t,n){n=n.replace(s,"='$1']");if(!x(t)&&!o.test(n)&&!a.test(n))try{var r=l.call(t,n);if(r||e||t.document&&11!==t.document.nodeType)return r}catch(e){}return i(n,null,null,[t]).length>0})}(),y.pseudos.nth=y.pseudos.eq,y.filters=g.prototype=y.pseudos,y.setFilters=new g,i.attr=J.attr,J.find=i,J.expr=i.selectors,J.expr[":"]=J.expr.pseudos,J.unique=i.uniqueSort,J.text=i.getText,J.isXMLDoc=i.isXML,J.contains=i.contains}(e);var je=/Until$/,Ae=/^(?:parents|prev(?:Until|All))/,Fe=/^.[^:#\[\.,]*$/,Le=J.expr.match.needsContext,He={children:!0,contents:!0,next:!0,prev:!0};J.fn.extend({find:function(e){var t,i,n,s,a,o,r=this;if("string"!=typeof e)return J(e).filter(function(){for(t=0,i=r.length;t<i;t++)if(J.contains(r[t],this))return!0});o=this.pushStack("","find",e);for(t=0,i=this.length;t<i;t++){n=o.length,J.find(e,this[t],o);if(t>0)for(s=n;s<o.length;s++)for(a=0;a<n;a++)if(o[a]===o[s]){o.splice(s--,1);break}}return o},has:function(e){var t,i=J(e,this),n=i.length;return this.filter(function(){for(t=0;t<n;t++)if(J.contains(this,i[t]))return!0})},not:function(e){return this.pushStack(c(this,e,!1),"not",e)},filter:function(e){return this.pushStack(c(this,e,!0),"filter",e)},is:function(e){return!!e&&("string"==typeof e?Le.test(e)?J(e,this.context).index(this[0])>=0:J.filter(e,this).length>0:this.filter(e).length>0)},closest:function(e,t){for(var i,n=0,s=this.length,a=[],o=Le.test(e)||"string"!=typeof e?J(e,t||this.context):0;n<s;n++){i=this[n];for(;i&&i.ownerDocument&&i!==t&&11!==i.nodeType;){if(o?o.index(i)>-1:J.find.matchesSelector(i,e)){a.push(i);break}i=i.parentNode}}return a=a.length>1?J.unique(a):a,this.pushStack(a,"closest",e)},index:function(e){return e?"string"==typeof e?J.inArray(this[0],J(e)):J.inArray(e.jquery?e[0]:e,this):this[0]&&this[0].parentNode?this.prevAll().length:-1},add:function(e,t){var i="string"==typeof e?J(e,t):J.makeArray(e&&e.nodeType?[e]:e),n=J.merge(this.get(),i);return this.pushStack(r(i[0])||r(n[0])?n:J.unique(n))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),J.fn.andSelf=J.fn.addBack,J.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return J.dir(e,"parentNode")},parentsUntil:function(e,t,i){return J.dir(e,"parentNode",i)},next:function(e){return l(e,"nextSibling")},prev:function(e){return l(e,"previousSibling")},nextAll:function(e){return J.dir(e,"nextSibling")},prevAll:function(e){return J.dir(e,"previousSibling")},nextUntil:function(e,t,i){return J.dir(e,"nextSibling",i)},prevUntil:function(e,t,i){return J.dir(e,"previousSibling",i)},siblings:function(e){return J.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return J.sibling(e.firstChild)},contents:function(e){return J.nodeName(e,"iframe")?e.contentDocument||e.contentWindow.document:J.merge([],e.childNodes)}},function(e,t){J.fn[e]=function(i,n){var s=J.map(this,t,i);return je.test(e)||(n=i),n&&"string"==typeof n&&(s=J.filter(n,s)),s=this.length>1&&!He[e]?J.unique(s):s,this.length>1&&Ae.test(e)&&(s=s.reverse()),this.pushStack(s,e,V.call(arguments).join(","))}}),J.extend({filter:function(e,t,i){return i&&(e=":not("+e+")"),1===t.length?J.find.matchesSelector(t[0],e)?[t[0]]:[]:J.find.matches(e,t)},dir:function(e,i,n){for(var s=[],a=e[i];a&&9!==a.nodeType&&(n===t||1!==a.nodeType||!J(a).is(n));)1===a.nodeType&&s.push(a),
a=a[i];return s},sibling:function(e,t){for(var i=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&i.push(e);return i}});var Re="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",ze=/ jQuery\d+="(?:null|\d+)"/g,$e=/^\s+/,We=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,qe=/<([\w:]+)/,Be=/<tbody/i,Ue=/<|&#?\w+;/,Ye=/<(?:script|style|link)/i,Ve=/<(?:script|object|embed|option|style)/i,Ke=new RegExp("<(?:"+Re+")[\\s/>]","i"),Qe=/^(?:checkbox|radio)$/,Xe=/checked\s*(?:[^=]|=\s*.checked.)/i,Ge=/\/(java|ecma)script/i,Je=/^\s*<!(?:\[CDATA\[|\-\-)|[\]\-]{2}>\s*$/g,Ze={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],area:[1,"<map>","</map>"],_default:[0,"",""]},et=h($),tt=et.appendChild($.createElement("div"));Ze.optgroup=Ze.option,Ze.tbody=Ze.tfoot=Ze.colgroup=Ze.caption=Ze.thead,Ze.th=Ze.td,J.support.htmlSerialize||(Ze._default=[1,"X<div>","</div>"]),J.fn.extend({text:function(e){return J.access(this,function(e){return e===t?J.text(this):this.empty().append((this[0]&&this[0].ownerDocument||$).createTextNode(e))},null,e,arguments.length)},wrapAll:function(e){if(J.isFunction(e))return this.each(function(t){J(this).wrapAll(e.call(this,t))});if(this[0]){var t=J(e,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){for(var e=this;e.firstChild&&1===e.firstChild.nodeType;)e=e.firstChild;return e}).append(this)}return this},wrapInner:function(e){return J.isFunction(e)?this.each(function(t){J(this).wrapInner(e.call(this,t))}):this.each(function(){var t=J(this),i=t.contents();i.length?i.wrapAll(e):t.append(e)})},wrap:function(e){var t=J.isFunction(e);return this.each(function(i){J(this).wrapAll(t?e.call(this,i):e)})},unwrap:function(){return this.parent().each(function(){J.nodeName(this,"body")||J(this).replaceWith(this.childNodes)}).end()},append:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType)&&this.appendChild(e)})},prepend:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType)&&this.insertBefore(e,this.firstChild)})},before:function(){if(!r(this[0]))return this.domManip(arguments,!1,function(e){this.parentNode.insertBefore(e,this)});if(arguments.length){var e=J.clean(arguments);return this.pushStack(J.merge(e,this),"before",this.selector)}},after:function(){if(!r(this[0]))return this.domManip(arguments,!1,function(e){this.parentNode.insertBefore(e,this.nextSibling)});if(arguments.length){var e=J.clean(arguments);return this.pushStack(J.merge(this,e),"after",this.selector)}},remove:function(e,t){for(var i,n=0;null!=(i=this[n]);n++)e&&!J.filter(e,[i]).length||(!t&&1===i.nodeType&&(J.cleanData(i.getElementsByTagName("*")),J.cleanData([i])),i.parentNode&&i.parentNode.removeChild(i));return this},empty:function(){for(var e,t=0;null!=(e=this[t]);t++){1===e.nodeType&&J.cleanData(e.getElementsByTagName("*"));for(;e.firstChild;)e.removeChild(e.firstChild)}return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return J.clone(this,e,t)})},html:function(e){return J.access(this,function(e){var i=this[0]||{},n=0,s=this.length;if(e===t)return 1===i.nodeType?i.innerHTML.replace(ze,""):t;if("string"==typeof e&&!Ye.test(e)&&(J.support.htmlSerialize||!Ke.test(e))&&(J.support.leadingWhitespace||!$e.test(e))&&!Ze[(qe.exec(e)||["",""])[1].toLowerCase()]){e=e.replace(We,"<$1></$2>");try{for(;n<s;n++)i=this[n]||{},1===i.nodeType&&(J.cleanData(i.getElementsByTagName("*")),i.innerHTML=e);i=0}catch(e){}}i&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(e){return r(this[0])?this.length?this.pushStack(J(J.isFunction(e)?e():e),"replaceWith",e):this:J.isFunction(e)?this.each(function(t){var i=J(this),n=i.html();i.replaceWith(e.call(this,t,n))}):("string"!=typeof e&&(e=J(e).detach()),this.each(function(){var t=this.nextSibling,i=this.parentNode;J(this).remove(),t?J(t).before(e):J(i).append(e)}))},detach:function(e){return this.remove(e,!0)},domManip:function(e,i,n){e=[].concat.apply([],e);var s,a,o,r,l=0,c=e[0],h=[],d=this.length;if(!J.support.checkClone&&d>1&&"string"==typeof c&&Xe.test(c))return this.each(function(){J(this).domManip(e,i,n)});if(J.isFunction(c))return this.each(function(s){var a=J(this);e[0]=c.call(this,s,i?a.html():t),a.domManip(e,i,n)});if(this[0]){s=J.buildFragment(e,this,h),o=s.fragment,a=o.firstChild,1===o.childNodes.length&&(o=a);if(a){i=i&&J.nodeName(a,"tr");for(r=s.cacheable||d-1;l<d;l++)n.call(i&&J.nodeName(this[l],"table")?u(this[l],"tbody"):this[l],l===r?o:J.clone(o,!0,!0))}o=a=null,h.length&&J.each(h,function(e,t){t.src?J.ajax?J.ajax({url:t.src,type:"GET",dataType:"script",async:!1,global:!1,throws:!0}):J.error("no ajax"):J.globalEval((t.text||t.textContent||t.innerHTML||"").replace(Je,"")),t.parentNode&&t.parentNode.removeChild(t)})}return this}}),J.buildFragment=function(e,i,n){var s,a,o,r=e[0];return i=i||$,i=!i.nodeType&&i[0]||i,i=i.ownerDocument||i,1===e.length&&"string"==typeof r&&r.length<512&&i===$&&"<"===r.charAt(0)&&!Ve.test(r)&&(J.support.checkClone||!Xe.test(r))&&(J.support.html5Clone||!Ke.test(r))&&(a=!0,s=J.fragments[r],o=s!==t),s||(s=i.createDocumentFragment(),J.clean(e,i,s,n),a&&(J.fragments[r]=o&&s)),{fragment:s,cacheable:a}},J.fragments={},J.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){J.fn[e]=function(i){var n,s=0,a=[],o=J(i),r=o.length,l=1===this.length&&this[0].parentNode;if((null==l||l&&11===l.nodeType&&1===l.childNodes.length)&&1===r)return o[t](this[0]),this;for(;s<r;s++)n=(s>0?this.clone(!0):this).get(),J(o[s])[t](n),a=a.concat(n);return this.pushStack(a,e,o.selector)}}),J.extend({clone:function(e,t,i){var n,s,a,o;J.support.html5Clone||J.isXMLDoc(e)||!Ke.test("<"+e.nodeName+">")?o=e.cloneNode(!0):(tt.innerHTML=e.outerHTML,tt.removeChild(o=tt.firstChild));if(!(J.support.noCloneEvent&&J.support.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||J.isXMLDoc(e))){p(e,o),n=f(e),s=f(o);for(a=0;n[a];++a)s[a]&&p(n[a],s[a])}if(t){d(e,o);if(i){n=f(e),s=f(o);for(a=0;n[a];++a)d(n[a],s[a])}}return n=s=null,o},clean:function(e,t,i,n){var s,a,o,r,l,c,u,d,p,f,g,v=t===$&&et,b=[];t&&"undefined"!=typeof t.createDocumentFragment||(t=$);for(s=0;null!=(o=e[s]);s++){"number"==typeof o&&(o+="");if(o){if("string"==typeof o)if(Ue.test(o)){v=v||h(t),u=t.createElement("div"),v.appendChild(u),o=o.replace(We,"<$1></$2>"),r=(qe.exec(o)||["",""])[1].toLowerCase(),l=Ze[r]||Ze._default,c=l[0],u.innerHTML=l[1]+o+l[2];for(;c--;)u=u.lastChild;if(!J.support.tbody){d=Be.test(o),p="table"!==r||d?"<table>"!==l[1]||d?[]:u.childNodes:u.firstChild&&u.firstChild.childNodes;for(a=p.length-1;a>=0;--a)J.nodeName(p[a],"tbody")&&!p[a].childNodes.length&&p[a].parentNode.removeChild(p[a])}!J.support.leadingWhitespace&&$e.test(o)&&u.insertBefore(t.createTextNode($e.exec(o)[0]),u.firstChild),o=u.childNodes,u.parentNode.removeChild(u)}else o=t.createTextNode(o);o.nodeType?b.push(o):J.merge(b,o)}}u&&(o=u=v=null);if(!J.support.appendChecked)for(s=0;null!=(o=b[s]);s++)J.nodeName(o,"input")?m(o):"undefined"!=typeof o.getElementsByTagName&&J.grep(o.getElementsByTagName("input"),m);if(i){f=function(e){if(!e.type||Ge.test(e.type))return n?n.push(e.parentNode?e.parentNode.removeChild(e):e):i.appendChild(e)};for(s=0;null!=(o=b[s]);s++)J.nodeName(o,"script")&&f(o)||(i.appendChild(o),"undefined"!=typeof o.getElementsByTagName&&(g=J.grep(J.merge([],o.getElementsByTagName("script")),f),b.splice.apply(b,[s+1,0].concat(g)),s+=g.length))}return b},cleanData:function(e,t){for(var i,n,s,a,o=0,r=J.expando,l=J.cache,c=J.support.deleteExpando,h=J.event.special;null!=(s=e[o]);o++)if(t||J.acceptData(s)){n=s[r],i=n&&l[n];if(i){if(i.events)for(a in i.events)h[a]?J.event.remove(s,a):J.removeEvent(s,a,i.handle);l[n]&&(delete l[n],c?delete s[r]:s.removeAttribute?s.removeAttribute(r):s[r]=null,J.deletedIds.push(n))}}}}),function(){var e,t;J.uaMatch=function(e){e=e.toLowerCase();var t=/(chrome)[ \/]([\w.]+)/.exec(e)||/(webkit)[ \/]([\w.]+)/.exec(e)||/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(e)||/(msie) ([\w.]+)/.exec(e)||e.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e)||[];return{browser:t[1]||"",version:t[2]||"0"}},e=J.uaMatch(q.userAgent),t={},e.browser&&(t[e.browser]=!0,t.version=e.version),t.chrome?t.webkit=!0:t.webkit&&(t.safari=!0),J.browser=t,J.sub=function(){function e(t,i){return new e.fn.init(t,i)}J.extend(!0,e,this),e.superclass=this,e.fn=e.prototype=this(),e.fn.constructor=e,e.sub=this.sub,e.fn.init=function(i,n){return n&&n instanceof J&&!(n instanceof e)&&(n=e(n)),J.fn.init.call(this,i,n,t)},e.fn.init.prototype=e.fn;var t=e($);return e}}();var it,nt,st,at=/alpha\([^)]*\)/i,ot=/opacity=([^)]*)/,rt=/^(top|right|bottom|left)$/,lt=/^(none|table(?!-c[ea]).+)/,ct=/^margin/,ht=new RegExp("^("+Z+")(.*)$","i"),ut=new RegExp("^("+Z+")(?!px)[a-z%]+$","i"),dt=new RegExp("^([-+])=("+Z+")","i"),pt={BODY:"block"},ft={position:"absolute",visibility:"hidden",display:"block"},mt={letterSpacing:0,fontWeight:400},gt=["Top","Right","Bottom","Left"],vt=["Webkit","O","Moz","ms"],bt=J.fn.toggle;J.fn.extend({css:function(e,i){return J.access(this,function(e,i,n){return n!==t?J.style(e,i,n):J.css(e,i)},e,i,arguments.length>1)},show:function(){return b(this,!0)},hide:function(){return b(this)},toggle:function(e,t){var i="boolean"==typeof e;return J.isFunction(e)&&J.isFunction(t)?bt.apply(this,arguments):this.each(function(){(i?e:v(this))?J(this).show():J(this).hide()})}}),J.extend({cssHooks:{opacity:{get:function(e,t){if(t){var i=it(e,"opacity");return""===i?"1":i}}}},cssNumber:{fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{float:J.support.cssFloat?"cssFloat":"styleFloat"},style:function(e,i,n,s){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var a,o,r,l=J.camelCase(i),c=e.style;i=J.cssProps[l]||(J.cssProps[l]=g(c,l)),r=J.cssHooks[i]||J.cssHooks[l];if(n===t)return r&&"get"in r&&(a=r.get(e,!1,s))!==t?a:c[i];o=typeof n,"string"===o&&(a=dt.exec(n))&&(n=(a[1]+1)*a[2]+parseFloat(J.css(e,i)),o="number");if(!(null==n||"number"===o&&isNaN(n))){"number"===o&&!J.cssNumber[l]&&(n+="px");if(!(r&&"set"in r&&(n=r.set(e,n,s))===t))try{c[i]=n}catch(e){}}}},css:function(e,i,n,s){var a,o,r,l=J.camelCase(i);return i=J.cssProps[l]||(J.cssProps[l]=g(e.style,l)),r=J.cssHooks[i]||J.cssHooks[l],r&&"get"in r&&(a=r.get(e,!0,s)),a===t&&(a=it(e,i)),"normal"===a&&i in mt&&(a=mt[i]),n||s!==t?(o=parseFloat(a),n||J.isNumeric(o)?o||0:a):a},swap:function(e,t,i){var n,s,a={};for(s in t)a[s]=e.style[s],e.style[s]=t[s];n=i.call(e);for(s in t)e.style[s]=a[s];return n}}),e.getComputedStyle?it=function(t,i){var n,s,a,o,r=e.getComputedStyle(t,null),l=t.style;return r&&(n=r.getPropertyValue(i)||r[i],""===n&&!J.contains(t.ownerDocument,t)&&(n=J.style(t,i)),ut.test(n)&&ct.test(i)&&(s=l.width,a=l.minWidth,o=l.maxWidth,l.minWidth=l.maxWidth=l.width=n,n=r.width,l.width=s,l.minWidth=a,l.maxWidth=o)),n}:$.documentElement.currentStyle&&(it=function(e,t){var i,n,s=e.currentStyle&&e.currentStyle[t],a=e.style;return null==s&&a&&a[t]&&(s=a[t]),ut.test(s)&&!rt.test(t)&&(i=a.left,n=e.runtimeStyle&&e.runtimeStyle.left,n&&(e.runtimeStyle.left=e.currentStyle.left),a.left="fontSize"===t?"1em":s,s=a.pixelLeft+"px",a.left=i,n&&(e.runtimeStyle.left=n)),""===s?"auto":s}),J.each(["height","width"],function(e,t){J.cssHooks[t]={get:function(e,i,n){if(i)return 0===e.offsetWidth&&lt.test(it(e,"display"))?J.swap(e,ft,function(){return x(e,t,n)}):x(e,t,n)},set:function(e,i,n){return y(e,i,n?w(e,t,n,J.support.boxSizing&&"border-box"===J.css(e,"boxSizing")):0)}}}),J.support.opacity||(J.cssHooks.opacity={get:function(e,t){return ot.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":t?"1":""},set:function(e,t){var i=e.style,n=e.currentStyle,s=J.isNumeric(t)?"alpha(opacity="+100*t+")":"",a=n&&n.filter||i.filter||"";i.zoom=1;if(t>=1&&""===J.trim(a.replace(at,""))&&i.removeAttribute){i.removeAttribute("filter");if(n&&!n.filter)return}i.filter=at.test(a)?a.replace(at,s):a+" "+s}}),J(function(){J.support.reliableMarginRight||(J.cssHooks.marginRight={get:function(e,t){return J.swap(e,{display:"inline-block"},function(){if(t)return it(e,"marginRight")})}}),!J.support.pixelPosition&&J.fn.position&&J.each(["top","left"],function(e,t){J.cssHooks[t]={get:function(e,i){if(i){var n=it(e,t);return ut.test(n)?J(e).position()[t]+"px":n}}}})}),J.expr&&J.expr.filters&&(J.expr.filters.hidden=function(e){return 0===e.offsetWidth&&0===e.offsetHeight||!J.support.reliableHiddenOffsets&&"none"===(e.style&&e.style.display||it(e,"display"))},J.expr.filters.visible=function(e){return!J.expr.filters.hidden(e)}),J.each({margin:"",padding:"",border:"Width"},function(e,t){J.cssHooks[e+t]={expand:function(i){var n,s="string"==typeof i?i.split(" "):[i],a={};for(n=0;n<4;n++)a[e+gt[n]+t]=s[n]||s[n-2]||s[0];return a}},ct.test(e)||(J.cssHooks[e+t].set=y)});var yt=/%20/g,wt=/\[\]$/,xt=/\r?\n/g,kt=/^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,_t=/^(?:select|textarea)/i;J.fn.extend({serialize:function(){return J.param(this.serializeArray())},serializeArray:function(){return this.map(function(){return this.elements?J.makeArray(this.elements):this}).filter(function(){return this.name&&!this.disabled&&(this.checked||_t.test(this.nodeName)||kt.test(this.type))}).map(function(e,t){var i=J(this).val();return null==i?null:J.isArray(i)?J.map(i,function(e,i){return{name:t.name,value:e.replace(xt,"\r\n")}}):{name:t.name,value:i.replace(xt,"\r\n")}}).get()}}),J.param=function(e,i){var n,s=[],a=function(e,t){t=J.isFunction(t)?t():null==t?"":t,s[s.length]=encodeURIComponent(e)+"="+encodeURIComponent(t)};i===t&&(i=J.ajaxSettings&&J.ajaxSettings.traditional);if(J.isArray(e)||e.jquery&&!J.isPlainObject(e))J.each(e,function(){a(this.name,this.value)});else for(n in e)_(n,e[n],i,a);return s.join("&").replace(yt,"+")};var Ct,Tt,St=/#.*$/,Et=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Dt=/^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,Pt=/^(?:GET|HEAD)$/,Mt=/^\/\//,Nt=/\?/,It=/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,Ot=/([?&])_=[^&]*/,jt=/^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,At=J.fn.load,Ft={},Lt={},Ht=["*/"]+["*"];try{Tt=W.href}catch(e){Tt=$.createElement("a"),Tt.href="",Tt=Tt.href}Ct=jt.exec(Tt.toLowerCase())||[],J.fn.load=function(e,i,n){if("string"!=typeof e&&At)return At.apply(this,arguments);if(!this.length)return this;var s,a,o,r=this,l=e.indexOf(" ");return l>=0&&(s=e.slice(l,e.length),e=e.slice(0,l)),J.isFunction(i)?(n=i,i=t):i&&"object"==typeof i&&(a="POST"),J.ajax({url:e,type:a,dataType:"html",data:i,complete:function(e,t){n&&r.each(n,o||[e.responseText,t,e])}}).done(function(e){o=arguments,r.html(s?J("<div>").append(e.replace(It,"")).find(s):e)}),this},J.each("ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split(" "),function(e,t){J.fn[t]=function(e){return this.on(t,e)}}),J.each(["get","post"],function(e,i){J[i]=function(e,n,s,a){return J.isFunction(n)&&(a=a||s,s=n,n=t),J.ajax({type:i,url:e,data:n,success:s,dataType:a})}}),J.extend({getScript:function(e,i){return J.get(e,t,i,"script")},getJSON:function(e,t,i){return J.get(e,t,i,"json")},ajaxSetup:function(e,t){return t?S(e,J.ajaxSettings):(t=e,e=J.ajaxSettings),S(e,t),e},ajaxSettings:{url:Tt,isLocal:Dt.test(Ct[1]),global:!0,type:"GET",contentType:"application/x-www-form-urlencoded; charset=UTF-8",processData:!0,async:!0,accepts:{xml:"application/xml, text/xml",html:"text/html",text:"text/plain",json:"application/json, text/javascript","*":Ht},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText"},converters:{"* text":e.String,"text html":!0,"text json":J.parseJSON,"text xml":J.parseXML},flatOptions:{context:!0,url:!0}},ajaxPrefilter:C(Ft),ajaxTransport:C(Lt),ajax:function(e,i){function n(e,i,n,o){var c,u,b,y,x,_=i;if(2!==w){w=2,l&&clearTimeout(l),r=t,a=o||"",k.readyState=e>0?4:0,n&&(y=E(d,k,n));if(e>=200&&e<300||304===e)d.ifModified&&(x=k.getResponseHeader("Last-Modified"),x&&(J.lastModified[s]=x),x=k.getResponseHeader("Etag"),x&&(J.etag[s]=x)),304===e?(_="notmodified",c=!0):(c=D(d,y),_=c.state,u=c.data,b=c.error,c=!b);else{b=_;_&&!e||(_="error",e<0&&(e=0))}k.status=e,k.statusText=(i||_)+"",c?m.resolveWith(p,[u,_,k]):m.rejectWith(p,[k,_,b]),k.statusCode(v),v=t,h&&f.trigger("ajax"+(c?"Success":"Error"),[k,d,c?u:b]),g.fireWith(p,[k,_]),h&&(f.trigger("ajaxComplete",[k,d]),--J.active||J.event.trigger("ajaxStop"))}}"object"==typeof e&&(i=e,e=t),i=i||{};var s,a,o,r,l,c,h,u,d=J.ajaxSetup({},i),p=d.context||d,f=p!==d&&(p.nodeType||p instanceof J)?J(p):J.event,m=J.Deferred(),g=J.Callbacks("once memory"),v=d.statusCode||{},b={},y={},w=0,x="canceled",k={readyState:0,setRequestHeader:function(e,t){if(!w){var i=e.toLowerCase();e=y[i]=y[i]||e,b[e]=t}return this},getAllResponseHeaders:function(){return 2===w?a:null},getResponseHeader:function(e){var i;if(2===w){if(!o){o={};for(;i=Et.exec(a);)o[i[1].toLowerCase()]=i[2]}i=o[e.toLowerCase()]}return i===t?null:i},overrideMimeType:function(e){return w||(d.mimeType=e),this},abort:function(e){return e=e||x,r&&r.abort(e),n(0,e),this}};m.promise(k),k.success=k.done,k.error=k.fail,k.complete=g.add,k.statusCode=function(e){if(e){var t;if(w<2)for(t in e)v[t]=[v[t],e[t]];else t=e[k.status],k.always(t)}return this},d.url=((e||d.url)+"").replace(St,"").replace(Mt,Ct[1]+"//"),d.dataTypes=J.trim(d.dataType||"*").toLowerCase().split(te),null==d.crossDomain&&(c=jt.exec(d.url.toLowerCase()),d.crossDomain=!(!c||c[1]===Ct[1]&&c[2]===Ct[2]&&(c[3]||("http:"===c[1]?80:443))==(Ct[3]||("http:"===Ct[1]?80:443)))),d.data&&d.processData&&"string"!=typeof d.data&&(d.data=J.param(d.data,d.traditional)),T(Ft,d,i,k);if(2===w)return k;h=d.global,d.type=d.type.toUpperCase(),d.hasContent=!Pt.test(d.type),h&&0===J.active++&&J.event.trigger("ajaxStart");if(!d.hasContent){d.data&&(d.url+=(Nt.test(d.url)?"&":"?")+d.data,delete d.data),s=d.url;if(d.cache===!1){var _=J.now(),C=d.url.replace(Ot,"$1_="+_);d.url=C+(C===d.url?(Nt.test(d.url)?"&":"?")+"_="+_:"")}}(d.data&&d.hasContent&&d.contentType!==!1||i.contentType)&&k.setRequestHeader("Content-Type",d.contentType),d.ifModified&&(s=s||d.url,J.lastModified[s]&&k.setRequestHeader("If-Modified-Since",J.lastModified[s]),J.etag[s]&&k.setRequestHeader("If-None-Match",J.etag[s])),k.setRequestHeader("Accept",d.dataTypes[0]&&d.accepts[d.dataTypes[0]]?d.accepts[d.dataTypes[0]]+("*"!==d.dataTypes[0]?", "+Ht+"; q=0.01":""):d.accepts["*"]);for(u in d.headers)k.setRequestHeader(u,d.headers[u]);if(!d.beforeSend||d.beforeSend.call(p,k,d)!==!1&&2!==w){x="abort";for(u in{success:1,error:1,complete:1})k[u](d[u]);r=T(Lt,d,i,k);if(r){k.readyState=1,h&&f.trigger("ajaxSend",[k,d]),d.async&&d.timeout>0&&(l=setTimeout(function(){k.abort("timeout")},d.timeout));try{w=1,r.send(b,n)}catch(e){if(!(w<2))throw e;n(-1,e)}}else n(-1,"No Transport");return k}return k.abort()},active:0,lastModified:{},etag:{}});var Rt=[],zt=/\?/,$t=/(=)\?(?=&|$)|\?\?/,Wt=J.now();J.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Rt.pop()||J.expando+"_"+Wt++;return this[e]=!0,e}}),J.ajaxPrefilter("json jsonp",function(i,n,s){var a,o,r,l=i.data,c=i.url,h=i.jsonp!==!1,u=h&&$t.test(c),d=h&&!u&&"string"==typeof l&&!(i.contentType||"").indexOf("application/x-www-form-urlencoded")&&$t.test(l);if("jsonp"===i.dataTypes[0]||u||d)return a=i.jsonpCallback=J.isFunction(i.jsonpCallback)?i.jsonpCallback():i.jsonpCallback,o=e[a],u?i.url=c.replace($t,"$1"+a):d?i.data=l.replace($t,"$1"+a):h&&(i.url+=(zt.test(c)?"&":"?")+i.jsonp+"="+a),i.converters["script json"]=function(){return r||J.error(a+" was not called"),r[0]},i.dataTypes[0]="json",e[a]=function(){r=arguments},s.always(function(){e[a]=o,i[a]&&(i.jsonpCallback=n.jsonpCallback,Rt.push(a)),r&&J.isFunction(o)&&o(r[0]),r=o=t}),"script"}),J.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/javascript|ecmascript/},converters:{"text script":function(e){return J.globalEval(e),e}}}),J.ajaxPrefilter("script",function(e){e.cache===t&&(e.cache=!1),e.crossDomain&&(e.type="GET",e.global=!1)}),J.ajaxTransport("script",function(e){if(e.crossDomain){var i,n=$.head||$.getElementsByTagName("head")[0]||$.documentElement;return{send:function(s,a){i=$.createElement("script"),i.async="async",e.scriptCharset&&(i.charset=e.scriptCharset),i.src=e.url,i.onload=i.onreadystatechange=function(e,s){(s||!i.readyState||/loaded|complete/.test(i.readyState))&&(i.onload=i.onreadystatechange=null,n&&i.parentNode&&n.removeChild(i),i=t,s||a(200,"success"))},n.insertBefore(i,n.firstChild)},abort:function(){i&&i.onload(0,1)}}}});var qt,Bt=!!e.ActiveXObject&&function(){for(var e in qt)qt[e](0,1)},Ut=0;J.ajaxSettings.xhr=e.ActiveXObject?function(){return!this.isLocal&&P()||M()}:P,function(e){J.extend(J.support,{ajax:!!e,cors:!!e&&"withCredentials"in e})}(J.ajaxSettings.xhr()),J.support.ajax&&J.ajaxTransport(function(i){if(!i.crossDomain||J.support.cors){var n;return{send:function(s,a){var o,r,l=i.xhr();i.username?l.open(i.type,i.url,i.async,i.username,i.password):l.open(i.type,i.url,i.async);if(i.xhrFields)for(r in i.xhrFields)l[r]=i.xhrFields[r];i.mimeType&&l.overrideMimeType&&l.overrideMimeType(i.mimeType),!i.crossDomain&&!s["X-Requested-With"]&&(s["X-Requested-With"]="XMLHttpRequest");try{for(r in s)l.setRequestHeader(r,s[r])}catch(e){}l.send(i.hasContent&&i.data||null),n=function(e,s){var r,c,h,u,d;try{if(n&&(s||4===l.readyState)){n=t,o&&(l.onreadystatechange=J.noop,Bt&&delete qt[o]);if(s)4!==l.readyState&&l.abort();else{r=l.status,h=l.getAllResponseHeaders(),u={},d=l.responseXML,d&&d.documentElement&&(u.xml=d);try{u.text=l.responseText}catch(e){}try{c=l.statusText}catch(e){c=""}r||!i.isLocal||i.crossDomain?1223===r&&(r=204):r=u.text?200:404}}}catch(e){s||a(-1,e)}u&&a(r,c,u,h)},i.async?4===l.readyState?setTimeout(n,0):(o=++Ut,Bt&&(qt||(qt={},J(e).unload(Bt)),qt[o]=n),l.onreadystatechange=n):n()},abort:function(){n&&n(0,1)}}}});var Yt,Vt,Kt=/^(?:toggle|show|hide)$/,Qt=new RegExp("^(?:([-+])=|)("+Z+")([a-z%]*)$","i"),Xt=/queueHooks$/,Gt=[A],Jt={"*":[function(e,t){var i,n,s=this.createTween(e,t),a=Qt.exec(t),o=s.cur(),r=+o||0,l=1,c=20;if(a){i=+a[2],n=a[3]||(J.cssNumber[e]?"":"px");if("px"!==n&&r){r=J.css(s.elem,e,!0)||i||1;do l=l||".5",r/=l,J.style(s.elem,e,r+n);while(l!==(l=s.cur()/o)&&1!==l&&--c)}s.unit=n,s.start=r,s.end=a[1]?r+(a[1]+1)*i:i}return s}]};J.Animation=J.extend(O,{tweener:function(e,t){J.isFunction(e)?(t=e,e=["*"]):e=e.split(" ");for(var i,n=0,s=e.length;n<s;n++)i=e[n],Jt[i]=Jt[i]||[],Jt[i].unshift(t)},prefilter:function(e,t){t?Gt.unshift(e):Gt.push(e)}}),J.Tween=F,F.prototype={constructor:F,init:function(e,t,i,n,s,a){this.elem=e,this.prop=i,this.easing=s||"swing",this.options=t,this.start=this.now=this.cur(),this.end=n,this.unit=a||(J.cssNumber[i]?"":"px")},cur:function(){var e=F.propHooks[this.prop];return e&&e.get?e.get(this):F.propHooks._default.get(this)},run:function(e){var t,i=F.propHooks[this.prop];return this.options.duration?this.pos=t=J.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),i&&i.set?i.set(this):F.propHooks._default.set(this),this}},F.prototype.init.prototype=F.prototype,F.propHooks={_default:{get:function(e){var t;return null==e.elem[e.prop]||e.elem.style&&null!=e.elem.style[e.prop]?(t=J.css(e.elem,e.prop,!1,""),t&&"auto"!==t?t:0):e.elem[e.prop]},set:function(e){J.fx.step[e.prop]?J.fx.step[e.prop](e):e.elem.style&&(null!=e.elem.style[J.cssProps[e.prop]]||J.cssHooks[e.prop])?J.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},F.propHooks.scrollTop=F.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},J.each(["toggle","show","hide"],function(e,t){var i=J.fn[t];J.fn[t]=function(n,s,a){return null==n||"boolean"==typeof n||!e&&J.isFunction(n)&&J.isFunction(s)?i.apply(this,arguments):this.animate(L(t,!0),n,s,a)}}),J.fn.extend({fadeTo:function(e,t,i,n){return this.filter(v).css("opacity",0).show().end().animate({opacity:t},e,i,n)},animate:function(e,t,i,n){var s=J.isEmptyObject(e),a=J.speed(t,i,n),o=function(){var t=O(this,J.extend({},e),a);s&&t.stop(!0)};return s||a.queue===!1?this.each(o):this.queue(a.queue,o)},stop:function(e,i,n){var s=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=i,i=e,e=t),i&&e!==!1&&this.queue(e||"fx",[]),this.each(function(){var t=!0,i=null!=e&&e+"queueHooks",a=J.timers,o=J._data(this);if(i)o[i]&&o[i].stop&&s(o[i]);else for(i in o)o[i]&&o[i].stop&&Xt.test(i)&&s(o[i]);for(i=a.length;i--;)a[i].elem===this&&(null==e||a[i].queue===e)&&(a[i].anim.stop(n),t=!1,a.splice(i,1));(t||!n)&&J.dequeue(this,e)})}}),J.each({slideDown:L("show"),slideUp:L("hide"),slideToggle:L("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){J.fn[e]=function(e,i,n){return this.animate(t,e,i,n)}}),J.speed=function(e,t,i){var n=e&&"object"==typeof e?J.extend({},e):{complete:i||!i&&t||J.isFunction(e)&&e,duration:e,easing:i&&t||t&&!J.isFunction(t)&&t};n.duration=J.fx.off?0:"number"==typeof n.duration?n.duration:n.duration in J.fx.speeds?J.fx.speeds[n.duration]:J.fx.speeds._default;null!=n.queue&&n.queue!==!0||(n.queue="fx");return n.old=n.complete,n.complete=function(){J.isFunction(n.old)&&n.old.call(this),n.queue&&J.dequeue(this,n.queue)},n},J.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}},J.timers=[],J.fx=F.prototype.init,J.fx.tick=function(){var e,i=J.timers,n=0;Yt=J.now();for(;n<i.length;n++)e=i[n],!e()&&i[n]===e&&i.splice(n--,1);i.length||J.fx.stop(),Yt=t},J.fx.timer=function(e){e()&&J.timers.push(e)&&!Vt&&(Vt=setInterval(J.fx.tick,J.fx.interval))},J.fx.interval=13,J.fx.stop=function(){clearInterval(Vt),Vt=null},J.fx.speeds={slow:600,fast:200,_default:400},J.fx.step={},J.expr&&J.expr.filters&&(J.expr.filters.animated=function(e){return J.grep(J.timers,function(t){return e===t.elem}).length});var Zt=/^(?:body|html)$/i;J.fn.offset=function(e){if(arguments.length)return e===t?this:this.each(function(t){J.offset.setOffset(this,e,t)});var i,n,s,a,o,r,l,c={top:0,left:0},h=this[0],u=h&&h.ownerDocument;return u?(n=u.body)===h?J.offset.bodyOffset(h):(i=u.documentElement,J.contains(i,h)?("undefined"!=typeof h.getBoundingClientRect&&(c=h.getBoundingClientRect()),s=H(u),a=i.clientTop||n.clientTop||0,o=i.clientLeft||n.clientLeft||0,r=s.pageYOffset||i.scrollTop,l=s.pageXOffset||i.scrollLeft,{top:c.top+r-a,left:c.left+l-o}):c):void 0},J.offset={bodyOffset:function(e){var t=e.offsetTop,i=e.offsetLeft;return J.support.doesNotIncludeMarginInBodyOffset&&(t+=parseFloat(J.css(e,"marginTop"))||0,i+=parseFloat(J.css(e,"marginLeft"))||0),{top:t,left:i}},setOffset:function(e,t,i){var n=J.css(e,"position");"static"===n&&(e.style.position="relative");var s,a,o=J(e),r=o.offset(),l=J.css(e,"top"),c=J.css(e,"left"),h=("absolute"===n||"fixed"===n)&&J.inArray("auto",[l,c])>-1,u={},d={};h?(d=o.position(),s=d.top,a=d.left):(s=parseFloat(l)||0,a=parseFloat(c)||0),J.isFunction(t)&&(t=t.call(e,i,r)),null!=t.top&&(u.top=t.top-r.top+s),null!=t.left&&(u.left=t.left-r.left+a),"using"in t?t.using.call(e,u):o.css(u)}},J.fn.extend({position:function(){if(this[0]){var e=this[0],t=this.offsetParent(),i=this.offset(),n=Zt.test(t[0].nodeName)?{top:0,left:0}:t.offset();return i.top-=parseFloat(J.css(e,"marginTop"))||0,i.left-=parseFloat(J.css(e,"marginLeft"))||0,n.top+=parseFloat(J.css(t[0],"borderTopWidth"))||0,n.left+=parseFloat(J.css(t[0],"borderLeftWidth"))||0,{top:i.top-n.top,left:i.left-n.left}}},offsetParent:function(){return this.map(function(){for(var e=this.offsetParent||$.body;e&&!Zt.test(e.nodeName)&&"static"===J.css(e,"position");)e=e.offsetParent;return e||$.body})}}),J.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,i){var n=/Y/.test(i);J.fn[e]=function(s){return J.access(this,function(e,s,a){var o=H(e);if(a===t)return o?i in o?o[i]:o.document.documentElement[s]:e[s];o?o.scrollTo(n?J(o).scrollLeft():a,n?a:J(o).scrollTop()):e[s]=a},e,s,arguments.length,null)}}),J.each({Height:"height",Width:"width"},function(e,i){J.each({padding:"inner"+e,content:i,"":"outer"+e},function(n,s){J.fn[s]=function(s,a){var o=arguments.length&&(n||"boolean"!=typeof s),r=n||(s===!0||a===!0?"margin":"border");return J.access(this,function(i,n,s){var a;return J.isWindow(i)?i.document.documentElement["client"+e]:9===i.nodeType?(a=i.documentElement,Math.max(i.body["scroll"+e],a["scroll"+e],i.body["offset"+e],a["offset"+e],a["client"+e])):s===t?J.css(i,n,s,r):J.style(i,n,s,r)},i,o?s:t,o,null)}})}),e.jQuery=e.$=J,"function"==typeof define&&define.amd&&define.amd.jQuery&&define("jquery",[],function(){return J})}(window);jQuery.extend(jQuery.easing,{easeInQuad:function(e,t,i,n,s){return n*(t/=s)*t+i},easeOutQuad:function(e,t,i,n,s){return-n*(t/=s)*(t-2)+i},easeInOutQuad:function(e,t,i,n,s){return(t/=s/2)<1?n/2*t*t+i:-n/2*(--t*(t-2)-1)+i},easeInCubic:function(e,t,i,n,s){return n*(t/=s)*t*t+i},easeOutCubic:function(e,t,i,n,s){return n*((t=t/s-1)*t*t+1)+i},easeInOutCubic:function(e,t,i,n,s){return(t/=s/2)<1?n/2*t*t*t+i:n/2*((t-=2)*t*t+2)+i},easeInQuart:function(e,t,i,n,s){return n*(t/=s)*t*t*t+i},easeOutQuart:function(e,t,i,n,s){return-n*((t=t/s-1)*t*t*t-1)+i},easeInOutQuart:function(e,t,i,n,s){return(t/=s/2)<1?n/2*t*t*t*t+i:-n/2*((t-=2)*t*t*t-2)+i},easeInQuint:function(e,t,i,n,s){return n*(t/=s)*t*t*t*t+i},easeOutQuint:function(e,t,i,n,s){return n*((t=t/s-1)*t*t*t*t+1)+i},easeInOutQuint:function(e,t,i,n,s){return(t/=s/2)<1?n/2*t*t*t*t*t+i:n/2*((t-=2)*t*t*t*t+2)+i},easeInSine:function(e,t,i,n,s){return-n*Math.cos(t/s*(Math.PI/2))+n+i},easeOutSine:function(e,t,i,n,s){return n*Math.sin(t/s*(Math.PI/2))+i},easeInOutSine:function(e,t,i,n,s){return-n/2*(Math.cos(Math.PI*t/s)-1)+i},easeInExpo:function(e,t,i,n,s){return 0==t?i:n*Math.pow(2,10*(t/s-1))+i},easeOutExpo:function(e,t,i,n,s){return t==s?i+n:n*(-Math.pow(2,-10*t/s)+1)+i},easeInOutExpo:function(e,t,i,n,s){return 0==t?i:t==s?i+n:(t/=s/2)<1?n/2*Math.pow(2,10*(t-1))+i:n/2*(-Math.pow(2,-10*--t)+2)+i},easeInCirc:function(e,t,i,n,s){return-n*(Math.sqrt(1-(t/=s)*t)-1)+i},easeOutCirc:function(e,t,i,n,s){return n*Math.sqrt(1-(t=t/s-1)*t)+i},easeInOutCirc:function(e,t,i,n,s){return(t/=s/2)<1?-n/2*(Math.sqrt(1-t*t)-1)+i:n/2*(Math.sqrt(1-(t-=2)*t)+1)+i},easeInElastic:function(e,t,i,n,s){var a=1.70158,o=0,r=n;if(0==t)return i;if(1==(t/=s))return i+n;o||(o=.3*s);if(r<Math.abs(n)){r=n;var a=o/4}else var a=o/(2*Math.PI)*Math.asin(n/r);return-(r*Math.pow(2,10*(t-=1))*Math.sin((t*s-a)*(2*Math.PI)/o))+i},easeOutElastic:function(e,t,i,n,s){var a=1.70158,o=0,r=n;if(0==t)return i;if(1==(t/=s))return i+n;o||(o=.3*s);if(r<Math.abs(n)){r=n;var a=o/4}else var a=o/(2*Math.PI)*Math.asin(n/r);return r*Math.pow(2,-10*t)*Math.sin((t*s-a)*(2*Math.PI)/o)+n+i},easeInOutElastic:function(e,t,i,n,s){var a=1.70158,o=0,r=n;if(0==t)return i;if(2==(t/=s/2))return i+n;o||(o=s*(.3*1.5));if(r<Math.abs(n)){r=n;var a=o/4}else var a=o/(2*Math.PI)*Math.asin(n/r);return t<1?-.5*(r*Math.pow(2,10*(t-=1))*Math.sin((t*s-a)*(2*Math.PI)/o))+i:r*Math.pow(2,-10*(t-=1))*Math.sin((t*s-a)*(2*Math.PI)/o)*.5+n+i},easeInBack:function(e,t,i,n,s,a){void 0==a&&(a=1.70158);return n*(t/=s)*t*((a+1)*t-a)+i},easeOutBack:function(e,t,i,n,s,a){void 0==a&&(a=1.70158);return n*((t=t/s-1)*t*((a+1)*t+a)+1)+i},easeInOutBack:function(e,t,i,n,s,a){void 0==a&&(a=1.70158);return(t/=s/2)<1?n/2*(t*t*(((a*=1.525)+1)*t-a))+i:n/2*((t-=2)*t*(((a*=1.525)+1)*t+a)+2)+i},easeInBounce:function(e,t,i,n,s){
return n-jQuery.easing.easeOutBounce(e,s-t,0,n,s)+i},easeOutBounce:function(e,t,i,n,s){return(t/=s)<1/2.75?n*(7.5625*t*t)+i:t<2/2.75?n*(7.5625*(t-=1.5/2.75)*t+.75)+i:t<2.5/2.75?n*(7.5625*(t-=2.25/2.75)*t+.9375)+i:n*(7.5625*(t-=2.625/2.75)*t+.984375)+i},easeInOutBounce:function(e,t,i,n,s){return t<s/2?.5*jQuery.easing.easeInBounce(e,2*t,0,n,s)+i:.5*jQuery.easing.easeOutBounce(e,2*t-s,0,n,s)+.5*n+i}});(function(){!function(e,t,i){var n,s,a;return a="slidesjs",s={width:940,height:528,start:1,navigation:{active:!0,effect:"slide"},pagination:{active:!0,effect:"slide"},play:{active:!1,effect:"slide",interval:5e3,auto:!1,swap:!0,pauseOnHover:!1,restartDelay:5e3},effect:{slide:{speed:1e3},fade:{speed:300,crossfade:!0}},callback:{loaded:function(){},start:function(){},complete:function(){}}},n=function(){function t(t,i){this.element=t,this.options=e.extend(!0,{},s,i),this._defaults=s,this._name=a,this.init()}return t}(),n.prototype.init=function(){var i,n,s,a,o,r,l=this;return i=e(this.element),this.data=e.data(this),e.data(this,"animating",!1),e.data(this,"total",i.children().not(".slidesjs-navigation",i).length),e.data(this,"current",this.options.start-1),e.data(this,"vendorPrefix",this._getVendorPrefix()),"undefined"!=typeof TouchEvent&&(e.data(this,"touch",!0),this.options.effect.slide.speed=this.options.effect.slide.speed/2),i.css({overflow:"hidden"}),i.slidesContainer=i.children().not(".slidesjs-navigation",i).wrapAll("<div class='slidesjs-container'>",i).parent().css({overflow:"hidden",position:"relative"}),e(".slidesjs-container",i).wrapInner("<div class='slidesjs-control'>",i).children(),e(".slidesjs-control",i).css({position:"relative",left:0}),e(".slidesjs-control",i).children().addClass("slidesjs-slide").css({position:"absolute",top:0,left:0,width:"100%",zIndex:0,display:"none",webkitBackfaceVisibility:"hidden"}),e.each(e(".slidesjs-control",i).children(),function(t){var i;return i=e(this),i.attr("slidesjs-index",t)}),this.data.touch&&(e(".slidesjs-control",i).on("touchstart",function(e){return l._touchstart(e)}),e(".slidesjs-control",i).on("touchmove",function(e){return l._touchmove(e)}),e(".slidesjs-control",i).on("touchend",function(e){return l._touchend(e)})),i.fadeIn(0),this.update(),this.data.touch&&this._setuptouch(),e(".slidesjs-control",i).children(":eq("+this.data.current+")").eq(0).fadeIn(0,function(){return e(this).css({zIndex:10})}),this.options.navigation.active&&(o=e("<a>",{class:"slidesjs-previous slidesjs-navigation",href:"#",title:"Previous",text:"Previous"}).appendTo(i),n=e("<a>",{class:"slidesjs-next slidesjs-navigation",href:"#",title:"Next",text:"Next"}).appendTo(i)),e(".slidesjs-next",i).click(function(e){return e.preventDefault(),l.stop(!0),l.next(l.options.navigation.effect)}),e(".slidesjs-previous",i).click(function(e){return e.preventDefault(),l.stop(!0),l.previous(l.options.navigation.effect)}),this.options.play.active&&(a=e("<a>",{class:"slidesjs-play slidesjs-navigation",href:"#",title:"Play",text:"Play"}).appendTo(i),r=e("<a>",{class:"slidesjs-stop slidesjs-navigation",href:"#",title:"Stop",text:"Stop"}).appendTo(i),a.click(function(e){return e.preventDefault(),l.play(!0)}),r.click(function(e){return e.preventDefault(),l.stop(!0)}),this.options.play.swap&&r.css({display:"none"})),this.options.pagination.active&&(s=e("<ul>",{class:"slidesjs-pagination"}).appendTo(i),e.each(Array(this.data.total),function(t){var i,n;return i=e("<li>",{class:"slidesjs-pagination-item"}).appendTo(s),n=e("<a>",{href:"#","data-slidesjs-item":t,html:t+1}).appendTo(i),n.click(function(t){return t.preventDefault(),l.stop(!0),l.goto(1*e(t.currentTarget).attr("data-slidesjs-item")+1)})})),e(t).bind("resize",function(){return l.update()}),this._setActive(),this.options.play.auto&&this.play(),this.options.callback.loaded(this.options.start)},n.prototype._setActive=function(t){var i,n;return i=e(this.element),this.data=e.data(this),n=t>-1?t:this.data.current,e(".active",i).removeClass("active"),e("li:eq("+n+") a",i).addClass("active")},n.prototype.update=function(){var t,i,n;return t=e(this.element),this.data=e.data(this),e(".slidesjs-control",t).children(":not(:eq("+this.data.current+"))").css({display:"none",left:0,zIndex:0}),n=t.width(),i=this.options.height/this.options.width*n,this.options.width=n,this.options.height=i,e(".slidesjs-control, .slidesjs-container",t).css({width:n,height:i})},n.prototype.next=function(t){var i;return i=e(this.element),this.data=e.data(this),e.data(this,"direction","next"),void 0===t&&(t=this.options.navigation.effect),"fade"===t?this._fade():this._slide()},n.prototype.previous=function(t){var i;return i=e(this.element),this.data=e.data(this),e.data(this,"direction","previous"),void 0===t&&(t=this.options.navigation.effect),"fade"===t?this._fade():this._slide()},n.prototype.goto=function(t){var i,n;if(i=e(this.element),this.data=e.data(this),void 0===n&&(n=this.options.pagination.effect),t>this.data.total?t=this.data.total:1>t&&(t=1),"number"==typeof t)return"fade"===n?this._fade(t):this._slide(t);if("string"==typeof t){if("first"===t)return"fade"===n?this._fade(0):this._slide(0);if("last"===t)return"fade"===n?this._fade(this.data.total):this._slide(this.data.total)}},n.prototype._setuptouch=function(){var t,i,n,s;return t=e(this.element),this.data=e.data(this),s=e(".slidesjs-control",t),i=this.data.current+1,n=this.data.current-1,0>n&&(n=this.data.total-1),i>this.data.total-1&&(i=0),s.children(":eq("+i+")").css({display:"block",left:this.options.width}),s.children(":eq("+n+")").css({display:"block",left:-this.options.width})},n.prototype._touchstart=function(t){var i,n;return i=e(this.element),this.data=e.data(this),n=t.originalEvent.touches[0],this._setuptouch(),e.data(this,"touchtimer",Number(new Date)),e.data(this,"touchstartx",n.pageX),e.data(this,"touchstarty",n.pageY),t.stopPropagation()},n.prototype._touchend=function(t){var i,n,s,a,o,r,l,c=this;return i=e(this.element),this.data=e.data(this),r=t.originalEvent.touches[0],a=e(".slidesjs-control",i),a.position().left>.5*this.options.width||a.position().left>.1*this.options.width&&250>Number(new Date)-this.data.touchtimer?(e.data(this,"direction","previous"),this._slide()):a.position().left<-(.5*this.options.width)||a.position().left<-(.1*this.options.width)&&250>Number(new Date)-this.data.touchtimer?(e.data(this,"direction","next"),this._slide()):(s=this.data.vendorPrefix,l=s+"Transform",n=s+"TransitionDuration",o=s+"TransitionTimingFunction",a[0].style[l]="translateX(0px)",a[0].style[n]=.85*this.options.effect.slide.speed+"ms"),a.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",function(){return s=c.data.vendorPrefix,l=s+"Transform",n=s+"TransitionDuration",o=s+"TransitionTimingFunction",a[0].style[l]="",a[0].style[n]="",a[0].style[o]=""}),t.stopPropagation()},n.prototype._touchmove=function(t){var i,n,s,a,o;return i=e(this.element),this.data=e.data(this),a=t.originalEvent.touches[0],n=this.data.vendorPrefix,s=e(".slidesjs-control",i),o=n+"Transform",e.data(this,"scrolling",Math.abs(a.pageX-this.data.touchstartx)<Math.abs(a.pageY-this.data.touchstarty)),this.data.animating||this.data.scrolling||(t.preventDefault(),this._setuptouch(),s[0].style[o]="translateX("+(a.pageX-this.data.touchstartx)+"px)"),t.stopPropagation()},n.prototype.play=function(t){var i,n,s,a=this;return i=e(this.element),this.data=e.data(this),!this.data.playInterval&&(t&&(n=this.data.current,this.data.direction="next","fade"===this.options.play.effect?this._fade():this._slide()),e.data(this,"playInterval",setInterval(function(){return n=a.data.current,a.data.direction="next","fade"===a.options.play.effect?a._fade():a._slide()},this.options.play.interval)),s=e(".slidesjs-container",i),this.options.play.pauseOnHover&&(s.unbind(),s.bind("mouseenter",function(){return a.stop()}),s.bind("mouseleave",function(){return a.options.play.restartDelay?e.data(a,"restartDelay",setTimeout(function(){return a.play(!0)},a.options.play.restartDelay)):a.play()})),e.data(this,"playing",!0),e(".slidesjs-play",i).addClass("slidesjs-playing"),this.options.play.swap)?(e(".slidesjs-play",i).hide(),e(".slidesjs-stop",i).show()):void 0},n.prototype.stop=function(t){var i;return i=e(this.element),this.data=e.data(this),clearInterval(this.data.playInterval),this.options.play.pauseOnHover&&t&&e(".slidesjs-container",i).unbind(),e.data(this,"playInterval",null),e.data(this,"playing",!1),e(".slidesjs-play",i).removeClass("slidesjs-playing"),this.options.play.swap?(e(".slidesjs-stop",i).hide(),e(".slidesjs-play",i).show()):void 0},n.prototype._slide=function(t){var i,n,s,a,o,r,l,c,h,u,d=this;return i=e(this.element),this.data=e.data(this),this.data.animating||t===this.data.current+1?void 0:(e.data(this,"animating",!0),n=this.data.current,t>-1?(t-=1,u=t>n?1:-1,s=t>n?-this.options.width:this.options.width,o=t):(u="next"===this.data.direction?1:-1,s="next"===this.data.direction?-this.options.width:this.options.width,o=n+u),-1===o&&(o=this.data.total-1),o===this.data.total&&(o=0),this._setActive(o),l=e(".slidesjs-control",i),t>-1&&l.children(":not(:eq("+n+"))").css({display:"none",left:0,zIndex:0}),l.children(":eq("+o+")").css({display:"block",left:u*this.options.width,zIndex:10}),this.options.callback.start(n+1),this.data.vendorPrefix?(r=this.data.vendorPrefix,h=r+"Transform",a=r+"TransitionDuration",c=r+"TransitionTimingFunction",l[0].style[h]="translateX("+s+"px)",l[0].style[a]=this.options.effect.slide.speed+"ms",l.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",function(){return l[0].style[h]="",l[0].style[a]="",l.children(":eq("+o+")").css({left:0}),l.children(":eq("+n+")").css({display:"none",left:0,zIndex:0}),e.data(d,"current",o),e.data(d,"animating",!1),l.unbind("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd"),l.children(":not(:eq("+o+"))").css({display:"none",left:0,zIndex:0}),d.data.touch&&d._setuptouch(),d.options.callback.complete(o+1)})):l.stop().animate({left:s},this.options.effect.slide.speed,function(){return l.css({left:0}),l.children(":eq("+o+")").css({left:0}),l.children(":eq("+n+")").css({display:"none",left:0,zIndex:0},e.data(d,"current",o),e.data(d,"animating",!1),d.options.callback.complete(o+1))}))},n.prototype._fade=function(t){var i,n,s,a,o,r=this;return i=e(this.element),this.data=e.data(this),this.data.animating||t===this.data.current+1?void 0:(e.data(this,"animating",!0),n=this.data.current,t?(t-=1,o=t>n?1:-1,s=t):(o="next"===this.data.direction?1:-1,s=n+o),-1===s&&(s=this.data.total-1),s===this.data.total&&(s=0),this._setActive(s),a=e(".slidesjs-control",i),a.children(":eq("+s+")").css({display:"none",left:0,zIndex:10}),this.options.callback.start(n+1),this.options.effect.fade.crossfade?(a.children(":eq("+this.data.current+")").stop().fadeOut(this.options.effect.fade.speed),a.children(":eq("+s+")").stop().fadeIn(this.options.effect.fade.speed,function(){return a.children(":eq("+s+")").css({zIndex:0}),e.data(r,"animating",!1),e.data(r,"current",s),r.options.callback.complete(s+1)})):a.children(":eq("+n+")").stop().fadeOut(this.options.effect.fade.speed,function(){return a.children(":eq("+s+")").stop().fadeIn(r.options.effect.fade.speed,function(){return a.children(":eq("+s+")").css({zIndex:10})}),e.data(r,"animating",!1),e.data(r,"current",s),r.options.callback.complete(s+1)}))},n.prototype._getVendorPrefix=function(){var e,t,n,s,a;for(e=i.body||i.documentElement,n=e.style,s="transition",a=["Moz","Webkit","Khtml","O","ms"],s=s.charAt(0).toUpperCase()+s.substr(1),t=0;a.length>t;){if("string"==typeof n[a[t]+s])return a[t];t++}return!1},e.fn[a]=function(t){return this.each(function(){return e.data(this,"plugin_"+a)?void 0:e.data(this,"plugin_"+a,new n(this,t))})}}(jQuery,window,document)}).call(this);!function(e,t,i){function n(i,n,s){var a=t.createElement(i);return n&&(a.id=ee+n),s&&(a.style.cssText=s),e(a)}function s(){return i.innerHeight?i.innerHeight:e(i).height()}function a(e){var t=T.length,i=(q+e)%t;return 0>i?t+i:i}function o(e,t){return Math.round((/%/.test(e)?("x"===t?S.width():s())/100:1)*parseInt(e,10))}function r(e,t){return e.photo||e.photoRegex.test(t)}function l(e,t){return e.retinaUrl&&i.devicePixelRatio>1?t.replace(e.photoRegex,e.retinaSuffix):t}function c(e){"contains"in b[0]&&!b[0].contains(e.target)&&(e.stopPropagation(),b.focus())}function h(){var t,i=e.data(W,Z);null==i?(L=e.extend({},J),console&&console.log&&void 0):L=e.extend({},i);for(t in L)e.isFunction(L[t])&&"on"!==t.slice(0,2)&&(L[t]=L[t].call(W));L.rel=L.rel||W.rel||e(W).data("rel")||"nofollow",L.href=L.href||e(W).attr("href"),L.title=L.title||W.title,"string"==typeof L.href&&(L.href=e.trim(L.href))}function u(i,n){e(t).trigger(i),le.trigger(i),e.isFunction(n)&&n.call(W)}function d(){var e,t,i,n,s,a=ee+"Slideshow_",o="click."+ee;L.slideshow&&T[1]?(t=function(){clearTimeout(e)},i=function(){(L.loop||T[q+1])&&(e=setTimeout(Q.next,L.slideshowSpeed))},n=function(){I.html(L.slideshowStop).unbind(o).one(o,s),le.bind(se,i).bind(ne,t).bind(ae,s),b.removeClass(a+"off").addClass(a+"on")},s=function(){t(),le.unbind(se,i).unbind(ne,t).unbind(ae,s),I.html(L.slideshowStart).unbind(o).one(o,function(){Q.next(),n()}),b.removeClass(a+"on").addClass(a+"off")},L.slideshowAuto?n():s()):b.removeClass(a+"off "+a+"on")}function p(i){V||(W=i,h(),T=e(W),q=0,"nofollow"!==L.rel&&(T=e("."+te).filter(function(){var t,i=e.data(this,Z);return i&&(t=e(this).data("rel")||i.rel||this.rel),t===L.rel}),q=T.index(W),-1===q&&(T=T.add(W),q=T.length-1)),v.css({opacity:parseFloat(L.opacity),cursor:L.overlayClose?"pointer":"auto",visibility:"visible"}).show(),X&&b.add(v).removeClass(X),L.className&&b.add(v).addClass(L.className),X=L.className,A.html(L.close).show(),U||(U=Y=!0,b.css({visibility:"hidden",display:"block"}),E=n(ce,"LoadedContent","width:0; height:0; overflow:hidden").appendTo(w),H=x.height()+C.height()+w.outerHeight(!0)-w.height(),R=k.width()+_.width()+w.outerWidth(!0)-w.width(),z=E.outerHeight(!0),$=E.outerWidth(!0),L.w=o(L.initialWidth,"x"),L.h=o(L.initialHeight,"y"),Q.position(),d(),u(ie,L.onOpen),F.add(M).hide(),b.focus(),t.addEventListener&&(t.addEventListener("focus",c,!0),le.one(oe,function(){t.removeEventListener("focus",c,!0)})),L.returnFocus&&le.one(oe,function(){e(W).focus()})),g())}function f(){!b&&t.body&&(G=!1,S=e(i),b=n(ce).attr({id:Z,class:e.support.opacity===!1?ee+"IE":"",role:"dialog",tabindex:"-1"}).hide(),v=n(ce,"Overlay").hide(),P=n(ce,"LoadingOverlay").add(n(ce,"LoadingGraphic")),y=n(ce,"Wrapper"),w=n(ce,"Content").append(M=n(ce,"Title"),N=n(ce,"Current"),j=e('<button type="button"/>').attr({id:ee+"Previous"}),O=e('<button type="button"/>').attr({id:ee+"Next"}),I=n("button","Slideshow"),P,A=e('<button type="button"/>').attr({id:ee+"Close"})),y.append(n(ce).append(n(ce,"TopLeft"),x=n(ce,"TopCenter"),n(ce,"TopRight")),n(ce,!1,"clear:left").append(k=n(ce,"MiddleLeft"),w,_=n(ce,"MiddleRight")),n(ce,!1,"clear:left").append(n(ce,"BottomLeft"),C=n(ce,"BottomCenter"),n(ce,"BottomRight"))).find("div div").css({float:"left"}),D=n(ce,!1,"position:absolute; width:9999px; visibility:hidden; display:none"),F=O.add(j).add(N).add(I),e(t.body).append(v,b.append(y,D)))}function m(){function i(e){e.which>1||e.shiftKey||e.altKey||e.metaKey||e.control||(e.preventDefault(),p(this))}return!!b&&(G||(G=!0,O.click(function(){Q.next()}),j.click(function(){Q.prev()}),A.click(function(){Q.close()}),v.click(function(){L.overlayClose&&Q.close()}),e(t).bind("keydown."+ee,function(e){var t=e.keyCode;U&&L.escKey&&27===t&&(e.preventDefault(),Q.close()),U&&L.arrowKey&&T[1]&&!e.altKey&&(37===t?(e.preventDefault(),j.click()):39===t&&(e.preventDefault(),O.click()))}),e.isFunction(e.fn.on)?e(t).on("click."+ee,"."+te,i):e("."+te).live("click."+ee,i)),!0)}function g(){var t,s,a,c=Q.prep,d=++he;Y=!0,B=!1,W=T[q],h(),u(re),u(ne,L.onLoad),L.h=L.height?o(L.height,"y")-z-H:L.innerHeight&&o(L.innerHeight,"y"),L.w=L.width?o(L.width,"x")-$-R:L.innerWidth&&o(L.innerWidth,"x"),L.mw=L.w,L.mh=L.h,L.maxWidth&&(L.mw=o(L.maxWidth,"x")-$-R,L.mw=L.w&&L.w<L.mw?L.w:L.mw),L.maxHeight&&(L.mh=o(L.maxHeight,"y")-z-H,L.mh=L.h&&L.h<L.mh?L.h:L.mh),t=L.href,K=setTimeout(function(){P.show()},100),L.inline?(a=n(ce).hide().insertBefore(e(t)[0]),le.one(re,function(){a.replaceWith(E.children())}),c(e(t))):L.iframe?c(" "):L.html?c(L.html):r(L,t)?(t=l(L,t),e(B=new Image).addClass(ee+"Photo").bind("error",function(){L.title=!1,c(n(ce,"Error").html(L.imgError))}).one("load",function(){var t;d===he&&(B.alt=e(W).attr("alt")||e(W).attr("data-alt")||"",L.retinaImage&&i.devicePixelRatio>1&&(B.height=B.height/i.devicePixelRatio,B.width=B.width/i.devicePixelRatio),L.scalePhotos&&(s=function(){B.height-=B.height*t,B.width-=B.width*t},L.mw&&B.width>L.mw&&(t=(B.width-L.mw)/B.width,s()),L.mh&&B.height>L.mh&&(t=(B.height-L.mh)/B.height,s())),L.h&&(B.style.marginTop=Math.max(L.mh-B.height,0)/2+"px"),T[1]&&(L.loop||T[q+1])&&(B.style.cursor="pointer",B.onclick=function(){Q.next()}),B.style.width=B.width+"px",B.style.height=B.height+"px",setTimeout(function(){c(B)},1))}),setTimeout(function(){B.src=t},1)):t&&D.load(t,L.data,function(t,i){d===he&&c("error"===i?n(ce,"Error").html(L.xhrError):e(this).contents())})}var v,b,y,w,x,k,_,C,T,S,E,D,P,M,N,I,O,j,A,F,L,H,R,z,$,W,q,B,U,Y,V,K,Q,X,G,J={transition:"elastic",speed:300,fadeOut:300,width:!1,initialWidth:"600",innerWidth:!1,maxWidth:!1,height:!1,initialHeight:"450",innerHeight:!1,maxHeight:!1,scalePhotos:!0,scrolling:!0,inline:!1,html:!1,iframe:!1,fastIframe:!0,photo:!1,href:!1,title:!1,rel:!1,opacity:.9,preloading:!0,className:!1,retinaImage:!1,retinaUrl:!1,retinaSuffix:"@2x.$1",current:"image {current} of {total}",previous:"previous",next:"next",close:"close",xhrError:"This content failed to load.",imgError:"This image failed to load.",open:!1,returnFocus:!0,reposition:!0,loop:!0,slideshow:!1,slideshowAuto:!0,slideshowSpeed:2500,slideshowStart:"start slideshow",slideshowStop:"stop slideshow",photoRegex:/\.(gif|png|jp(e|g|eg)|bmp|ico|webp)((#|\?).*)?$/i,onOpen:!1,onLoad:!1,onComplete:!1,onCleanup:!1,onClosed:!1,overlayClose:!0,escKey:!0,arrowKey:!0,top:!1,bottom:!1,left:!1,right:!1,fixed:!1,data:void 0},Z="colorbox",ee="cbox",te=ee+"Element",ie=ee+"_open",ne=ee+"_load",se=ee+"_complete",ae=ee+"_cleanup",oe=ee+"_closed",re=ee+"_purge",le=e("<a/>"),ce="div",he=0;e.colorbox||(e(f),Q=e.fn[Z]=e[Z]=function(t,i){var n=this;if(t=t||{},f(),m()){if(e.isFunction(n))n=e("<a/>"),t.open=!0;else if(!n[0])return n;i&&(t.onComplete=i),n.each(function(){e.data(this,Z,e.extend({},e.data(this,Z)||J,t))}).addClass(te),(e.isFunction(t.open)&&t.open.call(n)||t.open)&&p(n[0])}return n},Q.position=function(e,t){function i(e){x[0].style.width=C[0].style.width=w[0].style.width=parseInt(e.style.width,10)-R+"px",w[0].style.height=k[0].style.height=_[0].style.height=parseInt(e.style.height,10)-H+"px"}var n,a,r,l=0,c=0,h=b.offset();S.unbind("resize."+ee),b.css({top:-9e4,left:-9e4}),a=S.scrollTop(),r=S.scrollLeft(),L.fixed?(h.top-=a,h.left-=r,b.css({position:"fixed"})):(l=a,c=r,b.css({position:"absolute"})),c+=L.right!==!1?Math.max(S.width()-L.w-$-R-o(L.right,"x"),0):L.left!==!1?o(L.left,"x"):Math.round(Math.max(S.width()-L.w-$-R,0)/2),l+=L.bottom!==!1?Math.max(s()-L.h-z-H-o(L.bottom,"y"),0):L.top!==!1?o(L.top,"y"):Math.round(Math.max(s()-L.h-z-H,0)/2),b.css({top:h.top,left:h.left,visibility:"visible"}),e=b.width()===L.w+$&&b.height()===L.h+z?0:e||0,y[0].style.width=y[0].style.height="9999px",n={width:L.w+$+R,height:L.h+z+H,top:l,left:c},0===e&&b.css(n),b.dequeue().animate(n,{duration:e,complete:function(){i(this),Y=!1,y[0].style.width=L.w+$+R+"px",y[0].style.height=L.h+z+H+"px",L.reposition&&setTimeout(function(){S.bind("resize."+ee,Q.position)},1),t&&t()},step:function(){i(this)}})},Q.resize=function(e){U&&(e=e||{},e.width&&(L.w=o(e.width,"x")-$-R),e.innerWidth&&(L.w=o(e.innerWidth,"x")),E.css({width:L.w}),e.height&&(L.h=o(e.height,"y")-z-H),e.innerHeight&&(L.h=o(e.innerHeight,"y")),e.innerHeight||e.height||(E.css({height:"auto"}),L.h=E.height()),E.css({height:L.h}),Q.position("none"===L.transition?0:L.speed))},Q.prep=function(t){function i(){return L.w=L.w||E.width(),L.w=L.mw&&L.mw<L.w?L.mw:L.w,L.w}function s(){return L.h=L.h||E.height(),L.h=L.mh&&L.mh<L.h?L.mh:L.h,L.h}if(U){var o,c="none"===L.transition?0:L.speed;E.empty().remove(),E=n(ce,"LoadedContent").append(t),E.hide().appendTo(D.show()).css({width:i(),overflow:L.scrolling?"auto":"hidden"}).css({height:s()}).prependTo(w),D.hide(),e(B).css({float:"none"}),o=function(){function t(){e.support.opacity===!1&&b[0].style.removeAttribute("filter")}var i,s,o=T.length,h="frameBorder",d="allowTransparency";U&&(s=function(){clearTimeout(K),P.hide(),u(se,L.onComplete)},M.html(L.title).add(E).show(),o>1?("string"==typeof L.current&&N.html(L.current.replace("{current}",q+1).replace("{total}",o)).show(),O[L.loop||o-1>q?"show":"hide"]().html(L.next),j[L.loop||q?"show":"hide"]().html(L.previous),L.slideshow&&I.show(),L.preloading&&e.each([a(-1),a(1)],function(){var t,i,n=T[this],s=e.data(n,Z);s&&s.href?(t=s.href,e.isFunction(t)&&(t=t.call(n))):t=e(n).attr("href"),t&&r(s,t)&&(t=l(s,t),i=new Image,i.src=t)})):F.hide(),L.iframe?(i=n("iframe")[0],h in i&&(i[h]=0),d in i&&(i[d]="true"),L.scrolling||(i.scrolling="no"),e(i).attr({src:L.href,name:(new Date).getTime(),class:ee+"Iframe",allowFullScreen:!0,webkitAllowFullScreen:!0,mozallowfullscreen:!0}).one("load",s).appendTo(E),le.one(re,function(){i.src="//about:blank"}),L.fastIframe&&e(i).trigger("load")):s(),"fade"===L.transition?b.fadeTo(c,1,t):t())},"fade"===L.transition?b.fadeTo(c,0,function(){Q.position(0,o)}):Q.position(c,o)}},Q.next=function(){!Y&&T[1]&&(L.loop||T[q+1])&&(q=a(1),p(T[q]))},Q.prev=function(){!Y&&T[1]&&(L.loop||q)&&(q=a(-1),p(T[q]))},Q.close=function(){U&&!V&&(V=!0,U=!1,u(ae,L.onCleanup),S.unbind("."+ee),v.fadeTo(L.fadeOut||0,0),b.stop().fadeTo(L.fadeOut||0,0,function(){b.add(v).css({opacity:1,cursor:"auto"}).hide(),u(re),E.empty().remove(),setTimeout(function(){V=!1,u(oe,L.onClosed)},1)}))},Q.remove=function(){b&&(b.stop(),e.colorbox.close(),b.stop().remove(),v.remove(),V=!1,b=null,e("."+te).removeData(Z).removeClass(te),e(t).unbind("click."+ee))},Q.element=function(){return e(W)},Q.settings=J)}(jQuery,document,window);!function(e){var t={vertical:!1,rtl:!1,start:1,offset:1,size:null,scroll:3,visible:null,animation:"normal",easing:"swing",auto:0,wrap:null,initCallback:null,setupCallback:null,reloadCallback:null,itemLoadCallback:null,itemFirstInCallback:null,itemFirstOutCallback:null,itemLastInCallback:null,itemLastOutCallback:null,itemVisibleInCallback:null,itemVisibleOutCallback:null,animationStepCallback:null,buttonNextHTML:"<div></div>",buttonPrevHTML:"<div></div>",buttonNextEvent:"click",buttonPrevEvent:"click",buttonNextCallback:null,buttonPrevCallback:null,itemFallbackDimension:null},i=!1;e(window).bind("load.jcarousel",function(){i=!0}),e.jcarousel=function(s,a){this.options=e.extend({},t,a||{}),this.locked=!1,this.autoStopped=!1,this.container=null,this.clip=null,this.list=null,this.buttonNext=null,this.buttonPrev=null,this.buttonNextState=null,this.buttonPrevState=null,a&&void 0!==a.rtl||(this.options.rtl="rtl"==(e(s).attr("dir")||e("html").attr("dir")||"").toLowerCase()),this.wh=this.options.vertical?"height":"width",this.lt=this.options.vertical?"top":this.options.rtl?"right":"left";for(var o="",r=s.className.split(" "),l=0;r.length>l;l++)if(-1!=r[l].indexOf("jcarousel-skin")){e(s).removeClass(r[l]),o=r[l];break}"UL"==s.nodeName.toUpperCase()||"OL"==s.nodeName.toUpperCase()?(this.list=e(s),this.clip=this.list.parents(".jcarousel-clip"),this.container=this.list.parents(".jcarousel-container")):(this.container=e(s),this.list=this.container.find("ul,ol").eq(0),this.clip=this.container.find(".jcarousel-clip")),0===this.clip.size()&&(this.clip=this.list.wrap("<div></div>").parent()),0===this.container.size()&&(this.container=this.clip.wrap("<div></div>").parent()),""!==o&&-1==this.container.parent()[0].className.indexOf("jcarousel-skin")&&this.container.wrap('<div class=" '+o+'"></div>'),this.buttonPrev=e(".jcarousel-prev",this.container),0===this.buttonPrev.size()&&null!==this.options.buttonPrevHTML&&(this.buttonPrev=e(this.options.buttonPrevHTML).appendTo(this.container)),this.buttonPrev.addClass(this.className("jcarousel-prev")),this.buttonNext=e(".jcarousel-next",this.container),0===this.buttonNext.size()&&null!==this.options.buttonNextHTML&&(this.buttonNext=e(this.options.buttonNextHTML).appendTo(this.container)),this.buttonNext.addClass(this.className("jcarousel-next")),this.clip.addClass(this.className("jcarousel-clip")).css({position:"relative"}),this.list.addClass(this.className("jcarousel-list")).css({overflow:"hidden",position:"relative",top:0,margin:0,padding:0}).css(this.options.rtl?"right":"left",0),this.container.addClass(this.className("jcarousel-container")).css({position:"relative"}),!this.options.vertical&&this.options.rtl&&this.container.addClass("jcarousel-direction-rtl").attr("dir","rtl");var c=null!==this.options.visible?Math.ceil(this.clipping()/this.options.visible):null,h=this.list.children("li"),u=this;if(h.size()>0){var d=0,p=this.options.offset;h.each(function(){u.format(this,p++),d+=u.dimension(this,c)}),this.list.css(this.wh,d+100+"px"),a&&void 0!==a.size||(this.options.size=h.size())}this.container.css("display","block"),this.buttonNext.css("display","block"),this.buttonPrev.css("display","block"),this.funcNext=function(){return u.next(),!1},this.funcPrev=function(){return u.prev(),!1},this.funcResize=function(){u.resizeTimer&&clearTimeout(u.resizeTimer),u.resizeTimer=setTimeout(function(){u.reload()},100)},null!==this.options.initCallback&&this.options.initCallback(this,"init"),!i&&n.isSafari()?(this.buttons(!1,!1),e(window).bind("load.jcarousel",function(){u.setup()})):this.setup()};var n=e.jcarousel;n.fn=n.prototype={jcarousel:"0.2.9"},n.fn.extend=n.extend=e.extend,n.fn.extend({setup:function(){if(this.first=null,this.last=null,this.prevFirst=null,this.prevLast=null,this.animating=!1,this.timer=null,this.resizeTimer=null,this.tail=null,this.inTail=!1,!this.locked){this.list.css(this.lt,this.pos(this.options.offset)+"px");var t=this.pos(this.options.start,!0);this.prevFirst=this.prevLast=null,this.animate(t,!1),e(window).unbind("resize.jcarousel",this.funcResize).bind("resize.jcarousel",this.funcResize),null!==this.options.setupCallback&&this.options.setupCallback(this)}},reset:function(){this.list.empty(),this.list.css(this.lt,"0px"),this.list.css(this.wh,"10px"),null!==this.options.initCallback&&this.options.initCallback(this,"reset"),this.setup()},reload:function(){if(null!==this.tail&&this.inTail&&this.list.css(this.lt,n.intval(this.list.css(this.lt))+this.tail),this.tail=null,this.inTail=!1,null!==this.options.reloadCallback&&this.options.reloadCallback(this),null!==this.options.visible){var e=this,t=Math.ceil(this.clipping()/this.options.visible),i=0,s=0;this.list.children("li").each(function(n){i+=e.dimension(this,t),e.first>n+1&&(s=i)}),this.list.css(this.wh,i+"px"),this.list.css(this.lt,-s+"px")}this.scroll(this.first,!1)},lock:function(){this.locked=!0,this.buttons()},unlock:function(){this.locked=!1,this.buttons()},size:function(e){return void 0!==e&&(this.options.size=e,this.locked||this.buttons()),this.options.size},has:function(e,t){void 0!==t&&t||(t=e),null!==this.options.size&&t>this.options.size&&(t=this.options.size);for(var i=e;t>=i;i++){var n=this.get(i);if(!n.length||n.hasClass("jcarousel-item-placeholder"))return!1}return!0},get:function(t){return e(">.jcarousel-item-"+t,this.list)},add:function(t,i){var s=this.get(t),a=0,o=e(i);if(0===s.length){var r,l=n.intval(t);for(s=this.create(t);;)if(r=this.get(--l),0>=l||r.length){0>=l?this.list.prepend(s):r.after(s);break}}else a=this.dimension(s);"LI"==o.get(0).nodeName.toUpperCase()?(s.replaceWith(o),s=o):s.empty().append(i),this.format(s.removeClass(this.className("jcarousel-item-placeholder")),t);var c=null!==this.options.visible?Math.ceil(this.clipping()/this.options.visible):null,h=this.dimension(s,c)-a;return t>0&&this.first>t&&this.list.css(this.lt,n.intval(this.list.css(this.lt))-h+"px"),this.list.css(this.wh,n.intval(this.list.css(this.wh))+h+"px"),s},remove:function(e){var t=this.get(e);if(t.length&&!(e>=this.first&&this.last>=e)){var i=this.dimension(t);this.first>e&&this.list.css(this.lt,n.intval(this.list.css(this.lt))+i+"px"),t.remove(),this.list.css(this.wh,n.intval(this.list.css(this.wh))-i+"px")}},next:function(){null===this.tail||this.inTail?this.scroll("both"!=this.options.wrap&&"last"!=this.options.wrap||null===this.options.size||this.last!=this.options.size?this.first+this.options.scroll:1):this.scrollTail(!1)},prev:function(){null!==this.tail&&this.inTail?this.scrollTail(!0):this.scroll("both"!=this.options.wrap&&"first"!=this.options.wrap||null===this.options.size||1!=this.first?this.first-this.options.scroll:this.options.size)},scrollTail:function(e){if(!this.locked&&!this.animating&&this.tail){this.pauseAuto();var t=n.intval(this.list.css(this.lt));t=e?t+this.tail:t-this.tail,this.inTail=!e,this.prevFirst=this.first,this.prevLast=this.last,this.animate(t)}},scroll:function(e,t){this.locked||this.animating||(this.pauseAuto(),this.animate(this.pos(e),t))},pos:function(e,t){var i=n.intval(this.list.css(this.lt));if(this.locked||this.animating)return i;"circular"!=this.options.wrap&&(e=1>e?1:this.options.size&&e>this.options.size?this.options.size:e);for(var s,a=this.first>e,o="circular"!=this.options.wrap&&1>=this.first?1:this.first,r=a?this.get(o):this.get(this.last),l=a?o:o-1,c=null,h=0,u=!1,d=0;a?--l>=e:e>++l;)c=this.get(l),u=!c.length,0===c.length&&(c=this.create(l).addClass(this.className("jcarousel-item-placeholder")),r[a?"before":"after"](c),null!==this.first&&"circular"==this.options.wrap&&null!==this.options.size&&(0>=l||l>this.options.size)&&(s=this.get(this.index(l)),s.length&&(c=this.add(l,s.clone(!0))))),r=c,d=this.dimension(c),u&&(h+=d),null!==this.first&&("circular"==this.options.wrap||l>=1&&(null===this.options.size||this.options.size>=l))&&(i=a?i+d:i-d);var p=this.clipping(),f=[],m=0,g=0;for(r=this.get(e-1),l=e;++m;){if(c=this.get(l),u=!c.length,0===c.length&&(c=this.create(l).addClass(this.className("jcarousel-item-placeholder")),0===r.length?this.list.prepend(c):r[a?"before":"after"](c),null!==this.first&&"circular"==this.options.wrap&&null!==this.options.size&&(0>=l||l>this.options.size)&&(s=this.get(this.index(l)),s.length&&(c=this.add(l,s.clone(!0))))),r=c,d=this.dimension(c),0===d)throw Error("jCarousel: No width/height set for items. This will cause an infinite loop. Aborting...");if("circular"!=this.options.wrap&&null!==this.options.size&&l>this.options.size?f.push(c):u&&(h+=d),g+=d,g>=p)break;l++}for(var v=0;f.length>v;v++)f[v].remove();h>0&&(this.list.css(this.wh,this.dimension(this.list)+h+"px"),a&&(i-=h,this.list.css(this.lt,n.intval(this.list.css(this.lt))-h+"px")));var b=e+m-1;if("circular"!=this.options.wrap&&this.options.size&&b>this.options.size&&(b=this.options.size),l>b)for(m=0,l=b,g=0;++m&&(c=this.get(l--),c.length)&&(g+=this.dimension(c),!(g>=p)););var y=b-m+1;if("circular"!=this.options.wrap&&1>y&&(y=1),this.inTail&&a&&(i+=this.tail,this.inTail=!1),this.tail=null,"circular"!=this.options.wrap&&b==this.options.size&&b-m+1>=1){var w=n.intval(this.get(b).css(this.options.vertical?"marginBottom":"marginRight"));g-w>p&&(this.tail=g-p-w)}for(t&&e===this.options.size&&this.tail&&(i-=this.tail,this.inTail=!0);e-- >y;)i+=this.dimension(this.get(e));return this.prevFirst=this.first,this.prevLast=this.last,this.first=y,this.last=b,i},animate:function(t,i){if(!this.locked&&!this.animating){this.animating=!0;var n=this,s=function(){if(n.animating=!1,0===t&&n.list.css(n.lt,0),!n.autoStopped&&("circular"==n.options.wrap||"both"==n.options.wrap||"last"==n.options.wrap||null===n.options.size||n.last<n.options.size||n.last==n.options.size&&null!==n.tail&&!n.inTail)&&n.startAuto(),n.buttons(),n.notify("onAfterAnimation"),"circular"==n.options.wrap&&null!==n.options.size)for(var e=n.prevFirst;n.prevLast>=e;e++)null===e||e>=n.first&&n.last>=e||!(1>e||e>n.options.size)||n.remove(e);
};if(this.notify("onBeforeAnimation"),this.options.animation&&i!==!1){var a=this.options.vertical?{top:t}:this.options.rtl?{right:t}:{left:t},o={duration:this.options.animation,easing:this.options.easing,complete:s};e.isFunction(this.options.animationStepCallback)&&(o.step=this.options.animationStepCallback),this.list.animate(a,o)}else this.list.css(this.lt,t+"px"),s()}},startAuto:function(e){if(void 0!==e&&(this.options.auto=e),0===this.options.auto)return this.stopAuto();if(null===this.timer){this.autoStopped=!1;var t=this;this.timer=window.setTimeout(function(){t.next()},1e3*this.options.auto)}},stopAuto:function(){this.pauseAuto(),this.autoStopped=!0},pauseAuto:function(){null!==this.timer&&(window.clearTimeout(this.timer),this.timer=null)},buttons:function(e,t){null==e&&(e=!this.locked&&0!==this.options.size&&(this.options.wrap&&"first"!=this.options.wrap||null===this.options.size||this.last<this.options.size),this.locked||this.options.wrap&&"first"!=this.options.wrap||null===this.options.size||!(this.last>=this.options.size)||(e=null!==this.tail&&!this.inTail)),null==t&&(t=!this.locked&&0!==this.options.size&&(this.options.wrap&&"last"!=this.options.wrap||this.first>1),this.locked||this.options.wrap&&"last"!=this.options.wrap||null===this.options.size||1!=this.first||(t=null!==this.tail&&this.inTail));var i=this;this.buttonNext.size()>0?(this.buttonNext.unbind(this.options.buttonNextEvent+".jcarousel",this.funcNext),e&&this.buttonNext.bind(this.options.buttonNextEvent+".jcarousel",this.funcNext),this.buttonNext[e?"removeClass":"addClass"](this.className("jcarousel-next-disabled")).attr("disabled",!e),null!==this.options.buttonNextCallback&&this.buttonNext.data("jcarouselstate")!=e&&this.buttonNext.each(function(){i.options.buttonNextCallback(i,this,e)}).data("jcarouselstate",e)):null!==this.options.buttonNextCallback&&this.buttonNextState!=e&&this.options.buttonNextCallback(i,null,e),this.buttonPrev.size()>0?(this.buttonPrev.unbind(this.options.buttonPrevEvent+".jcarousel",this.funcPrev),t&&this.buttonPrev.bind(this.options.buttonPrevEvent+".jcarousel",this.funcPrev),this.buttonPrev[t?"removeClass":"addClass"](this.className("jcarousel-prev-disabled")).attr("disabled",!t),null!==this.options.buttonPrevCallback&&this.buttonPrev.data("jcarouselstate")!=t&&this.buttonPrev.each(function(){i.options.buttonPrevCallback(i,this,t)}).data("jcarouselstate",t)):null!==this.options.buttonPrevCallback&&this.buttonPrevState!=t&&this.options.buttonPrevCallback(i,null,t),this.buttonNextState=e,this.buttonPrevState=t},notify:function(e){var t=null===this.prevFirst?"init":this.prevFirst<this.first?"next":"prev";this.callback("itemLoadCallback",e,t),this.prevFirst!==this.first&&(this.callback("itemFirstInCallback",e,t,this.first),this.callback("itemFirstOutCallback",e,t,this.prevFirst)),this.prevLast!==this.last&&(this.callback("itemLastInCallback",e,t,this.last),this.callback("itemLastOutCallback",e,t,this.prevLast)),this.callback("itemVisibleInCallback",e,t,this.first,this.last,this.prevFirst,this.prevLast),this.callback("itemVisibleOutCallback",e,t,this.prevFirst,this.prevLast,this.first,this.last)},callback:function(t,i,n,s,a,o,r){if(null!=this.options[t]&&("object"==typeof this.options[t]||"onAfterAnimation"==i)){var l="object"==typeof this.options[t]?this.options[t][i]:this.options[t];if(e.isFunction(l)){var c=this;if(void 0===s)l(c,n,i);else if(void 0===a)this.get(s).each(function(){l(c,this,s,n,i)});else for(var h=function(e){c.get(e).each(function(){l(c,this,e,n,i)})},u=s;a>=u;u++)null===u||u>=o&&r>=u||h(u)}}},create:function(e){return this.format("<li></li>",e)},format:function(t,i){t=e(t);for(var n=t.get(0).className.split(" "),s=0;n.length>s;s++)-1!=n[s].indexOf("jcarousel-")&&t.removeClass(n[s]);return t.addClass(this.className("jcarousel-item")).addClass(this.className("jcarousel-item-"+i)).css({float:this.options.rtl?"right":"left","list-style":"none"}).attr("jcarouselindex",i),t},className:function(e){return e+" "+e+(this.options.vertical?"-vertical":"-horizontal")},dimension:function(t,i){var s=e(t);if(null==i)return this.options.vertical?s.innerHeight()+n.intval(s.css("margin-top"))+n.intval(s.css("margin-bottom"))+n.intval(s.css("border-top-width"))+n.intval(s.css("border-bottom-width"))||n.intval(this.options.itemFallbackDimension):s.innerWidth()+n.intval(s.css("margin-left"))+n.intval(s.css("margin-right"))+n.intval(s.css("border-left-width"))+n.intval(s.css("border-right-width"))||n.intval(this.options.itemFallbackDimension);var a=this.options.vertical?i-n.intval(s.css("marginTop"))-n.intval(s.css("marginBottom")):i-n.intval(s.css("marginLeft"))-n.intval(s.css("marginRight"));return e(s).css(this.wh,a+"px"),this.dimension(s)},clipping:function(){return this.options.vertical?this.clip[0].offsetHeight-n.intval(this.clip.css("borderTopWidth"))-n.intval(this.clip.css("borderBottomWidth")):this.clip[0].offsetWidth-n.intval(this.clip.css("borderLeftWidth"))-n.intval(this.clip.css("borderRightWidth"))},index:function(e,t){return null==t&&(t=this.options.size),Math.round(((e-1)/t-Math.floor((e-1)/t))*t)+1}}),n.extend({defaults:function(i){return e.extend(t,i||{})},intval:function(e){return e=parseInt(e,10),isNaN(e)?0:e},windowLoaded:function(){i=!0},isSafari:function(){var e=navigator.userAgent.toLowerCase(),t=/(chrome)[ \/]([\w.]+)/.exec(e)||/(webkit)[ \/]([\w.]+)/.exec(e)||[],i=t[1]||"";return"webkit"===i}}),e.fn.jcarousel=function(t){if("string"==typeof t){var i=e(this).data("jcarousel"),s=Array.prototype.slice.call(arguments,1);return i[t].apply(i,s)}return this.each(function(){var i=e(this).data("jcarousel");i?(t&&e.extend(i.options,t),i.reload()):e(this).data("jcarousel",new n(this,t))})}}(jQuery);!function(e,t){function i(t,i){var s,a,o,r=t.nodeName.toLowerCase();return"area"===r?(s=t.parentNode,a=s.name,!(!t.href||!a||"map"!==s.nodeName.toLowerCase())&&(o=e("img[usemap=#"+a+"]")[0],!!o&&n(o))):(/input|select|textarea|button|object/.test(r)?!t.disabled:"a"===r?t.href||i:i)&&n(t)}function n(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")}).length}var s=0,a=/^ui-id-\d+$/;e.ui=e.ui||{};e.ui.version||(e.extend(e.ui,{version:"1.10.1",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({_focus:e.fn.focus,focus:function(t,i){return"number"==typeof t?this.each(function(){var n=this;setTimeout(function(){e(n).focus(),i&&i.call(n)},t)}):this._focus.apply(this,arguments)},scrollParent:function(){var t;return t=e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(i){if(i!==t)return this.css("zIndex",i);if(this.length)for(var n,s,a=e(this[0]);a.length&&a[0]!==document;){n=a.css("position");if("absolute"===n||"relative"===n||"fixed"===n){s=parseInt(a.css("zIndex"),10);if(!isNaN(s)&&0!==s)return s}a=a.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++s)})},removeUniqueId:function(){return this.each(function(){a.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,n){return!!e.data(t,n[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var n=e.attr(t,"tabindex"),s=isNaN(n);return(s||n>=0)&&i(t,!s)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(i,n){function s(t,i,n,s){return e.each(a,function(){i-=parseFloat(e.css(t,"padding"+this))||0,n&&(i-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(i-=parseFloat(e.css(t,"margin"+this))||0)}),i}var a="Width"===n?["Left","Right"]:["Top","Bottom"],o=n.toLowerCase(),r={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+n]=function(i){return i===t?r["inner"+n].call(this):this.each(function(){e(this).css(o,s(this,i)+"px")})},e.fn["outer"+n]=function(t,i){return"number"!=typeof t?r["outer"+n].call(this,t):this.each(function(){e(this).css(o,s(this,t,!0,i)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.support.selectstart="onselectstart"in document.createElement("div"),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,i,n){var s,a=e.ui[t].prototype;for(s in n)a.plugins[s]=a.plugins[s]||[],a.plugins[s].push([i,n[s]])},call:function(e,t,i){var n,s=e.plugins[t];if(s&&e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType)for(n=0;n<s.length;n++)e.options[s[n][0]]&&s[n][1].apply(e.element,i)}},hasScroll:function(t,i){if("hidden"===e(t).css("overflow"))return!1;var n=i&&"left"===i?"scrollLeft":"scrollTop",s=!1;return t[n]>0||(t[n]=1,s=t[n]>0,t[n]=0,s)}}))}(jQuery);!function(e,t){var i=0,n=Array.prototype.slice,s=e.cleanData;e.cleanData=function(t){for(var i,n=0;null!=(i=t[n]);n++)try{e(i).triggerHandler("remove")}catch(e){}s(t)},e.widget=function(t,i,n){var s,a,o,r,l={},c=t.split(".")[0];t=t.split(".")[1],s=c+"-"+t,n||(n=i,i=e.Widget),e.expr[":"][s.toLowerCase()]=function(t){return!!e.data(t,s)},e[c]=e[c]||{},a=e[c][t],o=e[c][t]=function(e,t){if(!this._createWidget)return new o(e,t);arguments.length&&this._createWidget(e,t)},e.extend(o,a,{version:n.version,_proto:e.extend({},n),_childConstructors:[]}),r=new i,r.options=e.widget.extend({},r.options),e.each(n,function(t,n){e.isFunction(n)?l[t]=function(){var e=function(){return i.prototype[t].apply(this,arguments)},s=function(e){return i.prototype[t].apply(this,e)};return function(){var t,i=this._super,a=this._superApply;return this._super=e,this._superApply=s,t=n.apply(this,arguments),this._super=i,this._superApply=a,t}}():l[t]=n}),o.prototype=e.widget.extend(r,{widgetEventPrefix:a?r.widgetEventPrefix:t},l,{constructor:o,namespace:c,widgetName:t,widgetFullName:s}),a?(e.each(a._childConstructors,function(t,i){var n=i.prototype;e.widget(n.namespace+"."+n.widgetName,o,i._proto)}),delete a._childConstructors):i._childConstructors.push(o),e.widget.bridge(t,o)},e.widget.extend=function(i){for(var s,a,o=n.call(arguments,1),r=0,l=o.length;r<l;r++)for(s in o[r])a=o[r][s],o[r].hasOwnProperty(s)&&a!==t&&(e.isPlainObject(a)?i[s]=e.isPlainObject(i[s])?e.widget.extend({},i[s],a):e.widget.extend({},a):i[s]=a);return i},e.widget.bridge=function(i,s){var a=s.prototype.widgetFullName||i;e.fn[i]=function(o){var r="string"==typeof o,l=n.call(arguments,1),c=this;return o=!r&&l.length?e.widget.extend.apply(null,[o].concat(l)):o,r?this.each(function(){var n,s=e.data(this,a);if(!s)return e.error("cannot call methods on "+i+" prior to initialization; attempted to call method '"+o+"'");if(!e.isFunction(s[o])||"_"===o.charAt(0))return e.error("no such method '"+o+"' for "+i+" widget instance");n=s[o].apply(s,l);return n!==s&&n!==t?(c=n&&n.jquery?c.pushStack(n.get()):n,!1):void 0}):this.each(function(){var t=e.data(this,a);t?t.option(o||{})._init():e.data(this,a,new s(o,this))}),c}},e.Widget=function(){},e.Widget._childConstructors=[],e.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(t,n){n=e(n||this.defaultElement||this)[0],this.element=e(n),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=e.widget.extend({},this.options,this._getCreateOptions(),t),this.bindings=e(),this.hoverable=e(),this.focusable=e(),n!==this&&(e.data(n,this.widgetFullName,this),this._on(!0,this.element,{remove:function(e){e.target===n&&this.destroy()}}),this.document=e(n.style?n.ownerDocument:n.document||n),this.window=e(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:e.noop,_getCreateEventData:e.noop,_create:e.noop,_init:e.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:e.noop,widget:function(){return this.element},option:function(i,n){var s,a,o,r=i;if(0===arguments.length)return e.widget.extend({},this.options);if("string"==typeof i){r={},s=i.split("."),i=s.shift();if(s.length){a=r[i]=e.widget.extend({},this.options[i]);for(o=0;o<s.length-1;o++)a[s[o]]=a[s[o]]||{},a=a[s[o]];i=s.pop();if(n===t)return a[i]===t?null:a[i];a[i]=n}else{if(n===t)return this.options[i]===t?null:this.options[i];r[i]=n}}return this._setOptions(r),this},_setOptions:function(e){var t;for(t in e)this._setOption(t,e[t]);return this},_setOption:function(e,t){return this.options[e]=t,"disabled"===e&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!t).attr("aria-disabled",t),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(t,i,n){var s,a=this;"boolean"!=typeof t&&(n=i,i=t,t=!1),n?(i=s=e(i),this.bindings=this.bindings.add(i)):(n=i,i=this.element,s=this.widget()),e.each(n,function(n,o){function r(){if(t||a.options.disabled!==!0&&!e(this).hasClass("ui-state-disabled"))return("string"==typeof o?a[o]:o).apply(a,arguments)}"string"!=typeof o&&(r.guid=o.guid=o.guid||r.guid||e.guid++);var l=n.match(/^(\w+)\s*(.*)$/),c=l[1]+a.eventNamespace,h=l[2];h?s.delegate(h,c,r):i.bind(c,r)})},_off:function(e,t){t=(t||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(t).undelegate(t)},_delay:function(e,t){function i(){return("string"==typeof e?n[e]:e).apply(n,arguments)}var n=this;return setTimeout(i,t||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){e(t.currentTarget).addClass("ui-state-hover")},mouseleave:function(t){e(t.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){e(t.currentTarget).addClass("ui-state-focus")},focusout:function(t){e(t.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(t,i,n){var s,a,o=this.options[t];n=n||{},i=e.Event(i),i.type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),i.target=this.element[0],a=i.originalEvent;if(a)for(s in a)s in i||(i[s]=a[s]);return this.element.trigger(i,n),!(e.isFunction(o)&&o.apply(this.element[0],[i].concat(n))===!1||i.isDefaultPrevented())}},e.each({show:"fadeIn",hide:"fadeOut"},function(t,i){e.Widget.prototype["_"+t]=function(n,s,a){"string"==typeof s&&(s={effect:s});var o,r=s?s===!0||"number"==typeof s?i:s.effect||i:t;s=s||{},"number"==typeof s&&(s={duration:s}),o=!e.isEmptyObject(s),s.complete=a,s.delay&&n.delay(s.delay),o&&e.effects&&e.effects.effect[r]?n[t](s):r!==t&&n[r]?n[r](s.duration,s.easing,a):n.queue(function(i){e(this)[t](),a&&a.call(n[0]),i()})}})}(jQuery);!function(e,t){var i=!1;e(document).mouseup(function(){i=!1}),e.widget("ui.mouse",{version:"1.10.1",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var t=this;this.element.bind("mousedown."+this.widgetName,function(e){return t._mouseDown(e)}).bind("click."+this.widgetName,function(i){if(!0===e.data(i.target,t.widgetName+".preventClickEvent"))return e.removeData(i.target,t.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){if(!i){this._mouseStarted&&this._mouseUp(t),this._mouseDownEvent=t;var n=this,s=1===t.which,a=!("string"!=typeof this.options.cancel||!t.target.nodeName)&&e(t.target).closest(this.options.cancel).length;if(!s||a||!this._mouseCapture(t))return!0;this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){n.mouseDelayMet=!0},this.options.delay));if(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)){this._mouseStarted=this._mouseStart(t)!==!1;if(!this._mouseStarted)return t.preventDefault(),!0}return!0===e.data(t.target,this.widgetName+".preventClickEvent")&&e.removeData(t.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(e){return n._mouseMove(e)},this._mouseUpDelegate=function(e){return n._mouseUp(e)},e(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),t.preventDefault(),i=!0,!0}},_mouseMove:function(t){return e.ui.ie&&(!document.documentMode||document.documentMode<9)&&!t.button?this._mouseUp(t):this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,t)!==!1,this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){return e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&e.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),!1},_mouseDistanceMet:function(e){return Math.max(Math.abs(this._mouseDownEvent.pageX-e.pageX),Math.abs(this._mouseDownEvent.pageY-e.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})}(jQuery);!function(e,t){function i(e,t,i){return[parseFloat(e[0])*(p.test(e[0])?t/100:1),parseFloat(e[1])*(p.test(e[1])?i/100:1)]}function n(t,i){return parseInt(e.css(t,i),10)||0}function s(t){var i=t[0];return 9===i.nodeType?{width:t.width(),height:t.height(),offset:{top:0,left:0}}:e.isWindow(i)?{width:t.width(),height:t.height(),offset:{top:t.scrollTop(),left:t.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:t.outerWidth(),height:t.outerHeight(),offset:t.offset()}}e.ui=e.ui||{};var a,o=Math.max,r=Math.abs,l=Math.round,c=/left|center|right/,h=/top|center|bottom/,u=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=e.fn.position;e.position={scrollbarWidth:function(){if(a!==t)return a;var i,n,s=e("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=s.children()[0];return e("body").append(s),i=o.offsetWidth,s.css("overflow","scroll"),n=o.offsetWidth,i===n&&(n=s[0].clientWidth),s.remove(),a=i-n},getScrollInfo:function(t){var i=t.isWindow?"":t.element.css("overflow-x"),n=t.isWindow?"":t.element.css("overflow-y"),s="scroll"===i||"auto"===i&&t.width<t.element[0].scrollWidth,a="scroll"===n||"auto"===n&&t.height<t.element[0].scrollHeight;return{width:s?e.position.scrollbarWidth():0,height:a?e.position.scrollbarWidth():0}},getWithinInfo:function(t){var i=e(t||window),n=e.isWindow(i[0]);return{element:i,isWindow:n,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:n?i.width():i.outerWidth(),height:n?i.height():i.outerHeight()}}},e.fn.position=function(t){if(!t||!t.of)return f.apply(this,arguments);t=e.extend({},t);var a,p,m,g,v,b,y=e(t.of),w=e.position.getWithinInfo(t.within),x=e.position.getScrollInfo(w),k=(t.collision||"flip").split(" "),_={};return b=s(y),y[0].preventDefault&&(t.at="left top"),p=b.width,m=b.height,g=b.offset,v=e.extend({},g),e.each(["my","at"],function(){var e,i,n=(t[this]||"").split(" ");1===n.length&&(n=c.test(n[0])?n.concat(["center"]):h.test(n[0])?["center"].concat(n):["center","center"]),n[0]=c.test(n[0])?n[0]:"center",n[1]=h.test(n[1])?n[1]:"center",e=u.exec(n[0]),i=u.exec(n[1]),_[this]=[e?e[0]:0,i?i[0]:0],t[this]=[d.exec(n[0])[0],d.exec(n[1])[0]]}),1===k.length&&(k[1]=k[0]),"right"===t.at[0]?v.left+=p:"center"===t.at[0]&&(v.left+=p/2),"bottom"===t.at[1]?v.top+=m:"center"===t.at[1]&&(v.top+=m/2),a=i(_.at,p,m),v.left+=a[0],v.top+=a[1],this.each(function(){var s,c,h=e(this),u=h.outerWidth(),d=h.outerHeight(),f=n(this,"marginLeft"),b=n(this,"marginTop"),C=u+f+n(this,"marginRight")+x.width,T=d+b+n(this,"marginBottom")+x.height,S=e.extend({},v),E=i(_.my,h.outerWidth(),h.outerHeight());"right"===t.my[0]?S.left-=u:"center"===t.my[0]&&(S.left-=u/2),"bottom"===t.my[1]?S.top-=d:"center"===t.my[1]&&(S.top-=d/2),S.left+=E[0],S.top+=E[1],e.support.offsetFractions||(S.left=l(S.left),S.top=l(S.top)),s={marginLeft:f,marginTop:b},e.each(["left","top"],function(i,n){e.ui.position[k[i]]&&e.ui.position[k[i]][n](S,{targetWidth:p,targetHeight:m,elemWidth:u,elemHeight:d,collisionPosition:s,collisionWidth:C,collisionHeight:T,offset:[a[0]+E[0],a[1]+E[1]],my:t.my,at:t.at,within:w,elem:h})}),t.using&&(c=function(e){var i=g.left-S.left,n=i+p-u,s=g.top-S.top,a=s+m-d,l={target:{element:y,left:g.left,top:g.top,width:p,height:m},element:{element:h,left:S.left,top:S.top,width:u,height:d},horizontal:n<0?"left":i>0?"right":"center",vertical:a<0?"top":s>0?"bottom":"middle"};p<u&&r(i+n)<p&&(l.horizontal="center"),m<d&&r(s+a)<m&&(l.vertical="middle"),o(r(i),r(n))>o(r(s),r(a))?l.important="horizontal":l.important="vertical",t.using.call(this,e,l)}),h.offset(e.extend(S,{using:c}))})},e.ui.position={fit:{left:function(e,t){var i,n=t.within,s=n.isWindow?n.scrollLeft:n.offset.left,a=n.width,r=e.left-t.collisionPosition.marginLeft,l=s-r,c=r+t.collisionWidth-a-s;t.collisionWidth>a?l>0&&c<=0?(i=e.left+l+t.collisionWidth-a-s,e.left+=l-i):c>0&&l<=0?e.left=s:l>c?e.left=s+a-t.collisionWidth:e.left=s:l>0?e.left+=l:c>0?e.left-=c:e.left=o(e.left-r,e.left)},top:function(e,t){var i,n=t.within,s=n.isWindow?n.scrollTop:n.offset.top,a=t.within.height,r=e.top-t.collisionPosition.marginTop,l=s-r,c=r+t.collisionHeight-a-s;t.collisionHeight>a?l>0&&c<=0?(i=e.top+l+t.collisionHeight-a-s,e.top+=l-i):c>0&&l<=0?e.top=s:l>c?e.top=s+a-t.collisionHeight:e.top=s:l>0?e.top+=l:c>0?e.top-=c:e.top=o(e.top-r,e.top)}},flip:{left:function(e,t){var i,n,s=t.within,a=s.offset.left+s.scrollLeft,o=s.width,l=s.isWindow?s.scrollLeft:s.offset.left,c=e.left-t.collisionPosition.marginLeft,h=c-l,u=c+t.collisionWidth-o-l,d="left"===t.my[0]?-t.elemWidth:"right"===t.my[0]?t.elemWidth:0,p="left"===t.at[0]?t.targetWidth:"right"===t.at[0]?-t.targetWidth:0,f=-2*t.offset[0];if(h<0){i=e.left+d+p+f+t.collisionWidth-o-a;(i<0||i<r(h))&&(e.left+=d+p+f)}else if(u>0){n=e.left-t.collisionPosition.marginLeft+d+p+f-l;(n>0||r(n)<u)&&(e.left+=d+p+f)}},top:function(e,t){var i,n,s=t.within,a=s.offset.top+s.scrollTop,o=s.height,l=s.isWindow?s.scrollTop:s.offset.top,c=e.top-t.collisionPosition.marginTop,h=c-l,u=c+t.collisionHeight-o-l,d="top"===t.my[1],p=d?-t.elemHeight:"bottom"===t.my[1]?t.elemHeight:0,f="top"===t.at[1]?t.targetHeight:"bottom"===t.at[1]?-t.targetHeight:0,m=-2*t.offset[1];h<0?(n=e.top+p+f+m+t.collisionHeight-o-a,e.top+p+f+m>h&&(n<0||n<r(h))&&(e.top+=p+f+m)):u>0&&(i=e.top-t.collisionPosition.marginTop+p+f+m-l,e.top+p+f+m>u&&(i>0||r(i)<u)&&(e.top+=p+f+m))}},flipfit:{left:function(){e.ui.position.flip.left.apply(this,arguments),e.ui.position.fit.left.apply(this,arguments)},top:function(){e.ui.position.flip.top.apply(this,arguments),e.ui.position.fit.top.apply(this,arguments)}}},function(){var t,i,n,s,a,o=document.getElementsByTagName("body")[0],r=document.createElement("div");t=document.createElement(o?"div":"body"),n={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},o&&e.extend(n,{position:"absolute",left:"-1000px",top:"-1000px"});for(a in n)t.style[a]=n[a];t.appendChild(r),i=o||document.documentElement,i.insertBefore(t,i.firstChild),r.style.cssText="position: absolute; left: 10.7432222px;",s=e(r).offset().left,e.support.offsetFractions=s>10&&s<11,t.innerHTML="",i.removeChild(t)}()}(jQuery);!function(e,t){var i=0;e.widget("ui.autocomplete",{version:"1.10.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},pending:0,_create:function(){var t,i,n,s=this.element[0].nodeName.toLowerCase(),a="textarea"===s,o="input"===s;this.isMultiLine=!!a||!o&&this.element.prop("isContentEditable"),this.valueMethod=this.element[a||o?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(s){if(this.element.prop("readOnly"))t=!0,n=!0,i=!0;else{t=!1,n=!1,i=!1;var a=e.ui.keyCode;switch(s.keyCode){case a.PAGE_UP:t=!0,this._move("previousPage",s);break;case a.PAGE_DOWN:t=!0,this._move("nextPage",s);break;case a.UP:t=!0,this._keyEvent("previous",s);break;case a.DOWN:t=!0,this._keyEvent("next",s);break;case a.ENTER:case a.NUMPAD_ENTER:this.menu.active&&(t=!0,s.preventDefault(),this.menu.select(s));break;case a.TAB:this.menu.active&&this.menu.select(s);break;case a.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(s),s.preventDefault());break;default:i=!0,this._searchTimeout(s)}}},keypress:function(n){if(t)t=!1,n.preventDefault();else if(!i){var s=e.ui.keyCode;switch(n.keyCode){case s.PAGE_UP:this._move("previousPage",n);break;case s.PAGE_DOWN:this._move("nextPage",n);break;case s.UP:this._keyEvent("previous",n);break;case s.DOWN:this._keyEvent("next",n)}}},input:function(e){n?(n=!1,e.preventDefault()):this._searchTimeout(e)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(e){this.cancelBlur?delete this.cancelBlur:(clearTimeout(this.searching),this.close(e),this._change(e))}}),this._initSource(),this.menu=e("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({input:e(),role:null}).hide().data("ui-menu"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];e(t.target).closest(".ui-menu-item").length||this._delay(function(){var t=this;this.document.one("mousedown",function(n){n.target!==t.element[0]&&n.target!==i&&!e.contains(i,n.target)&&t.close()})})},menufocus:function(t,i){if(this.isNewMenu){this.isNewMenu=!1;if(t.originalEvent&&/^mouse/.test(t.originalEvent.type)){this.menu.blur(),this.document.one("mousemove",function(){e(t.target).trigger(t.originalEvent)});return}}var n=i.item.data("ui-autocomplete-item");!1!==this._trigger("focus",t,{item:n})?t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(n.value):this.liveRegion.text(n.value)},menuselect:function(e,t){var i=t.item.data("ui-autocomplete-item"),n=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=n,this._delay(function(){this.previous=n,this.selectedItem=i})),!1!==this._trigger("select",e,{item:i})&&this._value(i.value),this.term=this._value(),this.close(e),this.selectedItem=i}}),this.liveRegion=e("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertAfter(this.element),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(e,t){this._super(e,t),"source"===e&&this._initSource(),"appendTo"===e&&this.menu.element.appendTo(this._appendTo()),"disabled"===e&&t&&this.xhr&&this.xhr.abort()},_appendTo:function(){var t=this.options.appendTo;return t&&(t=t.jquery||t.nodeType?e(t):this.document.find(t).eq(0)),t||(t=this.element.closest(".ui-front")),t.length||(t=this.document[0].body),t},_initSource:function(){var t,i,n=this;e.isArray(this.options.source)?(t=this.options.source,this.source=function(i,n){n(e.ui.autocomplete.filter(t,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(t,s){n.xhr&&n.xhr.abort(),n.xhr=e.ajax({url:i,data:t,dataType:"json",success:function(e){s(e)},error:function(){s([])}})}):this.source=this.options.source},_searchTimeout:function(e){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,e))},this.options.delay)},search:function(e,t){e=null!=e?e:this._value(),this.term=this._value();return e.length<this.options.minLength?this.close(t):this._trigger("search",t)!==!1?this._search(e):void 0},_search:function(e){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:e},this._response())},_response:function(){var e=this,t=++i;return function(n){t===i&&e.__response(n),e.pending--,e.pending||e.element.removeClass("ui-autocomplete-loading")}},__response:function(e){e&&(e=this._normalize(e)),this._trigger("response",null,{content:e}),!this.options.disabled&&e&&e.length&&!this.cancelSearch?(this._suggest(e),this._trigger("open")):this._close()},close:function(e){this.cancelSearch=!0,this._close(e)},_close:function(e){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",e))},_change:function(e){this.previous!==this._value()&&this._trigger("change",e,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:e.map(t,function(t){return"string"==typeof t?{label:t,value:t}:e.extend({label:t.label||t.value,value:t.value||t.label},t)})},_suggest:function(t){var i=this.menu.element.empty();this._renderMenu(i,t),this.menu.refresh(),i.show(),this._resizeMenu(),i.position(e.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var e=this.menu.element;e.outerWidth(Math.max(e.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(t,i){var n=this;e.each(i,function(e,i){n._renderItemData(t,i)})},_renderItemData:function(e,t){return this._renderItem(e,t).data("ui-autocomplete-item",t)},_renderItem:function(t,i){return e("<li>").append(e("<a>").text(i.label)).appendTo(t)},_move:function(e,t){this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(e)||this.menu.isLastItem()&&/^next/.test(e)?(this._value(this.term),this.menu.blur()):this.menu[e](t):this.search(null,t)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(e,t){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(e,t),t.preventDefault())}}),e.extend(e.ui.autocomplete,{escapeRegex:function(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,i){var n=new RegExp(e.ui.autocomplete.escapeRegex(i),"i");
return e.grep(t,function(e){return n.test(e.label||e.value||e)})}}),e.widget("ui.autocomplete",e.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(e){return e+(e>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var t;this._superApply(arguments);this.options.disabled||this.cancelSearch||(t=e&&e.length?this.options.messages.results(e.length):this.options.messages.noResults,this.liveRegion.text(t))}})}(jQuery);!function(e,t){var i,n,s,a,o="ui-button ui-widget ui-state-default ui-corner-all",r="ui-state-hover ui-state-active ",l="ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",c=function(){var t=e(this).find(":ui-button");setTimeout(function(){t.button("refresh")},1)},h=function(t){var i=t.name,n=t.form,s=e([]);return i&&(i=i.replace(/'/g,"\\'"),s=n?e(n).find("[name='"+i+"']"):e("[name='"+i+"']",t.ownerDocument).filter(function(){return!this.form})),s};e.widget("ui.button",{version:"1.10.1",defaultElement:"<button>",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest("form").unbind("reset"+this.eventNamespace).bind("reset"+this.eventNamespace,c),"boolean"!=typeof this.options.disabled?this.options.disabled=!!this.element.prop("disabled"):this.element.prop("disabled",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr("title");var t=this,r=this.options,l="checkbox"===this.type||"radio"===this.type,u=l?"":"ui-state-active",d="ui-state-focus";null===r.label&&(r.label="input"===this.type?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(o).attr("role","button").bind("mouseenter"+this.eventNamespace,function(){r.disabled||this===i&&e(this).addClass("ui-state-active")}).bind("mouseleave"+this.eventNamespace,function(){r.disabled||e(this).removeClass(u)}).bind("click"+this.eventNamespace,function(e){r.disabled&&(e.preventDefault(),e.stopImmediatePropagation())}),this.element.bind("focus"+this.eventNamespace,function(){t.buttonElement.addClass(d)}).bind("blur"+this.eventNamespace,function(){t.buttonElement.removeClass(d)}),l&&(this.element.bind("change"+this.eventNamespace,function(){a||t.refresh()}),this.buttonElement.bind("mousedown"+this.eventNamespace,function(e){r.disabled||(a=!1,n=e.pageX,s=e.pageY)}).bind("mouseup"+this.eventNamespace,function(e){r.disabled||n===e.pageX&&s===e.pageY||(a=!0)})),"checkbox"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){if(r.disabled||a)return!1}):"radio"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){if(r.disabled||a)return!1;e(this).addClass("ui-state-active"),t.buttonElement.attr("aria-pressed","true");var i=t.element[0];h(i).not(i).map(function(){return e(this).button("widget")[0]}).removeClass("ui-state-active").attr("aria-pressed","false")}):(this.buttonElement.bind("mousedown"+this.eventNamespace,function(){if(r.disabled)return!1;e(this).addClass("ui-state-active"),i=this,t.document.one("mouseup",function(){i=null})}).bind("mouseup"+this.eventNamespace,function(){if(r.disabled)return!1;e(this).removeClass("ui-state-active")}).bind("keydown"+this.eventNamespace,function(t){if(r.disabled)return!1;(t.keyCode===e.ui.keyCode.SPACE||t.keyCode===e.ui.keyCode.ENTER)&&e(this).addClass("ui-state-active")}).bind("keyup"+this.eventNamespace+" blur"+this.eventNamespace,function(){e(this).removeClass("ui-state-active")}),this.buttonElement.is("a")&&this.buttonElement.keyup(function(t){t.keyCode===e.ui.keyCode.SPACE&&e(this).click()})),this._setOption("disabled",r.disabled),this._resetButton()},_determineButtonType:function(){var e,t,i;this.element.is("[type=checkbox]")?this.type="checkbox":this.element.is("[type=radio]")?this.type="radio":this.element.is("input")?this.type="input":this.type="button","checkbox"===this.type||"radio"===this.type?(e=this.element.parents().last(),t="label[for='"+this.element.attr("id")+"']",this.buttonElement=e.find(t),this.buttonElement.length||(e=e.length?e.siblings():this.element.siblings(),this.buttonElement=e.filter(t),this.buttonElement.length||(this.buttonElement=e.find(t))),this.element.addClass("ui-helper-hidden-accessible"),i=this.element.is(":checked"),i&&this.buttonElement.addClass("ui-state-active"),this.buttonElement.prop("aria-pressed",i)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass("ui-helper-hidden-accessible"),this.buttonElement.removeClass(o+" "+r+" "+l).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()),this.hasTitle||this.buttonElement.removeAttr("title")},_setOption:function(e,t){this._super(e,t);"disabled"!==e?this._resetButton():t?this.element.prop("disabled",!0):this.element.prop("disabled",!1)},refresh:function(){var t=this.element.is("input, button")?this.element.is(":disabled"):this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOption("disabled",t),"radio"===this.type?h(this.element[0]).each(function(){e(this).is(":checked")?e(this).button("widget").addClass("ui-state-active").attr("aria-pressed","true"):e(this).button("widget").removeClass("ui-state-active").attr("aria-pressed","false")}):"checkbox"===this.type&&(this.element.is(":checked")?this.buttonElement.addClass("ui-state-active").attr("aria-pressed","true"):this.buttonElement.removeClass("ui-state-active").attr("aria-pressed","false"))},_resetButton:function(){if("input"!==this.type){var t=this.buttonElement.removeClass(l),i=e("<span></span>",this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(t.empty()).text(),n=this.options.icons,s=n.primary&&n.secondary,a=[];n.primary||n.secondary?(this.options.text&&a.push("ui-button-text-icon"+(s?"s":n.primary?"-primary":"-secondary")),n.primary&&t.prepend("<span class='ui-button-icon-primary ui-icon "+n.primary+"'></span>"),n.secondary&&t.append("<span class='ui-button-icon-secondary ui-icon "+n.secondary+"'></span>"),this.options.text||(a.push(s?"ui-button-icons-only":"ui-button-icon-only"),this.hasTitle||t.attr("title",e.trim(i)))):a.push("ui-button-text-only"),t.addClass(a.join(" "))}else this.options.label&&this.element.val(this.options.label)}}),e.widget("ui.buttonset",{version:"1.10.1",options:{items:"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"},_create:function(){this.element.addClass("ui-buttonset")},_init:function(){this.refresh()},_setOption:function(e,t){"disabled"===e&&this.buttons.button("option",e,t),this._super(e,t)},refresh:function(){var t="rtl"===this.element.css("direction");this.buttons=this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(t?"ui-corner-right":"ui-corner-left").end().filter(":last").addClass(t?"ui-corner-left":"ui-corner-right").end().end()},_destroy:function(){this.element.removeClass("ui-buttonset"),this.buttons.map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-left ui-corner-right").end().button("destroy")}})}(jQuery);!function(e,t){function i(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[""]),this.dpDiv=n(e("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function n(t){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.delegate(i,"mouseout",function(){e(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).removeClass("ui-datepicker-next-hover")}).delegate(i,"mouseover",function(){e.datepicker._isDisabledDatepicker(a.inline?t.parent()[0]:a.input[0])||(e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),e(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).addClass("ui-datepicker-next-hover"))})}function s(t,i){e.extend(t,i);for(var n in i)null==i[n]&&(t[n]=i[n]);return t}e.extend(e.ui,{datepicker:{version:"1.10.1"}});var a,o="datepicker",r=(new Date).getTime();e.extend(i.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return s(this._defaults,e||{}),this},_attachDatepicker:function(t,i){var n,s,a;n=t.nodeName.toLowerCase(),s="div"===n||"span"===n,t.id||(this.uuid+=1,t.id="dp"+this.uuid),a=this._newInst(e(t),s),a.settings=e.extend({},i||{}),"input"===n?this._connectDatepicker(t,a):s&&this._inlineDatepicker(t,a)},_newInst:function(t,i){var s=t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:s,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?n(e("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,i){var n=e(t);i.append=e([]),i.trigger=e([]);n.hasClass(this.markerClassName)||(this._attachments(n,i),n.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(i),e.data(t,o,i),i.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,i){var n,s,a,o=this._get(i,"appendText"),r=this._get(i,"isRTL");i.append&&i.append.remove(),o&&(i.append=e("<span class='"+this._appendClass+"'>"+o+"</span>"),t[r?"before":"after"](i.append)),t.unbind("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),n=this._get(i,"showOn"),("focus"===n||"both"===n)&&t.focus(this._showDatepicker);"button"!==n&&"both"!==n||(s=this._get(i,"buttonText"),a=this._get(i,"buttonImage"),i.trigger=e(this._get(i,"buttonImageOnly")?e("<img/>").addClass(this._triggerClass).attr({src:a,alt:s,title:s}):e("<button type='button'></button>").addClass(this._triggerClass).html(a?e("<img/>").attr({src:a,alt:s,title:s}):s)),t[r?"before":"after"](i.trigger),i.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1}))},_autoSize:function(e){if(this._get(e,"autoSize")&&!e.inline){var t,i,n,s,a=new Date(2009,11,20),o=this._get(e,"dateFormat");o.match(/[DM]/)&&(t=function(e){i=0,n=0;for(s=0;s<e.length;s++)e[s].length>i&&(i=e[s].length,n=s);return n},a.setMonth(t(this._get(e,o.match(/MM/)?"monthNames":"monthNamesShort"))),a.setDate(t(this._get(e,o.match(/DD/)?"dayNames":"dayNamesShort"))+20-a.getDay())),e.input.attr("size",this._formatDate(e,a).length)}},_inlineDatepicker:function(t,i){var n=e(t);n.hasClass(this.markerClassName)||(n.addClass(this.markerClassName).append(i.dpDiv),e.data(t,o,i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(t),i.dpDiv.css("display","block"))},_dialogDatepicker:function(t,i,n,a,r){var l,c,h,u,d,p=this._dialogInst;return p||(this.uuid+=1,l="dp"+this.uuid,this._dialogInput=e("<input type='text' id='"+l+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),e("body").append(this._dialogInput),p=this._dialogInst=this._newInst(this._dialogInput,!1),p.settings={},e.data(this._dialogInput[0],o,p)),s(p.settings,a||{}),i=i&&i.constructor===Date?this._formatDate(p,i):i,this._dialogInput.val(i),this._pos=r?r.length?r:[r.pageX,r.pageY]:null,this._pos||(c=document.documentElement.clientWidth,h=document.documentElement.clientHeight,u=document.documentElement.scrollLeft||document.body.scrollLeft,d=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[c/2-100+u,h/2-150+d]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),p.settings.onSelect=n,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],o,p),this},_destroyDatepicker:function(t){var i,n=e(t),s=e.data(t,o);n.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),e.removeData(t,o),"input"===i?(s.append.remove(),s.trigger.remove(),n.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):("div"===i||"span"===i)&&n.removeClass(this.markerClassName).empty())},_enableDatepicker:function(t){var i,n,s=e(t),a=e.data(t,o);if(s.hasClass(this.markerClassName)){i=t.nodeName.toLowerCase();"input"===i?(t.disabled=!1,a.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==i&&"span"!==i||(n=s.children("."+this._inlineClass),n.children().removeClass("ui-state-disabled"),n.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1));this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e})}},_disableDatepicker:function(t){var i,n,s=e(t),a=e.data(t,o);if(s.hasClass(this.markerClassName)){i=t.nodeName.toLowerCase();"input"===i?(t.disabled=!0,a.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==i&&"span"!==i||(n=s.children("."+this._inlineClass),n.children().addClass("ui-state-disabled"),n.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0));this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t}},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;t<this._disabledInputs.length;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,o)}catch(e){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(i,n,a){var o,r,l,c,h=this._getInst(i);if(2===arguments.length&&"string"==typeof n)return"defaults"===n?e.extend({},e.datepicker._defaults):h?"all"===n?e.extend({},h.settings):this._get(h,n):null;o=n||{},"string"==typeof n&&(o={},o[n]=a),h&&(this._curInst===h&&this._hideDatepicker(),r=this._getDateDatepicker(i,!0),l=this._getMinMaxDate(h,"min"),c=this._getMinMaxDate(h,"max"),s(h.settings,o),null!==l&&o.dateFormat!==t&&o.minDate===t&&(h.settings.minDate=this._formatDate(h,l)),null!==c&&o.dateFormat!==t&&o.maxDate===t&&(h.settings.maxDate=this._formatDate(h,c)),"disabled"in o&&(o.disabled?this._disableDatepicker(i):this._enableDatepicker(i)),this._attachments(e(i),h),this._autoSize(h),this._setDate(h,r),this._updateAlternate(h),this._updateDatepicker(h))},_changeDatepicker:function(e,t,i){this._optionDatepicker(e,t,i)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var i=this._getInst(e);i&&(this._setDate(i,t),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(e,t){var i=this._getInst(e);return i&&!i.inline&&this._setDateFromField(i,t),i?this._getDate(i):null},_doKeyDown:function(t){var i,n,s,a=e.datepicker._getInst(t.target),o=!0,r=a.dpDiv.is(".ui-datepicker-rtl");a._keyEvent=!0;if(e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),o=!1;break;case 13:return s=e("td."+e.datepicker._dayOverClass+":not(."+e.datepicker._currentClass+")",a.dpDiv),s[0]&&e.datepicker._selectDay(t.target,a.selectedMonth,a.selectedYear,s[0]),i=e.datepicker._get(a,"onSelect"),i?(n=e.datepicker._formatDate(a),i.apply(a.input?a.input[0]:null,[n,a])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(a,"stepBigMonths"):-e.datepicker._get(a,"stepMonths"),"M");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(a,"stepBigMonths"):+e.datepicker._get(a,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),o=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),o=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,r?1:-1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(a,"stepBigMonths"):-e.datepicker._get(a,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,"D"),o=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,r?-1:1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(a,"stepBigMonths"):+e.datepicker._get(a,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,"D"),o=t.ctrlKey||t.metaKey;break;default:o=!1}else 36===t.keyCode&&t.ctrlKey?e.datepicker._showDatepicker(this):o=!1;o&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var i,n,s=e.datepicker._getInst(t.target);if(e.datepicker._get(s,"constrainInput"))return i=e.datepicker._possibleChars(e.datepicker._get(s,"dateFormat")),n=String.fromCharCode(null==t.charCode?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||n<" "||!i||i.indexOf(n)>-1},_doKeyUp:function(t){var i,n=e.datepicker._getInst(t.target);if(n.input.val()!==n.lastVal)try{i=e.datepicker.parseDate(e.datepicker._get(n,"dateFormat"),n.input?n.input.val():null,e.datepicker._getFormatConfig(n)),i&&(e.datepicker._setDateFromField(n),e.datepicker._updateAlternate(n),e.datepicker._updateDatepicker(n))}catch(e){}return!0},_showDatepicker:function(t){t=t.target||t,"input"!==t.nodeName.toLowerCase()&&(t=e("input",t.parentNode)[0]);if(!e.datepicker._isDisabledDatepicker(t)&&e.datepicker._lastInput!==t){var i,n,a,o,r,l,c;i=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==i&&(e.datepicker._curInst.dpDiv.stop(!0,!0),i&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),n=e.datepicker._get(i,"beforeShow"),a=n?n.apply(t,[t,i]):{};a!==!1&&(s(i.settings,a),i.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(i),e.datepicker._inDialog&&(t.value=""),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),o=!1,e(t).parents().each(function(){return o|="fixed"===e(this).css("position"),!o}),r={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,i.dpDiv.empty(),i.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),e.datepicker._updateDatepicker(i),r=e.datepicker._checkOffset(i,r,o),i.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?"static":o?"fixed":"absolute",display:"none",left:r.left+"px",top:r.top+"px"}),i.inline||(l=e.datepicker._get(i,"showAnim"),c=e.datepicker._get(i,"duration"),i.dpDiv.zIndex(e(t).zIndex()+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[l]?i.dpDiv.show(l,e.datepicker._get(i,"showOptions"),c):i.dpDiv[l||"show"](l?c:null),i.input.is(":visible")&&!i.input.is(":disabled")&&i.input.focus(),e.datepicker._curInst=i))}},_updateDatepicker:function(t){this.maxRows=4,a=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t),t.dpDiv.find("."+this._dayOverClass+" a").mouseover();var i,n=this._getNumberOfMonths(t),s=n[1],o=17;t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),s>1&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",o*s+"em"),t.dpDiv[(1!==n[0]||1!==n[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&t.input[0]!==document.activeElement&&t.input.focus(),t.yearshtml&&(i=t.yearshtml,setTimeout(function(){i===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml),i=t.yearshtml=null},0))},_getBorders:function(e){var t=function(e){return{thin:1,medium:2,thick:3}[e]||e};return[parseFloat(t(e.css("border-left-width"))),parseFloat(t(e.css("border-top-width")))]},_checkOffset:function(t,i,n){var s=t.dpDiv.outerWidth(),a=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,r=t.input?t.input.outerHeight():0,l=document.documentElement.clientWidth+(n?0:e(document).scrollLeft()),c=document.documentElement.clientHeight+(n?0:e(document).scrollTop());return i.left-=this._get(t,"isRTL")?s-o:0,i.left-=n&&i.left===t.input.offset().left?e(document).scrollLeft():0,i.top-=n&&i.top===t.input.offset().top+r?e(document).scrollTop():0,i.left-=Math.min(i.left,i.left+s>l&&l>s?Math.abs(i.left+s-l):0),i.top-=Math.min(i.top,i.top+a>c&&c>a?Math.abs(a+r):0),i},_findPos:function(t){for(var i,n=this._getInst(t),s=this._get(n,"isRTL");t&&("hidden"===t.type||1!==t.nodeType||e.expr.filters.hidden(t));)t=t[s?"previousSibling":"nextSibling"];return i=e(t).offset(),[i.left,i.top]},_hideDatepicker:function(t){var i,n,s,a,r=this._curInst;!r||t&&r!==e.data(t,o)||this._datepickerShowing&&(i=this._get(r,"showAnim"),n=this._get(r,"duration"),s=function(){e.datepicker._tidyDialog(r)},e.effects&&(e.effects.effect[i]||e.effects[i])?r.dpDiv.hide(i,e.datepicker._get(r,"showOptions"),n,s):r.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?n:null,s),i||s(),this._datepickerShowing=!1,a=this._get(r,"onClose"),a&&a.apply(r.input?r.input[0]:null,[r.input?r.input.val():"",r]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),e.blockUI&&(e.unblockUI(),e("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(t){if(e.datepicker._curInst){var i=e(t.target),n=e.datepicker._getInst(i[0]);(i[0].id!==e.datepicker._mainDivId&&0===i.parents("#"+e.datepicker._mainDivId).length&&!i.hasClass(e.datepicker.markerClassName)&&!i.closest("."+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||i.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==n)&&e.datepicker._hideDatepicker()}},_adjustDate:function(t,i,n){var s=e(t),a=this._getInst(s[0]);this._isDisabledDatepicker(s[0])||(this._adjustInstDate(a,i+("M"===n?this._get(a,"showCurrentAtPos"):0),n),this._updateDatepicker(a))},_gotoToday:function(t){var i,n=e(t),s=this._getInst(n[0]);this._get(s,"gotoCurrent")&&s.currentDay?(s.selectedDay=s.currentDay,s.drawMonth=s.selectedMonth=s.currentMonth,s.drawYear=s.selectedYear=s.currentYear):(i=new Date,s.selectedDay=i.getDate(),s.drawMonth=s.selectedMonth=i.getMonth(),s.drawYear=s.selectedYear=i.getFullYear()),this._notifyChange(s),this._adjustDate(n)},_selectMonthYear:function(t,i,n){var s=e(t),a=this._getInst(s[0]);a["selected"+("M"===n?"Month":"Year")]=a["draw"+("M"===n?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(a),this._adjustDate(s)},_selectDay:function(t,i,n,s){var a,o=e(t);e(s).hasClass(this._unselectableClass)||this._isDisabledDatepicker(o[0])||(a=this._getInst(o[0]),a.selectedDay=a.currentDay=e("a",s).html(),a.selectedMonth=a.currentMonth=i,a.selectedYear=a.currentYear=n,this._selectDate(t,this._formatDate(a,a.currentDay,a.currentMonth,a.currentYear)))},_clearDate:function(t){var i=e(t);this._selectDate(i,"")},_selectDate:function(t,i){var n,s=e(t),a=this._getInst(s[0]);i=null!=i?i:this._formatDate(a),a.input&&a.input.val(i),this._updateAlternate(a),n=this._get(a,"onSelect"),n?n.apply(a.input?a.input[0]:null,[i,a]):a.input&&a.input.trigger("change"),a.inline?this._updateDatepicker(a):(this._hideDatepicker(),this._lastInput=a.input[0],"object"!=typeof a.input[0]&&a.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var i,n,s,a=this._get(t,"altField");a&&(i=this._get(t,"altFormat")||this._get(t,"dateFormat"),n=this._getDate(t),s=this.formatDate(i,n,this._getFormatConfig(t)),e(a).each(function(){e(this).val(s)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&t<6,""]},iso8601Week:function(e){var t,i=new Date(e.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),t=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((t-i)/864e5)/7)+1},parseDate:function(t,i,n){if(null==t||null==i)throw"Invalid arguments";i="object"==typeof i?i.toString():i+"";if(""===i)return null;var s,a,o,r,l=0,c=(n?n.shortYearCutoff:null)||this._defaults.shortYearCutoff,h="string"!=typeof c?c:(new Date).getFullYear()%100+parseInt(c,10),u=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,d=(n?n.dayNames:null)||this._defaults.dayNames,p=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,f=(n?n.monthNames:null)||this._defaults.monthNames,m=-1,g=-1,v=-1,b=-1,y=!1,w=function(e){var i=s+1<t.length&&t.charAt(s+1)===e;return i&&s++,i},x=function(e){var t=w(e),n="@"===e?14:"!"===e?20:"y"===e&&t?4:"o"===e?3:2,s=new RegExp("^\\d{1,"+n+"}"),a=i.substring(l).match(s);if(!a)throw"Missing number at position "+l;return l+=a[0].length,parseInt(a[0],10)},k=function(t,n,s){var a=-1,o=e.map(w(t)?s:n,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});e.each(o,function(e,t){var n=t[1];if(i.substr(l,n.length).toLowerCase()===n.toLowerCase())return a=t[0],l+=n.length,!1});if(a!==-1)return a+1;throw"Unknown name at position "+l},_=function(){if(i.charAt(l)!==t.charAt(s))throw"Unexpected literal at position "+l;l++};for(s=0;s<t.length;s++)if(y)"'"!==t.charAt(s)||w("'")?_():y=!1;else switch(t.charAt(s)){case"d":v=x("d");break;case"D":k("D",u,d);break;case"o":b=x("o");break;case"m":g=x("m");break;case"M":g=k("M",p,f);break;case"y":m=x("y");break;case"@":r=new Date(x("@")),m=r.getFullYear(),g=r.getMonth()+1,v=r.getDate();break;case"!":r=new Date((x("!")-this._ticksTo1970)/1e4),m=r.getFullYear(),g=r.getMonth()+1,v=r.getDate();break;case"'":w("'")?_():y=!0;break;default:_()}if(l<i.length){o=i.substr(l);if(!/^\s+/.test(o))throw"Extra/unparsed characters found in date: "+o}m===-1?m=(new Date).getFullYear():m<100&&(m+=(new Date).getFullYear()-(new Date).getFullYear()%100+(m<=h?0:-100));if(b>-1){g=1,v=b;for(;;){a=this._getDaysInMonth(m,g-1);if(v<=a)break;g++,v-=a}}r=this._daylightSavingAdjust(new Date(m,g-1,v));if(r.getFullYear()!==m||r.getMonth()+1!==g||r.getDate()!==v)throw"Invalid date";return r},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(e,t,i){if(!t)return"";var n,s=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,a=(i?i.dayNames:null)||this._defaults.dayNames,o=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,r=(i?i.monthNames:null)||this._defaults.monthNames,l=function(t){var i=n+1<e.length&&e.charAt(n+1)===t;return i&&n++,i},c=function(e,t,i){var n=""+t;if(l(e))for(;n.length<i;)n="0"+n;return n},h=function(e,t,i,n){return l(e)?n[t]:i[t]},u="",d=!1;if(t)for(n=0;n<e.length;n++)if(d)"'"!==e.charAt(n)||l("'")?u+=e.charAt(n):d=!1;else switch(e.charAt(n)){case"d":u+=c("d",t.getDate(),2);break;case"D":u+=h("D",t.getDay(),s,a);break;case"o":u+=c("o",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=c("m",t.getMonth()+1,2);break;case"M":u+=h("M",t.getMonth(),o,r);break;case"y":u+=l("y")?t.getFullYear():(t.getYear()%100<10?"0":"")+t.getYear()%100;break;case"@":u+=t.getTime();break;case"!":u+=1e4*t.getTime()+this._ticksTo1970;break;case"'":l("'")?u+="'":d=!0;break;default:u+=e.charAt(n)}return u},_possibleChars:function(e){var t,i="",n=!1,s=function(i){var n=t+1<e.length&&e.charAt(t+1)===i;return n&&t++,n};for(t=0;t<e.length;t++)if(n)"'"!==e.charAt(t)||s("'")?i+=e.charAt(t):n=!1;else switch(e.charAt(t)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":s("'")?i+="'":n=!0;break;default:i+=e.charAt(t)}return i},_get:function(e,i){return e.settings[i]!==t?e.settings[i]:this._defaults[i]},_setDateFromField:function(e,t){if(e.input.val()!==e.lastVal){var i=this._get(e,"dateFormat"),n=e.lastVal=e.input?e.input.val():null,s=this._getDefaultDate(e),a=s,o=this._getFormatConfig(e);try{a=this.parseDate(i,n,o)||s}catch(e){n=t?"":n}e.selectedDay=a.getDate(),e.drawMonth=e.selectedMonth=a.getMonth(),e.drawYear=e.selectedYear=a.getFullYear(),e.currentDay=n?a.getDate():0,e.currentMonth=n?a.getMonth():0,e.currentYear=n?a.getFullYear():0,this._adjustInstDate(e)}},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(t,i,n){var s=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},a=function(i){try{return e.datepicker.parseDate(e.datepicker._get(t,"dateFormat"),i,e.datepicker._getFormatConfig(t))}catch(e){}for(var n=(i.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,s=n.getFullYear(),a=n.getMonth(),o=n.getDate(),r=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,l=r.exec(i);l;){switch(l[2]||"d"){case"d":case"D":o+=parseInt(l[1],10);break;case"w":case"W":o+=7*parseInt(l[1],10);break;case"m":case"M":a+=parseInt(l[1],10),o=Math.min(o,e.datepicker._getDaysInMonth(s,a));break;case"y":case"Y":s+=parseInt(l[1],10),o=Math.min(o,e.datepicker._getDaysInMonth(s,a))}l=r.exec(i)}return new Date(s,a,o)},o=null==i||""===i?n:"string"==typeof i?a(i):"number"==typeof i?isNaN(i)?n:s(i):new Date(i.getTime());return o=o&&"Invalid Date"===o.toString()?n:o,o&&(o.setHours(0),o.setMinutes(0),o.setSeconds(0),o.setMilliseconds(0)),this._daylightSavingAdjust(o);
},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,i){var n=!t,s=e.selectedMonth,a=e.selectedYear,o=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=o.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=o.getMonth(),e.drawYear=e.selectedYear=e.currentYear=o.getFullYear(),(s!==e.selectedMonth||a!==e.selectedYear)&&!i&&this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(n?"":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&""===e.input.val()?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var i=this._get(t,"stepMonths"),n="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){window["DP_jQuery_"+r].datepicker._adjustDate(n,-i,"M")},next:function(){window["DP_jQuery_"+r].datepicker._adjustDate(n,+i,"M")},hide:function(){window["DP_jQuery_"+r].datepicker._hideDatepicker()},today:function(){window["DP_jQuery_"+r].datepicker._gotoToday(n)},selectDay:function(){return window["DP_jQuery_"+r].datepicker._selectDay(n,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return window["DP_jQuery_"+r].datepicker._selectMonthYear(n,this,"M"),!1},selectYear:function(){return window["DP_jQuery_"+r].datepicker._selectMonthYear(n,this,"Y"),!1}};e(this).bind(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,i,n,s,a,o,r,l,c,h,u,d,p,f,m,g,v,b,y,w,x,k,_,C,T,S,E,D,P,M,N,I,O,j,A,F,L,H,R,z=new Date,$=this._daylightSavingAdjust(new Date(z.getFullYear(),z.getMonth(),z.getDate())),W=this._get(e,"isRTL"),q=this._get(e,"showButtonPanel"),B=this._get(e,"hideIfNoPrevNext"),U=this._get(e,"navigationAsDateFormat"),Y=this._getNumberOfMonths(e),V=this._get(e,"showCurrentAtPos"),K=this._get(e,"stepMonths"),Q=1!==Y[0]||1!==Y[1],X=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(e,"min"),J=this._getMinMaxDate(e,"max"),Z=e.drawMonth-V,ee=e.drawYear;Z<0&&(Z+=12,ee--);if(J){t=this._daylightSavingAdjust(new Date(J.getFullYear(),J.getMonth()-Y[0]*Y[1]+1,J.getDate())),t=G&&t<G?G:t;for(;this._daylightSavingAdjust(new Date(ee,Z,1))>t;)Z--,Z<0&&(Z=11,ee--)}e.drawMonth=Z,e.drawYear=ee,i=this._get(e,"prevText"),i=U?this.formatDate(i,this._daylightSavingAdjust(new Date(ee,Z-K,1)),this._getFormatConfig(e)):i,n=this._canAdjustMonth(e,-1,ee,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(W?"e":"w")+"'>"+i+"</span></a>":B?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(W?"e":"w")+"'>"+i+"</span></a>",s=this._get(e,"nextText"),s=U?this.formatDate(s,this._daylightSavingAdjust(new Date(ee,Z+K,1)),this._getFormatConfig(e)):s,a=this._canAdjustMonth(e,1,ee,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+s+"'><span class='ui-icon ui-icon-circle-triangle-"+(W?"w":"e")+"'>"+s+"</span></a>":B?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+s+"'><span class='ui-icon ui-icon-circle-triangle-"+(W?"w":"e")+"'>"+s+"</span></a>",o=this._get(e,"currentText"),r=this._get(e,"gotoCurrent")&&e.currentDay?X:$,o=U?this.formatDate(o,r,this._getFormatConfig(e)):o,l=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",c=q?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(W?l:"")+(this._isInRange(e,r)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+o+"</button>":"")+(W?"":l)+"</div>":"",h=parseInt(this._get(e,"firstDay"),10),h=isNaN(h)?0:h,u=this._get(e,"showWeek"),d=this._get(e,"dayNames"),p=this._get(e,"dayNamesMin"),f=this._get(e,"monthNames"),m=this._get(e,"monthNamesShort"),g=this._get(e,"beforeShowDay"),v=this._get(e,"showOtherMonths"),b=this._get(e,"selectOtherMonths"),y=this._getDefaultDate(e),w="",x;for(k=0;k<Y[0];k++){_="",this.maxRows=4;for(C=0;C<Y[1];C++){T=this._daylightSavingAdjust(new Date(ee,Z,e.selectedDay)),S=" ui-corner-all",E="";if(Q){E+="<div class='ui-datepicker-group";if(Y[1]>1)switch(C){case 0:E+=" ui-datepicker-group-first",S=" ui-corner-"+(W?"right":"left");break;case Y[1]-1:E+=" ui-datepicker-group-last",S=" ui-corner-"+(W?"left":"right");break;default:E+=" ui-datepicker-group-middle",S=""}E+="'>"}E+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+S+"'>"+(/all|left/.test(S)&&0===k?W?a:n:"")+(/all|right/.test(S)&&0===k?W?n:a:"")+this._generateMonthYearHeader(e,Z,ee,G,J,k>0||C>0,f,m)+"</div><table class='ui-datepicker-calendar'><thead><tr>",D=u?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"";for(x=0;x<7;x++)P=(x+h)%7,D+="<th"+((x+h+6)%7>=5?" class='ui-datepicker-week-end'":"")+"><span title='"+d[P]+"'>"+p[P]+"</span></th>";E+=D+"</tr></thead><tbody>",M=this._getDaysInMonth(ee,Z),ee===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,M)),N=(this._getFirstDayOfMonth(ee,Z)-h+7)%7,I=Math.ceil((N+M)/7),O=Q&&this.maxRows>I?this.maxRows:I,this.maxRows=O,j=this._daylightSavingAdjust(new Date(ee,Z,1-N));for(A=0;A<O;A++){E+="<tr>",F=u?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(j)+"</td>":"";for(x=0;x<7;x++)L=g?g.apply(e.input?e.input[0]:null,[j]):[!0,""],H=j.getMonth()!==Z,R=H&&!b||!L[0]||G&&j<G||J&&j>J,F+="<td class='"+((x+h+6)%7>=5?" ui-datepicker-week-end":"")+(H?" ui-datepicker-other-month":"")+(j.getTime()===T.getTime()&&Z===e.selectedMonth&&e._keyEvent||y.getTime()===j.getTime()&&y.getTime()===T.getTime()?" "+this._dayOverClass:"")+(R?" "+this._unselectableClass+" ui-state-disabled":"")+(H&&!v?"":" "+L[1]+(j.getTime()===X.getTime()?" "+this._currentClass:"")+(j.getTime()===$.getTime()?" ui-datepicker-today":""))+"'"+(H&&!v||!L[2]?"":" title='"+L[2].replace(/'/g,"&#39;")+"'")+(R?"":" data-handler='selectDay' data-event='click' data-month='"+j.getMonth()+"' data-year='"+j.getFullYear()+"'")+">"+(H&&!v?"&#xa0;":R?"<span class='ui-state-default'>"+j.getDate()+"</span>":"<a class='ui-state-default"+(j.getTime()===$.getTime()?" ui-state-highlight":"")+(j.getTime()===X.getTime()?" ui-state-active":"")+(H?" ui-priority-secondary":"")+"' href='#'>"+j.getDate()+"</a>")+"</td>",j.setDate(j.getDate()+1),j=this._daylightSavingAdjust(j);E+=F+"</tr>"}Z++,Z>11&&(Z=0,ee++),E+="</tbody></table>"+(Q?"</div>"+(Y[0]>0&&C===Y[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),_+=E}w+=_}return w+=c,e._keyEvent=!1,w},_generateMonthYearHeader:function(e,t,i,n,s,a,o,r){var l,c,h,u,d,p,f,m,g=this._get(e,"changeMonth"),v=this._get(e,"changeYear"),b=this._get(e,"showMonthAfterYear"),y="<div class='ui-datepicker-title'>",w="";if(a||!g)w+="<span class='ui-datepicker-month'>"+o[t]+"</span>";else{l=n&&n.getFullYear()===i,c=s&&s.getFullYear()===i,w+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";for(h=0;h<12;h++)(!l||h>=n.getMonth())&&(!c||h<=s.getMonth())&&(w+="<option value='"+h+"'"+(h===t?" selected='selected'":"")+">"+r[h]+"</option>");w+="</select>"}b||(y+=w+(!a&&g&&v?"":"&#xa0;"));if(!e.yearshtml){e.yearshtml="";if(a||!v)y+="<span class='ui-datepicker-year'>"+i+"</span>";else{u=this._get(e,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\-].*/)?i+parseInt(e.substring(1),10):e.match(/[+\-].*/)?d+parseInt(e,10):parseInt(e,10);return isNaN(t)?d:t},f=p(u[0]),m=Math.max(f,p(u[1]||"")),f=n?Math.max(f,n.getFullYear()):f,m=s?Math.min(m,s.getFullYear()):m,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";for(;f<=m;f++)e.yearshtml+="<option value='"+f+"'"+(f===i?" selected='selected'":"")+">"+f+"</option>";e.yearshtml+="</select>",y+=e.yearshtml,e.yearshtml=null}}return y+=this._get(e,"yearSuffix"),b&&(y+=(!a&&g&&v?"":"&#xa0;")+w),y+="</div>"},_adjustInstDate:function(e,t,i){var n=e.drawYear+("Y"===i?t:0),s=e.drawMonth+("M"===i?t:0),a=Math.min(e.selectedDay,this._getDaysInMonth(n,s))+("D"===i?t:0),o=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(n,s,a)));e.selectedDay=o.getDate(),e.drawMonth=e.selectedMonth=o.getMonth(),e.drawYear=e.selectedYear=o.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(e)},_restrictMinMax:function(e,t){var i=this._getMinMaxDate(e,"min"),n=this._getMinMaxDate(e,"max"),s=i&&t<i?i:t;return n&&s>n?n:s},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,"numberOfMonths");return null==t?[1,1]:"number"==typeof t?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return new Date(e,t,1).getDay()},_canAdjustMonth:function(e,t,i,n){var s=this._getNumberOfMonths(e),a=this._daylightSavingAdjust(new Date(i,n+(t<0?t:s[0]*s[1]),1));return t<0&&a.setDate(this._getDaysInMonth(a.getFullYear(),a.getMonth())),this._isInRange(e,a)},_isInRange:function(e,t){var i,n,s=this._getMinMaxDate(e,"min"),a=this._getMinMaxDate(e,"max"),o=null,r=null,l=this._get(e,"yearRange");return l&&(i=l.split(":"),n=(new Date).getFullYear(),o=parseInt(i[0],10),r=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(o+=n),i[1].match(/[+\-].*/)&&(r+=n)),(!s||t.getTime()>=s.getTime())&&(!a||t.getTime()<=a.getTime())&&(!o||t.getFullYear()>=o)&&(!r||t.getFullYear()<=r)},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return t="string"!=typeof t?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,i,n){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var s=t?"object"==typeof t?t:this._daylightSavingAdjust(new Date(n,i,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),s,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),0===e("#"+e.datepicker._mainDivId).length&&e("body").append(e.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof t||"isDisabled"!==t&&"getDate"!==t&&"widget"!==t?"option"===t&&2===arguments.length&&"string"==typeof arguments[1]?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof t?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this].concat(i)):e.datepicker._attachDatepicker(this,t)}):e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(i))},e.datepicker=new i,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version="1.10.1",window["DP_jQuery_"+r]=e}(jQuery);!function(e,t){e.widget("ui.menu",{version:"1.10.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,e.proxy(function(e){this.options.disabled&&e.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(e){e.preventDefault()},"click .ui-state-disabled > a":function(e){e.preventDefault()},"click .ui-menu-item:has(a)":function(t){var i=e(t.target).closest(".ui-menu-item");!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.mouseHandled=!0,this.select(t),i.has(".ui-menu").length?this.expand(t):this.element.is(":focus")||(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(t){var i=e(t.currentTarget);i.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(t,i)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(e,t){var i=this.active||this.element.children(".ui-menu-item").eq(0);t||this.focus(e,i)},blur:function(t){this._delay(function(){e.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){e(t.target).closest(".ui-menu").length||this.collapseAll(t),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var t=e(this);t.data("ui-menu-submenu-carat")&&t.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(t){function i(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var n,s,a,o,r,l=!0;switch(t.keyCode){case e.ui.keyCode.PAGE_UP:this.previousPage(t);break;case e.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case e.ui.keyCode.HOME:this._move("first","first",t);break;case e.ui.keyCode.END:this._move("last","last",t);break;case e.ui.keyCode.UP:this.previous(t);break;case e.ui.keyCode.DOWN:this.next(t);break;case e.ui.keyCode.LEFT:this.collapse(t);break;case e.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case e.ui.keyCode.ENTER:case e.ui.keyCode.SPACE:this._activate(t);break;case e.ui.keyCode.ESCAPE:this.collapse(t);break;default:l=!1,s=this.previousFilter||"",a=String.fromCharCode(t.keyCode),o=!1,clearTimeout(this.filterTimer),a===s?o=!0:a=s+a,r=new RegExp("^"+i(a),"i"),n=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(e(this).children("a").text())}),n=o&&n.index(this.active.next())!==-1?this.active.nextAll(".ui-menu-item"):n,n.length||(a=String.fromCharCode(t.keyCode),r=new RegExp("^"+i(a),"i"),n=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(e(this).children("a").text())})),n.length?(this.focus(t,n),n.length>1?(this.previousFilter=a,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}l&&t.preventDefault()},_activate:function(e){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(e):this.select(e))},refresh:function(){var t,i=this.options.icons.submenu,n=this.element.find(this.options.menus);n.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=e(this),n=t.prev("a"),s=e("<span>").addClass("ui-menu-icon ui-icon "+i).data("ui-menu-submenu-carat",!0);n.attr("aria-haspopup","true").prepend(s),t.attr("aria-labelledby",n.attr("id"))}),t=n.add(this.element),t.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),t.children(":not(.ui-menu-item)").each(function(){var t=e(this);/[^\-\u2014\u2013\s]/.test(t.text())||t.addClass("ui-widget-content ui-menu-divider")}),t.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!e.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(e,t){"icons"===e&&this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(t.submenu),this._super(e,t)},focus:function(e,t){var i,n;this.blur(e,e&&"focus"===e.type),this._scrollIntoView(t),this.active=t.first(),n=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",n.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),e&&"keydown"===e.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=t.children(".ui-menu"),i.length&&/^mouse/.test(e.type)&&this._startOpening(i),this.activeMenu=t.parent(),this._trigger("focus",e,{item:t})},_scrollIntoView:function(t){var i,n,s,a,o,r;this._hasScroll()&&(i=parseFloat(e.css(this.activeMenu[0],"borderTopWidth"))||0,n=parseFloat(e.css(this.activeMenu[0],"paddingTop"))||0,s=t.offset().top-this.activeMenu.offset().top-i-n,a=this.activeMenu.scrollTop(),o=this.activeMenu.height(),r=t.height(),s<0?this.activeMenu.scrollTop(a+s):s+r>o&&this.activeMenu.scrollTop(a+s-o+r))},blur:function(e,t){t||clearTimeout(this.timer);this.active&&(this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",e,{item:this.active}))},_startOpening:function(e){clearTimeout(this.timer);"true"===e.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(e)},this.delay))},_open:function(t){var i=e.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(t,i){clearTimeout(this.timer),this.timer=this._delay(function(){var n=i?this.element:e(t&&t.target).closest(this.element.find(".ui-menu"));n.length||(n=this.element),this._close(n),this.blur(t),this.activeMenu=n},this.delay)},_close:function(e){e||(e=this.active?this.active.parent():this.element),e.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(e){var t=this.active&&this.active.parent().closest(".ui-menu-item",this.element);t&&t.length&&(this._close(),this.focus(e,t))},expand:function(e){var t=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();t&&t.length&&(this._open(t.parent()),this._delay(function(){this.focus(e,t)}))},next:function(e){this._move("next","first",e)},previous:function(e){this._move("prev","last",e)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(e,t,i){var n;this.active&&(n="first"===e||"last"===e?this.active["first"===e?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[e+"All"](".ui-menu-item").eq(0));n&&n.length&&this.active||(n=this.activeMenu.children(".ui-menu-item")[t]());this.focus(i,n)},nextPage:function(t){var i,n,s;this.active?this.isLastItem()||(this._hasScroll()?(n=this.active.offset().top,s=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=e(this),i.offset().top-n-s<0}),this.focus(t,i)):this.focus(t,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())):this.next(t)},previousPage:function(t){var i,n,s;this.active?this.isFirstItem()||(this._hasScroll()?(n=this.active.offset().top,s=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=e(this),i.offset().top-n+s>0}),this.focus(t,i)):this.focus(t,this.activeMenu.children(".ui-menu-item").first())):this.next(t)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||e(t.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,i)}})}(jQuery);!function(e,t){var i=5;e.widget("ui.slider",e.ui.mouse,{version:"1.10.1",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget ui-widget-content ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,i,n=this.options,s=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),a="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",o=[];i=n.values&&n.values.length||1,s.length>i&&(s.slice(i).remove(),s=s.slice(0,i));for(t=s.length;t<i;t++)o.push(a);this.handles=s.add(e(o.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(t){e(this).data("ui-slider-handle-index",t)})},_createRange:function(){var t=this.options,i="";t.range?(t.range===!0&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:e.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}):(this.range=e("<div></div>").appendTo(this.element),i="ui-slider-range ui-widget-header ui-corner-all"),this.range.addClass(i+("min"===t.range||"max"===t.range?" ui-slider-range-"+t.range:""))):this.range=e([])},_setupEvents:function(){var e=this.handles.add(this.range).filter("a");this._off(e),this._on(e,this._handleEvents),this._hoverable(e),this._focusable(e)},_destroy:function(){this.handles.remove(),this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(t){var i,n,s,a,o,r,l,c,h=this,u=this.options;return!u.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:t.pageX,y:t.pageY},n=this._normValueFromMouse(i),s=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var i=Math.abs(n-h.values(t));(s>i||s===i&&(t===h._lastChangedValue||h.values(t)===u.min))&&(s=i,a=e(this),o=t)}),r=this._start(t,o),r!==!1&&(this._mouseSliding=!0,this._handleIndex=o,a.addClass("ui-state-active").focus(),l=a.offset(),c=!e(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=c?{left:0,top:0}:{left:t.pageX-l.left-a.width()/2,top:t.pageY-l.top-a.height()/2-(parseInt(a.css("borderTopWidth"),10)||0)-(parseInt(a.css("borderBottomWidth"),10)||0)+(parseInt(a.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,o,n),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(e){var t={x:e.pageX,y:e.pageY},i=this._normValueFromMouse(t);return this._slide(e,this._handleIndex,i),!1},_mouseStop:function(e){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(e,this._handleIndex),this._change(e,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(e){var t,i,n,s,a;return"horizontal"===this.orientation?(t=this.elementSize.width,i=e.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(t=this.elementSize.height,i=e.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),n=i/t,n>1&&(n=1),n<0&&(n=0),"vertical"===this.orientation&&(n=1-n),s=this._valueMax()-this._valueMin(),a=this._valueMin()+n*s,this._trimAlignValue(a)},_start:function(e,t){var i={handle:this.handles[t],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._trigger("start",e,i)},_slide:function(e,t,i){var n,s,a;this.options.values&&this.options.values.length?(n=this.values(t?0:1),2===this.options.values.length&&this.options.range===!0&&(0===t&&i>n||1===t&&i<n)&&(i=n),i!==this.values(t)&&(s=this.values(),s[t]=i,a=this._trigger("slide",e,{handle:this.handles[t],value:i,values:s}),n=this.values(t?0:1),a!==!1&&this.values(t,i,!0))):i!==this.value()&&(a=this._trigger("slide",e,{handle:this.handles[t],value:i}),a!==!1&&this.value(i))},_stop:function(e,t){var i={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._trigger("stop",e,i)},_change:function(e,t){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._lastChangedValue=t,this._trigger("change",e,i)}},value:function(e){if(!arguments.length)return this._value();this.options.value=this._trimAlignValue(e),this._refreshValue(),this._change(null,0)},values:function(t,i){var n,s,a;if(arguments.length>1)this.options.values[t]=this._trimAlignValue(i),this._refreshValue(),this._change(null,t);else{if(!arguments.length)return this._values();if(!e.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(t):this.value();n=this.options.values,s=arguments[0];for(a=0;a<n.length;a+=1)n[a]=this._trimAlignValue(s[a]),this._change(null,a);this._refreshValue()}},_setOption:function(t,i){var n,s=0;"range"===t&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),e.isArray(this.options.values)&&(s=this.options.values.length),e.Widget.prototype._setOption.apply(this,arguments);switch(t){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":this._animateOff=!0,this._refreshValue();for(n=0;n<s;n+=1)this._change(null,n);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var e=this.options.value;return e=this._trimAlignValue(e)},_values:function(e){var t,i,n;if(arguments.length)return t=this.options.values[e],t=this._trimAlignValue(t);if(this.options.values&&this.options.values.length){i=this.options.values.slice();for(n=0;n<i.length;n+=1)i[n]=this._trimAlignValue(i[n]);return i}return[]},_trimAlignValue:function(e){if(e<=this._valueMin())return this._valueMin();if(e>=this._valueMax())return this._valueMax();var t=this.options.step>0?this.options.step:1,i=(e-this._valueMin())%t,n=e-i;return 2*Math.abs(i)>=t&&(n+=i>0?t:-t),parseFloat(n.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var t,i,n,s,a,o=this.options.range,r=this.options,l=this,c=!this._animateOff&&r.animate,h={};this.options.values&&this.options.values.length?this.handles.each(function(n){i=(l.values(n)-l._valueMin())/(l._valueMax()-l._valueMin())*100,h["horizontal"===l.orientation?"left":"bottom"]=i+"%",e(this).stop(1,1)[c?"animate":"css"](h,r.animate),l.options.range===!0&&("horizontal"===l.orientation?(0===n&&l.range.stop(1,1)[c?"animate":"css"]({left:i+"%"},r.animate),1===n&&l.range[c?"animate":"css"]({width:i-t+"%"},{queue:!1,duration:r.animate})):(0===n&&l.range.stop(1,1)[c?"animate":"css"]({bottom:i+"%"},r.animate),1===n&&l.range[c?"animate":"css"]({height:i-t+"%"},{queue:!1,duration:r.animate}))),t=i}):(n=this.value(),s=this._valueMin(),a=this._valueMax(),i=a!==s?(n-s)/(a-s)*100:0,h["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[c?"animate":"css"](h,r.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[c?"animate":"css"]({width:i+"%"},r.animate),"max"===o&&"horizontal"===this.orientation&&this.range[c?"animate":"css"]({width:100-i+"%"},{queue:!1,duration:r.animate}),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[c?"animate":"css"]({height:i+"%"},r.animate),"max"===o&&"vertical"===this.orientation&&this.range[c?"animate":"css"]({height:100-i+"%"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(t){var n,s,a,o,r=e(t.target).data("ui-slider-handle-index");switch(t.keyCode){case e.ui.keyCode.HOME:case e.ui.keyCode.END:case e.ui.keyCode.PAGE_UP:case e.ui.keyCode.PAGE_DOWN:case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:t.preventDefault();if(!this._keySliding){this._keySliding=!0,e(t.target).addClass("ui-state-active"),n=this._start(t,r);if(n===!1)return}}o=this.options.step,s=a=this.options.values&&this.options.values.length?this.values(r):this.value();switch(t.keyCode){case e.ui.keyCode.HOME:a=this._valueMin();break;case e.ui.keyCode.END:a=this._valueMax();break;case e.ui.keyCode.PAGE_UP:a=this._trimAlignValue(s+(this._valueMax()-this._valueMin())/i);break;case e.ui.keyCode.PAGE_DOWN:a=this._trimAlignValue(s-(this._valueMax()-this._valueMin())/i);break;case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:if(s===this._valueMax())return;a=this._trimAlignValue(s+o);break;case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(s===this._valueMin())return;a=this._trimAlignValue(s-o)}this._slide(t,r,a)},click:function(e){e.preventDefault()},keyup:function(t){var i=e(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,i),this._change(t,i),e(t.target).removeClass("ui-state-active"))}}})}(jQuery);!function(e,t){function i(){return++s}function n(e){return e.hash.length>1&&decodeURIComponent(e.href.replace(a,""))===decodeURIComponent(location.href.replace(a,""))}var s=0,a=/#.*$/;e.widget("ui.tabs",{version:"1.10.1",delay:300,options:{active:null,collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_create:function(){var t=this,i=this.options;this.running=!1,this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible",i.collapsible).delegate(".ui-tabs-nav > li","mousedown"+this.eventNamespace,function(t){e(this).is(".ui-state-disabled")&&t.preventDefault()}).delegate(".ui-tabs-anchor","focus"+this.eventNamespace,function(){e(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this._processTabs(),i.active=this._initialActive(),e.isArray(i.disabled)&&(i.disabled=e.unique(i.disabled.concat(e.map(this.tabs.filter(".ui-state-disabled"),function(e){return t.tabs.index(e)}))).sort()),this.options.active!==!1&&this.anchors.length?this.active=this._findActive(i.active):this.active=e(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var t=this.options.active,i=this.options.collapsible,n=location.hash.substring(1);
if(null===t){n&&this.tabs.each(function(i,s){if(e(s).attr("aria-controls")===n)return t=i,!1}),null===t&&(t=this.tabs.index(this.tabs.filter(".ui-tabs-active")));null!==t&&t!==-1||(t=!!this.tabs.length&&0)}return t!==!1&&(t=this.tabs.index(this.tabs.eq(t)),t===-1&&(t=!i&&0)),!i&&t===!1&&this.anchors.length&&(t=0),t},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):e()}},_tabKeydown:function(t){var i=e(this.document[0].activeElement).closest("li"),n=this.tabs.index(i),s=!0;if(!this._handlePageNav(t)){switch(t.keyCode){case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:n++;break;case e.ui.keyCode.UP:case e.ui.keyCode.LEFT:s=!1,n--;break;case e.ui.keyCode.END:n=this.anchors.length-1;break;case e.ui.keyCode.HOME:n=0;break;case e.ui.keyCode.SPACE:t.preventDefault(),clearTimeout(this.activating),this._activate(n);return;case e.ui.keyCode.ENTER:t.preventDefault(),clearTimeout(this.activating),this._activate(n!==this.options.active&&n);return;default:return}t.preventDefault(),clearTimeout(this.activating),n=this._focusNextTab(n,s),t.ctrlKey||(i.attr("aria-selected","false"),this.tabs.eq(n).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",n)},this.delay))}},_panelKeydown:function(t){this._handlePageNav(t)||t.ctrlKey&&t.keyCode===e.ui.keyCode.UP&&(t.preventDefault(),this.active.focus())},_handlePageNav:function(t){return t.altKey&&t.keyCode===e.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):t.altKey&&t.keyCode===e.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(t,i){function n(){return t>s&&(t=0),t<0&&(t=s),t}for(var s=this.tabs.length-1;e.inArray(n(),this.options.disabled)!==-1;)t=i?t+1:t-1;return t},_focusNextTab:function(e,t){return e=this._findNextTab(e,t),this.tabs.eq(e).focus(),e},_setOption:function(e,t){"active"!==e?"disabled"!==e?(this._super(e,t),"collapsible"===e&&(this.element.toggleClass("ui-tabs-collapsible",t),!t&&this.options.active===!1&&this._activate(0)),"event"===e&&this._setupEvents(t),"heightStyle"===e&&this._setupHeightStyle(t)):this._setupDisabled(t):this._activate(t)},_tabId:function(e){return e.attr("aria-controls")||"ui-tabs-"+i()},_sanitizeSelector:function(e){return e?e.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var t=this.options,i=this.tablist.children(":has(a[href])");t.disabled=e.map(i.filter(".ui-state-disabled"),function(e){return i.index(e)}),this._processTabs(),t.active!==!1&&this.anchors.length?this.active.length&&!e.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=e()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active):(t.active=!1,this.active=e()),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-expanded":"false","aria-hidden":"true"}),this.active.length?(this.active.addClass("ui-tabs-active ui-state-active").attr({"aria-selected":"true",tabIndex:0}),this._getPanelForTab(this.active).show().attr({"aria-expanded":"true","aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var t=this;this.tablist=this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role","tablist"),this.tabs=this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({role:"tab",tabIndex:-1}),this.anchors=this.tabs.map(function(){return e("a",this)[0]}).addClass("ui-tabs-anchor").attr({role:"presentation",tabIndex:-1}),this.panels=e(),this.anchors.each(function(i,s){var a,o,r,l=e(s).uniqueId().attr("id"),c=e(s).closest("li"),h=c.attr("aria-controls");n(s)?(a=s.hash,o=t.element.find(t._sanitizeSelector(a))):(r=t._tabId(c),a="#"+r,o=t.element.find(a),o.length||(o=t._createPanel(r),o.insertAfter(t.panels[i-1]||t.tablist)),o.attr("aria-live","polite")),o.length&&(t.panels=t.panels.add(o)),h&&c.data("ui-tabs-aria-controls",h),c.attr({"aria-controls":a.substring(1),"aria-labelledby":l}),o.attr("aria-labelledby",l)}),this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role","tabpanel")},_getList:function(){return this.element.find("ol,ul").eq(0)},_createPanel:function(t){return e("<div>").attr("id",t).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy",!0)},_setupDisabled:function(t){e.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1);for(var i,n=0;i=this.tabs[n];n++)t===!0||e.inArray(n,t)!==-1?e(i).addClass("ui-state-disabled").attr("aria-disabled","true"):e(i).removeClass("ui-state-disabled").removeAttr("aria-disabled");this.options.disabled=t},_setupEvents:function(t){var i={click:function(e){e.preventDefault()}};t&&e.each(t.split(" "),function(e,t){i[t]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var i,n=this.element.parent();"fill"===t?(i=n.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var t=e(this),n=t.css("position");"absolute"!==n&&"fixed"!==n&&(i-=t.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=e(this).outerHeight(!0)}),this.panels.each(function(){e(this).height(Math.max(0,i-e(this).innerHeight()+e(this).height()))}).css("overflow","auto")):"auto"===t&&(i=0,this.panels.each(function(){i=Math.max(i,e(this).height("").height())}).height(i))},_eventHandler:function(t){var i=this.options,n=this.active,s=e(t.currentTarget),a=s.closest("li"),o=a[0]===n[0],r=o&&i.collapsible,l=r?e():this._getPanelForTab(a),c=n.length?this._getPanelForTab(n):e(),h={oldTab:n,oldPanel:c,newTab:r?e():a,newPanel:l};t.preventDefault();a.hasClass("ui-state-disabled")||a.hasClass("ui-tabs-loading")||this.running||o&&!i.collapsible||this._trigger("beforeActivate",t,h)===!1||(i.active=!r&&this.tabs.index(a),this.active=o?e():a,this.xhr&&this.xhr.abort(),!c.length&&!l.length&&e.error("jQuery UI Tabs: Mismatching fragment identifier."),l.length&&this.load(this.tabs.index(a),t),this._toggle(t,h))},_toggle:function(t,i){function n(){a.running=!1,a._trigger("activate",t,i)}function s(){i.newTab.closest("li").addClass("ui-tabs-active ui-state-active"),o.length&&a.options.show?a._show(o,a.options.show,n):(o.show(),n())}var a=this,o=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),s()}):(i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),r.hide(),s()),r.attr({"aria-expanded":"false","aria-hidden":"true"}),i.oldTab.attr("aria-selected","false"),o.length&&r.length?i.oldTab.attr("tabIndex",-1):o.length&&this.tabs.filter(function(){return 0===e(this).attr("tabIndex")}).attr("tabIndex",-1),o.attr({"aria-expanded":"true","aria-hidden":"false"}),i.newTab.attr({"aria-selected":"true",tabIndex:0})},_activate:function(t){var i,n=this._findActive(t);n[0]!==this.active[0]&&(n.length||(n=this.active),i=n.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:e.noop}))},_findActive:function(t){return t===!1?e():this.tabs.eq(t)},_getIndex:function(e){return"string"==typeof e&&(e=this.anchors.index(this.anchors.filter("[href$='"+e+"']"))),e},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible"),this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role"),this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){e.data(this,"ui-tabs-destroy")?e(this).remove():e(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role")}),this.tabs.each(function(){var t=e(this),i=t.data("ui-tabs-aria-controls");i?t.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):t.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var n=this.options.disabled;n!==!1&&(i===t?n=!1:(i=this._getIndex(i),n=e.isArray(n)?e.map(n,function(e){return e!==i?e:null}):e.map(this.tabs,function(e,t){return t!==i?t:null})),this._setupDisabled(n))},disable:function(i){var n=this.options.disabled;if(n!==!0){if(i===t)n=!0;else{i=this._getIndex(i);if(e.inArray(i,n)!==-1)return;n=e.isArray(n)?e.merge([i],n).sort():[i]}this._setupDisabled(n)}},load:function(t,i){t=this._getIndex(t);var s=this,a=this.tabs.eq(t),o=a.find(".ui-tabs-anchor"),r=this._getPanelForTab(a),l={tab:a,panel:r};n(o[0])||(this.xhr=e.ajax(this._ajaxSettings(o,i,l)),this.xhr&&"canceled"!==this.xhr.statusText&&(a.addClass("ui-tabs-loading"),r.attr("aria-busy","true"),this.xhr.success(function(e){setTimeout(function(){r.html(e),s._trigger("load",i,l)},1)}).complete(function(e,t){setTimeout(function(){"abort"===t&&s.panels.stop(!1,!0),a.removeClass("ui-tabs-loading"),r.removeAttr("aria-busy"),e===s.xhr&&delete s.xhr},1)})))},_ajaxSettings:function(t,i,n){var s=this;return{url:t.attr("href"),beforeSend:function(t,a){return s._trigger("beforeLoad",i,e.extend({jqXHR:t,ajaxSettings:a},n))}}},_getPanelForTab:function(t){var i=e(t).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}})}(jQuery);!function(e){function t(t,i){var n=(t.attr("aria-describedby")||"").split(/\s+/);n.push(i),t.data("ui-tooltip-id",i).attr("aria-describedby",e.trim(n.join(" ")))}function i(t){var i=t.data("ui-tooltip-id"),n=(t.attr("aria-describedby")||"").split(/\s+/),s=e.inArray(i,n);s!==-1&&n.splice(s,1),t.removeData("ui-tooltip-id"),n=e.trim(n.join(" ")),n?t.attr("aria-describedby",n):t.removeAttr("aria-describedby")}var n=0;e.widget("ui.tooltip",{version:"1.10.1",options:{content:function(){var t=e(this).attr("title")||"";return e("<a>").text(t).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable()},_setOption:function(t,i){var n=this;"disabled"!==t?(this._super(t,i),"content"===t&&e.each(this.tooltips,function(e,t){n._updateContent(t)})):(this[i?"_disable":"_enable"](),this.options[t]=i)},_disable:function(){var t=this;e.each(this.tooltips,function(i,n){var s=e.Event("blur");s.target=s.currentTarget=n[0],t.close(s,!0)}),this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.is("[title]")&&t.data("ui-tooltip-title",t.attr("title")).attr("title","")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.data("ui-tooltip-title")&&t.attr("title",t.data("ui-tooltip-title"))})},open:function(t){var i=this,n=e(t?t.target:this.element).closest(this.options.items);n.length&&!n.data("ui-tooltip-id")&&(n.attr("title")&&n.data("ui-tooltip-title",n.attr("title")),n.data("ui-tooltip-open",!0),t&&"mouseover"===t.type&&n.parents().each(function(){var t,n=e(this);n.data("ui-tooltip-open")&&(t=e.Event("blur"),t.target=t.currentTarget=this,i.close(t,!0)),n.attr("title")&&(n.uniqueId(),i.parents[this.id]={element:this,title:n.attr("title")},n.attr("title",""))}),this._updateContent(n,t))},_updateContent:function(e,t){var i,n=this.options.content,s=this,a=t?t.type:null;if("string"==typeof n)return this._open(t,e,n);i=n.call(e[0],function(i){e.data("ui-tooltip-open")&&s._delay(function(){t&&(t.type=a),this._open(t,e,i)})}),i&&this._open(t,e,i)},_open:function(i,n,s){function a(e){c.of=e;o.is(":hidden")||o.position(c)}var o,r,l,c=e.extend({},this.options.position);if(s){o=this._find(n);if(o.length)o.find(".ui-tooltip-content").html(s);else{n.is("[title]")&&(i&&"mouseover"===i.type?n.attr("title",""):n.removeAttr("title")),o=this._tooltip(n),t(n,o.attr("id")),o.find(".ui-tooltip-content").html(s),this.options.track&&i&&/^mouse/.test(i.type)?(this._on(this.document,{mousemove:a}),a(i)):o.position(e.extend({of:n},this.options.position)),o.hide(),this._show(o,this.options.show),this.options.show&&this.options.show.delay&&(l=this.delayedShow=setInterval(function(){o.is(":visible")&&(a(c.of),clearInterval(l))},e.fx.interval)),this._trigger("open",i,{tooltip:o}),r={keyup:function(t){if(t.keyCode===e.ui.keyCode.ESCAPE){var i=e.Event(t);i.currentTarget=n[0],this.close(i,!0)}},remove:function(){this._removeTooltip(o)}};i&&"mouseover"!==i.type||(r.mouseleave="close");i&&"focusin"!==i.type||(r.focusout="close");this._on(!0,n,r)}}},close:function(t){var n=this,s=e(t?t.currentTarget:this.element),a=this._find(s);this.closing||(clearInterval(this.delayedShow),s.data("ui-tooltip-title")&&s.attr("title",s.data("ui-tooltip-title")),i(s),a.stop(!0),this._hide(a,this.options.hide,function(){n._removeTooltip(e(this))}),s.removeData("ui-tooltip-open"),this._off(s,"mouseleave focusout keyup"),s[0]!==this.element[0]&&this._off(s,"remove"),this._off(this.document,"mousemove"),t&&"mouseleave"===t.type&&e.each(this.parents,function(t,i){e(i.element).attr("title",i.title),delete n.parents[t]}),this.closing=!0,this._trigger("close",t,{tooltip:a}),this.closing=!1)},_tooltip:function(t){var i="ui-tooltip-"+n++,s=e("<div>").attr({id:i,role:"tooltip"}).addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content "+(this.options.tooltipClass||""));return e("<div>").addClass("ui-tooltip-content").appendTo(s),s.appendTo(this.document[0].body),this.tooltips[i]=t,s},_find:function(t){var i=t.data("ui-tooltip-id");return i?e("#"+i):e()},_removeTooltip:function(e){e.remove(),delete this.tooltips[e.attr("id")]},_destroy:function(){var t=this;e.each(this.tooltips,function(i,n){var s=e.Event("blur");s.target=s.currentTarget=n[0],t.close(s,!0),e("#"+i).remove(),n.data("ui-tooltip-title")&&(n.attr("title",n.data("ui-tooltip-title")),n.removeData("ui-tooltip-title"))})}})}(jQuery);!function(e){function t(e,i){i=i?i:"";return e?t(--e,"0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".charAt(Math.floor(60*Math.random()))+i):i}function n(e,t){var i,n=e.apiendpoint,s="";n+=n.indexOf("?")<=0?"?":"&";n=n.replace("#","%23");null===e.maxWidth||"undefined"!=typeof e.params.maxwidth&&null!==e.params.maxwidth||(e.params.maxwidth=e.maxWidth);null===e.maxHeight||"undefined"!=typeof e.params.maxheight&&null!==e.params.maxheight||(e.params.maxheight=e.maxHeight);for(i in e.params)i!=e.callbackparameter&&null!==e.params[i]&&(s+="&"+escape(i)+"="+e.params[i]);n+="format="+e.format+"&url="+escape(t)+s;"json"!=e.dataType&&(n+="&"+e.callbackparameter+"=?");return n}function s(t,i,n){e("#jqoembeddata").data(i,t.code);r.beforeEmbed.call(n,t);r.onEmbed.call(n,t);r.afterEmbed.call(n,t)}function a(i,a,o){if(void 0!=e("#jqoembeddata").data(a)&&"iframe"!=o.embedtag.tag){var l={code:e("#jqoembeddata").data(a)};s(l,a,i)}else if(o.yql){var c=o.yql.from||"htmlstring",h=o.yql.url?o.yql.url(a):a,u="SELECT * FROM "+c+' WHERE url="'+h+'" and '+(/html/.test(c)?"xpath":"itemPath")+"='"+(o.yql.xpath||"/")+"'";"html"==c&&(u+=" and compat='html5'");var d=e.extend({url:"http://query.yahooapis.com/v1/public/yql",dataType:"jsonp",data:{q:u,format:"json",env:"store://datatables.org/alltableswithkeys",callback:"?"},success:function(t){var n;if(o.yql.xpath&&"//meta|//title|//link"==o.yql.xpath){var r={};null==t.query.results&&(t.query.results={meta:[]});for(var l=0,c=t.query.results.meta.length;l<c;l++){var u=t.query.results.meta[l].name||t.query.results.meta[l].property||null;null!=u&&(r[u.toLowerCase()]=t.query.results.meta[l].content)}r.hasOwnProperty("title")&&r.hasOwnProperty("og:title")||null!=t.query.results.title&&(r.title=t.query.results.title);if(!r.hasOwnProperty("og:image")&&t.query.results.hasOwnProperty("link"))for(var l=0,c=t.query.results.link.length;l<c;l++)t.query.results.link[l].hasOwnProperty("rel")&&"apple-touch-icon"==t.query.results.link[l].rel&&("/"==t.query.results.link[l].href.charAt(0)?r["og:image"]=h.match(/^(([a-z]+:)?(\/\/)?[^\/]+\/).*$/)[1]+t.query.results.link[l].href:r["og:image"]=t.query.results.link[l].href);n=o.yql.datareturn(r)}else n=o.yql.datareturn?o.yql.datareturn(t.query.results):t.query.results.result;if(n!==!1){var d=e.extend({},n);d.code=n;s(d,a,i)}},error:r.onError.call(i,a,o)},r.ajaxOptions||{});e.ajax(d)}else if(o.templateRegex)if(""!==o.embedtag.tag){var p=o.embedtag.flashvars||"",f=o.embedtag.tag||"embed",m=o.embedtag.width||"auto",g=(o.embedtag.nocache||0,o.embedtag.height||"auto"),v=a.replace(o.templateRegex,o.apiendpoint);o.nocache||(v+="&jqoemcache="+t(5));o.apikey&&(v=v.replace("_APIKEY_",r.apikeys[o.name]));var b=e("<"+f+"/>").attr("src",v).attr("width",m).attr("height",g).attr("allowfullscreen",o.embedtag.allowfullscreen||"true").attr("allowscriptaccess",o.embedtag.allowfullscreen||"always").css("max-height",r.maxHeight||"auto").css("max-width",r.maxWidth||"auto");"embed"==f&&b.attr("type",o.embedtag.type||"application/x-shockwave-flash").attr("flashvars",a.replace(o.templateRegex,p));"iframe"==f&&b.attr("scrolling",o.embedtag.scrolling||"no").attr("frameborder",o.embedtag.frameborder||"0");var l={code:b};s(l,a,i)}else if(o.apiendpoint){o.apikey&&(o.apiendpoint=o.apiendpoint.replace("_APIKEY_",r.apikeys[o.name]));d=e.extend({url:a.replace(o.templateRegex,o.apiendpoint),dataType:"jsonp",success:function(t){var n=e.extend({},t);n.code=o.templateData(t);s(n,a,i)},error:r.onError.call(i,a,o)},r.ajaxOptions||{});e.ajax(d)}else{var l={code:a.replace(o.templateRegex,o.template)};s(l,a,i)}else{var y=n(o,a),d=e.extend({url:y,dataType:o.dataType||"jsonp",success:function(t){var n=e.extend({},t);switch(n.type){case"file":case"photo":n.code=e.fn.oembed.getPhotoCode(a,n);break;case"video":case"rich":n.code=e.fn.oembed.getRichCode(a,n);break;default:n.code=e.fn.oembed.getGenericCode(a,n)}s(n,a,i)},error:r.onError.call(i,a,o)},r.ajaxOptions||{});e.ajax(d)}}function o(e){if(null===e)return null;var t,i={};for(t in e)null!==t&&(i[t.toLowerCase()]=e[t]);return i}e.fn.oembed=function(t,i,n){r=e.extend(!0,e.fn.oembed.defaults,i);var s=["0rz.tw","1link.in","1url.com","2.gp","2big.at","2tu.us","3.ly","307.to","4ms.me","4sq.com","4url.cc","6url.com","7.ly","a.gg","a.nf","aa.cx","abcurl.net","ad.vu","adf.ly","adjix.com","afx.cc","all.fuseurl.com","alturl.com","amzn.to","ar.gy","arst.ch","atu.ca","azc.cc","b23.ru","b2l.me","bacn.me","bcool.bz","binged.it","bit.ly","bizj.us","bloat.me","bravo.ly","bsa.ly","budurl.com","canurl.com","chilp.it","chzb.gr","cl.lk","cl.ly","clck.ru","cli.gs","cliccami.info","clickthru.ca","clop.in","conta.cc","cort.as","cot.ag","crks.me","ctvr.us","cutt.us","dai.ly","decenturl.com","dfl8.me","digbig.com","http://digg.com/[^/]+$","disq.us","dld.bz","dlvr.it","do.my","doiop.com","dopen.us","easyuri.com","easyurl.net","eepurl.com","eweri.com","fa.by","fav.me","fb.me","fbshare.me","ff.im","fff.to","fire.to","firsturl.de","firsturl.net","flic.kr","flq.us","fly2.ws","fon.gs","freak.to","fuseurl.com","fuzzy.to","fwd4.me","fwib.net","g.ro.lt","gizmo.do","gl.am","go.9nl.com","go.ign.com","go.usa.gov","goo.gl","goshrink.com","gurl.es","hex.io","hiderefer.com","hmm.ph","href.in","hsblinks.com","htxt.it","huff.to","hulu.com","hurl.me","hurl.ws","icanhaz.com","idek.net","ilix.in","is.gd","its.my","ix.lt","j.mp","jijr.com","kl.am","klck.me","korta.nu","krunchd.com","l9k.net","lat.ms","liip.to","liltext.com","linkbee.com","linkbun.ch","liurl.cn","ln-s.net","ln-s.ru","lnk.gd","lnk.ms","lnkd.in","lnkurl.com","lru.jp","lt.tl","lurl.no","macte.ch","mash.to","merky.de","migre.me","miniurl.com","minurl.fr","mke.me","moby.to","moourl.com","mrte.ch","myloc.me","myurl.in","n.pr","nbc.co","nblo.gs","nn.nf","not.my","notlong.com","nsfw.in","nutshellurl.com","nxy.in","nyti.ms","o-x.fr","oc1.us","om.ly","omf.gd","omoikane.net","on.cnn.com","on.mktw.net","onforb.es","orz.se","ow.ly","ping.fm","pli.gs","pnt.me","politi.co","post.ly","pp.gg","profile.to","ptiturl.com","pub.vitrue.com","qlnk.net","qte.me","qu.tc","qy.fi","r.ebay.com","r.im","rb6.me","read.bi","readthis.ca","reallytinyurl.com","redir.ec","redirects.ca","redirx.com","retwt.me","ri.ms","rickroll.it","riz.gd","rt.nu","ru.ly","rubyurl.com","rurl.org","rww.tw","s4c.in","s7y.us","safe.mn","sameurl.com","sdut.us","shar.es","shink.de","shorl.com","short.ie","short.to","shortlinks.co.uk","shorturl.com","shout.to","show.my","shrinkify.com","shrinkr.com","shrt.fr","shrt.st","shrten.com","shrunkin.com","simurl.com","slate.me","smallr.com","smsh.me","smurl.name","sn.im","snipr.com","snipurl.com","snurl.com","sp2.ro","spedr.com","srnk.net","srs.li","starturl.com","stks.co","su.pr","surl.co.uk","surl.hu","t.cn","t.co","t.lh.com","ta.gd","tbd.ly","tcrn.ch","tgr.me","tgr.ph","tighturl.com","tiniuri.com","tiny.cc","tiny.ly","tiny.pl","tinylink.in","tinyuri.ca","tinyurl.com","tk.","tl.gd","tmi.me","tnij.org","tnw.to","tny.com","to.ly","togoto.us","totc.us","toysr.us","tpm.ly","tr.im","tra.kz","trunc.it","twhub.com","twirl.at","twitclicks.com","twitterurl.net","twitterurl.org","twiturl.de","twurl.cc","twurl.nl","u.mavrev.com","u.nu","u76.org","ub0.cc","ulu.lu","updating.me","ur1.ca","url.az","url.co.uk","url.ie","url360.me","url4.eu","urlborg.com","urlbrief.com","urlcover.com","urlcut.com","urlenco.de","urli.nl","urls.im","urlshorteningservicefortwitter.com","urlx.ie","urlzen.com","usat.ly","use.my","vb.ly","vevo.ly","vgn.am","vl.am","vm.lc","w55.de","wapo.st","wapurl.co.uk","wipi.es","wp.me","x.vu","xr.com","xrl.in","xrl.us","xurl.es","xurl.jp","y.ahoo.it","yatuc.com","ye.pe","yep.it","yfrog.com","yhoo.it","yiyd.com","youtu.be","yuarel.com","z0p.de","zi.ma","zi.mu","zipmyurl.com","zud.me","zurl.ws","zz.gd","zzang.kr","›.ws","✩.ws","✿.ws","❥.ws","➔.ws","➞.ws","➡.ws","➨.ws","➯.ws","➹.ws","➽.ws"];0===e("#jqoembeddata").length&&e('<span id="jqoembeddata"></span>').appendTo("body");return this.each(function(){var i,l=e(this),c=!t||t.indexOf("http://")&&t.indexOf("https://")?l.attr("href"):t;n?r.onEmbed=n:r.onEmbed||(r.onEmbed=function(t){e.fn.oembed.insertCode(this,r.embedMethod,t)});if(null!==c&&void 0!==c){for(var h=0,u=s.length;h<u;h++){var d=new RegExp("://"+s[h]+"/","i");if(null!==c.match(d)){var p=e.extend({url:"http://api.longurl.org/v2/expand",dataType:"jsonp",data:{url:c,format:"json"},success:function(t){c=t["long-url"];i=e.fn.oembed.getOEmbedProvider(t["long-url"]);if(null!==i){i.params=o(r[i.name])||{};i.maxWidth=r.maxWidth;i.maxHeight=r.maxHeight;a(l,c,i)}else r.onProviderNotFound.call(l,c)}},r.ajaxOptions||{});e.ajax(p);return l}}i=e.fn.oembed.getOEmbedProvider(c);if(null!==i){i.params=o(r[i.name])||{};i.maxWidth=r.maxWidth;i.maxHeight=r.maxHeight;a(l,c,i)}else r.onProviderNotFound.call(l,c)}return l})};var r;e.fn.oembed.defaults={maxWidth:null,maxHeight:null,includeHandle:!0,embedMethod:"auto",onProviderNotFound:function(){},beforeEmbed:function(){},afterEmbed:function(){},onEmbed:!1,onError:function(){},ajaxOptions:{}};e.fn.oembed.insertCode=function(t,i,n){if(null!==n){"auto"==i&&null!==t.attr("href")?i="append":"auto"==i&&(i="replace");switch(i){case"replace":t.replaceWith(n.code);break;case"fill":t.html(n.code);break;case"append":t.wrap('<div class="oembedall-container"></div>');var s=t.parent();r.includeHandle&&e('<span class="oembedall-closehide">&darr;</span>').insertBefore(t).click(function(){var t=encodeURIComponent(e(this).text());e(this).html("%E2%86%91"==t?"&darr;":"&uarr;");e(this).parent().children().last().toggle()});s.append("<br/>");try{n.code.clone().appendTo(s)}catch(e){s.append(n.code)}if(r.maxWidth){var a=s.parent().width();if(a<r.maxWidth){var o=e("iframe",s).width(),l=e("iframe",s).height(),c=o/a;e("iframe",s).width(o/c);e("iframe",s).height(l/c)}else{r.maxWidth&&e("iframe",s).width(r.maxWidth);r.maxHeight&&e("iframe",s).height(r.maxHeight)}}}}};e.fn.oembed.getPhotoCode=function(e,t){var i,n=t.title?t.title:"";n+=t.author_name?" - "+t.author_name:"";n+=t.provider_name?" - "+t.provider_name:"";if(t.url)i='<div><a href="'+e+"\" target='_blank'><img src=\""+t.url+'" alt="'+n+'"/></a></div>';else if(t.thumbnail_url){var s=t.thumbnail_url.replace("_s","_b");i='<div><a href="'+e+"\" target='_blank'><img src=\""+s+'" alt="'+n+'"/></a></div>'}else i="<div>Error loading this picture</div>";t.html&&(i+="<div>"+t.html+"</div>");return i};e.fn.oembed.getRichCode=function(e,t){var i=t.html;return i};e.fn.oembed.getGenericCode=function(e,t){var i=null!==t.title?t.title:e,n='<a href="'+e+'">'+i+"</a>";t.html&&(n+="<div>"+t.html+"</div>");return n};e.fn.oembed.getOEmbedProvider=function(t){for(var i=0;i<e.fn.oembed.providers.length;i++)for(var n=0,s=e.fn.oembed.providers[i].urlschemes.length;n<s;n++){var a=new RegExp(e.fn.oembed.providers[i].urlschemes[n],"i");if(null!==t.match(a))return e.fn.oembed.providers[i]}return null};e.fn.oembed.OEmbedProvider=function(e,t,i,n,s){this.name=e;this.type=t;this.urlschemes=i;this.apiendpoint=n;this.maxWidth=500;this.maxHeight=400;s=s||{};if(s.useYQL){"xml"==s.useYQL?s.yql={xpath:"//oembed/html",from:"xml",apiendpoint:this.apiendpoint,url:function(e){return this.apiendpoint+"?format=xml&url="+e},datareturn:function(e){return e.html.replace(/.*\[CDATA\[(.*)\]\]>$/,"$1")||""}}:s.yql={from:"json",apiendpoint:this.apiendpoint,url:function(e){return this.apiendpoint+"?format=json&url="+e},datareturn:function(e){return"video"!=e.json.type&&(e.json.url||e.json.thumbnail_url)?'<img src="'+(e.json.url||e.json.thumbnail_url)+'" />':e.json.html||""}};this.apiendpoint=null}for(var a in s)this[a]=s[a];this.format=this.format||"json";this.callbackparameter=this.callbackparameter||"callback";this.embedtag=this.embedtag||{tag:""}};e.fn.updateOEmbedProvider=function(t,i,n,s,a){for(var o=0;o<e.fn.oembed.providers.length;o++)if(e.fn.oembed.providers[o].name===t){null!==i&&(e.fn.oembed.providers[o].type=i);null!==n&&(e.fn.oembed.providers[o].urlschemes=n);null!==s&&(e.fn.oembed.providers[o].apiendpoint=s);if(null!==a){e.fn.oembed.providers[o].extraSettings=a;for(var r in a)null!==r&&null!==a[r]&&(e.fn.oembed.providers[o][r]=a[r])}}};e.fn.oembed.providers=[new e.fn.oembed.OEmbedProvider("youtube","video",["youtube\\.com/watch.+v=[\\w-]+&?","youtu\\.be/[\\w-]+","youtube.com/embed"],"http://www.youtube.com/embed/$1?wmode=transparent",{templateRegex:/.*(?:v\=|be\/|embed\/)([\w\-]+)&?.*/,embedtag:{tag:"iframe",width:"425",height:"349"}}),new e.fn.oembed.OEmbedProvider("wistia","video",["wistia.com/m/.+","wistia.com/embed/.+","wi.st/m/.+","wi.st/embed/.+"],"http://fast.wistia.com/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("xtranormal","video",["xtranormal\\.com/watch/.+"],"http://www.xtranormal.com/xtraplayr/$1/$2",{templateRegex:/.*com\/watch\/([\w\-]+)\/([\w\-]+).*/,embedtag:{tag:"iframe",width:"320",height:"269"}}),new e.fn.oembed.OEmbedProvider("scivee","video",["scivee.tv/node/.+"],"http://www.scivee.tv/flash/embedCast.swf?",{templateRegex:/.*tv\/node\/(.+)/,embedtag:{width:"480",height:"400",flashvars:"id=$1&type=3"}}),new e.fn.oembed.OEmbedProvider("veoh","video",["veoh.com/watch/.+"],"http://www.veoh.com/swf/webplayer/WebPlayer.swf?version=AFrontend.5.7.0.1337&permalinkId=$1&player=videodetailsembedded&videoAutoPlay=0&id=anonymous",{templateRegex:/.*watch\/([^\?]+).*/,embedtag:{width:"410",height:"341"}}),new e.fn.oembed.OEmbedProvider("gametrailers","video",["gametrailers\\.com/video/.+"],"http://media.mtvnservices.com/mgid:moses:video:gametrailers.com:$2",{templateRegex:/.*com\/video\/([\w\-]+)\/([\w\-]+).*/,embedtag:{width:"512",height:"288"}}),new e.fn.oembed.OEmbedProvider("funnyordie","video",["funnyordie\\.com/videos/.+"],"http://player.ordienetworks.com/flash/fodplayer.swf?",{templateRegex:/.*videos\/([^\/]+)\/([^\/]+)?/,embedtag:{width:512,height:328,flashvars:"key=$1"}}),new e.fn.oembed.OEmbedProvider("colledgehumour","video",["collegehumor\\.com/video/.+"],"http://www.collegehumor.com/moogaloop/moogaloop.swf?clip_id=$1&use_node_id=true&fullscreen=1",{templateRegex:/.*video\/([^\/]+).*/,embedtag:{width:600,height:338}}),new e.fn.oembed.OEmbedProvider("metacafe","video",["metacafe\\.com/watch/.+"],"http://www.metacafe.com/fplayer/$1/$2.swf",{templateRegex:/.*watch\/(\d+)\/(\w+)\/.*/,embedtag:{width:400,height:345}}),new e.fn.oembed.OEmbedProvider("bambuser","video",["bambuser\\.com/channel/.*/broadcast/.*"],"http://static.bambuser.com/r/player.swf?vid=$1",{templateRegex:/.*bambuser\.com\/channel\/.*\/broadcast\/(\w+).*/,embedtag:{width:512,height:339}}),new e.fn.oembed.OEmbedProvider("twitvid","video",["twitvid\\.com/.+"],"http://www.twitvid.com/embed.php?guid=$1&autoplay=0",{templateRegex:/.*twitvid\.com\/(\w+).*/,embedtag:{tag:"iframe",width:480,height:360}}),new e.fn.oembed.OEmbedProvider("aniboom","video",["aniboom\\.com/animation-video/.+"],"http://api.aniboom.com/e/$1",{templateRegex:/.*animation-video\/(\d+).*/,embedtag:{width:594,height:334}}),new e.fn.oembed.OEmbedProvider("vzaar","video",["vzaar\\.com/videos/.+","vzaar.tv/.+"],"http://view.vzaar.com/$1/player?",{templateRegex:/.*\/(\d+).*/,embedtag:{tag:"iframe",width:576,height:324}}),new e.fn.oembed.OEmbedProvider("snotr","video",["snotr\\.com/video/.+"],"http://www.snotr.com/embed/$1",{templateRegex:/.*\/(\d+).*/,embedtag:{tag:"iframe",width:400,height:330,nocache:1}}),new e.fn.oembed.OEmbedProvider("youku","video",["v.youku.com/v_show/id_.+"],"http://player.youku.com/player.php/sid/$1/v.swf",{templateRegex:/.*id_(.+)\.html.*/,embedtag:{width:480,height:400,nocache:1}}),new e.fn.oembed.OEmbedProvider("tudou","video",["tudou.com/programs/view/.+/"],"http://www.tudou.com/v/$1/v.swf",{templateRegex:/.*view\/(.+)\//,embedtag:{width:480,height:400,nocache:1}}),new e.fn.oembed.OEmbedProvider("embedr","video",["embedr\\.com/playlist/.+"],"http://embedr.com/swf/slider/$1/425/520/default/false/std?",{templateRegex:/.*playlist\/([^\/]+).*/,embedtag:{width:425,height:520}}),new e.fn.oembed.OEmbedProvider("blip","video",["blip\\.tv/.+"],"http://blip.tv/oembed/"),new e.fn.oembed.OEmbedProvider("minoto-video","video",["http://api.minoto-video.com/publishers/.+/videos/.+","http://dashboard.minoto-video.com/main/video/details/.+","http://embed.minoto-video.com/.+"],"http://api.minoto-video.com/services/oembed.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("animoto","video",["animoto.com/play/.+"],"http://animoto.com/services/oembed"),new e.fn.oembed.OEmbedProvider("hulu","video",["hulu\\.com/watch/.*"],"http://www.hulu.com/api/oembed.json"),new e.fn.oembed.OEmbedProvider("ustream","video",["ustream\\.tv/recorded/.*"],"http://www.ustream.tv/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("videojug","video",["videojug\\.com/(film|payer|interview).*"],"http://www.videojug.com/oembed.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("sapo","video",["videos\\.sapo\\.pt/.*"],"http://videos.sapo.pt/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("vodpod","video",["vodpod.com/watch/.*"],"http://vodpod.com/oembed.js",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("vimeo","video",["www.vimeo.com/groups/.*/videos/.*","www.vimeo.com/.*","vimeo.com/groups/.*/videos/.*","vimeo.com/.*"],"//vimeo.com/api/oembed.json"),new e.fn.oembed.OEmbedProvider("dailymotion","video",["dailymotion\\.com/.+"],"http://www.dailymotion.com/services/oembed"),new e.fn.oembed.OEmbedProvider("5min","video",["www\\.5min\\.com/.+"],"http://api.5min.com/oembed.xml",{
useYQL:"xml"}),new e.fn.oembed.OEmbedProvider("National Film Board of Canada","video",["nfb\\.ca/film/.+"],"http://www.nfb.ca/remote/services/oembed/",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("qik","video",["qik\\.com/\\w+"],"http://qik.com/api/oembed.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("revision3","video",["revision3\\.com"],"http://revision3.com/api/oembed/"),new e.fn.oembed.OEmbedProvider("dotsub","video",["dotsub\\.com/view/.+"],"http://dotsub.com/services/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("clikthrough","video",["clikthrough\\.com/theater/video/\\d+"],"http://clikthrough.com/services/oembed"),new e.fn.oembed.OEmbedProvider("Kinomap","video",["kinomap\\.com/.+"],"http://www.kinomap.com/oembed"),new e.fn.oembed.OEmbedProvider("VHX","video",["vhx.tv/.+"],"http://vhx.tv/services/oembed.json"),new e.fn.oembed.OEmbedProvider("bambuser","video",["bambuser.com/.+"],"http://api.bambuser.com/oembed/iframe.json"),new e.fn.oembed.OEmbedProvider("justin.tv","video",["justin.tv/.+"],"http://api.justin.tv/api/embed/from_url.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("official.fm","rich",["official.fm/.+"],"http://official.fm/services/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("chirbit","rich",["chirb.it/.+"],"http://chirb.it/oembed.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("Huffduffer","rich",["huffduffer.com/[-.\\w@]+/\\d+"],"http://huffduffer.com/oembed"),new e.fn.oembed.OEmbedProvider("Spotify","rich",["open.spotify.com/(track|album|user)/"],"https://embed.spotify.com/oembed/"),new e.fn.oembed.OEmbedProvider("shoudio","rich",["shoudio.com/.+","shoud.io/.+"],"http://shoudio.com/api/oembed"),new e.fn.oembed.OEmbedProvider("mixcloud","rich",["mixcloud.com/.+"],"http://www.mixcloud.com/oembed/",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("rdio.com","rich",["rd.io/.+","rdio.com"],"http://www.rdio.com/api/oembed/"),new e.fn.oembed.OEmbedProvider("Soundcloud","rich",["soundcloud.com/.+","snd.sc/.+"],"http://soundcloud.com/oembed",{format:"js"}),new e.fn.oembed.OEmbedProvider("bandcamp","rich",["bandcamp\\.com/album/.+"],null,{yql:{xpath:"//meta[contains(@content, \\'EmbeddedPlayer\\')]",from:"html",datareturn:function(e){return!!e.meta&&'<iframe width="400" height="100" src="'+e.meta.content+'" allowtransparency="true" frameborder="0"></iframe>'}}}),new e.fn.oembed.OEmbedProvider("deviantart","photo",["deviantart.com/.+","fav.me/.+","deviantart.com/.+"],"http://backend.deviantart.com/oembed",{format:"jsonp"}),new e.fn.oembed.OEmbedProvider("skitch","photo",["skitch.com/.+"],null,{yql:{xpath:"json",from:"json",url:function(e){return"http://skitch.com/oembed/?format=json&url="+e},datareturn:function(t){return e.fn.oembed.getPhotoCode(t.json.url,t.json)}}}),new e.fn.oembed.OEmbedProvider("mobypicture","photo",["mobypicture.com/user/.+/view/.+","moby.to/.+"],"http://api.mobypicture.com/oEmbed"),new e.fn.oembed.OEmbedProvider("flickr","photo",["flickr\\.com/photos/.+"],"http://flickr.com/services/oembed",{callbackparameter:"jsoncallback"}),new e.fn.oembed.OEmbedProvider("photobucket","photo",["photobucket\\.com/(albums|groups)/.+"],"http://photobucket.com/oembed/"),new e.fn.oembed.OEmbedProvider("instagram","photo",["instagr\\.?am(\\.com)?/.+"],"http://api.instagram.com/oembed"),new e.fn.oembed.OEmbedProvider("SmugMug","photo",["smugmug.com/[-.\\w@]+/.+"],"http://api.smugmug.com/services/oembed/"),new e.fn.oembed.OEmbedProvider("dribbble","photo",["dribbble.com/shots/.+"],"http://api.dribbble.com/shots/$1?callback=?",{templateRegex:/.*shots\/([\d]+).*/,templateData:function(e){return!!e.image_teaser_url&&'<img src="'+e.image_teaser_url+'"/>'}}),new e.fn.oembed.OEmbedProvider("chart.ly","photo",["chart\\.ly/[a-z0-9]{6,8}"],"http://chart.ly/uploads/large_$1.png",{templateRegex:/.*ly\/([^\/]+).*/,embedtag:{tag:"img"},nocache:1}),new e.fn.oembed.OEmbedProvider("circuitlab","photo",["circuitlab.com/circuit/.+"],"https://www.circuitlab.com/circuit/$1/screenshot/540x405/",{templateRegex:/.*circuit\/([^\/]+).*/,embedtag:{tag:"img"},nocache:1}),new e.fn.oembed.OEmbedProvider("23hq","photo",["23hq.com/[-.\\w@]+/photo/.+"],"http://www.23hq.com/23/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("img.ly","photo",["img\\.ly/.+"],"http://img.ly/show/thumb/$1",{templateRegex:/.*ly\/([^\/]+).*/,embedtag:{tag:"img"},nocache:1}),new e.fn.oembed.OEmbedProvider("twitgoo.com","photo",["twitgoo\\.com/.+"],"http://twitgoo.com/show/thumb/$1",{templateRegex:/.*com\/([^\/]+).*/,embedtag:{tag:"img"},nocache:1}),new e.fn.oembed.OEmbedProvider("imgur.com","photo",["imgur\\.com/gallery/.+"],"http://imgur.com/$1l.jpg",{templateRegex:/.*gallery\/([^\/]+).*/,embedtag:{tag:"img"},nocache:1}),new e.fn.oembed.OEmbedProvider("visual.ly","rich",["visual\\.ly/.+"],null,{yql:{xpath:"//a[@id=\\'gc_article_graphic_image\\']/img",from:"htmlstring"}}),new e.fn.oembed.OEmbedProvider("gravtar","photo",["mailto:.+"],null,{templateRegex:/mailto:([^\/]+).*/,template:function(e,t){return'<img src="http://gravatar.com/avatar/'+t.md5()+'.jpg" alt="on Gravtar" class="jqoaImg">'}}),new e.fn.oembed.OEmbedProvider("twitter","rich",["twitter.com/.+"],"https://api.twitter.com/1/statuses/oembed.json"),new e.fn.oembed.OEmbedProvider("gmep","rich",["gmep.imeducate.com/.*","gmep.org/.*"],"http://gmep.org/oembed.json"),new e.fn.oembed.OEmbedProvider("urtak","rich",["urtak.com/(u|clr)/.+"],"http://oembed.urtak.com/1/oembed"),new e.fn.oembed.OEmbedProvider("cacoo","rich",["cacoo.com/.+"],"http://cacoo.com/oembed.json"),new e.fn.oembed.OEmbedProvider("dailymile","rich",["dailymile.com/people/.*/entries/.*"],"http://api.dailymile.com/oembed"),new e.fn.oembed.OEmbedProvider("dipity","rich",["dipity.com/timeline/.+"],"http://www.dipity.com/oembed/timeline/",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("sketchfab","rich",["sketchfab.com/show/.+"],"http://sketchfab.com/oembed",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("speakerdeck","rich",["speakerdeck.com/.+"],"http://speakerdeck.com/oembed.json",{useYQL:"json"}),new e.fn.oembed.OEmbedProvider("popplet","rich",["popplet.com/app/.*"],"http://popplet.com/app/Popplet_Alpha.swf?page_id=$1&em=1",{templateRegex:/.*#\/([^\/]+).*/,embedtag:{width:460,height:460}}),new e.fn.oembed.OEmbedProvider("pearltrees","rich",["pearltrees.com/.*"],"http://cdn.pearltrees.com/s/embed/getApp?",{templateRegex:/.*N-f=1_(\d+).*N-p=(\d+).*/,embedtag:{width:460,height:460,flashvars:"lang=en_US&amp;embedId=pt-embed-$1-693&amp;treeId=$1&amp;pearlId=$2&amp;treeTitle=Diagrams%2FVisualization&amp;site=www.pearltrees.com%2FF"}}),new e.fn.oembed.OEmbedProvider("prezi","rich",["prezi.com/.*"],"http://prezi.com/bin/preziloader.swf?",{templateRegex:/.*com\/([^\/]+)\/.*/,embedtag:{width:550,height:400,flashvars:"prezi_id=$1&amp;lock_to_path=0&amp;color=ffffff&amp;autoplay=no&amp;autohide_ctrls=0"}}),new e.fn.oembed.OEmbedProvider("tourwrist","rich",["tourwrist.com/tours/.+"],null,{templateRegex:/.*tours.([\d]+).*/,template:function(e,t){setTimeout(function(){loadEmbeds&&loadEmbeds()},2e3);return"<div id='"+t+"' class='tourwrist-tour-embed direct'></div> <script type='text/javascript' src='http://tourwrist.com/tour_embed.js'></script>"}}),new e.fn.oembed.OEmbedProvider("meetup","rich",["meetup\\.(com|ps)/.+"],"http://api.meetup.com/oembed"),new e.fn.oembed.OEmbedProvider("ebay","rich",["ebay\\.*"],"http://togo.ebay.com/togo/togo.swf?2008013100",{templateRegex:/.*\/([^\/]+)\/(\d{10,13}).*/,embedtag:{width:355,height:300,flashvars:"base=http://togo.ebay.com/togo/&lang=en-us&mode=normal&itemid=$2&query=$1"}}),new e.fn.oembed.OEmbedProvider("wikipedia","rich",["wikipedia.org/wiki/.+"],"http://$1.wikipedia.org/w/api.php?action=parse&page=$2&format=json&section=0&callback=?",{templateRegex:/.*\/\/([\w]+).*\/wiki\/([^\/]+).*/,templateData:function(e){if(!e.parse)return!1;var t=e.parse.text["*"].replace(/href="\/wiki/g,'href="http://en.wikipedia.org/wiki');return'<div id="content"><h3><a class="nav-link" href="http://en.wikipedia.org/wiki/'+e.parse.displaytitle+'">'+e.parse.displaytitle+"</a></h3>"+t+"</div>"}}),new e.fn.oembed.OEmbedProvider("imdb","rich",["imdb.com/title/.+"],"http://www.imdbapi.com/?i=$1&callback=?",{templateRegex:/.*\/title\/([^\/]+).*/,templateData:function(e){return!!e.Title&&'<div id="content"><h3><a class="nav-link" href="http://imdb.com/title/'+e.imdbID+'/">'+e.Title+"</a> ("+e.Year+")</h3><p>Rating: "+e.imdbRating+"<br/>Genre: "+e.Genre+"<br/>Starring: "+e.Actors+'</p></div>  <div id="view-photo-caption">'+e.Plot+"</div></div>"}}),new e.fn.oembed.OEmbedProvider("livejournal","rich",["livejournal.com/"],"http://ljpic.seacrow.com/json/$2$4?jsonp=?",{templateRegex:/(http:\/\/(((?!users).)+)\.livejournal\.com|.*users\.livejournal\.com\/([^\/]+)).*/,templateData:function(e){return!!e.username&&'<div><img src="'+e.image+'" align="left" style="margin-right: 1em;" /><span class="oembedall-ljuser"><a href="http://'+e.username+'.livejournal.com/profile"><img src="http://www.livejournal.com/img/userinfo.gif" alt="[info]" width="17" height="17" /></a><a href="http://'+e.username+'.livejournal.com/">'+e.username+"</a></span><br />"+e.name+"</div>"}}),new e.fn.oembed.OEmbedProvider("circuitbee","rich",["circuitbee\\.com/circuit/view/.+"],"http://c.circuitbee.com/build/r/schematic-embed.html?id=$1",{templateRegex:/.*circuit\/view\/(\d+).*/,embedtag:{tag:"iframe",width:"500",height:"350"}}),new e.fn.oembed.OEmbedProvider("googlecalendar","rich",["www.google.com/calendar/embed?.+"],"$1",{templateRegex:/(.*)/,embedtag:{tag:"iframe",width:"800",height:"600"}}),new e.fn.oembed.OEmbedProvider("jsfiddle","rich",["jsfiddle.net/[^/]+/?"],"http://jsfiddle.net/$1/embedded/result,js,resources,html,css/?",{templateRegex:/.*net\/([^\/]+).*/,embedtag:{tag:"iframe",width:"100%",height:"300"}}),new e.fn.oembed.OEmbedProvider("jsbin","rich",["jsbin.com/.+"],"http://jsbin.com/$1/?",{templateRegex:/.*com\/([^\/]+).*/,embedtag:{tag:"iframe",width:"100%",height:"300"}}),new e.fn.oembed.OEmbedProvider("jotform","rich",["form.jotform.co/form/.+"],"$1?",{templateRegex:/(.*)/,embedtag:{tag:"iframe",width:"100%",height:"507"}}),new e.fn.oembed.OEmbedProvider("reelapp","rich",["reelapp\\.com/.+"],"http://www.reelapp.com/$1/embed",{templateRegex:/.*com\/(\S{6}).*/,embedtag:{tag:"iframe",width:"400",height:"338"}}),new e.fn.oembed.OEmbedProvider("linkedin","rich",["linkedin.com/pub/.+"],"https://www.linkedin.com/cws/member/public_profile?public_profile_url=$1&format=inline&isFramed=true",{templateRegex:/(.*)/,embedtag:{tag:"iframe",width:"368px",height:"auto"}}),new e.fn.oembed.OEmbedProvider("timetoast","rich",["timetoast.com/timelines/[0-9]+"],"http://www.timetoast.com/flash/TimelineViewer.swf?passedTimelines=$1",{templateRegex:/.*timelines\/([0-9]*)/,embedtag:{width:550,height:400,nocache:1}}),new e.fn.oembed.OEmbedProvider("pastebin","rich",["pastebin\\.com/[\\S]{8}"],"http://pastebin.com/embed_iframe.php?i=$1",{templateRegex:/.*\/(\S{8}).*/,embedtag:{tag:"iframe",width:"100%",height:"auto"}}),new e.fn.oembed.OEmbedProvider("mixlr","rich",["mixlr.com/.+"],"http://mixlr.com/embed/$1?autoplay=ae",{templateRegex:/.*com\/([^\/]+).*/,embedtag:{tag:"iframe",width:"100%",height:"auto"}}),new e.fn.oembed.OEmbedProvider("pastie","rich",["pastie\\.org/pastes/.+"],null,{yql:{xpath:'//pre[@class="textmate-source"]'}}),new e.fn.oembed.OEmbedProvider("github","rich",["gist.github.com/.+"],"https://github.com/api/oembed"),new e.fn.oembed.OEmbedProvider("github","rich",["github.com/[-.\\w@]+/[-.\\w@]+"],"https://api.github.com/repos/$1/$2?callback=?",{templateRegex:/.*\/([^\/]+)\/([^\/]+).*/,templateData:function(e){return!!e.data.html_url&&'<div class="oembedall-githubrepos"><ul class="oembedall-repo-stats"><li>'+e.data.language+'</li><li class="oembedall-watchers"><a title="Watchers" href="'+e.data.html_url+'/watchers">&#x25c9; '+e.data.watchers+'</a></li><li class="oembedall-forks"><a title="Forks" href="'+e.data.html_url+'/network">&#x0265; '+e.data.forks+'</a></li></ul><h3><a href="'+e.data.html_url+'">'+e.data.name+'</a></h3><div class="oembedall-body"><p class="oembedall-description">'+e.data.description+'</p><p class="oembedall-updated-at">Last updated: '+e.data.pushed_at+"</p></div></div>"}}),new e.fn.oembed.OEmbedProvider("facebook","rich",["facebook.com/(people/[^\\/]+/\\d+|[^\\/]+$)"],"https://graph.facebook.com/$2$3/?callback=?",{templateRegex:/.*facebook.com\/(people\/[^\/]+\/(\d+).*|([^\/]+$))/,templateData:function(e){if(!e.id)return!1;var t='<div class="oembedall-facebook1"><div class="oembedall-facebook2"><a href="http://www.facebook.com/">facebook</a> ';t+=e.from?'<a href="http://www.facebook.com/'+e.from.id+'">'+e.from.name+"</a>":e.link?'<a href="'+e.link+'">'+e.name+"</a>":e.username?'<a href="http://www.facebook.com/'+e.username+'">'+e.name+"</a>":'<a href="http://www.facebook.com/'+e.id+'">'+e.name+"</a>";t+='</div><div class="oembedall-facebookBody"><div class="contents">';t+=e.picture?'<a href="'+e.link+'"><img src="'+e.picture+'"></a>':'<img src="https://graph.facebook.com/'+e.id+'/picture">';e.from&&(t+='<a href="'+e.link+'">'+e.name+"</a>");e.founded&&(t+="Founded: <strong>"+e.founded+"</strong><br>");e.category&&(t+="Category: <strong>"+e.category+"</strong><br>");e.website&&(t+='Website: <strong><a href="'+e.website+'">'+e.website+"</a></strong><br>");e.gender&&(t+="Gender: <strong>"+e.gender+"</strong><br>");e.description&&(t+=e.description+"<br>");t+="</div></div>";return t}}),new e.fn.oembed.OEmbedProvider("stackoverflow","rich",["stackoverflow.com/questions/[\\d]+"],"http://api.stackoverflow.com/1.1/questions/$1?body=true&jsonp=?",{templateRegex:/.*questions\/([\d]+).*/,templateData:function(t){if(!t.questions)return!1;var n=t.questions[0],s=e(n.body).text(),a='<div class="oembedall-stoqembed"><div class="oembedall-statscontainer"><div class="oembedall-statsarrow"></div><div class="oembedall-stats"><div class="oembedall-vote"><div class="oembedall-votes"><span class="oembedall-vote-count-post"><strong>'+(n.up_vote_count-n.down_vote_count)+'</strong></span><div class="oembedall-viewcount">vote(s)</div></div></div><div class="oembedall-status"><strong>'+n.answer_count+'</strong>answer</div></div><div class="oembedall-views">'+n.view_count+' view(s)</div></div><div class="oembedall-summary"><h3><a class="oembedall-question-hyperlink" href="http://stackoverflow.com/questions/'+n.question_id+'/">'+n.title+'</a></h3><div class="oembedall-excerpt">'+s.substring(0,100)+'...</div><div class="oembedall-tags">';for(i in n.tags)a+='<a title="" class="oembedall-post-tag" href="http://stackoverflow.com/questions/tagged/'+n.tags[i]+'">'+n.tags[i]+"</a>";a+='</div><div class="oembedall-fr"><div class="oembedall-user-info"><div class="oembedall-user-gravatar32"><a href="http://stackoverflow.com/users/'+n.owner.user_id+"/"+n.owner.display_name+'"><img width="32" height="32" alt="" src="http://www.gravatar.com/avatar/'+n.owner.email_hash+'?s=32&amp;d=identicon&amp;r=PG"></a></div><div class="oembedall-user-details"><a href="http://stackoverflow.com/users/'+n.owner.user_id+"/"+n.owner.display_name+'">'+n.owner.display_name+'</a><br><span title="reputation score" class="oembedall-reputation-score">'+n.owner.reputation+"</span></div></div></div></div></div>";return a}}),new e.fn.oembed.OEmbedProvider("wordpress","rich",["wordpress\\.com/.+","blogs\\.cnn\\.com/.+","techcrunch\\.com/.+","wp\\.me/.+"],"http://public-api.wordpress.com/oembed/1.0/?for=jquery-oembed-all"),new e.fn.oembed.OEmbedProvider("screenr","rich",["screenr.com"],"http://www.screenr.com/embed/$1",{templateRegex:/.*\/([^\/]+).*/,embedtag:{tag:"iframe",width:"650",height:396}}),new e.fn.oembed.OEmbedProvider("gigpans","rich",["gigapan\\.org/[-.\\w@]+/\\d+"],"http://gigapan.org/gigapans/$1/options/nosnapshots/iframe/flash.html",{templateRegex:/.*\/(\d+)\/?.*/,embedtag:{tag:"iframe",width:"100%",height:400}}),new e.fn.oembed.OEmbedProvider("scribd","rich",["scribd\\.com/.+"],"http://www.scribd.com/embeds/$1/content?start_page=1&view_mode=list",{templateRegex:/.*doc\/([^\/]+).*/,embedtag:{tag:"iframe",width:"100%",height:600}}),new e.fn.oembed.OEmbedProvider("kickstarter","rich",["kickstarter\\.com/projects/.+"],"$1/widget/card.html",{templateRegex:/([^\?]+).*/,embedtag:{tag:"iframe",width:"220",height:380}}),new e.fn.oembed.OEmbedProvider("amazon","rich",["amzn.com/B+","amazon.com.*/(B\\S+)($|\\/.*)"],"http://rcm.amazon.com/e/cm?t=_APIKEY_&o=1&p=8&l=as1&asins=$1&ref=qf_br_asin_til&fc1=000000&IS2=1&lt1=_blank&m=amazon&lc1=0000FF&bc1=000000&bg1=FFFFFF&f=ifr",{apikey:!0,templateRegex:/.*\/(B[0-9A-Z]+)($|\/.*)/,embedtag:{tag:"iframe",width:"120px",height:"240px"}}),new e.fn.oembed.OEmbedProvider("slideshare","rich",["slideshare.net"],"http://www.slideshare.net/api/oembed/2",{format:"jsonp"}),new e.fn.oembed.OEmbedProvider("roomsharejp","rich",["roomshare\\.jp/(en/)?post/.*"],"http://roomshare.jp/oembed.json"),new e.fn.oembed.OEmbedProvider("lanyard","rich",["lanyrd.com/\\d+/.+"],null,{yql:{xpath:'(//div[@class="primary"])[1]',from:"htmlstring",datareturn:function(e){return!!e.result&&'<div class="oembedall-lanyard">'+e.result+"</div>"}}}),new e.fn.oembed.OEmbedProvider("asciiartfarts","rich",["asciiartfarts.com/\\d+.html"],null,{yql:{xpath:"//pre/font",from:"htmlstring",datareturn:function(e){return!!e.result&&'<pre style="background-color:000;">'+e.result+"</div>"}}}),new e.fn.oembed.OEmbedProvider("opengraph","rich",[".*"],null,{yql:{xpath:"//meta|//title|//link",from:"html",datareturn:function(t){!t["og:title"]&&t.title&&t.description&&(t["og:title"]=t.title);if(!t["og:title"]&&!t.title)return!1;var i=e("<p/>");if(t["og:video"]){var n=e('<embed src="'+t["og:video"]+'"/>');n.attr("type",t["og:video:type"]||"application/x-shockwave-flash").css("max-height",r.maxHeight||"auto").css("max-width",r.maxWidth||"auto");t["og:video:width"]&&n.attr("width",t["og:video:width"]);t["og:video:height"]&&n.attr("height",t["og:video:height"]);i.append(n)}else if(t["og:image"]){var s=e('<img src="'+t["og:image"]+'">');s.css("max-height",r.maxHeight||"auto").css("max-width",r.maxWidth||"auto");t["og:image:width"]&&s.attr("width",t["og:image:width"]);t["og:image:height"]&&s.attr("height",t["og:image:height"]);i.append(s)}t["og:title"]&&i.append("<b>"+t["og:title"]+"</b><br/>");t["og:description"]?i.append(t["og:description"]+"<br/>"):t.description&&i.append(t.description+"<br/>");return i}}})]}(jQuery);String.prototype.md5=function(){var e=function(e,t){var i=(65535&e)+(65535&t),n=(e>>16)+(t>>16)+(i>>16);return n<<16|65535&i},t=function(e,t){return e<<t|e>>>32-t},i=function(i,n,s,a,o,r){return e(t(e(e(n,i),e(a,r)),o),s)},n=function(e,t,n,s,a,o,r){return i(t&n|~t&s,e,t,a,o,r)},s=function(e,t,n,s,a,o,r){return i(t&s|n&~s,e,t,a,o,r)},a=function(e,t,n,s,a,o,r){return i(t^n^s,e,t,a,o,r)},o=function(e,t,n,s,a,o,r){return i(n^(t|~s),e,t,a,o,r)},r=function(t){var i,r,l,c,h,u=t.length,d=1732584193,p=-271733879,f=-1732584194,m=271733878;for(h=0;h<u;h+=16){i=d;r=p;l=f;c=m;d=n(d,p,f,m,t[h+0],7,-680876936);m=n(m,d,p,f,t[h+1],12,-389564586);f=n(f,m,d,p,t[h+2],17,606105819);p=n(p,f,m,d,t[h+3],22,-1044525330);d=n(d,p,f,m,t[h+4],7,-176418897);m=n(m,d,p,f,t[h+5],12,1200080426);f=n(f,m,d,p,t[h+6],17,-1473231341);p=n(p,f,m,d,t[h+7],22,-45705983);d=n(d,p,f,m,t[h+8],7,1770035416);m=n(m,d,p,f,t[h+9],12,-1958414417);f=n(f,m,d,p,t[h+10],17,-42063);p=n(p,f,m,d,t[h+11],22,-1990404162);d=n(d,p,f,m,t[h+12],7,1804603682);m=n(m,d,p,f,t[h+13],12,-40341101);f=n(f,m,d,p,t[h+14],17,-1502002290);p=n(p,f,m,d,t[h+15],22,1236535329);d=s(d,p,f,m,t[h+1],5,-165796510);m=s(m,d,p,f,t[h+6],9,-1069501632);f=s(f,m,d,p,t[h+11],14,643717713);p=s(p,f,m,d,t[h+0],20,-373897302);d=s(d,p,f,m,t[h+5],5,-701558691);m=s(m,d,p,f,t[h+10],9,38016083);f=s(f,m,d,p,t[h+15],14,-660478335);p=s(p,f,m,d,t[h+4],20,-405537848);d=s(d,p,f,m,t[h+9],5,568446438);m=s(m,d,p,f,t[h+14],9,-1019803690);f=s(f,m,d,p,t[h+3],14,-187363961);p=s(p,f,m,d,t[h+8],20,1163531501);d=s(d,p,f,m,t[h+13],5,-1444681467);m=s(m,d,p,f,t[h+2],9,-51403784);f=s(f,m,d,p,t[h+7],14,1735328473);p=s(p,f,m,d,t[h+12],20,-1926607734);d=a(d,p,f,m,t[h+5],4,-378558);m=a(m,d,p,f,t[h+8],11,-2022574463);f=a(f,m,d,p,t[h+11],16,1839030562);p=a(p,f,m,d,t[h+14],23,-35309556);d=a(d,p,f,m,t[h+1],4,-1530992060);m=a(m,d,p,f,t[h+4],11,1272893353);f=a(f,m,d,p,t[h+7],16,-155497632);p=a(p,f,m,d,t[h+10],23,-1094730640);d=a(d,p,f,m,t[h+13],4,681279174);m=a(m,d,p,f,t[h+0],11,-358537222);f=a(f,m,d,p,t[h+3],16,-722521979);p=a(p,f,m,d,t[h+6],23,76029189);d=a(d,p,f,m,t[h+9],4,-640364487);m=a(m,d,p,f,t[h+12],11,-421815835);f=a(f,m,d,p,t[h+15],16,530742520);p=a(p,f,m,d,t[h+2],23,-995338651);d=o(d,p,f,m,t[h+0],6,-198630844);m=o(m,d,p,f,t[h+7],10,1126891415);f=o(f,m,d,p,t[h+14],15,-1416354905);p=o(p,f,m,d,t[h+5],21,-57434055);d=o(d,p,f,m,t[h+12],6,1700485571);m=o(m,d,p,f,t[h+3],10,-1894986606);f=o(f,m,d,p,t[h+10],15,-1051523);p=o(p,f,m,d,t[h+1],21,-2054922799);d=o(d,p,f,m,t[h+8],6,1873313359);m=o(m,d,p,f,t[h+15],10,-30611744);f=o(f,m,d,p,t[h+6],15,-1560198380);p=o(p,f,m,d,t[h+13],21,1309151649);d=o(d,p,f,m,t[h+4],6,-145523070);m=o(m,d,p,f,t[h+11],10,-1120210379);f=o(f,m,d,p,t[h+2],15,718787259);p=o(p,f,m,d,t[h+9],21,-343485551);d=e(d,i);p=e(p,r);f=e(f,l);m=e(m,c)}return[d,p,f,m]},l=function(e){var t,i="0123456789abcdef",n="",s=4*e.length;for(t=0;t<s;t++)n+=i.charAt(e[t>>2]>>t%4*8+4&15)+i.charAt(e[t>>2]>>t%4*8&15);return n},c=function(e){var t,i,n=(e.length+8>>6)+1,s=[],a=16*n,o=e.length;for(t=0;t<a;t++)s.push(0);for(i=0;i<o;i++)s[i>>2]|=(255&e.charCodeAt(i))<<i%4*8;s[i>>2]|=128<<i%4*8;s[16*n-2]=8*o;return s};return l(r(c(this)))};!function(e,t,i){function n(e){e=e||location.href;return"#"+e.replace(/^[^#]*#?(.*)$/,"$1")}var s,a="hashchange",o=document,r=e.event.special,l=o.documentMode,c="on"+a in t&&(l===i||l>7);e.fn[a]=function(e){return e?this.bind(a,e):this.trigger(a)};e.fn[a].delay=50;r[a]=e.extend(r[a],{setup:function(){if(c)return!1;e(s.start)},teardown:function(){if(c)return!1;e(s.stop)}});s=function(){function s(){var i=n(),o=p(h);if(i!==h){d(h=i,o);e(t).trigger(a)}else o!==h&&(location.href=location.href.replace(/#.*/,"")+o);r=setTimeout(s,e.fn[a].delay)}var r,l={},h=n(),u=function(e){return e},d=u,p=u;l.start=function(){r||s()};l.stop=function(){r&&clearTimeout(r);r=i};e.browser.msie&&!c&&function(){var t,i;l.start=function(){if(!t){i=e.fn[a].src;i=i&&i+n();t=e('<iframe tabindex="-1" title="empty"/>').hide().one("load",function(){i||d(n());s()}).attr("src",i||"javascript:0").insertAfter("body")[0].contentWindow;o.onpropertychange=function(){try{"title"===event.propertyName&&(t.document.title=o.title)}catch(e){}}}};l.stop=u;p=function(){return n(t.location.href)};d=function(i,n){var s=t.document,r=e.fn[a].domain;if(i!==n){s.title=o.title;s.open();r&&s.write('<script>document.domain="'+r+'"</script>');s.close();t.location.hash=i}}}();return l}()}(jQuery,this);!function(e){var t={filter_links:".tour_filters",alphabet_links:".alphabet_links",departure_date_links:".departure_date_links"},i={};e.fn.tourFilter=function(n){i=e.extend(t,n);return this.each(function(){var t=e(this),n=t.attr("id");n&&t.on("click",i.filter_links+" a, "+i.alphabet_links+" a, "+i.departure_date_links+" a",function(i){var s=e(this).attr("href").replace(/\s/g,"%20");i.preventDefault();t.load(s+" #"+n)})})}}(jQuery);!function(e,t){function i(e,t,i){var n=e.children(),s=!1;e.empty();for(var o=0,r=n.length;r>o;o++){var l=n.eq(o);if(e.append(l),i&&e.append(i),a(e,t)){l.remove(),s=!0;break}i&&i.detach()}return s}function n(t,i,o,r,l){var c=!1,h="table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style",u="script";return t.contents().detach().each(function(){var d=this,p=e(d);if("undefined"==typeof d||3==d.nodeType&&0==e.trim(d.data).length)return!0;if(p.is(u))t.append(p);else{if(c)return!0;t.append(p),l&&t[t.is(h)?"after":"append"](l),a(o,r)&&(c=3==d.nodeType?s(p,i,o,r,l):n(p,i,o,r,l),c||(p.detach(),c=!0)),c||l&&l.detach()}}),c}function s(t,i,n,s,r){var h=t[0];if(!h)return!1;var d=c(h),p=-1!==d.indexOf(" ")?" ":"　",f="letter"==s.wrap?"":p,m=d.split(f),g=-1,v=-1,b=0,y=m.length-1;for(s.fallbackToLetter&&0==b&&0==y&&(f="",m=d.split(f),y=m.length-1);y>=b&&(0!=b||0!=y);){var w=Math.floor((b+y)/2);if(w==v)break;v=w,l(h,m.slice(0,v+1).join(f)+s.ellipsis),a(n,s)?(y=v,s.fallbackToLetter&&0==b&&0==y&&(f="",m=m[0].split(f),g=-1,v=-1,b=0,y=m.length-1)):(g=v,b=v)}if(-1==g||1==m.length&&0==m[0].length){var x=t.parent();t.detach();var k=r&&r.closest(x).length?r.length:0;x.contents().length>k?h=u(x.contents().eq(-1-k),i):(h=u(x,i,!0),k||x.detach()),h&&(d=o(c(h),s),l(h,d),k&&r&&e(h).parent().append(r))}else d=o(m.slice(0,g+1).join(f),s),l(h,d);return!0}function a(e,t){return e.innerHeight()>t.maxHeight}function o(t,i){for(;e.inArray(t.slice(-1),i.lastCharacter.remove)>-1;)t=t.slice(0,-1);return e.inArray(t.slice(-1),i.lastCharacter.noEllipsis)<0&&(t+=i.ellipsis),t}function r(e){return{width:e.innerWidth(),height:e.innerHeight()}}function l(e,t){e.innerText?e.innerText=t:e.nodeValue?e.nodeValue=t:e.textContent&&(e.textContent=t)}function c(e){return e.innerText?e.innerText:e.nodeValue?e.nodeValue:e.textContent?e.textContent:""}function h(e){do e=e.previousSibling;while(e&&1!==e.nodeType&&3!==e.nodeType);return e}function u(t,i,n){var s,a=t&&t[0];if(a){if(!n){if(3===a.nodeType)return a;if(e.trim(t.text()))return u(t.contents().last(),i)}for(s=h(a);!s;){if(t=t.parent(),t.is(i)||!t.length)return!1;s=h(t[0])}if(s)return u(e(s),i)}return!1}function d(t,i){return!!t&&("string"==typeof t?(t=e(t,i),!!t.length&&t):!!t.jquery&&t)}function p(e){for(var t=e.innerHeight(),i=["paddingTop","paddingBottom"],n=0,s=i.length;s>n;n++){var a=parseInt(e.css(i[n]),10);isNaN(a)&&(a=0),t-=a}return t}if(!e.fn.dotdotdot){e.fn.dotdotdot=function(t){if(0==this.length)return e.fn.dotdotdot.debug('No element found for "'+this.selector+'".'),this;if(this.length>1)return this.each(function(){e(this).dotdotdot(t)});var s=this;s.data("dotdotdot")&&s.trigger("destroy.dot"),s.data("dotdotdot-style",s.attr("style")||""),s.css("word-wrap","break-word"),"nowrap"===s.css("white-space")&&s.css("white-space","normal"),s.bind_events=function(){return s.bind("update.dot",function(t,r){t.preventDefault(),t.stopPropagation(),l.maxHeight="number"==typeof l.height?l.height:p(s),l.maxHeight+=l.tolerance,"undefined"!=typeof r&&(("string"==typeof r||r instanceof HTMLElement)&&(r=e("<div />").append(r).contents()),r instanceof e&&(o=r)),m=s.wrapInner('<div class="dotdotdot" />').children(),m.contents().detach().end().append(o.clone(!0)).find("br").replaceWith("  <br />  ").end().css({height:"auto",width:"auto",border:"none",padding:0,margin:0});var h=!1,u=!1;return c.afterElement&&(h=c.afterElement.clone(!0),h.show(),c.afterElement.detach()),a(m,l)&&(u="children"==l.wrap?i(m,l,h):n(m,s,m,l,h)),m.replaceWith(m.contents()),m=null,e.isFunction(l.callback)&&l.callback.call(s[0],u,o),c.isTruncated=u,u}).bind("isTruncated.dot",function(e,t){return e.preventDefault(),e.stopPropagation(),"function"==typeof t&&t.call(s[0],c.isTruncated),c.isTruncated}).bind("originalContent.dot",function(e,t){return e.preventDefault(),e.stopPropagation(),"function"==typeof t&&t.call(s[0],o),o}).bind("destroy.dot",function(e){e.preventDefault(),e.stopPropagation(),s.unwatch().unbind_events().contents().detach().end().append(o).attr("style",s.data("dotdotdot-style")||"").data("dotdotdot",!1)}),s},s.unbind_events=function(){return s.unbind(".dot"),s},s.watch=function(){if(s.unwatch(),"window"==l.watch){var t=e(window),i=t.width(),n=t.height();t.bind("resize.dot"+c.dotId,function(){i==t.width()&&n==t.height()&&l.windowResizeFix||(i=t.width(),n=t.height(),u&&clearInterval(u),u=setTimeout(function(){s.trigger("update.dot")},10))})}else h=r(s),u=setInterval(function(){var e=r(s);(h.width!=e.width||h.height!=e.height)&&(s.trigger("update.dot"),h=r(s))},100);return s},s.unwatch=function(){return e(window).unbind("resize.dot"+c.dotId),u&&clearInterval(u),s};var o=s.contents(),l=e.extend(!0,{},e.fn.dotdotdot.defaults,t),c={},h={},u=null,m=null;return l.lastCharacter.remove instanceof Array||(l.lastCharacter.remove=e.fn.dotdotdot.defaultArrays.lastCharacter.remove),l.lastCharacter.noEllipsis instanceof Array||(l.lastCharacter.noEllipsis=e.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),c.afterElement=d(l.after,s),c.isTruncated=!1,c.dotId=f++,s.data("dotdotdot",!0).bind_events().trigger("update.dot"),l.watch&&s.watch(),s},e.fn.dotdotdot.defaults={ellipsis:"... ",wrap:"word",fallbackToLetter:!0,lastCharacter:{},tolerance:0,callback:null,after:null,height:null,watch:!1,windowResizeFix:!0},e.fn.dotdotdot.defaultArrays={lastCharacter:{remove:[" ","　",",",";",".","!","?"],noEllipsis:[]}},e.fn.dotdotdot.debug=function(){};var f=1,m=e.fn.html;e.fn.html=function(i){return i!=t&&!e.isFunction(i)&&this.data("dotdotdot")?this.trigger("update",[i]):m.apply(this,arguments)};var g=e.fn.text;e.fn.text=function(i){return i!=t&&!e.isFunction(i)&&this.data("dotdotdot")?(i=e("<div />").text(i).html(),this.trigger("update",[i])):g.apply(this,arguments)}}}(jQuery);!function(e){e.fn.CWTdotdotdot=function(t){var i={height:400,read_more:"Read more&hellip;",read_less:"Read less&hellip;"};if(t)var n=e.extend(i,t);else var n=i;this.each(function(){var t=e(this);t.dotdotdot({height:n.height,callback:function(e){e&&n.read_more&&t.append('<p><a class="read_more">'+n.read_more+"</a></p>").find("a.read_more").click(function(e){e.preventDefault();t.trigger("destroy")})}}).bind("destroy",function(){var e=t.find("a.read_more").length?"":'<p><a class="read_more">'+n.read_less+"</a></p>";t.append(e).find("a.read_more").click(function(e){e.preventDefault();t.CWTdotdotdot()})})})}}(jQuery);!function(){"use strict";function e(e){function t(t,n){var a,m,g=t==window,v=n&&void 0!==n.message?n.message:void 0;n=e.extend({},e.blockUI.defaults,n||{});if(!n.ignoreIfBlocked||!e(t).data("blockUI.isBlocked")){n.overlayCSS=e.extend({},e.blockUI.defaults.overlayCSS,n.overlayCSS||{});a=e.extend({},e.blockUI.defaults.css,n.css||{});n.onOverlayClick&&(n.overlayCSS.cursor="pointer");m=e.extend({},e.blockUI.defaults.themedCSS,n.themedCSS||{});v=void 0===v?n.message:v;g&&p&&i(window,{fadeOut:0});if(v&&"string"!=typeof v&&(v.parentNode||v.jquery)){var b=v.jquery?v[0]:v,y={};e(t).data("blockUI.history",y);y.el=b;y.parent=b.parentNode;y.display=b.style.display;y.position=b.style.position;y.parent&&y.parent.removeChild(b)}e(t).data("blockUI.onUnblock",n.onUnblock);var w,x,k,_,C=n.baseZ;w=e(h||n.forceIframe?'<iframe class="blockUI" style="z-index:'+C++ +';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="'+n.iframeSrc+'"></iframe>':'<div class="blockUI" style="display:none"></div>');x=e(n.theme?'<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:'+C++ +';display:none"></div>':'<div class="blockUI blockOverlay" style="z-index:'+C++ +';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');if(n.theme&&g){_='<div class="blockUI '+n.blockMsgClass+' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:'+(C+10)+';display:none;position:fixed">';n.title&&(_+='<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(n.title||"&nbsp;")+"</div>");_+='<div class="ui-widget-content ui-dialog-content"></div>';_+="</div>"}else if(n.theme){_='<div class="blockUI '+n.blockMsgClass+' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:'+(C+10)+';display:none;position:absolute">';n.title&&(_+='<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(n.title||"&nbsp;")+"</div>");_+='<div class="ui-widget-content ui-dialog-content"></div>';_+="</div>"}else _=g?'<div class="blockUI '+n.blockMsgClass+' blockPage" style="z-index:'+(C+10)+';display:none;position:fixed"></div>':'<div class="blockUI '+n.blockMsgClass+' blockElement" style="z-index:'+(C+10)+';display:none;position:absolute"></div>';k=e(_);if(v)if(n.theme){k.css(m);k.addClass("ui-widget-content");
}else k.css(a);n.theme||x.css(n.overlayCSS);x.css("position",g?"fixed":"absolute");(h||n.forceIframe)&&w.css("opacity",0);var T=[w,x,k],S=e(g?"body":t);e.each(T,function(){this.appendTo(S)});n.theme&&n.draggable&&e.fn.draggable&&k.draggable({handle:".ui-dialog-titlebar",cancel:"li"});var E=d&&(!e.support.boxModel||e("object,embed",g?null:t).length>0);if(u||E){g&&n.allowBodyStretch&&e.support.boxModel&&e("html,body").css("height","100%");if((u||!e.support.boxModel)&&!g)var D=l(t,"borderTopWidth"),P=l(t,"borderLeftWidth"),M=D?"(0 - "+D+")":0,N=P?"(0 - "+P+")":0;e.each(T,function(e,t){var i=t[0].style;i.position="absolute";if(e<2){g?i.setExpression("height","Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:"+n.quirksmodeOffsetHack+') + "px"'):i.setExpression("height",'this.parentNode.offsetHeight + "px"');g?i.setExpression("width",'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"'):i.setExpression("width",'this.parentNode.offsetWidth + "px"');N&&i.setExpression("left",N);M&&i.setExpression("top",M)}else if(n.centerY){g&&i.setExpression("top",'(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');i.marginTop=0}else if(!n.centerY&&g){var s=n.css&&n.css.top?parseInt(n.css.top,10):0,a="((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "+s+') + "px"';i.setExpression("top",a)}})}if(v){n.theme?k.find(".ui-widget-content").append(v):k.append(v);(v.jquery||v.nodeType)&&e(v).show()}(h||n.forceIframe)&&n.showOverlay&&w.show();if(n.fadeIn){var I=n.onBlock?n.onBlock:c,O=n.showOverlay&&!v?I:c,j=v?I:c;n.showOverlay&&x._fadeIn(n.fadeIn,O);v&&k._fadeIn(n.fadeIn,j)}else{n.showOverlay&&x.show();v&&k.show();n.onBlock&&n.onBlock()}s(1,t,n);if(g){p=k[0];f=e(n.focusableElements,p);n.focusInput&&setTimeout(o,20)}else r(k[0],n.centerX,n.centerY);if(n.timeout){var A=setTimeout(function(){g?e.unblockUI(n):e(t).unblock(n)},n.timeout);e(t).data("blockUI.timeout",A)}}}function i(t,i){var a,o=t==window,r=e(t),l=r.data("blockUI.history"),c=r.data("blockUI.timeout");if(c){clearTimeout(c);r.removeData("blockUI.timeout")}i=e.extend({},e.blockUI.defaults,i||{});s(0,t,i);if(null===i.onUnblock){i.onUnblock=r.data("blockUI.onUnblock");r.removeData("blockUI.onUnblock")}var h;h=o?e("body").children().filter(".blockUI").add("body > .blockUI"):r.find(">.blockUI");if(i.cursorReset){h.length>1&&(h[1].style.cursor=i.cursorReset);h.length>2&&(h[2].style.cursor=i.cursorReset)}o&&(p=f=null);if(i.fadeOut){a=h.length;h.stop().fadeOut(i.fadeOut,function(){0===--a&&n(h,l,i,t)})}else n(h,l,i,t)}function n(t,i,n,s){var a=e(s);if(!a.data("blockUI.isBlocked")){t.each(function(e,t){this.parentNode&&this.parentNode.removeChild(this)});if(i&&i.el){i.el.style.display=i.display;i.el.style.position=i.position;i.parent&&i.parent.appendChild(i.el);a.removeData("blockUI.history")}a.data("blockUI.static")&&a.css("position","static");"function"==typeof n.onUnblock&&n.onUnblock(s,n);var o=e(document.body),r=o.width(),l=o[0].style.width;o.width(r-1).width(r);o[0].style.width=l}}function s(t,i,n){var s=i==window,o=e(i);if(t||(!s||p)&&(s||o.data("blockUI.isBlocked"))){o.data("blockUI.isBlocked",t);if(s&&n.bindEvents&&(!t||n.showOverlay)){var r="mousedown mouseup keydown keypress keyup touchstart touchend touchmove";t?e(document).bind(r,n,a):e(document).unbind(r,a)}}}function a(t){if("keydown"===t.type&&t.keyCode&&9==t.keyCode&&p&&t.data.constrainTabKey){var i=f,n=!t.shiftKey&&t.target===i[i.length-1],s=t.shiftKey&&t.target===i[0];if(n||s){setTimeout(function(){o(s)},10);return!1}}var a=t.data,r=e(t.target);r.hasClass("blockOverlay")&&a.onOverlayClick&&a.onOverlayClick(t);return r.parents("div."+a.blockMsgClass).length>0||0===r.parents().children().filter("div.blockUI").length}function o(e){if(f){var t=f[e===!0?f.length-1:0];t&&t.focus()}}function r(e,t,i){var n=e.parentNode,s=e.style,a=(n.offsetWidth-e.offsetWidth)/2-l(n,"borderLeftWidth"),o=(n.offsetHeight-e.offsetHeight)/2-l(n,"borderTopWidth");t&&(s.left=a>0?a+"px":"0");i&&(s.top=o>0?o+"px":"0")}function l(t,i){return parseInt(e.css(t,i),10)||0}e.fn._fadeIn=e.fn.fadeIn;var c=e.noop||function(){},h=/MSIE/.test(navigator.userAgent),u=/MSIE 6.0/.test(navigator.userAgent)&&!/MSIE 8.0/.test(navigator.userAgent),d=(document.documentMode||0,e.isFunction(document.createElement("div").style.setExpression));e.blockUI=function(e){t(window,e)};e.unblockUI=function(e){i(window,e)};e.growlUI=function(t,i,n,s){var a=e('<div class="growlUI"></div>');t&&a.append("<h1>"+t+"</h1>");i&&a.append("<h2>"+i+"</h2>");void 0===n&&(n=3e3);var o=function(t){t=t||{};e.blockUI({message:a,fadeIn:"undefined"!=typeof t.fadeIn?t.fadeIn:700,fadeOut:"undefined"!=typeof t.fadeOut?t.fadeOut:1e3,timeout:"undefined"!=typeof t.timeout?t.timeout:n,centerY:!1,showOverlay:!1,onUnblock:s,css:e.blockUI.defaults.growlCSS})};o();a.css("opacity");a.mouseover(function(){o({fadeIn:0,timeout:3e4});var t=e(".blockMsg");t.stop();t.fadeTo(300,1)}).mouseout(function(){e(".blockMsg").fadeOut(1e3)})};e.fn.block=function(i){if(this[0]===window){e.blockUI(i);return this}var n=e.extend({},e.blockUI.defaults,i||{});this.each(function(){var t=e(this);n.ignoreIfBlocked&&t.data("blockUI.isBlocked")||t.unblock({fadeOut:0})});return this.each(function(){if("static"==e.css(this,"position")){this.style.position="relative";e(this).data("blockUI.static",!0)}this.style.zoom=1;t(this,i)})};e.fn.unblock=function(t){if(this[0]===window){e.unblockUI(t);return this}return this.each(function(){i(this,t)})};e.blockUI.version=2.66;e.blockUI.defaults={message:"<h1>Please wait...</h1>",title:null,draggable:!0,theme:!1,css:{padding:0,margin:0,width:"30%",top:"40%",left:"35%",textAlign:"center",color:"#000",border:"3px solid #aaa",backgroundColor:"#fff",cursor:"wait"},themedCSS:{width:"30%",top:"40%",left:"35%"},overlayCSS:{backgroundColor:"#000",opacity:.6,cursor:"wait"},cursorReset:"default",growlCSS:{width:"350px",top:"10px",left:"",right:"10px",border:"none",padding:"5px",opacity:.6,cursor:"default",color:"#fff",backgroundColor:"#000","-webkit-border-radius":"10px","-moz-border-radius":"10px","border-radius":"10px"},iframeSrc:/^https/i.test(window.location.href||"")?"javascript:false":"about:blank",forceIframe:!1,baseZ:1e3,centerX:!0,centerY:!0,allowBodyStretch:!0,bindEvents:!0,constrainTabKey:!0,fadeIn:200,fadeOut:400,timeout:0,showOverlay:!0,focusInput:!0,focusableElements:":input:enabled:visible",onBlock:null,onUnblock:null,onOverlayClick:null,quirksmodeOffsetHack:4,blockMsgClass:"blockMsg",ignoreIfBlocked:!1};var p=null,f=[]}"function"==typeof define&&define.amd&&define.amd.jQuery?define(["jquery"],e):e(jQuery)}();!function(e){"undefined"==typeof e.fn.each2&&e.extend(e.fn,{each2:function(t){for(var i=e([0]),n=-1,s=this.length;++n<s&&(i.context=i[0]=this[n])&&t.call(i[0],n,i)!==!1;);return this}})}(jQuery),function(e,t){"use strict";function i(t){var i=e(document.createTextNode(""));t.before(i),i.before(t),i.remove()}function n(e){function t(e){return z[e]||e}return e.replace(/[^\u0000-\u007E]/g,t)}function s(e,t){for(var i=0,n=t.length;n>i;i+=1)if(o(e,t[i]))return i;return-1}function a(){var t=e(R);t.appendTo("body");var i={width:t.width()-t[0].clientWidth,height:t.height()-t[0].clientHeight};return t.remove(),i}function o(e,i){return e===i||e!==t&&i!==t&&(null!==e&&null!==i&&(e.constructor===String?e+""==i+"":i.constructor===String&&i+""==e+""))}function r(t,i){var n,s,a;if(null===t||t.length<1)return[];for(n=t.split(i),s=0,a=n.length;a>s;s+=1)n[s]=e.trim(n[s]);return n}function l(e){return e.outerWidth(!1)-e.width()}function c(i){var n="keyup-change-value";i.on("keydown",function(){e.data(i,n)===t&&e.data(i,n,i.val())}),i.on("keyup",function(){var s=e.data(i,n);s!==t&&i.val()!==s&&(e.removeData(i,n),i.trigger("keyup-change"))})}function h(i){i.on("mousemove",function(i){var n=H;(n===t||n.x!==i.pageX||n.y!==i.pageY)&&e(i.target).trigger("mousemove-filtered",i)})}function u(e,i,n){n=n||t;var s;return function(){var t=arguments;window.clearTimeout(s),s=window.setTimeout(function(){i.apply(n,t)},e)}}function d(e,t){var i=u(e,function(e){t.trigger("scroll-debounced",e)});t.on("scroll",function(e){s(e.target,t.get())>=0&&i(e)})}function p(e){e[0]!==document.activeElement&&window.setTimeout(function(){var t,i=e[0],n=e.val().length;e.focus();var s=i.offsetWidth>0||i.offsetHeight>0;s&&i===document.activeElement&&(i.setSelectionRange?i.setSelectionRange(n,n):i.createTextRange&&(t=i.createTextRange(),t.collapse(!1),t.select()))},0)}function f(t){t=e(t)[0];var i=0,n=0;if("selectionStart"in t)i=t.selectionStart,n=t.selectionEnd-i;else if("selection"in document){t.focus();var s=document.selection.createRange();n=document.selection.createRange().text.length,s.moveStart("character",-t.value.length),i=s.text.length-n}return{offset:i,length:n}}function m(e){e.preventDefault(),e.stopPropagation()}function g(e){e.preventDefault(),e.stopImmediatePropagation()}function v(t){if(!A){var i=t[0].currentStyle||window.getComputedStyle(t[0],null);A=e(document.createElement("div")).css({position:"absolute",left:"-10000px",top:"-10000px",display:"none",fontSize:i.fontSize,fontFamily:i.fontFamily,fontStyle:i.fontStyle,fontWeight:i.fontWeight,letterSpacing:i.letterSpacing,textTransform:i.textTransform,whiteSpace:"nowrap"}),A.attr("class","select2-sizer"),e("body").append(A)}return A.text(t.val()),A.width()}function b(t,i,n){var s,a,o=[];s=t.attr("class"),s&&(s=""+s,e(s.split(" ")).each2(function(){0===this.indexOf("select2-")&&o.push(this)})),s=i.attr("class"),s&&(s=""+s,e(s.split(" ")).each2(function(){0!==this.indexOf("select2-")&&(a=n(this),a&&o.push(a))})),t.attr("class",o.join(" "))}function y(e,t,i,s){var a=n(e.toUpperCase()).indexOf(n(t.toUpperCase())),o=t.length;return 0>a?void i.push(s(e)):(i.push(s(e.substring(0,a))),i.push("<span class='select2-match'>"),i.push(s(e.substring(a,a+o))),i.push("</span>"),void i.push(s(e.substring(a+o,e.length))))}function w(e){var t={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return String(e).replace(/[&<>"'\/\\]/g,function(e){return t[e]})}function x(i){var n,s=null,a=i.quietMillis||100,o=i.url,r=this;return function(l){window.clearTimeout(n),n=window.setTimeout(function(){var n=i.data,a=o,c=i.transport||e.fn.select2.ajaxDefaults.transport,h={type:i.type||"GET",cache:i.cache||!1,jsonpCallback:i.jsonpCallback||t,dataType:i.dataType||"json"},u=e.extend({},e.fn.select2.ajaxDefaults.params,h);n=n?n.call(r,l.term,l.page,l.context):null,a="function"==typeof a?a.call(r,l.term,l.page,l.context):a,s&&"function"==typeof s.abort&&s.abort(),i.params&&(e.isFunction(i.params)?e.extend(u,i.params.call(r)):e.extend(u,i.params)),e.extend(u,{url:a,dataType:i.dataType,data:n,success:function(e){var t=i.results(e,l.page);l.callback(t)}}),s=c.call(r,u)},a)}}function k(t){var i,n,s=t,a=function(e){return""+e.text};e.isArray(s)&&(n=s,s={results:n}),e.isFunction(s)===!1&&(n=s,s=function(){return n});var o=s();return o.text&&(a=o.text,e.isFunction(a)||(i=o.text,a=function(e){return e[i]})),function(t){var i,n=t.term,o={results:[]};return""===n?void t.callback(s()):(i=function(s,o){var r,l;if(s=s[0],s.children){r={};for(l in s)s.hasOwnProperty(l)&&(r[l]=s[l]);r.children=[],e(s.children).each2(function(e,t){i(t,r.children)}),(r.children.length||t.matcher(n,a(r),s))&&o.push(r)}else t.matcher(n,a(s),s)&&o.push(s)},e(s().results).each2(function(e,t){i(t,o.results)}),void t.callback(o))}}function _(i){var n=e.isFunction(i);return function(s){var a=s.term,o={results:[]},r=n?i(s):i;e.isArray(r)&&(e(r).each(function(){var e=this.text!==t,i=e?this.text:this;(""===a||s.matcher(a,i))&&o.results.push(e?this:{id:this,text:this})}),s.callback(o))}}function C(t,i){if(e.isFunction(t))return!0;if(!t)return!1;if("string"==typeof t)return!0;throw new Error(i+" must be a string, function, or falsy value")}function T(t){if(e.isFunction(t)){var i=Array.prototype.slice.call(arguments,1);return t.apply(null,i)}return t}function S(t){var i=0;return e.each(t,function(e,t){t.children?i+=S(t.children):i++}),i}function E(e,i,n,s){var a,r,l,c,h,u=e,d=!1;if(!s.createSearchChoice||!s.tokenSeparators||s.tokenSeparators.length<1)return t;for(;;){for(r=-1,l=0,c=s.tokenSeparators.length;c>l&&(h=s.tokenSeparators[l],r=e.indexOf(h),!(r>=0));l++);if(0>r)break;if(a=e.substring(0,r),e=e.substring(r+h.length),a.length>0&&(a=s.createSearchChoice.call(this,a,i),a!==t&&null!==a&&s.id(a)!==t&&null!==s.id(a))){for(d=!1,l=0,c=i.length;c>l;l++)if(o(s.id(a),s.id(i[l]))){d=!0;break}d||n(a)}}return u!==e?e:void 0}function D(){var e=this;Array.prototype.forEach.call(arguments,function(t){e[t].remove(),e[t]=null})}function P(t,i){var n=function(){};return n.prototype=new t,n.prototype.constructor=n,n.prototype.parent=t.prototype,n.prototype=e.extend(n.prototype,i),n}if(window.Select2===t){var M,N,I,O,j,A,F,L,H={x:0,y:0},M={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,isArrow:function(e){switch(e=e.which?e.which:e){case M.LEFT:case M.RIGHT:case M.UP:case M.DOWN:return!0}return!1},isControl:function(e){var t=e.which;switch(t){case M.SHIFT:case M.CTRL:case M.ALT:return!0}return!!e.metaKey},isFunctionKey:function(e){return e=e.which?e.which:e,e>=112&&123>=e}},R="<div class='select2-measure-scrollbar'></div>",z={"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z"};F=e(document),j=function(){var e=1;return function(){return e++}}(),F.on("mousemove",function(e){H.x=e.pageX,H.y=e.pageY}),N=P(Object,{bind:function(e){var t=this;return function(){e.apply(t,arguments)}},init:function(i){var n,s,o=".select2-results";this.opts=i=this.prepareOpts(i),this.id=i.id,i.element.data("select2")!==t&&null!==i.element.data("select2")&&i.element.data("select2").destroy(),this.container=this.createContainer(),this.liveRegion=e("<span>",{role:"status","aria-live":"polite"}).addClass("select2-hidden-accessible").appendTo(document.body),this.containerId="s2id_"+(i.element.attr("id")||"autogen"+j()),this.containerEventName=this.containerId.replace(/([.])/g,"_").replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g,"\\$1"),this.container.attr("id",this.containerId),this.container.attr("title",i.element.attr("title")),this.body=e("body"),b(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.attr("style",i.element.attr("style")),this.container.css(T(i.containerCss)),this.container.addClass(T(i.containerCssClass)),this.elementTabIndex=this.opts.element.attr("tabindex"),this.opts.element.data("select2",this).attr("tabindex","-1").before(this.container).on("click.select2",m),this.container.data("select2",this),this.dropdown=this.container.find(".select2-drop"),b(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(T(i.dropdownCssClass)),this.dropdown.data("select2",this),this.dropdown.on("click",m),this.results=n=this.container.find(o),this.search=s=this.container.find("input.select2-input"),this.queryCount=0,this.resultsPage=0,this.context=null,this.initContainer(),this.container.on("click",m),h(this.results),this.dropdown.on("mousemove-filtered",o,this.bind(this.highlightUnderEvent)),this.dropdown.on("touchstart touchmove touchend",o,this.bind(function(e){this._touchEvent=!0,this.highlightUnderEvent(e)})),this.dropdown.on("touchmove",o,this.bind(this.touchMoved)),this.dropdown.on("touchstart touchend",o,this.bind(this.clearTouchMoved)),this.dropdown.on("click",this.bind(function(){this._touchEvent&&(this._touchEvent=!1,this.selectHighlighted())})),d(80,this.results),this.dropdown.on("scroll-debounced",o,this.bind(this.loadMoreIfNeeded)),e(this.container).on("change",".select2-input",function(e){e.stopPropagation()}),e(this.dropdown).on("change",".select2-input",function(e){e.stopPropagation()}),e.fn.mousewheel&&n.mousewheel(function(e,t,i,s){var a=n.scrollTop();s>0&&0>=a-s?(n.scrollTop(0),m(e)):0>s&&n.get(0).scrollHeight-n.scrollTop()+s<=n.height()&&(n.scrollTop(n.get(0).scrollHeight-n.height()),m(e))}),c(s),s.on("keyup-change input paste",this.bind(this.updateResults)),s.on("focus",function(){s.addClass("select2-focused")}),s.on("blur",function(){s.removeClass("select2-focused")}),this.dropdown.on("mouseup",o,this.bind(function(t){e(t.target).closest(".select2-result-selectable").length>0&&(this.highlightUnderEvent(t),this.selectHighlighted(t))})),this.dropdown.on("click mouseup mousedown touchstart touchend focusin",function(e){e.stopPropagation()}),this.nextSearchTerm=t,e.isFunction(this.opts.initSelection)&&(this.initSelection(),this.monitorSource()),null!==i.maximumInputLength&&this.search.attr("maxlength",i.maximumInputLength);var r=i.element.prop("disabled");r===t&&(r=!1),this.enable(!r);var l=i.element.prop("readonly");l===t&&(l=!1),this.readonly(l),L=L||a(),this.autofocus=i.element.prop("autofocus"),i.element.prop("autofocus",!1),this.autofocus&&this.focus(),this.search.attr("placeholder",i.searchInputPlaceholder)},destroy:function(){var e=this.opts.element,i=e.data("select2");this.close(),this.propertyObserver&&(this.propertyObserver.disconnect(),this.propertyObserver=null),i!==t&&(i.container.remove(),i.liveRegion.remove(),i.dropdown.remove(),e.removeClass("select2-offscreen").removeData("select2").off(".select2").prop("autofocus",this.autofocus||!1),this.elementTabIndex?e.attr({tabindex:this.elementTabIndex}):e.removeAttr("tabindex"),e.show()),D.call(this,"container","liveRegion","dropdown","results","search")},optionToData:function(e){return e.is("option")?{id:e.prop("value"),text:e.text(),element:e.get(),css:e.attr("class"),disabled:e.prop("disabled"),locked:o(e.attr("locked"),"locked")||o(e.data("locked"),!0)}:e.is("optgroup")?{text:e.attr("label"),children:[],element:e.get(),css:e.attr("class")}:void 0},prepareOpts:function(i){var n,s,a,l,c=this;if(n=i.element,"select"===n.get(0).tagName.toLowerCase()&&(this.select=s=i.element),s&&e.each(["id","multiple","ajax","query","createSearchChoice","initSelection","data","tags"],function(){if(this in i)throw new Error("Option '"+this+"' is not allowed for Select2 when attached to a <select> element.")}),i=e.extend({},{populateResults:function(n,s,a){var o,r=this.opts.id,l=this.liveRegion;(o=function(n,s,h){var u,d,p,f,m,g,v,b,y,w;for(n=i.sortResults(n,s,a),u=0,d=n.length;d>u;u+=1)p=n[u],m=p.disabled===!0,f=!m&&r(p)!==t,g=p.children&&p.children.length>0,v=e("<li></li>"),v.addClass("select2-results-dept-"+h),v.addClass("select2-result"),v.addClass(f?"select2-result-selectable":"select2-result-unselectable"),m&&v.addClass("select2-disabled"),g&&v.addClass("select2-result-with-children"),v.addClass(c.opts.formatResultCssClass(p)),v.attr("role","presentation"),b=e(document.createElement("div")),b.addClass("select2-result-label"),b.attr("id","select2-result-label-"+j()),b.attr("role","option"),w=i.formatResult(p,b,a,c.opts.escapeMarkup),w!==t&&(b.html(w),v.append(b)),g&&(y=e("<ul></ul>"),y.addClass("select2-result-sub"),o(p.children,y,h+1),v.append(y)),v.data("select2-data",p),s.append(v);l.text(i.formatMatches(n.length))})(s,n,0)}},e.fn.select2.defaults,i),"function"!=typeof i.id&&(a=i.id,i.id=function(e){return e[a]}),e.isArray(i.element.data("select2Tags"))){if("tags"in i)throw"tags specified as both an attribute 'data-select2-tags' and in options of Select2 "+i.element.attr("id");i.tags=i.element.data("select2Tags")}if(s?(i.query=this.bind(function(e){var i,s,a,o={results:[],more:!1},r=e.term;a=function(t,i){var n;t.is("option")?e.matcher(r,t.text(),t)&&i.push(c.optionToData(t)):t.is("optgroup")&&(n=c.optionToData(t),t.children().each2(function(e,t){a(t,n.children)}),n.children.length>0&&i.push(n))},i=n.children(),this.getPlaceholder()!==t&&i.length>0&&(s=this.getPlaceholderOption(),s&&(i=i.not(s))),i.each2(function(e,t){a(t,o.results)}),e.callback(o)}),i.id=function(e){return e.id}):"query"in i||("ajax"in i?(l=i.element.data("ajax-url"),l&&l.length>0&&(i.ajax.url=l),i.query=x.call(i.element,i.ajax)):"data"in i?i.query=k(i.data):"tags"in i&&(i.query=_(i.tags),i.createSearchChoice===t&&(i.createSearchChoice=function(t){return{id:e.trim(t),text:e.trim(t)}}),i.initSelection===t&&(i.initSelection=function(t,n){var s=[];e(r(t.val(),i.separator)).each(function(){var t={id:this,text:this},n=i.tags;e.isFunction(n)&&(n=n()),e(n).each(function(){return o(this.id,t.id)?(t=this,!1):void 0}),s.push(t)}),n(s)}))),"function"!=typeof i.query)throw"query function not defined for Select2 "+i.element.attr("id");if("top"===i.createSearchChoicePosition)i.createSearchChoicePosition=function(e,t){e.unshift(t)};else if("bottom"===i.createSearchChoicePosition)i.createSearchChoicePosition=function(e,t){e.push(t)};else if("function"!=typeof i.createSearchChoicePosition)throw"invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";return i},monitorSource:function(){var e,i,n=this.opts.element;n.on("change.select2",this.bind(function(){this.opts.element.data("select2-change-triggered")!==!0&&this.initSelection()})),e=this.bind(function(){var e=n.prop("disabled");e===t&&(e=!1),this.enable(!e);var i=n.prop("readonly");i===t&&(i=!1),this.readonly(i),b(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.addClass(T(this.opts.containerCssClass)),b(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(T(this.opts.dropdownCssClass))}),n.length&&n[0].attachEvent&&n.each(function(){this.attachEvent("onpropertychange",e)}),i=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,i!==t&&(this.propertyObserver&&(delete this.propertyObserver,this.propertyObserver=null),this.propertyObserver=new i(function(t){t.forEach(e)}),this.propertyObserver.observe(n.get(0),{attributes:!0,subtree:!1}))},triggerSelect:function(t){var i=e.Event("select2-selecting",{val:this.id(t),object:t});return this.opts.element.trigger(i),!i.isDefaultPrevented()},triggerChange:function(t){t=t||{},t=e.extend({},t,{type:"change",val:this.val()}),this.opts.element.data("select2-change-triggered",!0),this.opts.element.trigger(t),this.opts.element.data("select2-change-triggered",!1),this.opts.element.click(),this.opts.blurOnChange&&this.opts.element.blur()},isInterfaceEnabled:function(){return this.enabledInterface===!0},enableInterface:function(){var e=this._enabled&&!this._readonly,t=!e;return e!==this.enabledInterface&&(this.container.toggleClass("select2-container-disabled",t),this.close(),this.enabledInterface=e,!0)},enable:function(e){e===t&&(e=!0),this._enabled!==e&&(this._enabled=e,this.opts.element.prop("disabled",!e),this.enableInterface())},disable:function(){this.enable(!1)},readonly:function(e){e===t&&(e=!1),this._readonly!==e&&(this._readonly=e,this.opts.element.prop("readonly",e),this.enableInterface())},opened:function(){return this.container.hasClass("select2-dropdown-open")},positionDropdown:function(){var t,i,n,s,a,o=this.dropdown,r=this.container.offset(),l=this.container.outerHeight(!1),c=this.container.outerWidth(!1),h=o.outerHeight(!1),u=e(window),d=u.width(),p=u.height(),f=u.scrollLeft()+d,m=u.scrollTop()+p,g=r.top+l,v=r.left,b=m>=g+h,y=r.top-h>=u.scrollTop(),w=o.outerWidth(!1),x=f>=v+w,k=o.hasClass("select2-drop-above");k?(i=!0,!y&&b&&(n=!0,i=!1)):(i=!1,!b&&y&&(n=!0,i=!0)),n&&(o.hide(),r=this.container.offset(),l=this.container.outerHeight(!1),c=this.container.outerWidth(!1),h=o.outerHeight(!1),f=u.scrollLeft()+d,m=u.scrollTop()+p,g=r.top+l,v=r.left,w=o.outerWidth(!1),x=f>=v+w,o.show(),this.focusSearch()),this.opts.dropdownAutoWidth?(a=e(".select2-results",o)[0],o.addClass("select2-drop-auto-width"),o.css("width",""),w=o.outerWidth(!1)+(a.scrollHeight===a.clientHeight?0:L.width),w>c?c=w:w=c,h=o.outerHeight(!1),x=f>=v+w):this.container.removeClass("select2-drop-auto-width"),"static"!==this.body.css("position")&&(t=this.body.offset(),g-=t.top,v-=t.left),x||(v=r.left+this.container.outerWidth(!1)-w),s={left:v,width:c},i?(s.top=r.top-h,s.bottom="auto",this.container.addClass("select2-drop-above"),o.addClass("select2-drop-above")):(s.top=g,s.bottom="auto",this.container.removeClass("select2-drop-above"),o.removeClass("select2-drop-above")),s=e.extend(s,T(this.opts.dropdownCss)),o.css(s)},shouldOpen:function(){var t;return!this.opened()&&(this._enabled!==!1&&this._readonly!==!0&&(t=e.Event("select2-opening"),this.opts.element.trigger(t),!t.isDefaultPrevented()))},clearDropdownAlignmentPreference:function(){this.container.removeClass("select2-drop-above"),this.dropdown.removeClass("select2-drop-above")},open:function(){return!!this.shouldOpen()&&(this.opening(),!0)},opening:function(){var t,n=this.containerEventName,s="scroll."+n,a="resize."+n,o="orientationchange."+n;this.container.addClass("select2-dropdown-open").addClass("select2-container-active"),this.clearDropdownAlignmentPreference(),this.dropdown[0]!==this.body.children().last()[0]&&this.dropdown.detach().appendTo(this.body),t=e("#select2-drop-mask"),0==t.length&&(t=e(document.createElement("div")),t.attr("id","select2-drop-mask").attr("class","select2-drop-mask"),t.hide(),t.appendTo(this.body),t.on("mousedown touchstart click",function(n){i(t);var s,a=e("#select2-drop");a.length>0&&(s=a.data("select2"),s.opts.selectOnBlur&&s.selectHighlighted({noFocus:!0}),s.close(),n.preventDefault(),
n.stopPropagation())})),this.dropdown.prev()[0]!==t[0]&&this.dropdown.before(t),e("#select2-drop").removeAttr("id"),this.dropdown.attr("id","select2-drop"),t.show(),this.positionDropdown(),this.dropdown.show(),this.positionDropdown(),this.dropdown.addClass("select2-drop-active");var r=this;this.container.parents().add(window).each(function(){e(this).on(a+" "+s+" "+o,function(){r.opened()&&r.positionDropdown()})})},close:function(){if(this.opened()){var t=this.containerEventName,i="scroll."+t,n="resize."+t,s="orientationchange."+t;this.container.parents().add(window).each(function(){e(this).off(i).off(n).off(s)}),this.clearDropdownAlignmentPreference(),e("#select2-drop-mask").hide(),this.dropdown.removeAttr("id"),this.dropdown.hide(),this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active"),this.results.empty(),this.clearSearch(),this.search.removeClass("select2-active"),this.opts.element.trigger(e.Event("select2-close"))}},externalSearch:function(e){this.open(),this.search.val(e),this.updateResults(!1)},clearSearch:function(){},getMaximumSelectionSize:function(){return T(this.opts.maximumSelectionSize)},ensureHighlightVisible:function(){var t,i,n,s,a,o,r,l=this.results;if(i=this.highlight(),!(0>i)){if(0==i)return void l.scrollTop(0);t=this.findHighlightableChoices().find(".select2-result-label"),n=e(t[i]),s=n.offset().top+n.outerHeight(!0),i===t.length-1&&(r=l.find("li.select2-more-results"),r.length>0&&(s=r.offset().top+r.outerHeight(!0))),a=l.offset().top+l.outerHeight(!0),s>a&&l.scrollTop(l.scrollTop()+(s-a)),o=n.offset().top-l.offset().top,0>o&&"none"!=n.css("display")&&l.scrollTop(l.scrollTop()+o)}},findHighlightableChoices:function(){return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)")},moveHighlight:function(t){for(var i=this.findHighlightableChoices(),n=this.highlight();n>-1&&n<i.length;){n+=t;var s=e(i[n]);if(s.hasClass("select2-result-selectable")&&!s.hasClass("select2-disabled")&&!s.hasClass("select2-selected")){this.highlight(n);break}}},highlight:function(t){var i,n,a=this.findHighlightableChoices();return 0===arguments.length?s(a.filter(".select2-highlighted")[0],a.get()):(t>=a.length&&(t=a.length-1),0>t&&(t=0),this.removeHighlight(),i=e(a[t]),i.addClass("select2-highlighted"),this.search.attr("aria-activedescendant",i.find(".select2-result-label").attr("id")),this.ensureHighlightVisible(),this.liveRegion.text(i.text()),n=i.data("select2-data"),void(n&&this.opts.element.trigger({type:"select2-highlight",val:this.id(n),choice:n})))},removeHighlight:function(){this.results.find(".select2-highlighted").removeClass("select2-highlighted")},touchMoved:function(){this._touchMoved=!0},clearTouchMoved:function(){this._touchMoved=!1},countSelectableResults:function(){return this.findHighlightableChoices().length},highlightUnderEvent:function(t){var i=e(t.target).closest(".select2-result-selectable");if(i.length>0&&!i.is(".select2-highlighted")){var n=this.findHighlightableChoices();this.highlight(n.index(i))}else 0==i.length&&this.removeHighlight()},loadMoreIfNeeded:function(){var e,t=this.results,i=t.find("li.select2-more-results"),n=this.resultsPage+1,s=this,a=this.search.val(),o=this.context;0!==i.length&&(e=i.offset().top-t.offset().top-t.height(),e<=this.opts.loadMorePadding&&(i.addClass("select2-active"),this.opts.query({element:this.opts.element,term:a,page:n,context:o,matcher:this.opts.matcher,callback:this.bind(function(e){s.opened()&&(s.opts.populateResults.call(this,t,e.results,{term:a,page:n,context:o}),s.postprocessResults(e,!1,!1),e.more===!0?(i.detach().appendTo(t).text(T(s.opts.formatLoadMore,n+1)),window.setTimeout(function(){s.loadMoreIfNeeded()},10)):i.remove(),s.positionDropdown(),s.resultsPage=n,s.context=e.context,this.opts.element.trigger({type:"select2-loaded",items:e}))})})))},tokenize:function(){},updateResults:function(i){function n(){c.removeClass("select2-active"),d.positionDropdown(),h.find(".select2-no-results,.select2-selection-limit,.select2-searching").length?d.liveRegion.text(h.text()):d.liveRegion.text(d.opts.formatMatches(h.find(".select2-result-selectable").length))}function s(e){h.html(e),n()}var a,r,l,c=this.search,h=this.results,u=this.opts,d=this,p=c.val(),f=e.data(this.container,"select2-last-term");if((i===!0||!f||!o(p,f))&&(e.data(this.container,"select2-last-term",p),i===!0||this.showSearchInput!==!1&&this.opened())){l=++this.queryCount;var m=this.getMaximumSelectionSize();if(m>=1&&(a=this.data(),e.isArray(a)&&a.length>=m&&C(u.formatSelectionTooBig,"formatSelectionTooBig")))return void s("<li class='select2-selection-limit'>"+T(u.formatSelectionTooBig,m)+"</li>");if(c.val().length<u.minimumInputLength)return s(C(u.formatInputTooShort,"formatInputTooShort")?"<li class='select2-no-results'>"+T(u.formatInputTooShort,c.val(),u.minimumInputLength)+"</li>":""),void(i&&this.showSearch&&this.showSearch(!0));if(u.maximumInputLength&&c.val().length>u.maximumInputLength)return void s(C(u.formatInputTooLong,"formatInputTooLong")?"<li class='select2-no-results'>"+T(u.formatInputTooLong,c.val(),u.maximumInputLength)+"</li>":"");u.formatSearching&&0===this.findHighlightableChoices().length&&s("<li class='select2-searching'>"+T(u.formatSearching)+"</li>"),c.addClass("select2-active"),this.removeHighlight(),r=this.tokenize(),r!=t&&null!=r&&c.val(r),this.resultsPage=1,u.query({element:u.element,term:c.val(),page:this.resultsPage,context:null,matcher:u.matcher,callback:this.bind(function(a){var r;if(l==this.queryCount){if(!this.opened())return void this.search.removeClass("select2-active");if(this.context=a.context===t?null:a.context,this.opts.createSearchChoice&&""!==c.val()&&(r=this.opts.createSearchChoice.call(d,c.val(),a.results),r!==t&&null!==r&&d.id(r)!==t&&null!==d.id(r)&&0===e(a.results).filter(function(){return o(d.id(this),d.id(r))}).length&&this.opts.createSearchChoicePosition(a.results,r)),0===a.results.length&&C(u.formatNoMatches,"formatNoMatches"))return void s("<li class='select2-no-results'>"+T(u.formatNoMatches,c.val())+"</li>");h.empty(),d.opts.populateResults.call(this,h,a.results,{term:c.val(),page:this.resultsPage,context:null}),a.more===!0&&C(u.formatLoadMore,"formatLoadMore")&&(h.append("<li class='select2-more-results'>"+d.opts.escapeMarkup(T(u.formatLoadMore,this.resultsPage))+"</li>"),window.setTimeout(function(){d.loadMoreIfNeeded()},10)),this.postprocessResults(a,i),n(),this.opts.element.trigger({type:"select2-loaded",items:a})}})})}},cancel:function(){this.close()},blur:function(){this.opts.selectOnBlur&&this.selectHighlighted({noFocus:!0}),this.close(),this.container.removeClass("select2-container-active"),this.search[0]===document.activeElement&&this.search.blur(),this.clearSearch(),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus")},focusSearch:function(){p(this.search)},selectHighlighted:function(e){if(this._touchMoved)return void this.clearTouchMoved();var t=this.highlight(),i=this.results.find(".select2-highlighted"),n=i.closest(".select2-result").data("select2-data");n?(this.highlight(t),this.onSelect(n,e)):e&&e.noFocus&&this.close()},getPlaceholder:function(){var e;return this.opts.element.attr("placeholder")||this.opts.element.attr("data-placeholder")||this.opts.element.data("placeholder")||this.opts.placeholder||((e=this.getPlaceholderOption())!==t?e.text():t)},getPlaceholderOption:function(){if(this.select){var i=this.select.children("option").first();if(this.opts.placeholderOption!==t)return"first"===this.opts.placeholderOption&&i||"function"==typeof this.opts.placeholderOption&&this.opts.placeholderOption(this.select);if(""===e.trim(i.text())&&""===i.val())return i}},initContainerWidth:function(){function i(){var i,n,s,a,o,r;if("off"===this.opts.width)return null;if("element"===this.opts.width)return 0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px";if("copy"===this.opts.width||"resolve"===this.opts.width){if(i=this.opts.element.attr("style"),i!==t)for(n=i.split(";"),a=0,o=n.length;o>a;a+=1)if(r=n[a].replace(/\s/g,""),s=r.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i),null!==s&&s.length>=1)return s[1];return"resolve"===this.opts.width?(i=this.opts.element.css("width"),i.indexOf("%")>0?i:0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px"):null}return e.isFunction(this.opts.width)?this.opts.width():this.opts.width}var n=i.call(this);null!==n&&this.container.css("width",n)}}),I=P(N,{createContainer:function(){var t=e(document.createElement("div")).attr({class:"select2-container"}).html(["<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>","   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>","   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>","</a>","<label for='' class='select2-offscreen'></label>","<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />","<div class='select2-drop select2-display-none'>","   <div class='select2-search'>","       <label for='' class='select2-offscreen'></label>","       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'","       aria-autocomplete='list' />","   </div>","   <ul class='select2-results' role='listbox'>","   </ul>","</div>"].join(""));return t},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.focusser.prop("disabled",!this.isInterfaceEnabled())},opening:function(){var i,n,s;this.opts.minimumResultsForSearch>=0&&this.showSearch(!0),this.parent.opening.apply(this,arguments),this.showSearchInput!==!1&&this.search.val(this.focusser.val()),this.opts.shouldFocusInput(this)&&(this.search.focus(),i=this.search.get(0),i.createTextRange?(n=i.createTextRange(),n.collapse(!1),n.select()):i.setSelectionRange&&(s=this.search.val().length,i.setSelectionRange(s,s))),""===this.search.val()&&this.nextSearchTerm!=t&&(this.search.val(this.nextSearchTerm),this.search.select()),this.focusser.prop("disabled",!0).val(""),this.updateResults(!0),this.opts.element.trigger(e.Event("select2-open"))},close:function(){this.opened()&&(this.parent.close.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},focus:function(){this.opened()?this.close():(this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},isFocused:function(){return this.container.hasClass("select2-container-active")},cancel:function(){this.parent.cancel.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus()},destroy:function(){e("label[for='"+this.focusser.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),D.call(this,"selection","focusser")},initContainer:function(){var t,n,s=this.container,a=this.dropdown,o=j();this.opts.minimumResultsForSearch<0?this.showSearch(!1):this.showSearch(!0),this.selection=t=s.find(".select2-choice"),this.focusser=s.find(".select2-focusser"),t.find(".select2-chosen").attr("id","select2-chosen-"+o),this.focusser.attr("aria-labelledby","select2-chosen-"+o),this.results.attr("id","select2-results-"+o),this.search.attr("aria-owns","select2-results-"+o),this.focusser.attr("id","s2id_autogen"+o),n=e("label[for='"+this.opts.element.attr("id")+"']"),this.focusser.prev().text(n.text()).attr("for",this.focusser.attr("id"));var r=this.opts.element.attr("title");this.opts.element.attr("title",r||n.text()),this.focusser.attr("tabindex",this.elementTabIndex),this.search.attr("id",this.focusser.attr("id")+"_search"),this.search.prev().text(e("label[for='"+this.focusser.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.search.on("keydown",this.bind(function(e){if(this.isInterfaceEnabled()){if(e.which===M.PAGE_UP||e.which===M.PAGE_DOWN)return void m(e);switch(e.which){case M.UP:case M.DOWN:return this.moveHighlight(e.which===M.UP?-1:1),void m(e);case M.ENTER:return this.selectHighlighted(),void m(e);case M.TAB:return void this.selectHighlighted({noFocus:!0});case M.ESC:return this.cancel(e),void m(e)}}})),this.search.on("blur",this.bind(function(){document.activeElement===this.body.get(0)&&window.setTimeout(this.bind(function(){this.opened()&&this.search.focus()}),0)})),this.focusser.on("keydown",this.bind(function(e){if(this.isInterfaceEnabled()&&e.which!==M.TAB&&!M.isControl(e)&&!M.isFunctionKey(e)&&e.which!==M.ESC){if(this.opts.openOnEnter===!1&&e.which===M.ENTER)return void m(e);if(e.which==M.DOWN||e.which==M.UP||e.which==M.ENTER&&this.opts.openOnEnter){if(e.altKey||e.ctrlKey||e.shiftKey||e.metaKey)return;return this.open(),void m(e)}return e.which==M.DELETE||e.which==M.BACKSPACE?(this.opts.allowClear&&this.clear(),void m(e)):void 0}})),c(this.focusser),this.focusser.on("keyup-change input",this.bind(function(e){if(this.opts.minimumResultsForSearch>=0){if(e.stopPropagation(),this.opened())return;this.open()}})),t.on("mousedown touchstart","abbr",this.bind(function(e){this.isInterfaceEnabled()&&(this.clear(),g(e),this.close(),this.selection.focus())})),t.on("mousedown touchstart",this.bind(function(n){i(t),this.container.hasClass("select2-container-active")||this.opts.element.trigger(e.Event("select2-focus")),this.opened()?this.close():this.isInterfaceEnabled()&&this.open(),m(n)})),a.on("mousedown touchstart",this.bind(function(){this.opts.shouldFocusInput(this)&&this.search.focus()})),t.on("focus",this.bind(function(e){m(e)})),this.focusser.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(e.Event("select2-focus")),this.container.addClass("select2-container-active")})).on("blur",this.bind(function(){this.opened()||(this.container.removeClass("select2-container-active"),this.opts.element.trigger(e.Event("select2-blur")))})),this.search.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(e.Event("select2-focus")),this.container.addClass("select2-container-active")})),this.initContainerWidth(),this.opts.element.addClass("select2-offscreen"),this.setPlaceholder()},clear:function(t){var i=this.selection.data("select2-data");if(i){var n=e.Event("select2-clearing");if(this.opts.element.trigger(n),n.isDefaultPrevented())return;var s=this.getPlaceholderOption();this.opts.element.val(s?s.val():""),this.selection.find(".select2-chosen").empty(),this.selection.removeData("select2-data"),this.setPlaceholder(),t!==!1&&(this.opts.element.trigger({type:"select2-removed",val:this.id(i),choice:i}),this.triggerChange({removed:i}))}},initSelection:function(){if(this.isPlaceholderOptionSelected())this.updateSelection(null),this.close(),this.setPlaceholder();else{var e=this;this.opts.initSelection.call(null,this.opts.element,function(i){i!==t&&null!==i&&(e.updateSelection(i),e.close(),e.setPlaceholder(),e.nextSearchTerm=e.opts.nextSearchTerm(i,e.search.val()))})}},isPlaceholderOptionSelected:function(){var e;return this.getPlaceholder()!==t&&((e=this.getPlaceholderOption())!==t&&e.prop("selected")||""===this.opts.element.val()||this.opts.element.val()===t||null===this.opts.element.val())},prepareOpts:function(){var t=this.parent.prepareOpts.apply(this,arguments),i=this;return"select"===t.element.get(0).tagName.toLowerCase()?t.initSelection=function(e,t){var n=e.find("option").filter(function(){return this.selected&&!this.disabled});t(i.optionToData(n))}:"data"in t&&(t.initSelection=t.initSelection||function(i,n){var s=i.val(),a=null;t.query({matcher:function(e,i,n){var r=o(s,t.id(n));return r&&(a=n),r},callback:e.isFunction(n)?function(){n(a)}:e.noop})}),t},getPlaceholder:function(){return this.select&&this.getPlaceholderOption()===t?t:this.parent.getPlaceholder.apply(this,arguments)},setPlaceholder:function(){var e=this.getPlaceholder();if(this.isPlaceholderOptionSelected()&&e!==t){if(this.select&&this.getPlaceholderOption()===t)return;this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(e)),this.selection.addClass("select2-default"),this.container.removeClass("select2-allowclear")}},postprocessResults:function(e,t,i){var n=0,s=this;if(this.findHighlightableChoices().each2(function(e,t){return o(s.id(t.data("select2-data")),s.opts.element.val())?(n=e,!1):void 0}),i!==!1&&(t===!0&&n>=0?this.highlight(n):this.highlight(0)),t===!0){var a=this.opts.minimumResultsForSearch;a>=0&&this.showSearch(S(e.results)>=a)}},showSearch:function(t){this.showSearchInput!==t&&(this.showSearchInput=t,this.dropdown.find(".select2-search").toggleClass("select2-search-hidden",!t),this.dropdown.find(".select2-search").toggleClass("select2-offscreen",!t),e(this.dropdown,this.container).toggleClass("select2-with-searchbox",t))},onSelect:function(e,t){if(this.triggerSelect(e)){var i=this.opts.element.val(),n=this.data();this.opts.element.val(this.id(e)),this.updateSelection(e),this.opts.element.trigger({type:"select2-selected",val:this.id(e),choice:e}),this.nextSearchTerm=this.opts.nextSearchTerm(e,this.search.val()),this.close(),t&&t.noFocus||!this.opts.shouldFocusInput(this)||this.focusser.focus(),o(i,this.id(e))||this.triggerChange({added:e,removed:n})}},updateSelection:function(e){var i,n,s=this.selection.find(".select2-chosen");this.selection.data("select2-data",e),s.empty(),null!==e&&(i=this.opts.formatSelection(e,s,this.opts.escapeMarkup)),i!==t&&s.append(i),n=this.opts.formatSelectionCssClass(e,s),n!==t&&s.addClass(n),this.selection.removeClass("select2-default"),this.opts.allowClear&&this.getPlaceholder()!==t&&this.container.addClass("select2-allowclear")},val:function(){var e,i=!1,n=null,s=this,a=this.data();if(0===arguments.length)return this.opts.element.val();if(e=arguments[0],arguments.length>1&&(i=arguments[1]),this.select)this.select.val(e).find("option").filter(function(){return this.selected}).each2(function(e,t){return n=s.optionToData(t),!1}),this.updateSelection(n),this.setPlaceholder(),i&&this.triggerChange({added:n,removed:a});else{if(!e&&0!==e)return void this.clear(i);if(this.opts.initSelection===t)throw new Error("cannot call val() if initSelection() is not defined");this.opts.element.val(e),this.opts.initSelection(this.opts.element,function(e){s.opts.element.val(e?s.id(e):""),s.updateSelection(e),s.setPlaceholder(),i&&s.triggerChange({added:e,removed:a})})}},clearSearch:function(){this.search.val(""),this.focusser.val("")},data:function(e){var i,n=!1;return 0===arguments.length?(i=this.selection.data("select2-data"),i==t&&(i=null),i):(arguments.length>1&&(n=arguments[1]),void(e?(i=this.data(),this.opts.element.val(e?this.id(e):""),this.updateSelection(e),n&&this.triggerChange({added:e,removed:i})):this.clear(n)))}}),O=P(N,{createContainer:function(){var t=e(document.createElement("div")).attr({class:"select2-container select2-container-multi"}).html(["<ul class='select2-choices'>","  <li class='select2-search-field'>","    <label for='' class='select2-offscreen'></label>","    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>","  </li>","</ul>","<div class='select2-drop select2-drop-multi select2-display-none'>","   <ul class='select2-results'>","   </ul>","</div>"].join(""));return t},prepareOpts:function(){var t=this.parent.prepareOpts.apply(this,arguments),i=this;return"select"===t.element.get(0).tagName.toLowerCase()?t.initSelection=function(e,t){var n=[];e.find("option").filter(function(){return this.selected&&!this.disabled}).each2(function(e,t){n.push(i.optionToData(t))}),t(n)}:"data"in t&&(t.initSelection=t.initSelection||function(i,n){var s=r(i.val(),t.separator),a=[];t.query({matcher:function(i,n,r){var l=e.grep(s,function(e){return o(e,t.id(r))}).length;return l&&a.push(r),l},callback:e.isFunction(n)?function(){for(var e=[],i=0;i<s.length;i++)for(var r=s[i],l=0;l<a.length;l++){var c=a[l];if(o(r,t.id(c))){e.push(c),a.splice(l,1);break}}n(e)}:e.noop})}),t},selectChoice:function(e){var t=this.container.find(".select2-search-choice-focus");t.length&&e&&e[0]==t[0]||(t.length&&this.opts.element.trigger("choice-deselected",t),t.removeClass("select2-search-choice-focus"),e&&e.length&&(this.close(),e.addClass("select2-search-choice-focus"),this.opts.element.trigger("choice-selected",e)))},destroy:function(){e("label[for='"+this.search.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),D.call(this,"searchContainer","selection")},initContainer:function(){var t,i=".select2-choices";this.searchContainer=this.container.find(".select2-search-field"),this.selection=t=this.container.find(i);var n=this;this.selection.on("click",".select2-search-choice:not(.select2-locked)",function(){n.search[0].focus(),n.selectChoice(e(this))}),this.search.attr("id","s2id_autogen"+j()),this.search.prev().text(e("label[for='"+this.opts.element.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.search.on("input paste",this.bind(function(){this.isInterfaceEnabled()&&(this.opened()||this.open())})),this.search.attr("tabindex",this.elementTabIndex),this.keydowns=0,this.search.on("keydown",this.bind(function(e){if(this.isInterfaceEnabled()){++this.keydowns;var i=t.find(".select2-search-choice-focus"),n=i.prev(".select2-search-choice:not(.select2-locked)"),s=i.next(".select2-search-choice:not(.select2-locked)"),a=f(this.search);if(i.length&&(e.which==M.LEFT||e.which==M.RIGHT||e.which==M.BACKSPACE||e.which==M.DELETE||e.which==M.ENTER)){var o=i;return e.which==M.LEFT&&n.length?o=n:e.which==M.RIGHT?o=s.length?s:null:e.which===M.BACKSPACE?this.unselect(i.first())&&(this.search.width(10),o=n.length?n:s):e.which==M.DELETE?this.unselect(i.first())&&(this.search.width(10),o=s.length?s:null):e.which==M.ENTER&&(o=null),this.selectChoice(o),m(e),void(o&&o.length||this.open())}if((e.which===M.BACKSPACE&&1==this.keydowns||e.which==M.LEFT)&&0==a.offset&&!a.length)return this.selectChoice(t.find(".select2-search-choice:not(.select2-locked)").last()),void m(e);if(this.selectChoice(null),this.opened())switch(e.which){case M.UP:case M.DOWN:return this.moveHighlight(e.which===M.UP?-1:1),void m(e);case M.ENTER:return this.selectHighlighted(),void m(e);case M.TAB:return this.selectHighlighted({noFocus:!0}),void this.close();case M.ESC:return this.cancel(e),void m(e)}if(e.which!==M.TAB&&!M.isControl(e)&&!M.isFunctionKey(e)&&e.which!==M.BACKSPACE&&e.which!==M.ESC){if(e.which===M.ENTER){if(this.opts.openOnEnter===!1)return;if(e.altKey||e.ctrlKey||e.shiftKey||e.metaKey)return}this.open(),(e.which===M.PAGE_UP||e.which===M.PAGE_DOWN)&&m(e),e.which===M.ENTER&&m(e)}}})),this.search.on("keyup",this.bind(function(){this.keydowns=0,this.resizeSearch()})),this.search.on("blur",this.bind(function(t){this.container.removeClass("select2-container-active"),this.search.removeClass("select2-focused"),this.selectChoice(null),this.opened()||this.clearSearch(),t.stopImmediatePropagation(),this.opts.element.trigger(e.Event("select2-blur"))})),this.container.on("click",i,this.bind(function(t){this.isInterfaceEnabled()&&(e(t.target).closest(".select2-search-choice").length>0||(this.selectChoice(null),this.clearPlaceholder(),this.container.hasClass("select2-container-active")||this.opts.element.trigger(e.Event("select2-focus")),this.open(),this.focusSearch(),t.preventDefault()))})),this.container.on("focus",i,this.bind(function(){this.isInterfaceEnabled()&&(this.container.hasClass("select2-container-active")||this.opts.element.trigger(e.Event("select2-focus")),this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"),this.clearPlaceholder())})),this.initContainerWidth(),this.opts.element.addClass("select2-offscreen"),this.clearSearch()},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.search.prop("disabled",!this.isInterfaceEnabled())},initSelection:function(){if(""===this.opts.element.val()&&""===this.opts.element.text()&&(this.updateSelection([]),this.close(),this.clearSearch()),this.select||""!==this.opts.element.val()){var e=this;this.opts.initSelection.call(null,this.opts.element,function(i){i!==t&&null!==i&&(e.updateSelection(i),e.close(),e.clearSearch())})}},clearSearch:function(){var e=this.getPlaceholder(),i=this.getMaxSearchWidth();e!==t&&0===this.getVal().length&&this.search.hasClass("select2-focused")===!1?(this.search.val(e).addClass("select2-default"),this.search.width(i>0?i:this.container.css("width"))):this.search.val("").width(10)},clearPlaceholder:function(){this.search.hasClass("select2-default")&&this.search.val("").removeClass("select2-default")},opening:function(){this.clearPlaceholder(),this.resizeSearch(),this.parent.opening.apply(this,arguments),this.focusSearch(),""===this.search.val()&&this.nextSearchTerm!=t&&(this.search.val(this.nextSearchTerm),this.search.select()),this.updateResults(!0),this.opts.shouldFocusInput(this)&&this.search.focus(),this.opts.element.trigger(e.Event("select2-open"))},close:function(){this.opened()&&this.parent.close.apply(this,arguments)},focus:function(){this.close(),this.search.focus()},isFocused:function(){return this.search.hasClass("select2-focused")},updateSelection:function(t){var i=[],n=[],a=this;e(t).each(function(){s(a.id(this),i)<0&&(i.push(a.id(this)),n.push(this))}),t=n,this.selection.find(".select2-search-choice").remove(),e(t).each(function(){a.addSelectedChoice(this)}),a.postprocessResults()},tokenize:function(){var e=this.search.val();e=this.opts.tokenizer.call(this,e,this.data(),this.bind(this.onSelect),this.opts),null!=e&&e!=t&&(this.search.val(e),e.length>0&&this.open())},onSelect:function(e,i){this.triggerSelect(e)&&(this.addSelectedChoice(e),this.opts.element.trigger({type:"selected",val:this.id(e),choice:e}),this.nextSearchTerm=this.opts.nextSearchTerm(e,this.search.val()),this.clearSearch(),this.updateResults(),(this.select||!this.opts.closeOnSelect)&&this.postprocessResults(e,!1,this.opts.closeOnSelect===!0),this.opts.closeOnSelect?(this.close(),this.search.width(10)):this.countSelectableResults()>0?(this.search.width(10),this.resizeSearch(),this.getMaximumSelectionSize()>0&&this.val().length>=this.getMaximumSelectionSize()?this.updateResults(!0):this.nextSearchTerm!=t&&(this.search.val(this.nextSearchTerm),this.updateResults(),this.search.select()),this.positionDropdown()):(this.close(),this.search.width(10)),this.triggerChange({added:e}),i&&i.noFocus||this.focusSearch())},cancel:function(){this.close(),this.focusSearch()},addSelectedChoice:function(i){var n,s,a=!i.locked,o=e("<li class='select2-search-choice'>    <div></div>    <a href='#' class='select2-search-choice-close' tabindex='-1'></a></li>"),r=e("<li class='select2-search-choice select2-locked'><div></div></li>"),l=a?o:r,c=this.id(i),h=this.getVal();n=this.opts.formatSelection(i,l.find("div"),this.opts.escapeMarkup),n!=t&&l.find("div").replaceWith("<div>"+n+"</div>"),s=this.opts.formatSelectionCssClass(i,l.find("div")),s!=t&&l.addClass(s),a&&l.find(".select2-search-choice-close").on("mousedown",m).on("click dblclick",this.bind(function(t){this.isInterfaceEnabled()&&(this.unselect(e(t.target)),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus"),m(t),this.close(),this.focusSearch())})).on("focus",this.bind(function(){this.isInterfaceEnabled()&&(this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"))})),l.data("select2-data",i),l.insertBefore(this.searchContainer),h.push(c),this.setVal(h)},unselect:function(t){var i,n,a=this.getVal();if(t=t.closest(".select2-search-choice"),0===t.length)throw"Invalid argument: "+t+". Must be .select2-search-choice";if(i=t.data("select2-data")){var o=e.Event("select2-removing");if(o.val=this.id(i),o.choice=i,this.opts.element.trigger(o),o.isDefaultPrevented())return!1;for(;(n=s(this.id(i),a))>=0;)a.splice(n,1),this.setVal(a),this.select&&this.postprocessResults();return t.remove(),this.opts.element.trigger({type:"select2-removed",val:this.id(i),choice:i}),this.triggerChange({removed:i}),!0}},postprocessResults:function(e,t,i){var n=this.getVal(),a=this.results.find(".select2-result"),o=this.results.find(".select2-result-with-children"),r=this;a.each2(function(e,t){var i=r.id(t.data("select2-data"));s(i,n)>=0&&(t.addClass("select2-selected"),t.find(".select2-result-selectable").addClass("select2-selected"))}),o.each2(function(e,t){t.is(".select2-result-selectable")||0!==t.find(".select2-result-selectable:not(.select2-selected)").length||t.addClass("select2-selected")}),-1==this.highlight()&&i!==!1&&r.highlight(0),!this.opts.createSearchChoice&&!a.filter(".select2-result:not(.select2-selected)").length>0&&(!e||e&&!e.more&&0===this.results.find(".select2-no-results").length)&&C(r.opts.formatNoMatches,"formatNoMatches")&&this.results.append("<li class='select2-no-results'>"+T(r.opts.formatNoMatches,r.search.val())+"</li>")},getMaxSearchWidth:function(){return this.selection.width()-l(this.search)},resizeSearch:function(){var e,t,i,n,s,a=l(this.search);e=v(this.search)+10,t=this.search.offset().left,i=this.selection.width(),n=this.selection.offset().left,s=i-(t-n)-a,e>s&&(s=i-a),40>s&&(s=i-a),0>=s&&(s=e),this.search.width(Math.floor(s))},getVal:function(){var e;return this.select?(e=this.select.val(),null===e?[]:e):(e=this.opts.element.val(),r(e,this.opts.separator))},setVal:function(t){var i;this.select?this.select.val(t):(i=[],e(t).each(function(){s(this,i)<0&&i.push(this)}),this.opts.element.val(0===i.length?"":i.join(this.opts.separator)))},buildChangeDetails:function(e,t){for(var t=t.slice(0),e=e.slice(0),i=0;i<t.length;i++)for(var n=0;n<e.length;n++)o(this.opts.id(t[i]),this.opts.id(e[n]))&&(t.splice(i,1),i>0&&i--,e.splice(n,1),n--);return{added:t,removed:e}},val:function(i,n){var s,a=this;if(0===arguments.length)return this.getVal();if(s=this.data(),s.length||(s=[]),!i&&0!==i)return this.opts.element.val(""),this.updateSelection([]),this.clearSearch(),void(n&&this.triggerChange({added:this.data(),removed:s}));if(this.setVal(i),this.select)this.opts.initSelection(this.select,this.bind(this.updateSelection)),n&&this.triggerChange(this.buildChangeDetails(s,this.data()));else{if(this.opts.initSelection===t)throw new Error("val() cannot be called if initSelection() is not defined");this.opts.initSelection(this.opts.element,function(t){var i=e.map(t,a.id);a.setVal(i),a.updateSelection(t),a.clearSearch(),n&&a.triggerChange(a.buildChangeDetails(s,a.data()))})}this.clearSearch()},onSortStart:function(){if(this.select)throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");this.search.width(0),this.searchContainer.hide()},onSortEnd:function(){var t=[],i=this;this.searchContainer.show(),this.searchContainer.appendTo(this.searchContainer.parent()),this.resizeSearch(),this.selection.find(".select2-search-choice").each(function(){t.push(i.opts.id(e(this).data("select2-data")))}),this.setVal(t),this.triggerChange()},data:function(t,i){var n,s,a=this;return 0===arguments.length?this.selection.children(".select2-search-choice").map(function(){return e(this).data("select2-data")}).get():(s=this.data(),t||(t=[]),n=e.map(t,function(e){return a.opts.id(e)}),this.setVal(n),this.updateSelection(t),this.clearSearch(),void(i&&this.triggerChange(this.buildChangeDetails(s,this.data()))))}}),e.fn.select2=function(){var i,n,a,o,r,l=Array.prototype.slice.call(arguments,0),c=["val","destroy","opened","open","close","focus","isFocused","container","dropdown","onSortStart","onSortEnd","enable","disable","readonly","positionDropdown","data","search"],h=["opened","isFocused","container","dropdown"],u=["val","data"],d={search:"externalSearch"};return this.each(function(){if(0===l.length||"object"==typeof l[0])i=0===l.length?{}:e.extend({},l[0]),i.element=e(this),"select"===i.element.get(0).tagName.toLowerCase()?r=i.element.prop("multiple"):(r=i.multiple||!1,
"tags"in i&&(i.multiple=r=!0)),n=r?new window.Select2.class.multi:new window.Select2.class.single,n.init(i);else{if("string"!=typeof l[0])throw"Invalid arguments to select2 plugin: "+l;if(s(l[0],c)<0)throw"Unknown method: "+l[0];if(o=t,n=e(this).data("select2"),n===t)return;if(a=l[0],"container"===a?o=n.container:"dropdown"===a?o=n.dropdown:(d[a]&&(a=d[a]),o=n[a].apply(n,l.slice(1))),s(l[0],h)>=0||s(l[0],u)>=0&&1==l.length)return!1}}),o===t?this:o},e.fn.select2.defaults={width:"copy",loadMorePadding:0,closeOnSelect:!0,openOnEnter:!0,containerCss:{},dropdownCss:{},containerCssClass:"",dropdownCssClass:"",formatResult:function(e,t,i,n){var s=[];return y(e.text,i.term,s,n),s.join("")},formatSelection:function(e,i,n){return e?n(e.text):t},sortResults:function(e){return e},formatResultCssClass:function(e){return e.css},formatSelectionCssClass:function(){return t},formatMatches:function(e){return e+" results are available, use up and down arrow keys to navigate."},formatNoMatches:function(){return"No matches found"},formatInputTooShort:function(e,t){var i=t-e.length;return"Please enter "+i+" or more character"+(1==i?"":"s")},formatInputTooLong:function(e,t){var i=e.length-t;return"Please delete "+i+" character"+(1==i?"":"s")},formatSelectionTooBig:function(e){return"You can only select "+e+" item"+(1==e?"":"s")},formatLoadMore:function(){return"Loading more results…"},formatSearching:function(){return"Searching…"},minimumResultsForSearch:0,minimumInputLength:0,maximumInputLength:null,maximumSelectionSize:0,id:function(e){return e==t?null:e.id},matcher:function(e,t){return n(""+t).toUpperCase().indexOf(n(""+e).toUpperCase())>=0},separator:",",tokenSeparators:[],tokenizer:E,escapeMarkup:w,blurOnChange:!1,selectOnBlur:!1,adaptContainerCssClass:function(e){return e},adaptDropdownCssClass:function(){return null},nextSearchTerm:function(){return t},searchInputPlaceholder:"",createSearchChoicePosition:"top",shouldFocusInput:function(e){var t="ontouchstart"in window||navigator.msMaxTouchPoints>0;return!t||!(e.opts.minimumResultsForSearch<0)}},e.fn.select2.ajaxDefaults={transport:e.ajax,params:{type:"GET",cache:!1,dataType:"json"}},window.Select2={query:{ajax:x,local:k,tags:_},util:{debounce:u,markMatch:y,escapeMarkup:w,stripDiacritics:n},class:{abstract:N,single:I,multi:O}}}}(jQuery);!function(e,t,i){e.anythingSlider=function(n,s){var a,o,r=this;r.el=n;r.$el=e(n).addClass("anythingBase").wrap('<div class="anythingSlider"><div class="anythingWindow" /></div>');r.$el.data("AnythingSlider",r);r.init=function(){r.options=a=e.extend({},e.anythingSlider.defaults,s);r.initialized=!1;e.isFunction(a.onBeforeInitialize)&&r.$el.bind("before_initialize",a.onBeforeInitialize);r.$el.trigger("before_initialize",r);e('<!--[if lte IE 8]><script>jQuery("body").addClass("as-oldie");</script><![endif]-->').appendTo("body").remove();r.$wrapper=r.$el.parent().closest("div.anythingSlider").addClass("anythingSlider-"+a.theme);r.$outer=r.$wrapper.parent();r.$window=r.$el.closest("div.anythingWindow");r.$win=e(t);r.$controls=e('<div class="anythingControls"></div>');r.$nav=e('<ul class="thumbNav"><li><a><span></span></a></li></ul>');r.$startStop=e('<a href="#" class="start-stop"></a>');(a.buildStartStop||a.buildNavigation)&&r.$controls.appendTo(a.appendControlsTo&&e(a.appendControlsTo).length?e(a.appendControlsTo):r.$wrapper);a.buildNavigation&&r.$nav.appendTo(a.appendNavigationTo&&e(a.appendNavigationTo).length?e(a.appendNavigationTo):r.$controls);a.buildStartStop&&r.$startStop.appendTo(a.appendStartStopTo&&e(a.appendStartStopTo).length?e(a.appendStartStopTo):r.$controls);r.runTimes=e(".anythingBase").length;r.regex=a.hashTags?RegExp("panel"+r.runTimes+"-(\\d+)","i"):null;1===r.runTimes&&r.makeActive();r.flag=!1;a.autoPlayLocked&&(a.autoPlay=!0);r.playing=a.autoPlay;r.slideshow=!1;r.hovered=!1;r.panelSize=[];r.currentPage=r.targetPage=a.startPanel=parseInt(a.startPanel,10)||1;a.changeBy=parseInt(a.changeBy,10)||1;o=(a.mode||"h").toLowerCase().match(/(h|v|f)/);o=a.vertical?"v":(o||["h"])[0];a.mode="v"===o?"vertical":"f"===o?"fade":"horizontal";"f"===o&&(a.showMultiple=1,a.infiniteSlides=!1);r.adj=a.infiniteSlides?0:1;r.adjustMultiple=0;a.playRtl&&r.$wrapper.addClass("rtl");a.buildStartStop&&r.buildAutoPlay();a.buildArrows&&r.buildNextBackButtons();r.$lastPage=r.$targetPage=r.$currentPage;if(a.expand){if(!0===a.aspectRatio)a.aspectRatio=r.$el.width()/r.$el.height();else if("string"==typeof a.aspectRatio&&-1!==a.aspectRatio.indexOf(":")){var n=a.aspectRatio.split(":");a.aspectRatio=n[0]/n[1]}0<a.aspectRatio&&1<a.showMultiple&&(a.aspectRatio*=a.showMultiple)}r.updateSlider();a.expand&&(r.$window.css({width:"100%",height:"100%"}),r.checkResize());e.isFunction(e.easing[a.easing])||(a.easing="swing");a.pauseOnHover&&r.$wrapper.hover(function(){r.playing&&(r.$el.trigger("slideshow_paused",r),r.clearTimer(!0))},function(){r.playing&&(r.$el.trigger("slideshow_unpaused",r),r.startStop(r.playing,!0))});r.slideControls(!1);r.$wrapper.bind("mouseenter mouseleave",function(t){e(this)["mouseenter"===t.type?"addClass":"removeClass"]("anythingSlider-hovered");r.hovered="mouseenter"===t.type;r.slideControls(r.hovered)});e(i).keyup(function(e){if(a.enableKeyboard&&r.$wrapper.hasClass("activeSlider")&&!e.target.tagName.match("TEXTAREA|INPUT|SELECT")&&("vertical"===a.mode||38!==e.which&&40!==e.which))switch(e.which){case 39:case 40:r.goForward();break;case 37:case 38:r.goBack()}});r.currentPage=(a.hashTags?r.gotoHash():"")||a.startPanel||1;r.gotoPage(r.currentPage,!1,null,-1);var l="slideshow_resized slideshow_paused slideshow_unpaused slide_init slide_begin slideshow_stop slideshow_start initialized swf_completed".split(" ");e.each("onSliderResize onShowPause onShowUnpause onSlideInit onSlideBegin onShowStop onShowStart onInitialized onSWFComplete".split(" "),function(t,i){e.isFunction(a[i])&&r.$el.bind(l[t],a[i])});e.isFunction(a.onSlideComplete)&&r.$el.bind("slide_complete",function(){setTimeout(function(){a.onSlideComplete(r)},0);return!1});r.initialized=!0;r.$el.trigger("initialized",r);r.startStop(a.autoPlay)};r.updateSlider=function(){r.$el.children(".cloned").remove();r.navTextVisible="hidden"!==r.$nav.find("span:first").css("visibility");r.$nav.empty();r.currentPage=r.currentPage||1;r.$items=r.$el.children();r.pages=r.$items.length;r.dir="vertical"===a.mode?"top":"left";a.showMultiple=parseInt(a.showMultiple,10)||1;a.navigationSize=!1===a.navigationSize?0:parseInt(a.navigationSize,10)||0;r.$items.find("a").unbind("focus.AnythingSlider").bind("focus.AnythingSlider",function(t){var i=e(this).closest(".panel"),i=r.$items.index(i)+r.adj;r.$items.find(".focusedLink").removeClass("focusedLink");e(this).addClass("focusedLink");r.$window.scrollLeft(0).scrollTop(0);-1!==i&&(i>=r.currentPage+a.showMultiple||i<r.currentPage)&&(r.gotoPage(i),t.preventDefault())});1<a.showMultiple&&(a.showMultiple>r.pages&&(a.showMultiple=r.pages),r.adjustMultiple=a.infiniteSlides&&1<r.pages?0:a.showMultiple-1);r.$controls.add(r.$nav).add(r.$startStop).add(r.$forward).add(r.$back)[1>=r.pages?"hide":"show"]();1<r.pages&&r.buildNavigation();"fade"!==a.mode&&a.infiniteSlides&&1<r.pages&&(r.$el.prepend(r.$items.filter(":last").clone().addClass("cloned")),1<a.showMultiple?r.$el.append(r.$items.filter(":lt("+a.showMultiple+")").clone().addClass("cloned multiple")):r.$el.append(r.$items.filter(":first").clone().addClass("cloned")),r.$el.find(".cloned").each(function(){e(this).find("a,input,textarea,select,button,area,form").attr({disabled:"disabled",name:""});e(this).find("[id]")[e.fn.addBack?"addBack":"andSelf"]().removeAttr("id")}));r.$items=r.$el.addClass(a.mode).children().addClass("panel");r.setDimensions();a.resizeContents?(r.$items.css("width",r.width),r.$wrapper.css("width",r.getDim(r.currentPage)[0]).add(r.$items).css("height",r.height)):r.$win.load(function(){r.setDimensions();o=r.getDim(r.currentPage);r.$wrapper.css({width:o[0],height:o[1]});r.setCurrentPage(r.currentPage,!1)});r.currentPage>r.pages&&(r.currentPage=r.pages);r.setCurrentPage(r.currentPage,!1);r.$nav.find("a").eq(r.currentPage-1).addClass("cur");"fade"===a.mode&&(o=r.$items.eq(r.currentPage-1),a.resumeOnVisible?o.css({opacity:1,visibility:"visible"}).siblings().css({opacity:0,visibility:"hidden"}):(r.$items.css("opacity",1),o.fadeIn(0).siblings().fadeOut(0)))};r.buildNavigation=function(){if(a.buildNavigation&&1<r.pages){var t,i,n,s,o;r.$items.filter(":not(.cloned)").each(function(l){o=e("<li/>");n=l+1;i=(1===n?" first":"")+(n===r.pages?" last":"");t='<a class="panel'+n+(r.navTextVisible?'"':" "+a.tooltipClass+'" title="@"')+' href="#"><span>@</span></a>';e.isFunction(a.navigationFormatter)?(s=a.navigationFormatter(n,e(this)),"string"==typeof s?o.html(t.replace(/@/g,s)):o=e("<li/>",s)):o.html(t.replace(/@/g,n));o.appendTo(r.$nav).addClass(i).data("index",n)});r.$nav.children("li").bind(a.clickControls,function(t){!r.flag&&a.enableNavigation&&(r.flag=!0,setTimeout(function(){r.flag=!1},100),r.gotoPage(e(this).data("index")));t.preventDefault()});a.navigationSize&&a.navigationSize<r.pages&&(r.$controls.find(".anythingNavWindow").length||r.$nav.before('<ul><li class="prev"><a href="#"><span>'+a.backText+"</span></a></li></ul>").after('<ul><li class="next"><a href="#"><span>'+a.forwardText+"</span></a></li></ul>").wrap('<div class="anythingNavWindow"></div>'),r.navWidths=r.$nav.find("li").map(function(){return e(this).outerWidth(!0)+Math.ceil(parseInt(e(this).find("span").css("left"),10)/2||0)}).get(),r.navLeft=r.currentPage,r.$nav.width(r.navWidth(1,r.pages+1)+25),r.$controls.find(".anythingNavWindow").width(r.navWidth(1,a.navigationSize+1)).end().find(".prev,.next").bind(a.clickControls,function(t){r.flag||(r.flag=!0,setTimeout(function(){r.flag=!1},200),r.navWindow(r.navLeft+a.navigationSize*(e(this).is(".prev")?-1:1)));t.preventDefault()}))}};r.navWidth=function(e,t){var i;i=Math.min(e,t);for(var n=Math.max(e,t),s=0;i<n;i++)s+=r.navWidths[i-1]||0;return s};r.navWindow=function(e){if(a.navigationSize&&a.navigationSize<r.pages&&r.navWidths){var t=r.pages-a.navigationSize+1;e=1>=e?1:1<e&&e<t?e:t;e!==r.navLeft&&(r.$controls.find(".anythingNavWindow").animate({scrollLeft:r.navWidth(1,e),width:r.navWidth(e,e+a.navigationSize)},{queue:!1,duration:a.animationTime}),r.navLeft=e)}};r.buildNextBackButtons=function(){r.$forward=e('<span class="arrow forward"><a href="#"><span>'+a.forwardText+"</span></a></span>");r.$back=e('<span class="arrow back"><a href="#"><span>'+a.backText+"</span></a></span>");r.$back.bind(a.clickBackArrow,function(e){a.enableArrows&&!r.flag&&(r.flag=!0,setTimeout(function(){r.flag=!1},100),r.goBack());e.preventDefault()});r.$forward.bind(a.clickForwardArrow,function(e){a.enableArrows&&!r.flag&&(r.flag=!0,setTimeout(function(){r.flag=!1},100),r.goForward());e.preventDefault()});r.$back.add(r.$forward).find("a").bind("focusin focusout",function(){e(this).toggleClass("hover")});r.$back.appendTo(a.appendBackTo&&e(a.appendBackTo).length?e(a.appendBackTo):r.$wrapper);r.$forward.appendTo(a.appendForwardTo&&e(a.appendForwardTo).length?e(a.appendForwardTo):r.$wrapper);r.arrowWidth=r.$forward.width();r.arrowRight=parseInt(r.$forward.css("right"),10);r.arrowLeft=parseInt(r.$back.css("left"),10)};r.buildAutoPlay=function(){r.$startStop.html("<span>"+(r.playing?a.stopText:a.startText)+"</span>").bind(a.clickSlideshow,function(e){a.enableStartStop&&(r.startStop(!r.playing),r.makeActive(),r.playing&&!a.autoPlayDelayed&&r.goForward(!0,a.playRtl));e.preventDefault()}).bind("focusin focusout",function(){e(this).toggleClass("hover")})};r.checkResize=function(e){var t=!!(i.hidden||i.webkitHidden||i.mozHidden||i.msHidden);clearTimeout(r.resizeTimer);r.resizeTimer=setTimeout(function(){var i=r.$outer.width(),n="BODY"===r.$outer[0].tagName?r.$win.height():r.$outer.height();t||r.lastDim[0]===i&&r.lastDim[1]===n||(r.setDimensions(),r.$el.trigger("slideshow_resized",r),r.gotoPage(r.currentPage,r.playing,null,-1));"undefined"==typeof e&&r.checkResize()},t?2e3:500)};r.setDimensions=function(){r.$wrapper.find(".anythingWindow, .anythingBase, .panel")[e.fn.addBack?"addBack":"andSelf"]().css({width:"",height:""});r.width=r.$el.width();r.height=r.$el.height();r.outerPad=[r.$wrapper.innerWidth()-r.$wrapper.width(),r.$wrapper.innerHeight()-r.$wrapper.height()];var t,i,n,s,o=0,l={width:"100%",height:"100%"},c=1<a.showMultiple&&"horizontal"===a.mode?r.width||r.$window.width()/a.showMultiple:r.$window.width(),h=1<a.showMultiple&&"vertical"===a.mode?r.height/a.showMultiple||r.$window.height()/a.showMultiple:r.$window.height();if(a.expand){r.lastDim=[r.$outer.width(),r.$outer.height()];t=r.lastDim[0]-r.outerPad[0];i=r.lastDim[1]-r.outerPad[1];if(a.aspectRatio&&a.aspectRatio<r.width){var u=i*a.aspectRatio;u<t?t=u:(u=t/a.aspectRatio,u<i&&(i=u))}r.$wrapper.add(r.$window).css({width:t,height:i});r.height=i=1<a.showMultiple&&"vertical"===a.mode?h:i;r.width=c=1<a.showMultiple&&"horizontal"===a.mode?t/a.showMultiple:t;r.$items.css({width:c,height:h})}r.$items.each(function(h){s=e(this);n=s.children();a.resizeContents?(t=r.width,i=r.height,s.css({width:t,height:i}),n.length&&("EMBED"===n[0].tagName&&n.attr(l),"OBJECT"===n[0].tagName&&n.find("embed").attr(l),1===n.length&&n.css(l))):("vertical"===a.mode?(t=s.css("display","inline-block").width(),s.css("display","")):t=s.width()||r.width,1===n.length&&t>=c&&(t=n.width()>=c?c:n.width(),n.css("max-width",t)),s.css({width:t,height:""}),i=1===n.length?n.outerHeight(!0):s.height(),i<=r.outerPad[1]&&(i=r.height),s.css("height",i));r.panelSize[h]=[t,i,o];o+="vertical"===a.mode?i:t});r.$el.css("vertical"===a.mode?"height":"width","fade"===a.mode?r.width:o)};r.getDim=function(e){var t,i,n=r.width,s=r.height;if(1>r.pages||isNaN(e))return[n,s];e=a.infiniteSlides&&1<r.pages?e:e-1;(i=r.panelSize[e])&&(n=i[0]||n,s=i[1]||s);if(1<a.showMultiple)for(i=1;i<a.showMultiple;i++)t=e+i,"vertical"===a.mode?(n=Math.max(n,r.panelSize[t][0]),s+=r.panelSize[t][1]):(n+=r.panelSize[t][0],s=Math.max(s,r.panelSize[t][1]));return[n,s]};r.goForward=function(e,t){r.gotoPage(r[a.allowRapidChange?"targetPage":"currentPage"]+a.changeBy*(t?-1:1),e)};r.goBack=function(e){r.gotoPage(r[a.allowRapidChange?"targetPage":"currentPage"]-a.changeBy,e)};r.gotoPage=function(t,i,n,s){!0!==i&&(i=!1,r.startStop(!1),r.makeActive());/^[#|.]/.test(t)&&e(t).length&&(t=e(t).closest(".panel").index()+r.adj);if(1!==a.changeBy){var o=r.pages-r.adjustMultiple;1>t&&(t=a.stopAtEnd?1:a.infiniteSlides?r.pages+t:a.showMultiple>1-t?1:o);t>r.pages?t=a.stopAtEnd?r.pages:a.showMultiple>1-t?1:t-=o:t>=o&&(t=o)}1>=r.pages||(r.$lastPage=r.$currentPage,"number"!=typeof t&&(t=parseInt(t,10)||a.startPanel,r.setCurrentPage(t)),i&&a.isVideoPlaying(r)||(a.stopAtEnd&&!a.infiniteSlides&&t>r.pages-a.showMultiple&&(t=r.pages-a.showMultiple+1),r.exactPage=t,t>r.pages+1-r.adj&&(t=a.infiniteSlides||a.stopAtEnd?r.pages:1),t<r.adj&&(t=a.infiniteSlides||a.stopAtEnd?1:r.pages),a.infiniteSlides||(r.exactPage=t),r.currentPage=t>r.pages?r.pages:1>t?1:r.currentPage,r.$currentPage=r.$items.eq(r.currentPage-r.adj),r.targetPage=0===t?r.pages:t>r.pages?1:t,r.$targetPage=r.$items.eq(r.targetPage-r.adj),s="undefined"!=typeof s?s:a.animationTime,0<=s&&r.$el.trigger("slide_init",r),0<s&&!0===a.toggleControls&&r.slideControls(!0),a.buildNavigation&&r.setNavigation(r.targetPage),!0!==i&&(i=!1),(!i||a.stopAtEnd&&t===r.pages)&&r.startStop(!1),0<=s&&r.$el.trigger("slide_begin",r),setTimeout(function(e){var i,o=!0;a.allowRapidChange&&r.$wrapper.add(r.$el).add(r.$items).stop(!0,!0);a.resizeContents||(i=r.getDim(t),e={},r.$wrapper.width()!==i[0]&&(e.width=i[0]||r.width,o=!1),r.$wrapper.height()!==i[1]&&(e.height=i[1]||r.height,o=!1),o||r.$wrapper.filter(":not(:animated)").animate(e,{queue:!1,duration:0>s?0:s,easing:a.easing}));"fade"===a.mode?r.$lastPage[0]!==r.$targetPage[0]?(r.fadeIt(r.$lastPage,0,s),r.fadeIt(r.$targetPage,1,s,function(){r.endAnimation(t,n,s)})):r.endAnimation(t,n,s):(e={},e[r.dir]=-r.panelSize[a.infiniteSlides&&1<r.pages?t:t-1][2],"vertical"!==a.mode||a.resizeContents||(e.width=i[0]),r.$el.filter(":not(:animated)").animate(e,{queue:!1,duration:0>s?0:s,easing:a.easing,complete:function(){r.endAnimation(t,n,s)}}))},parseInt(a.delayBeforeAnimate,10)||0)))};r.endAnimation=function(e,t,i){0===e?(r.$el.css(r.dir,"fade"===a.mode?0:-r.panelSize[r.pages][2]),e=r.pages):e>r.pages&&(r.$el.css(r.dir,"fade"===a.mode?0:-r.panelSize[1][2]),e=1);r.exactPage=e;r.setCurrentPage(e,!1);"fade"===a.mode&&r.fadeIt(r.$items.not(":eq("+(e-r.adj)+")"),0,0);r.hovered||r.slideControls(!1);a.hashTags&&r.setHash(e);0<=i&&r.$el.trigger("slide_complete",r);"function"==typeof t&&t(r);a.autoPlayLocked&&!r.playing&&setTimeout(function(){r.startStop(!0)},a.resumeDelay-(a.autoPlayDelayed?a.delay:0))};r.fadeIt=function(t,i,n,s){var o=t.filter(":not(:animated)");t=0>n?0:n;a.resumeOnVisible?(1===i&&o.css("visibility","visible"),o.fadeTo(t,i,function(){0===i&&o.css("visibility","hidden");e.isFunction(s)&&s()})):o[0===i?"fadeOut":"fadeIn"](t,s)};r.setCurrentPage=function(e,t){e=parseInt(e,10);if(!(1>r.pages||0===e||isNaN(e))){e>r.pages+1-r.adj&&(e=r.pages-r.adj);e<r.adj&&(e=1);a.buildArrows&&!a.infiniteSlides&&a.stopAtEnd&&(r.$forward[e===r.pages-r.adjustMultiple?"addClass":"removeClass"]("disabled"),r.$back[1===e?"addClass":"removeClass"]("disabled"),e===r.pages&&r.playing&&r.startStop());if(!t){var i=r.getDim(e);r.$wrapper.css({width:i[0],height:i[1]}).add(r.$window).scrollLeft(0).scrollTop(0);r.$el.css(r.dir,"fade"===a.mode?0:-r.panelSize[a.infiniteSlides&&1<r.pages?e:e-1][2])}r.currentPage=e;r.$currentPage=r.$items.removeClass("activePage").eq(e-r.adj).addClass("activePage");a.buildNavigation&&r.setNavigation(e)}};r.setNavigation=function(e){r.$nav.find(".cur").removeClass("cur").end().find("a").eq(e-1).addClass("cur")};r.makeActive=function(){r.$wrapper.hasClass("activeSlider")||(e(".activeSlider").removeClass("activeSlider"),r.$wrapper.addClass("activeSlider"))};r.gotoHash=function(){var i=t.location.hash,n=i.indexOf("&"),s=i.match(r.regex);null!==s||/^#&/.test(i)||/#!?\//.test(i)||/\=/.test(i)?null!==s&&(s=a.hashTags?parseInt(s[1],10):null):(i=i.substring(0,0<=n?n:i.length),s=e(i).length&&e(i).closest(".anythingBase")[0]===r.el?r.$items.index(e(i).closest(".panel"))+r.adj:null);return s};r.setHash=function(e){var i="panel"+r.runTimes+"-",n=t.location.hash;"undefined"!=typeof n&&(t.location.hash=0<n.indexOf(i)?n.replace(r.regex,i+e):n+"&"+i+e)};r.slideControls=function(e){var t=e?"slideDown":"slideUp",i=e?0:a.animationTime,n=e?a.animationTime:0,s=e?1:0;e=e?0:1;a.toggleControls&&r.$controls.stop(!0,!0).delay(i)[t](a.animationTime/2).delay(n);a.buildArrows&&a.toggleArrows&&(!r.hovered&&r.playing&&(e=1,s=0),r.$forward.stop(!0,!0).delay(i).animate({right:r.arrowRight+e*r.arrowWidth,opacity:s},a.animationTime/2),r.$back.stop(!0,!0).delay(i).animate({left:r.arrowLeft+e*r.arrowWidth,opacity:s},a.animationTime/2))};r.clearTimer=function(e){r.timer&&(t.clearInterval(r.timer),!e&&r.slideshow&&(r.$el.trigger("slideshow_stop",r),r.slideshow=!1))};r.startStop=function(e,n){!0!==e&&(e=!1);(r.playing=e)&&!n&&(r.$el.trigger("slideshow_start",r),r.slideshow=!0);a.buildStartStop&&(r.$startStop.toggleClass("playing",e).find("span").html(e?a.stopText:a.startText),"hidden"===r.$startStop.find("span").css("visibility")&&r.$startStop.addClass(a.tooltipClass).attr("title",e?a.stopText:a.startText));e?(r.clearTimer(!0),r.timer=t.setInterval(function(){i.hidden||i.webkitHidden||i.mozHidden||i.msHidden?a.autoPlayLocked||r.startStop():a.isVideoPlaying(r)?a.resumeOnVideoEnd||r.startStop():r.goForward(!0,a.playRtl)},a.delay)):r.clearTimer()};r.init()};e.anythingSlider.defaults={theme:"default",mode:"horiz",expand:!1,resizeContents:!0,showMultiple:!1,easing:"swing",buildArrows:!0,buildNavigation:!0,buildStartStop:!0,toggleArrows:!1,toggleControls:!1,startText:"Start",stopText:"Stop",forwardText:"&raquo;",backText:"&laquo;",tooltipClass:"tooltip",enableArrows:!0,enableNavigation:!0,enableStartStop:!0,enableKeyboard:!0,startPanel:1,changeBy:1,hashTags:!0,infiniteSlides:!0,navigationFormatter:null,navigationSize:!1,autoPlay:!1,autoPlayLocked:!1,autoPlayDelayed:!1,pauseOnHover:!0,stopAtEnd:!1,playRtl:!1,delay:3e3,resumeDelay:15e3,animationTime:600,delayBeforeAnimate:0,clickForwardArrow:"click",clickBackArrow:"click",clickControls:"click focusin",clickSlideshow:"click",allowRapidChange:!1,resumeOnVideoEnd:!0,resumeOnVisible:!0,isVideoPlaying:function(e){return!1}};e.fn.anythingSlider=function(t,i){return this.each(function(){var n,s=e(this).data("AnythingSlider");(typeof t).match("object|undefined")?s?s.updateSlider():new e.anythingSlider(this,t):/\d/.test(t)&&!isNaN(t)&&s?(n="number"==typeof t?t:parseInt(e.trim(t),10),1<=n&&n<=s.pages&&s.gotoPage(n,!1,i)):/^[#|.]/.test(t)&&e(t).length&&s.gotoPage(t,!1,i)})}}(jQuery,window,document);!function(e){e.fn.anythingSliderVideo=function(t){var i={videoId:"asvideo",wmode:"opaque",youtubeAutoLoad:!0,youtubeParams:{modestbranding:1,iv_load_policy:3,fs:1}};return this.each(function(){var n,s,a,o,r=e(this).data("AnythingSlider");if(r){n=r.video={};n.options=e.extend({},i,t);n.hasSwfo="undefined"!=typeof swfobject&&swfobject.hasOwnProperty("embedSWF")&&"function"==typeof swfobject.embedSWF&&swfobject.hasFlashPlayerVersion("1");n.list={};n.hasVid=!1;n.hasEmbed=!1;n.services=e.fn.anythingSliderVideo.services;n.hasEmbedCount=0;n.hasiframeCount=0;n.$items=r.$items.filter(":not(.cloned)");for(a in n.services)"string"==typeof a&&(o=n.services[a].selector,n.$items.find(o).each(function(){s=e(this);s.attr("id",n.options.videoId+e.fn.anythingSliderVideo.videoIndex);n.list[e.fn.anythingSliderVideo.videoIndex]={id:n.options.videoId+e.fn.anythingSliderVideo.videoIndex++,panel:s.closest(".panel")[0],service:a,selector:o,status:-1};n.hasVid=!0;o.match("embed|object")?(n.hasEmbed=!0,n.hasEmbedCount++):o.match("iframe")&&n.hasiframeCount++}));e.each(n.list,function(t,i){var s,a,o,l,c=e(i.panel).find(i.selector),h=n.services[i.service],u=h.api&&h.api.initParam||"",d=h.api&&h.api.playerId||"";n.hasEmbed&&n.hasSwfo&&i.selector.match("embed|object")?c.each(function(){s=e(this);a="OBJECT"===e(this).parent()[0].tagName?e(this).parent():e(this);o="EMBED"===a[0].tagName?a.attr("src"):a.find("embed").attr("src")||a.children().filter("[name=movie]").attr("value");l=e.extend(!0,{},{flashvars:null,params:{allowScriptAccess:"always",wmode:n.options.wmode||r.options.addWmodeToObject,allowfullscreen:!0},attr:{class:a.attr("class"),style:a.attr("style"),"data-url":o}},h.embedOpts);a.wrap('<div id="'+i.id+'"></div>');swfobject.embedSWF(o+u+(d?d+i.id:""),i.id,a.attr("width"),a.attr("height"),"10",null,l.flashvars,l.params,l.attr,function(){h.hasOwnProperty("init")&&h.init(r,s,t);t>=n.hasEmbedCount&&r.$el.trigger("swf_completed",r)})}):i.selector.match("iframe")&&c.each(function(){var i=e(this);h.hasOwnProperty("init")&&h.init(r,i,t)})});n.gup=function(e,t){e=e.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var i=RegExp("[\\?&]"+e+"=([^&#]*)").exec(t||window.location.href);return null===i?"":i[1]};n.postMsg=function(t,i){var n=e("#"+i);n.length&&n[0].contentWindow.postMessage(t,n.attr("src").split("?")[0])};n.message=function(t){if(t.data&&!/infoDelivery/g.test(t.data)){var i=e.parseJSON(t.data);e.each(n.list,function(e){n.services[n.list[e].service].hasOwnProperty("message")&&n.services[n.list[e].service].message(r,i)})}};n.control=function(t){var i,s=n.list,a="pause"===t?r.$lastPage[0]:r.$currentPage[0],o=!1;for(i=0;i<e.fn.anythingSliderVideo.videoIndex;i++)s[i]&&s[i].panel===a&&n.services[s[i].service].hasOwnProperty(t)&&(o=n.services[s[i].service][t](r,e("#"+s[i].id),i));return o};n.bindFrames=function(e){window.addEventListener?window.addEventListener(e,n.message,!1):window.attachEvent(/^on/.test(e)?e:"on"+e,n.message,!1)};n.hasiframeCount&&n.bindFrames("message");r.$el.bind("slide_init",function(){n.control("pause")}).bind("slide_complete",function(){n.control("cont")});n.isVideoPlayingOrig=r.options.isVideoPlaying;r.options.isVideoPlaying=function(){return n.control("isPlaying")||n.isVideoPlayingOrig&&n.isVideoPlayingOrig()};"function"==typeof n.options.onVideoInitialized&&n.options.onVideoInitialized(r)}})};e.fn.anythingSliderVideo.videoIndex=0;e.fn.anythingSliderVideo.services={video:{selector:"video",cont:function(e,t){e.options.resumeOnVisible&&t.length&&t[0].paused&&0<t[0].currentTime&&!t[0].ended&&t[0].play()},pause:function(){e("video").each(function(){"undefined"!=typeof this.pause&&this.pause()})},isPlaying:function(e,t){return!(!t.length||"undefined"==typeof t[0].pause||t[0].paused||t[0].ended)}},vimeo1:{selector:"iframe[src*=vimeo]",init:function(e,t){var i=t.attr("src");t.attr("src",function(n,s){return s+(i.match(/\?/g)?"":"?")+"&wmode="+(e.video.options.wmode||e.options.addWmodeToObject)+"&api=1&player_id="+t[0].id})},cont:function(e,t,i){e.options.resumeOnVisible&&"pause"===e.video.list[i].status&&e.video.postMsg('{"method":"play"}',t[0].id)},pause:function(t){e("iframe[src*=vimeo]").each(function(){t.video.postMsg('{"method":"pause"}',this.id)})},message:function(e,t){var i,n=t.player_id||"";""!==n&&(i=n.replace(e.video.options.videoId,""),"ready"===t.event&&(e.video.postMsg('{"method":"addEventListener","value":"play"}',n),e.video.postMsg('{"method":"addEventListener","value":"pause"}',n),e.video.postMsg('{"method":"addEventListener","value":"finish"}',n)),e.video.list[i]&&(e.video.list[i].status=t.event))},isPlaying:function(e,t,i){return"play"===e.video.list[i].status}},vimeo2:{selector:"object[data-url*=vimeo], embed[src*=vimeo]",embedOpts:{flashvars:{api:1}},cont:function(e,t){e.options.resumeOnVisible&&"function"==typeof t[0].api_play&&t[0].api_paused()&&0!==t[0].api_getCurrentTime()&&2<t[0].api_getDuration()-t[0].api_getCurrentTime()&&t[0].api_play()},pause:function(){e("object[data-url*=vimeo], embed[src*=vimeo]").each(function(){var t="EMBED"===this.tagName?e(this).parent()[0]:this;"function"==typeof t.api_pause&&t.api_pause()})},isPlaying:function(e,t){return"function"==typeof t[0].api_paused&&!t[0].api_paused()}},youtube1:{selector:"iframe[src*=youtube]",init:function(t,i,n){!e.fn.anythingSliderVideo.youTubeLoaded&&t.video.options.youtubeAutoLoad&&e.getScript("http://www.youtube.com/iframe_api",function(){e.fn.anythingSliderVideo.youTubeLoaded=!0});var s=0,a=setInterval(function(){if(e.fn.anythingSliderVideo.youTubeReady){var o=i[0].id,r=i.attr("src").split("embed/")[1],l=t.video.options.youtubeParams;l.wmode=t.video.options.wmode||t.options.addWmodeToObject||"opaque";i.wrap('<div id="'+o+'"/>').attr("id","");t.video.list[n].player=new YT.Player(o,{height:"100%",width:"100%",videoId:r,playerVars:l,events:{onReady:function(e){t.video.list[n].status=e.data},onStateChange:function(e){t.video.list[n].status=e.data}}});clearInterval(a)}60<++s&&clearInterval(a)},1e3)},cont:function(e,t,i){e.options.resumeOnVisible&&2===e.video.list[i].status&&e.video.list[i].player&&e.video.list[i].player.playVideo()},pause:function(e,t,i){e.video.list[i].player&&e.video.list[i].player.pauseVideo()},isPlaying:function(e,t,i){e=e.video.list[i].status;return 1===e||2<e}},youtube2:{selector:"object[data-url*=youtube], embed[src*=youtube]",api:{initParam:"&enablejsapi=1",playerId:"&iv_load_policy=3&version=3&playerapiid="},cont:function(e,t){e.options.resumeOnVisible&&t.length&&"function"==typeof t[0].getPlayerState&&0<t[0].getPlayerState()&&t[0].playVideo()},pause:function(){e("object[data-url*=youtube], embed[src*=youtube]").each(function(){var t="EMBED"===this.tagName?e(this).parent()[0]:this;"function"==typeof t.getPlayerState&&0<t.getPlayerState()&&t.pauseVideo()})},isPlaying:function(e,t){return"function"==typeof t[0].getPlayerState&&(1===t[0].getPlayerState()||2<t[0].getPlayerState())}}}}(jQuery);
//# sourceMappingURL=compiled-jquery.js.map

/*
 * Foundation Responsive Library
 * http://foundation.zurb.com
 * Copyright 2015, ZURB
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
*/

(function ($, window, document, undefined) {
  'use strict';

  var header_helpers = function (class_array) {
    var head = $('head');
    head.prepend($.map(class_array, function (class_name) {
      if (head.has('.' + class_name).length === 0) {
        return '<meta class="' + class_name + '" />';
      }
    }));
  };

  header_helpers([
    'foundation-mq-small',
    'foundation-mq-small-only',
    'foundation-mq-medium',
    'foundation-mq-medium-only',
    'foundation-mq-large',
    'foundation-mq-large-only',
    'foundation-mq-xlarge',
    'foundation-mq-xlarge-only',
    'foundation-mq-xxlarge',
    'foundation-data-attribute-namespace']);

  // Enable FastClick if present

  $(function () {
    if (typeof FastClick !== 'undefined') {
      // Don't attach to body if undefined
      if (typeof document.body !== 'undefined') {
        FastClick.attach(document.body);
      }
    }
  });

  // private Fast Selector wrapper,
  // returns jQuery object. Only use where
  // getElementById is not available.
  var S = function (selector, context) {
    if (typeof selector === 'string') {
      if (context) {
        var cont;
        if (context.jquery) {
          cont = context[0];
          if (!cont) {
            return context;
          }
        } else {
          cont = context;
        }
        return $(cont.querySelectorAll(selector));
      }

      return $(document.querySelectorAll(selector));
    }

    return $(selector, context);
  };

  // Namespace functions.

  var attr_name = function (init) {
    var arr = [];
    if (!init) {
      arr.push('data');
    }
    if (this.namespace.length > 0) {
      arr.push(this.namespace);
    }
    arr.push(this.name);

    return arr.join('-');
  };

  var add_namespace = function (str) {
    var parts = str.split('-'),
        i = parts.length,
        arr = [];

    while (i--) {
      if (i !== 0) {
        arr.push(parts[i]);
      } else {
        if (this.namespace.length > 0) {
          arr.push(this.namespace, parts[i]);
        } else {
          arr.push(parts[i]);
        }
      }
    }

    return arr.reverse().join('-');
  };

  // Event binding and data-options updating.

  var bindings = function (method, options) {
    var self = this,
        bind = function(){
          var $this = S(this),
              should_bind_events = !$this.data(self.attr_name(true) + '-init');
          $this.data(self.attr_name(true) + '-init', $.extend({}, self.settings, (options || method), self.data_options($this)));

          if (should_bind_events) {
            self.events(this);
          }
        };

    if (S(this.scope).is('[' + this.attr_name() +']')) {
      bind.call(this.scope);
    } else {
      S('[' + this.attr_name() +']', this.scope).each(bind);
    }
    // # Patch to fix #5043 to move this *after* the if/else clause in order for Backbone and similar frameworks to have improved control over event binding and data-options updating.
    if (typeof method === 'string') {
      return this[method].call(this, options);
    }

  };

  var single_image_loaded = function (image, callback) {
    function loaded () {
      callback(image[0]);
    }

    function bindLoad () {
      this.one('load', loaded);

      if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        var src = this.attr( 'src' ),
            param = src.match( /\?/ ) ? '&' : '?';

        param += 'random=' + (new Date()).getTime();
        this.attr('src', src + param);
      }
    }

    if (!image.attr('src')) {
      loaded();
      return;
    }

    if (image[0].complete || image[0].readyState === 4) {
      loaded();
    } else {
      bindLoad.call(image);
    }
  };

  /*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */

  window.matchMedia || (window.matchMedia = function() {
      "use strict";

      // For browsers that support matchMedium api such as IE 9 and webkit
      var styleMedia = (window.styleMedia || window.media);

      // For those that don't support matchMedium
      if (!styleMedia) {
          var style       = document.createElement('style'),
              script      = document.getElementsByTagName('script')[0],
              info        = null;

          style.type  = 'text/css';
          style.id    = 'matchmediajs-test';

          script.parentNode.insertBefore(style, script);

          // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
          info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

          styleMedia = {
              matchMedium: function(media) {
                  var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                  // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                  if (style.styleSheet) {
                      style.styleSheet.cssText = text;
                  } else {
                      style.textContent = text;
                  }

                  // Test if media query is true or false
                  return info.width === '1px';
              }
          };
      }

      return function(media) {
          return {
              matches: styleMedia.matchMedium(media || 'all'),
              media: media || 'all'
          };
      };
  }());

  /*
   * jquery.requestAnimationFrame
   * https://github.com/gnarf37/jquery-requestAnimationFrame
   * Requires jQuery 1.8+
   *
   * Copyright (c) 2012 Corey Frang
   * Licensed under the MIT license.
   */

  (function(jQuery) {


  // requestAnimationFrame polyfill adapted from Erik Möller
  // fixes from Paul Irish and Tino Zijdel
  // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
  // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

  var animating,
      lastTime = 0,
      vendors = ['webkit', 'moz'],
      requestAnimationFrame = window.requestAnimationFrame,
      cancelAnimationFrame = window.cancelAnimationFrame,
      jqueryFxAvailable = 'undefined' !== typeof jQuery.fx;

  for (; lastTime < vendors.length && !requestAnimationFrame; lastTime++) {
    requestAnimationFrame = window[ vendors[lastTime] + 'RequestAnimationFrame' ];
    cancelAnimationFrame = cancelAnimationFrame ||
      window[ vendors[lastTime] + 'CancelAnimationFrame' ] ||
      window[ vendors[lastTime] + 'CancelRequestAnimationFrame' ];
  }

  function raf() {
    if (animating) {
      requestAnimationFrame(raf);

      if (jqueryFxAvailable) {
        jQuery.fx.tick();
      }
    }
  }

  if (requestAnimationFrame) {
    // use rAF
    window.requestAnimationFrame = requestAnimationFrame;
    window.cancelAnimationFrame = cancelAnimationFrame;

    if (jqueryFxAvailable) {
      jQuery.fx.timer = function (timer) {
        if (timer() && jQuery.timers.push(timer) && !animating) {
          animating = true;
          raf();
        }
      };

      jQuery.fx.stop = function () {
        animating = false;
      };
    }
  } else {
    // polyfill
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime(),
        timeToCall = Math.max(0, 16 - (currTime - lastTime)),
        id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };

  }

  }( $ ));

  function removeQuotes (string) {
    if (typeof string === 'string' || string instanceof String) {
      string = string.replace(/^['\\/"]+|(;\s?})+|['\\/"]+$/g, '');
    }

    return string;
  }

  function MediaQuery(selector) {
    this.selector = selector;
    this.query = '';
  }

  MediaQuery.prototype.toString = function () {
    return this.query || (this.query = S(this.selector).css('font-family').replace(/^[\/\\'"]+|(;\s?})+|[\/\\'"]+$/g, ''));
  };

  window.Foundation = {
    name : 'Foundation',

    version : '5.5.3',

    media_queries : {
      'small'       : new MediaQuery('.foundation-mq-small'),
      'small-only'  : new MediaQuery('.foundation-mq-small-only'),
      'medium'      : new MediaQuery('.foundation-mq-medium'),
      'medium-only' : new MediaQuery('.foundation-mq-medium-only'),
      'large'       : new MediaQuery('.foundation-mq-large'),
      'large-only'  : new MediaQuery('.foundation-mq-large-only'),
      'xlarge'      : new MediaQuery('.foundation-mq-xlarge'),
      'xlarge-only' : new MediaQuery('.foundation-mq-xlarge-only'),
      'xxlarge'     : new MediaQuery('.foundation-mq-xxlarge')
    },

    stylesheet : $('<style></style>').appendTo('head')[0].sheet,

    global : {
      namespace : undefined
    },

    init : function (scope, libraries, method, options, response) {
      var args = [scope, method, options, response],
          responses = [];

      // check RTL
      this.rtl = /rtl/i.test(S('html').attr('dir'));

      // set foundation global scope
      this.scope = scope || this.scope;

      this.set_namespace();

      if (libraries && typeof libraries === 'string' && !/reflow/i.test(libraries)) {
        if (this.libs.hasOwnProperty(libraries)) {
          responses.push(this.init_lib(libraries, args));
        }
      } else {
        for (var lib in this.libs) {
          responses.push(this.init_lib(lib, libraries));
        }
      }

      S(window).load(function () {
        S(window)
          .trigger('resize.fndtn.clearing')
          .trigger('resize.fndtn.dropdown')
          .trigger('resize.fndtn.equalizer')
          .trigger('resize.fndtn.interchange')
          .trigger('resize.fndtn.joyride')
          .trigger('resize.fndtn.magellan')
          .trigger('resize.fndtn.topbar')
          .trigger('resize.fndtn.slider');
      });

      return scope;
    },

    init_lib : function (lib, args) {
      if (this.libs.hasOwnProperty(lib)) {
        this.patch(this.libs[lib]);

        if (args && args.hasOwnProperty(lib)) {
            if (typeof this.libs[lib].settings !== 'undefined') {
              $.extend(true, this.libs[lib].settings, args[lib]);
            } else if (typeof this.libs[lib].defaults !== 'undefined') {
              $.extend(true, this.libs[lib].defaults, args[lib]);
            }
          return this.libs[lib].init.apply(this.libs[lib], [this.scope, args[lib]]);
        }

        args = args instanceof Array ? args : new Array(args);
        return this.libs[lib].init.apply(this.libs[lib], args);
      }

      return function () {};
    },

    patch : function (lib) {
      lib.scope = this.scope;
      lib.namespace = this.global.namespace;
      lib.rtl = this.rtl;
      lib['data_options'] = this.utils.data_options;
      lib['attr_name'] = attr_name;
      lib['add_namespace'] = add_namespace;
      lib['bindings'] = bindings;
      lib['S'] = this.utils.S;
    },

    inherit : function (scope, methods) {
      var methods_arr = methods.split(' '),
          i = methods_arr.length;

      while (i--) {
        if (this.utils.hasOwnProperty(methods_arr[i])) {
          scope[methods_arr[i]] = this.utils[methods_arr[i]];
        }
      }
    },

    set_namespace : function () {

      // Description:
      //    Don't bother reading the namespace out of the meta tag
      //    if the namespace has been set globally in javascript
      //
      // Example:
      //    Foundation.global.namespace = 'my-namespace';
      // or make it an empty string:
      //    Foundation.global.namespace = '';
      //
      //

      // If the namespace has not been set (is undefined), try to read it out of the meta element.
      // Otherwise use the globally defined namespace, even if it's empty ('')
      var namespace = ( this.global.namespace === undefined ) ? $('.foundation-data-attribute-namespace').css('font-family') : this.global.namespace;

      // Finally, if the namsepace is either undefined or false, set it to an empty string.
      // Otherwise use the namespace value.
      this.global.namespace = ( namespace === undefined || /false/i.test(namespace) ) ? '' : namespace;
    },

    libs : {},

    // methods that can be inherited in libraries
    utils : {

      // Description:
      //    Fast Selector wrapper returns jQuery object. Only use where getElementById
      //    is not available.
      //
      // Arguments:
      //    Selector (String): CSS selector describing the element(s) to be
      //    returned as a jQuery object.
      //
      //    Scope (String): CSS selector describing the area to be searched. Default
      //    is document.
      //
      // Returns:
      //    Element (jQuery Object): jQuery object containing elements matching the
      //    selector within the scope.
      S : S,

      // Description:
      //    Executes a function a max of once every n milliseconds
      //
      // Arguments:
      //    Func (Function): Function to be throttled.
      //
      //    Delay (Integer): Function execution threshold in milliseconds.
      //
      // Returns:
      //    Lazy_function (Function): Function with throttling applied.
      throttle : function (func, delay) {
        var timer = null;

        return function () {
          var context = this, args = arguments;

          if (timer == null) {
            timer = setTimeout(function () {
              func.apply(context, args);
              timer = null;
            }, delay);
          }
        };
      },

      // Description:
      //    Executes a function when it stops being invoked for n seconds
      //    Modified version of _.debounce() http://underscorejs.org
      //
      // Arguments:
      //    Func (Function): Function to be debounced.
      //
      //    Delay (Integer): Function execution threshold in milliseconds.
      //
      //    Immediate (Bool): Whether the function should be called at the beginning
      //    of the delay instead of the end. Default is false.
      //
      // Returns:
      //    Lazy_function (Function): Function with debouncing applied.
      debounce : function (func, delay, immediate) {
        var timeout, result;
        return function () {
          var context = this, args = arguments;
          var later = function () {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, delay);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },

      // Description:
      //    Parses data-options attribute
      //
      // Arguments:
      //    El (jQuery Object): Element to be parsed.
      //
      // Returns:
      //    Options (Javascript Object): Contents of the element's data-options
      //    attribute.
      data_options : function (el, data_attr_name) {
        data_attr_name = data_attr_name || 'options';
        var opts = {}, ii, p, opts_arr,
            data_options = function (el) {
              var namespace = Foundation.global.namespace;

              if (namespace.length > 0) {
                return el.data(namespace + '-' + data_attr_name);
              }

              return el.data(data_attr_name);
            };

        var cached_options = data_options(el);

        if (typeof cached_options === 'object') {
          return cached_options;
        }

        opts_arr = (cached_options || ':').split(';');
        ii = opts_arr.length;

        function isNumber (o) {
          return !isNaN (o - 0) && o !== null && o !== '' && o !== false && o !== true;
        }

        function trim (str) {
          if (typeof str === 'string') {
            return $.trim(str);
          }
          return str;
        }

        while (ii--) {
          p = opts_arr[ii].split(':');
          p = [p[0], p.slice(1).join(':')];

          if (/true/i.test(p[1])) {
            p[1] = true;
          }
          if (/false/i.test(p[1])) {
            p[1] = false;
          }
          if (isNumber(p[1])) {
            if (p[1].indexOf('.') === -1) {
              p[1] = parseInt(p[1], 10);
            } else {
              p[1] = parseFloat(p[1]);
            }
          }

          if (p.length === 2 && p[0].length > 0) {
            opts[trim(p[0])] = trim(p[1]);
          }
        }

        return opts;
      },

      // Description:
      //    Adds JS-recognizable media queries
      //
      // Arguments:
      //    Media (String): Key string for the media query to be stored as in
      //    Foundation.media_queries
      //
      //    Class (String): Class name for the generated <meta> tag
      register_media : function (media, media_class) {
        if (Foundation.media_queries[media] === undefined) {
          $('head').append('<meta class="' + media_class + '"/>');
          Foundation.media_queries[media] = removeQuotes($('.' + media_class).css('font-family'));
        }
      },

      // Description:
      //    Add custom CSS within a JS-defined media query
      //
      // Arguments:
      //    Rule (String): CSS rule to be appended to the document.
      //
      //    Media (String): Optional media query string for the CSS rule to be
      //    nested under.
      add_custom_rule : function (rule, media) {
        if (media === undefined && Foundation.stylesheet) {
          Foundation.stylesheet.insertRule(rule, Foundation.stylesheet.cssRules.length);
        } else {
          var query = Foundation.media_queries[media];

          if (query !== undefined) {
            Foundation.stylesheet.insertRule('@media ' +
              Foundation.media_queries[media] + '{ ' + rule + ' }', Foundation.stylesheet.cssRules.length);
          }
        }
      },

      // Description:
      //    Performs a callback function when an image is fully loaded
      //
      // Arguments:
      //    Image (jQuery Object): Image(s) to check if loaded.
      //
      //    Callback (Function): Function to execute when image is fully loaded.
      image_loaded : function (images, callback) {
        var self = this,
            unloaded = images.length;

        function pictures_has_height(images) {
          var pictures_number = images.length;

          for (var i = pictures_number - 1; i >= 0; i--) {
            if(images.attr('height') === undefined) {
              return false;
            };
          };

          return true;
        }

        if (unloaded === 0 || pictures_has_height(images)) {
          callback(images);
        }

        images.each(function () {
          single_image_loaded(self.S(this), function () {
            unloaded -= 1;
            if (unloaded === 0) {
              callback(images);
            }
          });
        });
      },

      // Description:
      //    Returns a random, alphanumeric string
      //
      // Arguments:
      //    Length (Integer): Length of string to be generated. Defaults to random
      //    integer.
      //
      // Returns:
      //    Rand (String): Pseudo-random, alphanumeric string.
      random_str : function () {
        if (!this.fidx) {
          this.fidx = 0;
        }
        this.prefix = this.prefix || [(this.name || 'F'), (+new Date).toString(36)].join('-');

        return this.prefix + (this.fidx++).toString(36);
      },

      // Description:
      //    Helper for window.matchMedia
      //
      // Arguments:
      //    mq (String): Media query
      //
      // Returns:
      //    (Boolean): Whether the media query passes or not
      match : function (mq) {
        return window.matchMedia(mq).matches;
      },

      // Description:
      //    Helpers for checking Foundation default media queries with JS
      //
      // Returns:
      //    (Boolean): Whether the media query passes or not

      is_small_up : function () {
        return this.match(Foundation.media_queries.small);
      },

      is_medium_up : function () {
        return this.match(Foundation.media_queries.medium);
      },

      is_large_up : function () {
        return this.match(Foundation.media_queries.large);
      },

      is_xlarge_up : function () {
        return this.match(Foundation.media_queries.xlarge);
      },

      is_xxlarge_up : function () {
        return this.match(Foundation.media_queries.xxlarge);
      },

      is_small_only : function () {
        return !this.is_medium_up() && !this.is_large_up() && !this.is_xlarge_up() && !this.is_xxlarge_up();
      },

      is_medium_only : function () {
        return this.is_medium_up() && !this.is_large_up() && !this.is_xlarge_up() && !this.is_xxlarge_up();
      },

      is_large_only : function () {
        return this.is_medium_up() && this.is_large_up() && !this.is_xlarge_up() && !this.is_xxlarge_up();
      },

      is_xlarge_only : function () {
        return this.is_medium_up() && this.is_large_up() && this.is_xlarge_up() && !this.is_xxlarge_up();
      },

      is_xxlarge_only : function () {
        return this.is_medium_up() && this.is_large_up() && this.is_xlarge_up() && this.is_xxlarge_up();
      }
    }
  };

  $.fn.foundation = function () {
    var args = Array.prototype.slice.call(arguments, 0);

    return this.each(function () {
      Foundation.init.apply(Foundation, [this].concat(args));
      return this;
    });
  };

}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.abide = {
    name : 'abide',

    version : '5.5.3',

    settings : {
      live_validate : true, // validate the form as you go
      validate_on_blur : true, // validate whenever you focus/blur on an input field
      // validate_on: 'tab', // tab (when user tabs between fields), change (input changes), manual (call custom events)

      focus_on_invalid : true, // automatically bring the focus to an invalid input field
      error_labels : true, // labels with a for="inputId" will receive an `error` class
      error_class : 'error', // labels with a for="inputId" will receive an `error` class
      // the amount of time Abide will take before it validates the form (in ms).
      // smaller time will result in faster validation
      timeout : 1000,
      patterns : {
        alpha : /^[a-zA-Z]+$/,
        alpha_numeric : /^[a-zA-Z0-9]+$/,
        integer : /^[-+]?\d+$/,
        number : /^[-+]?\d*(?:[\.\,]\d+)?$/,

        // amex, visa, diners
        card : /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
        cvv : /^([0-9]){3,4}$/,

        // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
        email : /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,

        // http://blogs.lse.ac.uk/lti/2008/04/23/a-regular-expression-to-match-any-url/
        url: /^(https?|ftp|file|ssh):\/\/([-;:&=\+\$,\w]+@{1})?([-A-Za-z0-9\.]+)+:?(\d+)?((\/[-\+~%\/\.\w]+)?\??([-\+=&;%@\.\w]+)?#?([\w]+)?)?/,
        // abc.de
        domain : /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,

        datetime : /^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/,
        // YYYY-MM-DD
        date : /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/,
        // HH:MM:SS
        time : /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,
        dateISO : /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/,
        // MM/DD/YYYY
        month_day_year : /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/,
        // DD/MM/YYYY
        day_month_year : /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/,

        // #FFF or #FFFFFF
        color : /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/
      },
      validators : {
        equalTo : function (el, required, parent) {
          var from  = document.getElementById(el.getAttribute(this.add_namespace('data-equalto'))).value,
              to    = el.value,
              valid = (from === to);

          return valid;
        }
      }
    },

    timer : null,

    init : function (scope, method, options) {
      this.bindings(method, options);
    },

    events : function (scope) {
      var self = this,
          form = self.S(scope).attr('novalidate', 'novalidate'),
          settings = form.data(this.attr_name(true) + '-init') || {};

      this.invalid_attr = this.add_namespace('data-invalid');

      function validate(originalSelf, e) {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () {
          self.validate([originalSelf], e);
        }.bind(originalSelf), settings.timeout);
      }

      form
        .off('.abide')
        .on('submit.fndtn.abide', function (e) {
          var is_ajax = /ajax/i.test(self.S(this).attr(self.attr_name()));
          return self.validate(self.S(this).find('input, textarea, select').not(":hidden, [data-abide-ignore]").get(), e, is_ajax);
        })
        .on('validate.fndtn.abide', function (e) {
          if (settings.validate_on === 'manual') {
            self.validate([e.target], e);
          }
        })
        .on('reset', function (e) {
          return self.reset($(this), e);
        })
        .find('input, textarea, select').not(":hidden, [data-abide-ignore]")
          .off('.abide')
          .on('blur.fndtn.abide change.fndtn.abide', function (e) {
              var id = this.getAttribute('id'),
                  eqTo = form.find('[data-equalto="'+ id +'"]');
            // old settings fallback
            // will be deprecated with F6 release
            if (settings.validate_on_blur && settings.validate_on_blur === true) {
              validate(this, e);
            }
            // checks if there is an equalTo equivalent related by id
            if(typeof eqTo.get(0) !== "undefined" && eqTo.val().length){
              validate(eqTo.get(0),e);
            }
            // new settings combining validate options into one setting
            if (settings.validate_on === 'change') {
              validate(this, e);
            }
          })
          .on('keydown.fndtn.abide', function (e) {
            var id = this.getAttribute('id'),
                eqTo = form.find('[data-equalto="'+ id +'"]');
            // old settings fallback
            // will be deprecated with F6 release
            if (settings.live_validate && settings.live_validate === true && e.which != 9) {
              validate(this, e);
            }
            // checks if there is an equalTo equivalent related by id
            if(typeof eqTo.get(0) !== "undefined" && eqTo.val().length){
              validate(eqTo.get(0),e);
            }
            // new settings combining validate options into one setting
            if (settings.validate_on === 'tab' && e.which === 9) {
              validate(this, e);
            }
            else if (settings.validate_on === 'change') {
              validate(this, e);
            }
          })
          .on('focus', function (e) {
            if (navigator.userAgent.match(/iPad|iPhone|Android|BlackBerry|Windows Phone|webOS/i)) {
              $('html, body').animate({
                  scrollTop: $(e.target).offset().top
              }, 100);
            }
          });
    },

    reset : function (form, e) {
      var self = this;
      form.removeAttr(self.invalid_attr);

      $('[' + self.invalid_attr + ']', form).removeAttr(self.invalid_attr);
      $('.' + self.settings.error_class, form).not('small').removeClass(self.settings.error_class);
      $(':input', form).not(':button, :submit, :reset, :hidden, [data-abide-ignore]').val('').removeAttr(self.invalid_attr);
    },

    validate : function (els, e, is_ajax) {
      var validations = this.parse_patterns(els),
          validation_count = validations.length,
          form = this.S(els[0]).closest('form'),
          submit_event = /submit/.test(e.type);

      // Has to count up to make sure the focus gets applied to the top error
      for (var i = 0; i < validation_count; i++) {
        if (!validations[i] && (submit_event || is_ajax)) {
          if (this.settings.focus_on_invalid) {
            els[i].focus();
          }
          form.trigger('invalid.fndtn.abide');
          this.S(els[i]).closest('form').attr(this.invalid_attr, '');
          return false;
        }
      }

      if (submit_event || is_ajax) {
        form.trigger('valid.fndtn.abide');
      }

      form.removeAttr(this.invalid_attr);

      if (is_ajax) {
        return false;
      }

      return true;
    },

    parse_patterns : function (els) {
      var i = els.length,
          el_patterns = [];

      while (i--) {
        el_patterns.push(this.pattern(els[i]));
      }

      return this.check_validation_and_apply_styles(el_patterns);
    },

    pattern : function (el) {
      var type = el.getAttribute('type'),
          required = typeof el.getAttribute('required') === 'string';

      var pattern = el.getAttribute('pattern') || '';

      if (this.settings.patterns.hasOwnProperty(pattern) && pattern.length > 0) {
        return [el, this.settings.patterns[pattern], required];
      } else if (pattern.length > 0) {
        return [el, new RegExp(pattern), required];
      }

      if (this.settings.patterns.hasOwnProperty(type)) {
        return [el, this.settings.patterns[type], required];
      }

      pattern = /.*/;

      return [el, pattern, required];
    },

    // TODO: Break this up into smaller methods, getting hard to read.
    check_validation_and_apply_styles : function (el_patterns) {
      var i = el_patterns.length,
          validations = [];
      if (i == 0) {
        return validations;
      }
      var form = this.S(el_patterns[0][0]).closest('[data-' + this.attr_name(true) + ']'),
          settings = form.data(this.attr_name(true) + '-init') || {};
      while (i--) {
        var el = el_patterns[i][0],
            required = el_patterns[i][2],
            value = el.value.trim(),
            direct_parent = this.S(el).parent(),
            validator = el.getAttribute(this.add_namespace('data-abide-validator')),
            is_radio = el.type === 'radio',
            is_checkbox = el.type === 'checkbox',
            label = this.S('label[for="' + el.getAttribute('id') + '"]'),
            valid_length = (required) ? (el.value.length > 0) : true,
            el_validations = [];

        var parent, valid;

        // support old way to do equalTo validations
        if (el.getAttribute(this.add_namespace('data-equalto'))) { validator = 'equalTo' }

        if (!direct_parent.is('label')) {
          parent = direct_parent;
        } else {
          parent = direct_parent.parent();
        }

        if (is_radio && required) {
          el_validations.push(this.valid_radio(el, required));
        } else if (is_checkbox && required) {
          el_validations.push(this.valid_checkbox(el, required));

        } else if (validator) {
          // Validate using each of the specified (space-delimited) validators.
          var validators = validator.split(' ');
          var last_valid = true, all_valid = true;
          for (var iv = 0; iv < validators.length; iv++) {
              valid = this.settings.validators[validators[iv]].apply(this, [el, required, parent])
              el_validations.push(valid);
              all_valid = valid && last_valid;
              last_valid = valid;
          }
          if (all_valid) {
              this.S(el).removeAttr(this.invalid_attr);
              parent.removeClass('error');
              if (label.length > 0 && this.settings.error_labels) {
                label.removeClass(this.settings.error_class).removeAttr('role');
              }
              $(el).triggerHandler('valid');
          } else {
              this.S(el).attr(this.invalid_attr, '');
              parent.addClass('error');
              if (label.length > 0 && this.settings.error_labels) {
                label.addClass(this.settings.error_class).attr('role', 'alert');
              }
              $(el).triggerHandler('invalid');
          }
        } else {

          if (el_patterns[i][1].test(value) && valid_length ||
            !required && el.value.length < 1 || $(el).attr('disabled')) {
            el_validations.push(true);
          } else {
            el_validations.push(false);
          }

          el_validations = [el_validations.every(function (valid) {return valid;})];
          if (el_validations[0]) {
            this.S(el).removeAttr(this.invalid_attr);
            el.setAttribute('aria-invalid', 'false');
            el.removeAttribute('aria-describedby');
            parent.removeClass(this.settings.error_class);
            if (label.length > 0 && this.settings.error_labels) {
              label.removeClass(this.settings.error_class).removeAttr('role');
            }
            $(el).triggerHandler('valid');
          } else {
            this.S(el).attr(this.invalid_attr, '');
            el.setAttribute('aria-invalid', 'true');

            // Try to find the error associated with the input
            var errorElem = parent.find('small.' + this.settings.error_class, 'span.' + this.settings.error_class);
            var errorID = errorElem.length > 0 ? errorElem[0].id : '';
            if (errorID.length > 0) {
              el.setAttribute('aria-describedby', errorID);
            }

            // el.setAttribute('aria-describedby', $(el).find('.error')[0].id);
            parent.addClass(this.settings.error_class);
            if (label.length > 0 && this.settings.error_labels) {
              label.addClass(this.settings.error_class).attr('role', 'alert');
            }
            $(el).triggerHandler('invalid');
          }
        }
        validations = validations.concat(el_validations);
      }

      return validations;
    },

    valid_checkbox : function (el, required) {
      var el = this.S(el),
          valid = (el.is(':checked') || !required || el.get(0).getAttribute('disabled'));

      if (valid) {
        el.removeAttr(this.invalid_attr).parent().removeClass(this.settings.error_class);
        $(el).triggerHandler('valid');
      } else {
        el.attr(this.invalid_attr, '').parent().addClass(this.settings.error_class);
        $(el).triggerHandler('invalid');
      }

      return valid;
    },

    valid_radio : function (el, required) {
      var name = el.getAttribute('name'),
          group = this.S(el).closest('[data-' + this.attr_name(true) + ']').find("[name='" + name + "']"),
          count = group.length,
          valid = false,
          disabled = false;

      // Has to count up to make sure the focus gets applied to the top error
      for (var i=0; i < count; i++) {
        if( group[i].getAttribute('disabled') ){
          disabled=true;
          valid=true;
        } else {
          if (group[i].checked){
            valid = true;
          } else {
            if( disabled ){
              valid = false;
            }
          }
        }
      }

      // Has to count up to make sure the focus gets applied to the top error
      for (var i = 0; i < count; i++) {
        if (valid) {
          this.S(group[i]).removeAttr(this.invalid_attr).parent().removeClass(this.settings.error_class);
          $(group[i]).triggerHandler('valid');
        } else {
          this.S(group[i]).attr(this.invalid_attr, '').parent().addClass(this.settings.error_class);
          $(group[i]).triggerHandler('invalid');
        }
      }

      return valid;
    },

    valid_equal : function (el, required, parent) {
      var from  = document.getElementById(el.getAttribute(this.add_namespace('data-equalto'))).value,
          to    = el.value,
          valid = (from === to);

      if (valid) {
        this.S(el).removeAttr(this.invalid_attr);
        parent.removeClass(this.settings.error_class);
        if (label.length > 0 && settings.error_labels) {
          label.removeClass(this.settings.error_class);
        }
      } else {
        this.S(el).attr(this.invalid_attr, '');
        parent.addClass(this.settings.error_class);
        if (label.length > 0 && settings.error_labels) {
          label.addClass(this.settings.error_class);
        }
      }

      return valid;
    },

    valid_oneof : function (el, required, parent, doNotValidateOthers) {
      var el = this.S(el),
        others = this.S('[' + this.add_namespace('data-oneof') + ']'),
        valid = others.filter(':checked').length > 0;

      if (valid) {
        el.removeAttr(this.invalid_attr).parent().removeClass(this.settings.error_class);
      } else {
        el.attr(this.invalid_attr, '').parent().addClass(this.settings.error_class);
      }

      if (!doNotValidateOthers) {
        var _this = this;
        others.each(function () {
          _this.valid_oneof.call(_this, this, null, null, true);
        });
      }

      return valid;
    },

    reflow : function(scope, options) {
      var self = this,
          form = self.S('[' + this.attr_name() + ']').attr('novalidate', 'novalidate');
          self.S(form).each(function (idx, el) {
            self.events(el);
          });
    }
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.accordion = {
    name : 'accordion',

    version : '5.5.3',

    settings : {
      content_class : 'content',
      active_class : 'active',
      multi_expand : false,
      toggleable : true,
      callback : function () {}
    },

    init : function (scope, method, options) {
      this.bindings(method, options);
    },

    events : function (instance) {
      var self = this;
      var S = this.S;
      self.create(this.S(instance));

      S(this.scope)
      .off('.fndtn.accordion')
      .on('click.fndtn.accordion', '[' + this.attr_name() + '] > dd > a, [' + this.attr_name() + '] > li > a', function (e) {
        var accordion = S(this).closest('[' + self.attr_name() + ']'),
            groupSelector = self.attr_name() + '=' + accordion.attr(self.attr_name()),
            settings = accordion.data(self.attr_name(true) + '-init') || self.settings,
            target = S('#' + this.href.split('#')[1]),
            aunts = $('> dd, > li', accordion),
            siblings = aunts.children('.' + settings.content_class),
            active_content = siblings.filter('.' + settings.active_class);

        e.preventDefault();

        if (accordion.attr(self.attr_name())) {
          siblings = siblings.add('[' + groupSelector + '] dd > ' + '.' + settings.content_class + ', [' + groupSelector + '] li > ' + '.' + settings.content_class);
          aunts = aunts.add('[' + groupSelector + '] dd, [' + groupSelector + '] li');
        }

        if (settings.toggleable && target.is(active_content)) {
          target.parent('dd, li').toggleClass(settings.active_class, false);
          target.toggleClass(settings.active_class, false);
          S(this).attr('aria-expanded', function(i, attr){
              return attr === 'true' ? 'false' : 'true';
          });
          settings.callback(target);
          target.triggerHandler('toggled', [accordion]);
          accordion.triggerHandler('toggled', [target]);
          return;
        }

        if (!settings.multi_expand) {
          siblings.removeClass(settings.active_class);
          aunts.removeClass(settings.active_class);
          aunts.children('a').attr('aria-expanded','false');
        }

        target.addClass(settings.active_class).parent().addClass(settings.active_class);
        settings.callback(target);
        target.triggerHandler('toggled', [accordion]);
        accordion.triggerHandler('toggled', [target]);
        S(this).attr('aria-expanded','true');
      });
    },

    create: function($instance) {
      var self = this,
          accordion = $instance,
          aunts = $('> .accordion-navigation', accordion),
          settings = accordion.data(self.attr_name(true) + '-init') || self.settings;

      aunts.children('a').attr('aria-expanded','false');
      aunts.has('.' + settings.content_class + '.' + settings.active_class).addClass(settings.active_class).children('a').attr('aria-expanded','true');

      if (settings.multi_expand) {
        $instance.attr('aria-multiselectable','true');
      }
    },
	
  	toggle : function(options) {
  		var options = typeof options !== 'undefined' ? options : {};
  		var selector = typeof options.selector !== 'undefined' ? options.selector : '';
  		var toggle_state = typeof options.toggle_state !== 'undefined' ? options.toggle_state : '';
  		var $accordion = typeof options.$accordion !== 'undefined' ? options.$accordion : this.S(this.scope).closest('[' + this.attr_name() + ']');
  
  		var $items = $accordion.find('> dd' + selector + ', > li' + selector);
  		if ( $items.length < 1 ) {
  			if ( window.console ) {
  				console.error('Selection not found.', selector);
  			}
  			return false;
  		}
  
  		var S = this.S;
  		var active_class = this.settings.active_class;
  		$items.each(function() {
  			var $item = S(this);
  			var is_active = $item.hasClass(active_class);
  			if ( ( is_active && toggle_state === 'close' ) || ( !is_active && toggle_state === 'open' ) || toggle_state === '' ) {
  				$item.find('> a').trigger('click.fndtn.accordion');
  			}
  		});
  	},
  
  	open : function(options) {
  		var options = typeof options !== 'undefined' ? options : {};
  		options.toggle_state = 'open';
  		this.toggle(options);
  	},
  
  	close : function(options) {
  		var options = typeof options !== 'undefined' ? options : {};
  		options.toggle_state = 'close';
  		this.toggle(options);
  	},	

    off : function () {},

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.alert = {
    name : 'alert',

    version : '5.5.3',

    settings : {
      callback : function () {}
    },

    init : function (scope, method, options) {
      this.bindings(method, options);
    },

    events : function () {
      var self = this,
          S = this.S;

      $(this.scope).off('.alert').on('click.fndtn.alert', '[' + this.attr_name() + '] .close', function (e) {
        var alertBox = S(this).closest('[' + self.attr_name() + ']'),
            settings = alertBox.data(self.attr_name(true) + '-init') || self.settings;

        e.preventDefault();
        if (Modernizr.csstransitions) {
          alertBox.addClass('alert-close');
          alertBox.on('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
            S(this).trigger('close.fndtn.alert').remove();
            settings.callback();
          });
        } else {
          alertBox.fadeOut(300, function () {
            S(this).trigger('close.fndtn.alert').remove();
            settings.callback();
          });
        }
      });
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.clearing = {
    name : 'clearing',

    version : '5.5.3',

    settings : {
      templates : {
        viewing : '<a href="#" class="clearing-close">&times;</a>' +
          '<div class="visible-img" style="display: none"><div class="clearing-touch-label"></div><img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D" alt="" />' +
          '<p class="clearing-caption"></p><a href="#" class="clearing-main-prev"><span></span></a>' +
          '<a href="#" class="clearing-main-next"><span></span></a></div>' +
          '<img class="clearing-preload-next" style="display: none" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D" alt="" />' +
          '<img class="clearing-preload-prev" style="display: none" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D" alt="" />'
      },

      // comma delimited list of selectors that, on click, will close clearing,
      // add 'div.clearing-blackout, div.visible-img' to close on background click
      close_selectors : '.clearing-close, div.clearing-blackout',

      // Default to the entire li element.
      open_selectors : '',

      // Image will be skipped in carousel.
      skip_selector : '',

      touch_label : '',

      // event initializer and locks
      init : false,
      locked : false
    },

    init : function (scope, method, options) {
      var self = this;
      Foundation.inherit(this, 'throttle image_loaded');

      this.bindings(method, options);

      if (self.S(this.scope).is('[' + this.attr_name() + ']')) {
        this.assemble(self.S('li', this.scope));
      } else {
        self.S('[' + this.attr_name() + ']', this.scope).each(function () {
          self.assemble(self.S('li', this));
        });
      }
    },

    events : function (scope) {
      var self = this,
          S = self.S,
          $scroll_container = $('.scroll-container');

      if ($scroll_container.length > 0) {
        this.scope = $scroll_container;
      }

      S(this.scope)
        .off('.clearing')
        .on('click.fndtn.clearing', 'ul[' + this.attr_name() + '] li ' + this.settings.open_selectors,
          function (e, current, target) {
            var current = current || S(this),
                target = target || current,
                next = current.next('li'),
                settings = current.closest('[' + self.attr_name() + ']').data(self.attr_name(true) + '-init'),
                image = S(e.target);

            e.preventDefault();

            if (!settings) {
              self.init();
              settings = current.closest('[' + self.attr_name() + ']').data(self.attr_name(true) + '-init');
            }

            // if clearing is open and the current image is
            // clicked, go to the next image in sequence
            if (target.hasClass('visible') &&
              current[0] === target[0] &&
              next.length > 0 && self.is_open(current)) {
              target = next;
              image = S('img', target);
            }

            // set current and target to the clicked li if not otherwise defined.
            self.open(image, current, target);
            self.update_paddles(target);
          })

        .on('click.fndtn.clearing', '.clearing-main-next',
          function (e) { self.nav(e, 'next') })
        .on('click.fndtn.clearing', '.clearing-main-prev',
          function (e) { self.nav(e, 'prev') })
        .on('click.fndtn.clearing', this.settings.close_selectors,
          function (e) { Foundation.libs.clearing.close(e, this) });

      $(document).on('keydown.fndtn.clearing',
          function (e) { self.keydown(e) });

      S(window).off('.clearing').on('resize.fndtn.clearing',
        function () { self.resize() });

      this.swipe_events(scope);
    },

    swipe_events : function (scope) {
      var self = this,
      S = self.S;

      S(this.scope)
        .on('touchstart.fndtn.clearing', '.visible-img', function (e) {
          if (!e.touches) { e = e.originalEvent; }
          var data = {
                start_page_x : e.touches[0].pageX,
                start_page_y : e.touches[0].pageY,
                start_time : (new Date()).getTime(),
                delta_x : 0,
                is_scrolling : undefined
              };

          S(this).data('swipe-transition', data);
          e.stopPropagation();
        })
        .on('touchmove.fndtn.clearing', '.visible-img', function (e) {
          if (!e.touches) {
            e = e.originalEvent;
          }
          // Ignore pinch/zoom events
          if (e.touches.length > 1 || e.scale && e.scale !== 1) {
            return;
          }

          var data = S(this).data('swipe-transition');

          if (typeof data === 'undefined') {
            data = {};
          }

          data.delta_x = e.touches[0].pageX - data.start_page_x;

          if (Foundation.rtl) {
            data.delta_x = -data.delta_x;
          }

          if (typeof data.is_scrolling === 'undefined') {
            data.is_scrolling = !!( data.is_scrolling || Math.abs(data.delta_x) < Math.abs(e.touches[0].pageY - data.start_page_y) );
          }

          if (!data.is_scrolling && !data.active) {
            e.preventDefault();
            var direction = (data.delta_x < 0) ? 'next' : 'prev';
            data.active = true;
            self.nav(e, direction);
          }
        })
        .on('touchend.fndtn.clearing', '.visible-img', function (e) {
          S(this).data('swipe-transition', {});
          e.stopPropagation();
        });
    },

    assemble : function ($li) {
      var $el = $li.parent();

      if ($el.parent().hasClass('carousel')) {
        return;
      }

      $el.after('<div id="foundationClearingHolder"></div>');

      var grid = $el.detach(),
          grid_outerHTML = '';

      if (grid[0] == null) {
        return;
      } else {
        grid_outerHTML = grid[0].outerHTML;
      }

      var holder = this.S('#foundationClearingHolder'),
          settings = $el.data(this.attr_name(true) + '-init'),
          data = {
            grid : '<div class="carousel">' + grid_outerHTML + '</div>',
            viewing : settings.templates.viewing
          },
          wrapper = '<div class="clearing-assembled"><div>' + data.viewing +
            data.grid + '</div></div>',
          touch_label = this.settings.touch_label;

      if (Modernizr.touch) {
        wrapper = $(wrapper).find('.clearing-touch-label').html(touch_label).end();
      }

      holder.after(wrapper).remove();
    },

    open : function ($image, current, target) {
      var self = this,
          body = $(document.body),
          root = target.closest('.clearing-assembled'),
          container = self.S('div', root).first(),
          visible_image = self.S('.visible-img', container),
          image = self.S('img', visible_image).not($image),
          label = self.S('.clearing-touch-label', container),
          error = false,
          loaded = {};

      // Event to disable scrolling on touch devices when Clearing is activated
      $('body').on('touchmove', function (e) {
        e.preventDefault();
      });

      image.error(function () {
        error = true;
      });

      function startLoad() {
        setTimeout(function () {
          this.image_loaded(image, function () {
            if (image.outerWidth() === 1 && !error) {
              startLoad.call(this);
            } else {
              cb.call(this, image);
            }
          }.bind(this));
        }.bind(this), 100);
      }

      function cb (image) {
        var $image = $(image);
        $image.css('visibility', 'visible');
        $image.trigger('imageVisible');
        // toggle the gallery
        body.css('overflow', 'hidden');
        root.addClass('clearing-blackout');
        container.addClass('clearing-container');
        visible_image.show();
        this.fix_height(target)
          .caption(self.S('.clearing-caption', visible_image), self.S('img', target))
          .center_and_label(image, label)
          .shift(current, target, function () {
            target.closest('li').siblings().removeClass('visible');
            target.closest('li').addClass('visible');
          });
        visible_image.trigger('opened.fndtn.clearing')
      }

      if (!this.locked()) {
        visible_image.trigger('open.fndtn.clearing');
        // set the image to the selected thumbnail
        loaded = this.load($image);
        if (loaded.interchange) {
          image
            .attr('data-interchange', loaded.interchange)
            .foundation('interchange', 'reflow');
        } else {
          image
            .attr('src', loaded.src)
            .attr('data-interchange', '');
        }
        image.css('visibility', 'hidden');

        startLoad.call(this);
      }
    },

    close : function (e, el) {
      e.preventDefault();

      var root = (function (target) {
            if (/blackout/.test(target.selector)) {
              return target;
            } else {
              return target.closest('.clearing-blackout');
            }
          }($(el))),
          body = $(document.body), container, visible_image;

      if (el === e.target && root) {
        body.css('overflow', '');
        container = $('div', root).first();
        visible_image = $('.visible-img', container);
        visible_image.trigger('close.fndtn.clearing');
        this.settings.prev_index = 0;
        $('ul[' + this.attr_name() + ']', root)
          .attr('style', '').closest('.clearing-blackout')
          .removeClass('clearing-blackout');
        container.removeClass('clearing-container');
        visible_image.hide();
        visible_image.trigger('closed.fndtn.clearing');
      }

      // Event to re-enable scrolling on touch devices
      $('body').off('touchmove');

      return false;
    },

    is_open : function (current) {
      return current.parent().prop('style').length > 0;
    },

    keydown : function (e) {
      var clearing = $('.clearing-blackout ul[' + this.attr_name() + ']'),
          NEXT_KEY = this.rtl ? 37 : 39,
          PREV_KEY = this.rtl ? 39 : 37,
          ESC_KEY = 27;

      if (e.which === NEXT_KEY) {
        this.go(clearing, 'next');
      }
      if (e.which === PREV_KEY) {
        this.go(clearing, 'prev');
      }
      if (e.which === ESC_KEY) {
        this.S('a.clearing-close').trigger('click.fndtn.clearing');
      }
    },

    nav : function (e, direction) {
      var clearing = $('ul[' + this.attr_name() + ']', '.clearing-blackout');

      e.preventDefault();
      this.go(clearing, direction);
    },

    resize : function () {
      var image = $('img', '.clearing-blackout .visible-img'),
          label = $('.clearing-touch-label', '.clearing-blackout');

      if (image.length) {
        this.center_and_label(image, label);
        image.trigger('resized.fndtn.clearing')
      }
    },

    // visual adjustments
    fix_height : function (target) {
      var lis = target.parent().children(),
          self = this;

      lis.each(function () {
        var li = self.S(this),
            image = li.find('img');

        if (li.height() > image.outerHeight()) {
          li.addClass('fix-height');
        }
      })
      .closest('ul')
      .width(lis.length * 100 + '%');

      return this;
    },

    update_paddles : function (target) {
      target = target.closest('li');
      var visible_image = target
        .closest('.carousel')
        .siblings('.visible-img');

      if (target.next().length > 0) {
        this.S('.clearing-main-next', visible_image).removeClass('disabled');
      } else {
        this.S('.clearing-main-next', visible_image).addClass('disabled');
      }

      if (target.prev().length > 0) {
        this.S('.clearing-main-prev', visible_image).removeClass('disabled');
      } else {
        this.S('.clearing-main-prev', visible_image).addClass('disabled');
      }
    },

    center_and_label : function (target, label) {
      if (!this.rtl && label.length > 0) {
        label.css({
          marginLeft : -(label.outerWidth() / 2),
          marginTop : -(target.outerHeight() / 2)-label.outerHeight()-10
        });
      } else {
        label.css({
          marginRight : -(label.outerWidth() / 2),
          marginTop : -(target.outerHeight() / 2)-label.outerHeight()-10,
          left: 'auto',
          right: '50%'
        });
      }
      return this;
    },

    // image loading and preloading

    load : function ($image) {
      var href,
          interchange,
          closest_a;

      if ($image[0].nodeName === 'A') {
        href = $image.attr('href');
        interchange = $image.data('clearing-interchange');
      } else {
        closest_a = $image.closest('a');
        href = closest_a.attr('href');
        interchange = closest_a.data('clearing-interchange');
      }

      this.preload($image);

      return {
        'src': href ? href : $image.attr('src'),
        'interchange': href ? interchange : $image.data('clearing-interchange')
      }
    },

    preload : function ($image) {
      this
        .img($image.closest('li').next(), 'next')
        .img($image.closest('li').prev(), 'prev');
    },

    img : function (img, sibling_type) {
      if (img.length) {
        var preload_img = $('.clearing-preload-' + sibling_type),
            new_a = this.S('a', img),
            src,
            interchange,
            image;

        if (new_a.length) {
          src = new_a.attr('href');
          interchange = new_a.data('clearing-interchange');
        } else {
          image = this.S('img', img);
          src = image.attr('src');
          interchange = image.data('clearing-interchange');
        }

        if (interchange) {
          preload_img.attr('data-interchange', interchange);
        } else {
          preload_img.attr('src', src);
          preload_img.attr('data-interchange', '');
        }
      }
      return this;
    },

    // image caption

    caption : function (container, $image) {
      var caption = $image.attr('data-caption');

      if (caption) {
      	var containerPlain = container.get(0);
      	containerPlain.innerHTML = caption;
        container.show();
      } else {
        container
          .text('')
          .hide();
      }
      return this;
    },

    // directional methods

    go : function ($ul, direction) {
      var current = this.S('.visible', $ul),
          target = current[direction]();

      // Check for skip selector.
      if (this.settings.skip_selector && target.find(this.settings.skip_selector).length != 0) {
        target = target[direction]();
      }

      if (target.length) {
        this.S('img', target)
          .trigger('click.fndtn.clearing', [current, target])
          .trigger('change.fndtn.clearing');
      }
    },

    shift : function (current, target, callback) {
      var clearing = target.parent(),
          old_index = this.settings.prev_index || target.index(),
          direction = this.direction(clearing, current, target),
          dir = this.rtl ? 'right' : 'left',
          left = parseInt(clearing.css('left'), 10),
          width = target.outerWidth(),
          skip_shift;

      var dir_obj = {};

      // we use jQuery animate instead of CSS transitions because we
      // need a callback to unlock the next animation
      // needs support for RTL **
      if (target.index() !== old_index && !/skip/.test(direction)) {
        if (/left/.test(direction)) {
          this.lock();
          dir_obj[dir] = left + width;
          clearing.animate(dir_obj, 300, this.unlock());
        } else if (/right/.test(direction)) {
          this.lock();
          dir_obj[dir] = left - width;
          clearing.animate(dir_obj, 300, this.unlock());
        }
      } else if (/skip/.test(direction)) {
        // the target image is not adjacent to the current image, so
        // do we scroll right or not
        skip_shift = target.index() - this.settings.up_count;
        this.lock();

        if (skip_shift > 0) {
          dir_obj[dir] = -(skip_shift * width);
          clearing.animate(dir_obj, 300, this.unlock());
        } else {
          dir_obj[dir] = 0;
          clearing.animate(dir_obj, 300, this.unlock());
        }
      }

      callback();
    },

    direction : function ($el, current, target) {
      var lis = this.S('li', $el),
          li_width = lis.outerWidth() + (lis.outerWidth() / 4),
          up_count = Math.floor(this.S('.clearing-container').outerWidth() / li_width) - 1,
          target_index = lis.index(target),
          response;

      this.settings.up_count = up_count;

      if (this.adjacent(this.settings.prev_index, target_index)) {
        if ((target_index > up_count) && target_index > this.settings.prev_index) {
          response = 'right';
        } else if ((target_index > up_count - 1) && target_index <= this.settings.prev_index) {
          response = 'left';
        } else {
          response = false;
        }
      } else {
        response = 'skip';
      }

      this.settings.prev_index = target_index;

      return response;
    },

    adjacent : function (current_index, target_index) {
      for (var i = target_index + 1; i >= target_index - 1; i--) {
        if (i === current_index) {
          return true;
        }
      }
      return false;
    },

    // lock management

    lock : function () {
      this.settings.locked = true;
    },

    unlock : function () {
      this.settings.locked = false;
    },

    locked : function () {
      return this.settings.locked;
    },

    off : function () {
      this.S(this.scope).off('.fndtn.clearing');
      this.S(window).off('.fndtn.clearing');
    },

    reflow : function () {
      this.init();
    }
  };

}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.dropdown = {
    name : 'dropdown',

    version : '5.5.3',

    settings : {
      active_class : 'open',
      disabled_class : 'disabled',
      mega_class : 'mega',
      align : 'bottom',
      is_hover : false,
      hover_timeout : 150,
      opened : function () {},
      closed : function () {}
    },

    init : function (scope, method, options) {
      Foundation.inherit(this, 'throttle');

      $.extend(true, this.settings, method, options);
      this.bindings(method, options);
    },

    events : function (scope) {
      var self = this,
          S = self.S;

      S(this.scope)
        .off('.dropdown')
        .on('click.fndtn.dropdown', '[' + this.attr_name() + ']', function (e) {
          var settings = S(this).data(self.attr_name(true) + '-init') || self.settings;
          if (!settings.is_hover || Modernizr.touch) {
            e.preventDefault();
            if (S(this).parent('[data-reveal-id]').length) {
              e.stopPropagation();
            }
            self.toggle($(this));
          }
        })
        .on('mouseenter.fndtn.dropdown', '[' + this.attr_name() + '], [' + this.attr_name() + '-content]', function (e) {
          var $this = S(this),
              dropdown,
              target;

          clearTimeout(self.timeout);

          if ($this.data(self.data_attr())) {
            dropdown = S('#' + $this.data(self.data_attr()));
            target = $this;
          } else {
            dropdown = $this;
            target = S('[' + self.attr_name() + '="' + dropdown.attr('id') + '"]');
          }

          var settings = target.data(self.attr_name(true) + '-init') || self.settings;

          if (S(e.currentTarget).data(self.data_attr()) && settings.is_hover) {
            self.closeall.call(self);
          }

          if (settings.is_hover) {
            self.open.apply(self, [dropdown, target]);
          }
        })
        .on('mouseleave.fndtn.dropdown', '[' + this.attr_name() + '], [' + this.attr_name() + '-content]', function (e) {
          var $this = S(this);
          var settings;

          if ($this.data(self.data_attr())) {
              settings = $this.data(self.data_attr(true) + '-init') || self.settings;
          } else {
              var target   = S('[' + self.attr_name() + '="' + S(this).attr('id') + '"]'),
                  settings = target.data(self.attr_name(true) + '-init') || self.settings;
          }

          self.timeout = setTimeout(function () {
            if ($this.data(self.data_attr())) {
              if (settings.is_hover) {
                self.close.call(self, S('#' + $this.data(self.data_attr())));
              }
            } else {
              if (settings.is_hover) {
                self.close.call(self, $this);
              }
            }
          }.bind(this), settings.hover_timeout);
        })
        .on('click.fndtn.dropdown', function (e) {
          var parent = S(e.target).closest('[' + self.attr_name() + '-content]');
          var links  = parent.find('a');

          if (links.length > 0 && parent.attr('aria-autoclose') !== 'false') {
              self.close.call(self, S('[' + self.attr_name() + '-content]'));
          }

          if (e.target !== document && !$.contains(document.documentElement, e.target)) {
            return;
          }

          if (S(e.target).closest('[' + self.attr_name() + ']').length > 0) {
            return;
          }

          if (!(S(e.target).data('revealId')) &&
            (parent.length > 0 && (S(e.target).is('[' + self.attr_name() + '-content]') ||
              $.contains(parent.first()[0], e.target)))) {
            e.stopPropagation();
            return;
          }

          self.close.call(self, S('[' + self.attr_name() + '-content]'));
        })
        .on('opened.fndtn.dropdown', '[' + self.attr_name() + '-content]', function () {
          self.settings.opened.call(this);
        })
        .on('closed.fndtn.dropdown', '[' + self.attr_name() + '-content]', function () {
          self.settings.closed.call(this);
        });

      S(window)
        .off('.dropdown')
        .on('resize.fndtn.dropdown', self.throttle(function () {
          self.resize.call(self);
        }, 50));

      this.resize();
    },

    close : function (dropdown) {
      var self = this;
      dropdown.each(function (idx) {
        var original_target = $('[' + self.attr_name() + '=' + dropdown[idx].id + ']') || $('aria-controls=' + dropdown[idx].id + ']');
        original_target.attr('aria-expanded', 'false');
        if (self.S(this).hasClass(self.settings.active_class)) {
          self.S(this)
            .css(Foundation.rtl ? 'right' : 'left', '-99999px')
            .attr('aria-hidden', 'true')
            .removeClass(self.settings.active_class)
            .prev('[' + self.attr_name() + ']')
            .removeClass(self.settings.active_class)
            .removeData('target');

          self.S(this).trigger('closed.fndtn.dropdown', [dropdown]);
        }
      });
      dropdown.removeClass('f-open-' + this.attr_name(true));
    },

    closeall : function () {
      var self = this;
      $.each(self.S('.f-open-' + this.attr_name(true)), function () {
        self.close.call(self, self.S(this));
      });
    },

    open : function (dropdown, target) {
      this
        .css(dropdown
        .addClass(this.settings.active_class), target);
      dropdown.prev('[' + this.attr_name() + ']').addClass(this.settings.active_class);
      dropdown.data('target', target.get(0)).trigger('opened.fndtn.dropdown', [dropdown, target]);
      dropdown.attr('aria-hidden', 'false');
      target.attr('aria-expanded', 'true');
      dropdown.focus();
      dropdown.addClass('f-open-' + this.attr_name(true));
    },

    data_attr : function () {
      if (this.namespace.length > 0) {
        return this.namespace + '-' + this.name;
      }

      return this.name;
    },

    toggle : function (target) {
      if (target.hasClass(this.settings.disabled_class)) {
        return;
      }
      var dropdown = this.S('#' + target.data(this.data_attr()));
      if (dropdown.length === 0) {
        // No dropdown found, not continuing
        return;
      }

      this.close.call(this, this.S('[' + this.attr_name() + '-content]').not(dropdown));

      if (dropdown.hasClass(this.settings.active_class)) {
        this.close.call(this, dropdown);
        if (dropdown.data('target') !== target.get(0)) {
          this.open.call(this, dropdown, target);
        }
      } else {
        this.open.call(this, dropdown, target);
      }
    },

    resize : function () {
      var dropdown = this.S('[' + this.attr_name() + '-content].open');
      var target = $(dropdown.data("target"));

      if (dropdown.length && target.length) {
        this.css(dropdown, target);
      }
    },

    css : function (dropdown, target) {
      var left_offset = Math.max((target.width() - dropdown.width()) / 2, 8),
          settings = target.data(this.attr_name(true) + '-init') || this.settings,
          parentOverflow = dropdown.parent().css('overflow-y') || dropdown.parent().css('overflow');

      this.clear_idx();



      if (this.small()) {
        var p = this.dirs.bottom.call(dropdown, target, settings);

        dropdown.attr('style', '').removeClass('drop-left drop-right drop-top').css({
          position : 'absolute',
          width : '95%',
          'max-width' : 'none',
          top : p.top
        });

        dropdown.css(Foundation.rtl ? 'right' : 'left', left_offset);
      }
      // detect if dropdown is in an overflow container
      else if (parentOverflow !== 'visible') {
        var offset = target[0].offsetTop + target[0].offsetHeight;

        dropdown.attr('style', '').css({
          position : 'absolute',
          top : offset
        });

        dropdown.css(Foundation.rtl ? 'right' : 'left', left_offset);
      }
      else {

        this.style(dropdown, target, settings);
      }

      return dropdown;
    },

    style : function (dropdown, target, settings) {
      var css = $.extend({position : 'absolute'},
        this.dirs[settings.align].call(dropdown, target, settings));

      dropdown.attr('style', '').css(css);
    },

    // return CSS property object
    // `this` is the dropdown
    dirs : {
      // Calculate target offset
      _base : function (t, s) {
        var o_p = this.offsetParent(),
            o = o_p.offset(),
            p = t.offset();

        p.top -= o.top;
        p.left -= o.left;

        //set some flags on the p object to pass along
        p.missRight = false;
        p.missTop = false;
        p.missLeft = false;
        p.leftRightFlag = false;

        //lets see if the panel will be off the screen
        //get the actual width of the page and store it
        var actualBodyWidth;
        var windowWidth = window.innerWidth;
        
        if (document.getElementsByClassName('row')[0]) {
          actualBodyWidth = document.getElementsByClassName('row')[0].clientWidth;
        } else {
          actualBodyWidth = windowWidth;
        }

        var actualMarginWidth = (windowWidth - actualBodyWidth) / 2;
        var actualBoundary = actualBodyWidth;

        if (!this.hasClass('mega') && !s.ignore_repositioning) {
          var outerWidth = this.outerWidth();
          var o_left = t.offset().left;
		  
          //miss top
          if (t.offset().top <= this.outerHeight()) {
            p.missTop = true;
            actualBoundary = windowWidth - actualMarginWidth;
            p.leftRightFlag = true;
          }

          //miss right
          if (o_left + outerWidth > o_left + actualMarginWidth && o_left - actualMarginWidth > outerWidth) {
            p.missRight = true;
            p.missLeft = false;
          }

          //miss left
          if (o_left - outerWidth <= 0) {
            p.missLeft = true;
            p.missRight = false;
          }
        }

        return p;
      },

      top : function (t, s) {
        var self = Foundation.libs.dropdown,
            p = self.dirs._base.call(this, t, s);

        this.addClass('drop-top');

        if (p.missTop == true) {
          p.top = p.top + t.outerHeight() + this.outerHeight();
          this.removeClass('drop-top');
        }

        if (p.missRight == true) {
          p.left = p.left - this.outerWidth() + t.outerWidth();
        }

        if (t.outerWidth() < this.outerWidth() || self.small() || this.hasClass(s.mega_menu)) {
          self.adjust_pip(this, t, s, p);
        }

        if (Foundation.rtl) {
          return {left : p.left - this.outerWidth() + t.outerWidth(),
            top : p.top - this.outerHeight()};
        }

        return {left : p.left, top : p.top - this.outerHeight()};
      },

      bottom : function (t, s) {
        var self = Foundation.libs.dropdown,
            p = self.dirs._base.call(this, t, s);

        if (p.missRight == true) {
          p.left = p.left - this.outerWidth() + t.outerWidth();
        }

        if (t.outerWidth() < this.outerWidth() || self.small() || this.hasClass(s.mega_menu)) {
          self.adjust_pip(this, t, s, p);
        }

        if (self.rtl) {
          return {left : p.left - this.outerWidth() + t.outerWidth(), top : p.top + t.outerHeight()};
        }

        return {left : p.left, top : p.top + t.outerHeight()};
      },

      left : function (t, s) {
        var p = Foundation.libs.dropdown.dirs._base.call(this, t, s);

        this.addClass('drop-left');

        if (p.missLeft == true) {
          p.left =  p.left + this.outerWidth();
          p.top = p.top + t.outerHeight();
          this.removeClass('drop-left');
        }

        return {left : p.left - this.outerWidth(), top : p.top};
      },

      right : function (t, s) {
        var p = Foundation.libs.dropdown.dirs._base.call(this, t, s);

        this.addClass('drop-right');

        if (p.missRight == true) {
          p.left = p.left - this.outerWidth();
          p.top = p.top + t.outerHeight();
          this.removeClass('drop-right');
        } else {
          p.triggeredRight = true;
        }

        var self = Foundation.libs.dropdown;

        if (t.outerWidth() < this.outerWidth() || self.small() || this.hasClass(s.mega_menu)) {
          self.adjust_pip(this, t, s, p);
        }

        return {left : p.left + t.outerWidth(), top : p.top};
      }
    },

    // Insert rule to style psuedo elements
    adjust_pip : function (dropdown, target, settings, position) {
      var sheet = Foundation.stylesheet,
          pip_offset_base = 8;

      if (dropdown.hasClass(settings.mega_class)) {
        pip_offset_base = position.left + (target.outerWidth() / 2) - 8;
      } else if (this.small()) {
        pip_offset_base += position.left - 8;
      }

      this.rule_idx = sheet.cssRules.length;

      //default
      var sel_before = '.f-dropdown.open:before',
          sel_after  = '.f-dropdown.open:after',
          css_before = 'left: ' + pip_offset_base + 'px;',
          css_after  = 'left: ' + (pip_offset_base - 1) + 'px;';

      if (position.missRight == true) {
        pip_offset_base = dropdown.outerWidth() - 23;
        sel_before = '.f-dropdown.open:before',
        sel_after  = '.f-dropdown.open:after',
        css_before = 'left: ' + pip_offset_base + 'px;',
        css_after  = 'left: ' + (pip_offset_base - 1) + 'px;';
      }

      //just a case where right is fired, but its not missing right
      if (position.triggeredRight == true) {
        sel_before = '.f-dropdown.open:before',
        sel_after  = '.f-dropdown.open:after',
        css_before = 'left:-12px;',
        css_after  = 'left:-14px;';
      }

      if (sheet.insertRule) {
        sheet.insertRule([sel_before, '{', css_before, '}'].join(' '), this.rule_idx);
        sheet.insertRule([sel_after, '{', css_after, '}'].join(' '), this.rule_idx + 1);
      } else {
        sheet.addRule(sel_before, css_before, this.rule_idx);
        sheet.addRule(sel_after, css_after, this.rule_idx + 1);
      }
    },

    // Remove old dropdown rule index
    clear_idx : function () {
      var sheet = Foundation.stylesheet;

      if (typeof this.rule_idx !== 'undefined') {
        sheet.deleteRule(this.rule_idx);
        sheet.deleteRule(this.rule_idx);
        delete this.rule_idx;
      }
    },

    small : function () {
      return matchMedia(Foundation.media_queries.small).matches &&
        !matchMedia(Foundation.media_queries.medium).matches;
    },

    off : function () {
      this.S(this.scope).off('.fndtn.dropdown');
      this.S('html, body').off('.fndtn.dropdown');
      this.S(window).off('.fndtn.dropdown');
      this.S('[data-dropdown-content]').off('.fndtn.dropdown');
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.equalizer = {
    name : 'equalizer',

    version : '5.5.3',

    settings : {
      use_tallest : true,
      before_height_change : $.noop,
      after_height_change : $.noop,
      equalize_on_stack : false,
      act_on_hidden_el: false
    },

    init : function (scope, method, options) {
      Foundation.inherit(this, 'image_loaded');
      this.bindings(method, options);
      this.reflow();
    },

    events : function () {
      this.S(window).off('.equalizer').on('resize.fndtn.equalizer', function (e) {
        this.reflow();
      }.bind(this));
    },

    equalize : function (equalizer) {
      var isStacked = false,
          group = equalizer.data('equalizer'),
          settings = equalizer.data(this.attr_name(true)+'-init') || this.settings,
          vals,
          firstTopOffset;

      if (settings.act_on_hidden_el) {
        vals = group ? equalizer.find('['+this.attr_name()+'-watch="'+group+'"]') : equalizer.find('['+this.attr_name()+'-watch]');
      }
      else {
        vals = group ? equalizer.find('['+this.attr_name()+'-watch="'+group+'"]:visible') : equalizer.find('['+this.attr_name()+'-watch]:visible');
      }
      
      if (vals.length === 0) {
        return;
      }

      settings.before_height_change();
      equalizer.trigger('before-height-change.fndth.equalizer');
      vals.height('inherit');

      if (settings.equalize_on_stack === false) {
        firstTopOffset = vals.first().offset().top;
        vals.each(function () {
          if ($(this).offset().top !== firstTopOffset) {
            isStacked = true;
            return false;
          }
        });
        if (isStacked) {
          return;
        }
      }

      var heights = vals.map(function () { return $(this).outerHeight(false) }).get();

      if (settings.use_tallest) {
        var max = Math.max.apply(null, heights);
        vals.css('height', max);
      } else {
        var min = Math.min.apply(null, heights);
        vals.css('height', min);
      }

      settings.after_height_change();
      equalizer.trigger('after-height-change.fndtn.equalizer');
    },

    reflow : function () {
      var self = this;

      this.S('[' + this.attr_name() + ']', this.scope).each(function () {
        var $eq_target = $(this),
            media_query = $eq_target.data('equalizer-mq'),
            ignore_media_query = true;

        if (media_query) {
          media_query = 'is_' + media_query.replace(/-/g, '_');
          if (Foundation.utils.hasOwnProperty(media_query)) {
            ignore_media_query = false;
          }
        }

        self.image_loaded(self.S('img', this), function () {
          if (ignore_media_query || Foundation.utils[media_query]()) {
            self.equalize($eq_target)
          } else {
            var vals = $eq_target.find('[' + self.attr_name() + '-watch]:visible');
            vals.css('height', 'auto');
          }
        });
      });
    }
  };
})(jQuery, window, window.document);

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.interchange = {
    name : 'interchange',

    version : '5.5.3',

    cache : {},

    images_loaded : false,
    nodes_loaded : false,

    settings : {
      load_attr : 'interchange',

      named_queries : {
        'default'     : 'only screen',
        'small'       : Foundation.media_queries['small'],
        'small-only'  : Foundation.media_queries['small-only'],
        'medium'      : Foundation.media_queries['medium'],
        'medium-only' : Foundation.media_queries['medium-only'],
        'large'       : Foundation.media_queries['large'],
        'large-only'  : Foundation.media_queries['large-only'],
        'xlarge'      : Foundation.media_queries['xlarge'],
        'xlarge-only' : Foundation.media_queries['xlarge-only'],
        'xxlarge'     : Foundation.media_queries['xxlarge'],
        'landscape'   : 'only screen and (orientation: landscape)',
        'portrait'    : 'only screen and (orientation: portrait)',
        'retina'      : 'only screen and (-webkit-min-device-pixel-ratio: 2),' +
          'only screen and (min--moz-device-pixel-ratio: 2),' +
          'only screen and (-o-min-device-pixel-ratio: 2/1),' +
          'only screen and (min-device-pixel-ratio: 2),' +
          'only screen and (min-resolution: 192dpi),' +
          'only screen and (min-resolution: 2dppx)'
      },

      directives : {
        replace : function (el, path, trigger) {
          // The trigger argument, if called within the directive, fires
          // an event named after the directive on the element, passing
          // any parameters along to the event that you pass to trigger.
          //
          // ex. trigger(), trigger([a, b, c]), or trigger(a, b, c)
          //
          // This allows you to bind a callback like so:
          // $('#interchangeContainer').on('replace', function (e, a, b, c) {
          //   console.log($(this).html(), a, b, c);
          // });

          if (el !== null && /IMG/.test(el[0].nodeName)) {
            var orig_path = $.each(el, function(){this.src = path;});
            // var orig_path = el[0].src;

            if (new RegExp(path, 'i').test(orig_path)) {
              return;
            }

            el.attr("src", path);

            return trigger(el[0].src);
          }
          var last_path = el.data(this.data_attr + '-last-path'),
              self = this;

          if (last_path == path) {
            return;
          }

          if (/\.(gif|jpg|jpeg|tiff|png)([?#].*)?/i.test(path)) {
            $(el).css('background-image', 'url(' + path + ')');
            el.data('interchange-last-path', path);
            return trigger(path);
          }

          return $.get(path, function (response) {
            el.html(response);
            el.data(self.data_attr + '-last-path', path);
            trigger();
          });

        }
      }
    },

    init : function (scope, method, options) {
      Foundation.inherit(this, 'throttle random_str');

      this.data_attr = this.set_data_attr();
      $.extend(true, this.settings, method, options);
      this.bindings(method, options);
      this.reflow();
    },

    get_media_hash : function () {
        var mediaHash = '';
        for (var queryName in this.settings.named_queries ) {
            mediaHash += matchMedia(this.settings.named_queries[queryName]).matches.toString();
        }
        return mediaHash;
    },

    events : function () {
      var self = this, prevMediaHash;

      $(window)
        .off('.interchange')
        .on('resize.fndtn.interchange', self.throttle(function () {
            var currMediaHash = self.get_media_hash();
            if (currMediaHash !== prevMediaHash) {
                self.resize();
            }
            prevMediaHash = currMediaHash;
        }, 50));

      return this;
    },

    resize : function () {
      var cache = this.cache;

      if (!this.images_loaded || !this.nodes_loaded) {
        setTimeout($.proxy(this.resize, this), 50);
        return;
      }

      for (var uuid in cache) {
        if (cache.hasOwnProperty(uuid)) {
          var passed = this.results(uuid, cache[uuid]);
          if (passed) {
            this.settings.directives[passed
              .scenario[1]].call(this, passed.el, passed.scenario[0], (function (passed) {
                if (arguments[0] instanceof Array) {
                  var args = arguments[0];
                } else {
                  var args = Array.prototype.slice.call(arguments, 0);
                }

                return function() {
                  passed.el.trigger(passed.scenario[1], args);
                }
              }(passed)));
          }
        }
      }

    },

    results : function (uuid, scenarios) {
      var count = scenarios.length;

      if (count > 0) {
        var el = this.S('[' + this.add_namespace('data-uuid') + '="' + uuid + '"]');

        while (count--) {
          var mq, rule = scenarios[count][2];
          if (this.settings.named_queries.hasOwnProperty(rule)) {
            mq = matchMedia(this.settings.named_queries[rule]);
          } else {
            mq = matchMedia(rule);
          }
          if (mq.matches) {
            return {el : el, scenario : scenarios[count]};
          }
        }
      }

      return false;
    },

    load : function (type, force_update) {
      if (typeof this['cached_' + type] === 'undefined' || force_update) {
        this['update_' + type]();
      }

      return this['cached_' + type];
    },

    update_images : function () {
      var images = this.S('img[' + this.data_attr + ']'),
          count = images.length,
          i = count,
          loaded_count = 0,
          data_attr = this.data_attr;

      this.cache = {};
      this.cached_images = [];
      this.images_loaded = (count === 0);

      while (i--) {
        loaded_count++;
        if (images[i]) {
          var str = images[i].getAttribute(data_attr) || '';

          if (str.length > 0) {
            this.cached_images.push(images[i]);
          }
        }

        if (loaded_count === count) {
          this.images_loaded = true;
          this.enhance('images');
        }
      }

      return this;
    },

    update_nodes : function () {
      var nodes = this.S('[' + this.data_attr + ']').not('img'),
          count = nodes.length,
          i = count,
          loaded_count = 0,
          data_attr = this.data_attr;

      this.cached_nodes = [];
      this.nodes_loaded = (count === 0);

      while (i--) {
        loaded_count++;
        var str = nodes[i].getAttribute(data_attr) || '';

        if (str.length > 0) {
          this.cached_nodes.push(nodes[i]);
        }

        if (loaded_count === count) {
          this.nodes_loaded = true;
          this.enhance('nodes');
        }
      }

      return this;
    },

    enhance : function (type) {
      var i = this['cached_' + type].length;

      while (i--) {
        this.object($(this['cached_' + type][i]));
      }

      return $(window).trigger('resize.fndtn.interchange');
    },

    convert_directive : function (directive) {

      var trimmed = this.trim(directive);

      if (trimmed.length > 0) {
        return trimmed;
      }

      return 'replace';
    },

    parse_scenario : function (scenario) {
      // This logic had to be made more complex since some users were using commas in the url path
      // So we cannot simply just split on a comma

      var directive_match = scenario[0].match(/(.+),\s*(\w+)\s*$/),
      // getting the mq has gotten a bit complicated since we started accounting for several use cases
      // of URLs. For now we'll continue to match these scenarios, but we may consider having these scenarios
      // as nested objects or arrays in F6.
      // regex: match everything before close parenthesis for mq
      media_query         = scenario[1].match(/(.*)\)/);

      if (directive_match) {
        var path  = directive_match[1],
        directive = directive_match[2];

      } else {
        var cached_split = scenario[0].split(/,\s*$/),
        path             = cached_split[0],
        directive        = '';
      }

      return [this.trim(path), this.convert_directive(directive), this.trim(media_query[1])];
    },

    object : function (el) {
      var raw_arr = this.parse_data_attr(el),
          scenarios = [],
          i = raw_arr.length;

      if (i > 0) {
        while (i--) {
          // split array between comma delimited content and mq
          // regex: comma, optional space, open parenthesis
          var scenario = raw_arr[i].split(/,\s?\(/);

          if (scenario.length > 1) {
            var params = this.parse_scenario(scenario);
            scenarios.push(params);
          }
        }
      }

      return this.store(el, scenarios);
    },

    store : function (el, scenarios) {
      var uuid = this.random_str(),
          current_uuid = el.data(this.add_namespace('uuid', true));

      if (this.cache[current_uuid]) {
        return this.cache[current_uuid];
      }

      el.attr(this.add_namespace('data-uuid'), uuid);
      return this.cache[uuid] = scenarios;
    },

    trim : function (str) {

      if (typeof str === 'string') {
        return $.trim(str);
      }

      return str;
    },

    set_data_attr : function (init) {
      if (init) {
        if (this.namespace.length > 0) {
          return this.namespace + '-' + this.settings.load_attr;
        }

        return this.settings.load_attr;
      }

      if (this.namespace.length > 0) {
        return 'data-' + this.namespace + '-' + this.settings.load_attr;
      }

      return 'data-' + this.settings.load_attr;
    },

    parse_data_attr : function (el) {
      var raw = el.attr(this.attr_name()).split(/\[(.*?)\]/),
          i = raw.length,
          output = [];

      while (i--) {
        if (raw[i].replace(/[\W\d]+/, '').length > 4) {
          output.push(raw[i]);
        }
      }

      return output;
    },

    reflow : function () {
      this.load('images', true);
      this.load('nodes', true);
    }

  };

}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  var Modernizr = Modernizr || false;

  Foundation.libs.joyride = {
    name : 'joyride',

    version : '5.5.3',

    defaults : {
      expose                   : false,     // turn on or off the expose feature
      modal                    : true,      // Whether to cover page with modal during the tour
      keyboard                 : true,      // enable left, right and esc keystrokes
      tip_location             : 'bottom',  // 'top', 'bottom', 'left' or 'right' in relation to parent
      nub_position             : 'auto',    // override on a per tooltip bases
      scroll_speed             : 1500,      // Page scrolling speed in milliseconds, 0 = no scroll animation
      scroll_animation         : 'linear',  // supports 'swing' and 'linear', extend with jQuery UI.
      timer                    : 0,         // 0 = no timer , all other numbers = timer in milliseconds
      start_timer_on_click     : true,      // true or false - true requires clicking the first button start the timer
      start_offset             : 0,         // the index of the tooltip you want to start on (index of the li)
      next_button              : true,      // true or false to control whether a next button is used
      prev_button              : true,      // true or false to control whether a prev button is used
      tip_animation            : 'fade',    // 'pop' or 'fade' in each tip
      pause_after              : [],        // array of indexes where to pause the tour after
      exposed                  : [],        // array of expose elements
      tip_animation_fade_speed : 300,       // when tipAnimation = 'fade' this is speed in milliseconds for the transition
      cookie_monster           : false,     // true or false to control whether cookies are used
      cookie_name              : 'joyride', // Name the cookie you'll use
      cookie_domain            : false,     // Will this cookie be attached to a domain, ie. '.notableapp.com'
      cookie_expires           : 365,       // set when you would like the cookie to expire.
      tip_container            : 'body',    // Where will the tip be attached
      abort_on_close           : true,      // When true, the close event will not fire any callback
      tip_location_patterns    : {
        top : ['bottom'],
        bottom : [], // bottom should not need to be repositioned
        left : ['right', 'top', 'bottom'],
        right : ['left', 'top', 'bottom']
      },
      post_ride_callback     : function () {},    // A method to call once the tour closes (canceled or complete)
      post_step_callback     : function () {},    // A method to call after each step
      pre_step_callback      : function () {},    // A method to call before each step
      pre_ride_callback      : function () {},    // A method to call before the tour starts (passed index, tip, and cloned exposed element)
      post_expose_callback   : function () {},    // A method to call after an element has been exposed
      template : { // HTML segments for tip layout
        link          : '<a href="#close" class="joyride-close-tip">&times;</a>',
        timer         : '<div class="joyride-timer-indicator-wrap"><span class="joyride-timer-indicator"></span></div>',
        tip           : '<div class="joyride-tip-guide"><span class="joyride-nub"></span></div>',
        wrapper       : '<div class="joyride-content-wrapper"></div>',
        button        : '<a href="#" class="small button joyride-next-tip"></a>',
        prev_button   : '<a href="#" class="small button joyride-prev-tip"></a>',
        modal         : '<div class="joyride-modal-bg"></div>',
        expose        : '<div class="joyride-expose-wrapper"></div>',
        expose_cover  : '<div class="joyride-expose-cover"></div>'
      },
      expose_add_class : '' // One or more space-separated class names to be added to exposed element
    },

    init : function (scope, method, options) {
      Foundation.inherit(this, 'throttle random_str');

      this.settings = this.settings || $.extend({}, this.defaults, (options || method));

      this.bindings(method, options)
    },

    go_next : function () {
      if (this.settings.$li.next().length < 1) {
        this.end();
      } else if (this.settings.timer > 0) {
        clearTimeout(this.settings.automate);
        this.hide();
        this.show();
        this.startTimer();
      } else {
        this.hide();
        this.show();
      }
    },

    go_prev : function () {
      if (this.settings.$li.prev().length < 1) {
        // Do nothing if there are no prev element
      } else if (this.settings.timer > 0) {
        clearTimeout(this.settings.automate);
        this.hide();
        this.show(null, true);
        this.startTimer();
      } else {
        this.hide();
        this.show(null, true);
      }
    },

    events : function () {
      var self = this;

      $(this.scope)
        .off('.joyride')
        .on('click.fndtn.joyride', '.joyride-next-tip, .joyride-modal-bg', function (e) {
          e.preventDefault();
          this.go_next()
        }.bind(this))
        .on('click.fndtn.joyride', '.joyride-prev-tip', function (e) {
          e.preventDefault();
          this.go_prev();
        }.bind(this))

        .on('click.fndtn.joyride', '.joyride-close-tip', function (e) {
          e.preventDefault();
          this.end(this.settings.abort_on_close);
        }.bind(this))

        .on('keyup.fndtn.joyride', function (e) {
          // Don't do anything if keystrokes are disabled
          // or if the joyride is not being shown
          if (!this.settings.keyboard || !this.settings.riding) {
            return;
          }

          switch (e.which) {
            case 39: // right arrow
              e.preventDefault();
              this.go_next();
              break;
            case 37: // left arrow
              e.preventDefault();
              this.go_prev();
              break;
            case 27: // escape
              e.preventDefault();
              this.end(this.settings.abort_on_close);
          }
        }.bind(this));

      $(window)
        .off('.joyride')
        .on('resize.fndtn.joyride', self.throttle(function () {
          if ($('[' + self.attr_name() + ']').length > 0 && self.settings.$next_tip && self.settings.riding) {
            if (self.settings.exposed.length > 0) {
              var $els = $(self.settings.exposed);

              $els.each(function () {
                var $this = $(this);
                self.un_expose($this);
                self.expose($this);
              });
            }

            if (self.is_phone()) {
              self.pos_phone();
            } else {
              self.pos_default(false);
            }
          }
        }, 100));
    },

    start : function () {
      var self = this,
          $this = $('[' + this.attr_name() + ']', this.scope),
          integer_settings = ['timer', 'scrollSpeed', 'startOffset', 'tipAnimationFadeSpeed', 'cookieExpires'],
          int_settings_count = integer_settings.length;

      if (!$this.length > 0) {
        return;
      }

      if (!this.settings.init) {
        this.events();
      }

      this.settings = $this.data(this.attr_name(true) + '-init');

      // non configureable settings
      this.settings.$content_el = $this;
      this.settings.$body = $(this.settings.tip_container);
      this.settings.body_offset = $(this.settings.tip_container).position();
      this.settings.$tip_content = this.settings.$content_el.find('> li');
      this.settings.paused = false;
      this.settings.attempts = 0;
      this.settings.riding = true;

      // can we create cookies?
      if (typeof $.cookie !== 'function') {
        this.settings.cookie_monster = false;
      }

      // generate the tips and insert into dom.
      if (!this.settings.cookie_monster || this.settings.cookie_monster && !$.cookie(this.settings.cookie_name)) {
        this.settings.$tip_content.each(function (index) {
          var $this = $(this);
          this.settings = $.extend({}, self.defaults, self.data_options($this));

          // Make sure that settings parsed from data_options are integers where necessary
          var i = int_settings_count;
          while (i--) {
            self.settings[integer_settings[i]] = parseInt(self.settings[integer_settings[i]], 10);
          }
          self.create({$li : $this, index : index});
        });

        // show first tip
        if (!this.settings.start_timer_on_click && this.settings.timer > 0) {
          this.show('init');
          this.startTimer();
        } else {
          this.show('init');
        }

      }
    },

    resume : function () {
      this.set_li();
      this.show();
    },

    tip_template : function (opts) {
      var $blank, content;

      opts.tip_class = opts.tip_class || '';

      $blank = $(this.settings.template.tip).addClass(opts.tip_class);
      content = $.trim($(opts.li).html()) +
        this.prev_button_text(opts.prev_button_text, opts.index) +
        this.button_text(opts.button_text) +
        this.settings.template.link +
        this.timer_instance(opts.index);

      $blank.append($(this.settings.template.wrapper));
      $blank.first().attr(this.add_namespace('data-index'), opts.index);
      $('.joyride-content-wrapper', $blank).append(content);

      return $blank[0];
    },

    timer_instance : function (index) {
      var txt;

      if ((index === 0 && this.settings.start_timer_on_click && this.settings.timer > 0) || this.settings.timer === 0) {
        txt = '';
      } else {
        txt = $(this.settings.template.timer)[0].outerHTML;
      }
      return txt;
    },

    button_text : function (txt) {
      if (this.settings.tip_settings.next_button) {
        txt = $.trim(txt) || 'Next';
        txt = $(this.settings.template.button).append(txt)[0].outerHTML;
      } else {
        txt = '';
      }
      return txt;
    },

    prev_button_text : function (txt, idx) {
      if (this.settings.tip_settings.prev_button) {
        txt = $.trim(txt) || 'Previous';

        // Add the disabled class to the button if it's the first element
        if (idx == 0) {
          txt = $(this.settings.template.prev_button).append(txt).addClass('disabled')[0].outerHTML;
        } else {
          txt = $(this.settings.template.prev_button).append(txt)[0].outerHTML;
        }
      } else {
        txt = '';
      }
      return txt;
    },

    create : function (opts) {
      this.settings.tip_settings = $.extend({}, this.settings, this.data_options(opts.$li));
      var buttonText = opts.$li.attr(this.add_namespace('data-button')) || opts.$li.attr(this.add_namespace('data-text')),
          prevButtonText = opts.$li.attr(this.add_namespace('data-button-prev')) || opts.$li.attr(this.add_namespace('data-prev-text')),
        tipClass = opts.$li.attr('class'),
        $tip_content = $(this.tip_template({
          tip_class : tipClass,
          index : opts.index,
          button_text : buttonText,
          prev_button_text : prevButtonText,
          li : opts.$li
        }));

      $(this.settings.tip_container).append($tip_content);
    },

    show : function (init, is_prev) {
      var $timer = null;

      // are we paused?
      if (this.settings.$li === undefined || ($.inArray(this.settings.$li.index(), this.settings.pause_after) === -1)) {

        // don't go to the next li if the tour was paused
        if (this.settings.paused) {
          this.settings.paused = false;
        } else {
          this.set_li(init, is_prev);
        }

        this.settings.attempts = 0;

        if (this.settings.$li.length && this.settings.$target.length > 0) {
          if (init) { //run when we first start
            this.settings.pre_ride_callback(this.settings.$li.index(), this.settings.$next_tip);
            if (this.settings.modal) {
              this.show_modal();
            }
          }

          this.settings.pre_step_callback(this.settings.$li.index(), this.settings.$next_tip);

          if (this.settings.modal && this.settings.expose) {
            this.expose();
          }

          this.settings.tip_settings = $.extend({}, this.settings, this.data_options(this.settings.$li));

          this.settings.timer = parseInt(this.settings.timer, 10);

          this.settings.tip_settings.tip_location_pattern = this.settings.tip_location_patterns[this.settings.tip_settings.tip_location];

          // scroll and hide bg if not modal and not expose
          if (!/body/i.test(this.settings.$target.selector) && !this.settings.expose) {
            var joyridemodalbg = $('.joyride-modal-bg');
            if (/pop/i.test(this.settings.tipAnimation)) {
                joyridemodalbg.hide();
            } else {
                joyridemodalbg.fadeOut(this.settings.tipAnimationFadeSpeed);
            }
            this.scroll_to();
          }

          if (this.is_phone()) {
            this.pos_phone(true);
          } else {
            this.pos_default(true);
          }

          $timer = this.settings.$next_tip.find('.joyride-timer-indicator');

          if (/pop/i.test(this.settings.tip_animation)) {

            $timer.width(0);

            if (this.settings.timer > 0) {

              this.settings.$next_tip.show();

              setTimeout(function () {
                $timer.animate({
                  width : $timer.parent().width()
                }, this.settings.timer, 'linear');
              }.bind(this), this.settings.tip_animation_fade_speed);

            } else {
              this.settings.$next_tip.show();

            }

          } else if (/fade/i.test(this.settings.tip_animation)) {

            $timer.width(0);

            if (this.settings.timer > 0) {

              this.settings.$next_tip
                .fadeIn(this.settings.tip_animation_fade_speed)
                .show();

              setTimeout(function () {
                $timer.animate({
                  width : $timer.parent().width()
                }, this.settings.timer, 'linear');
              }.bind(this), this.settings.tip_animation_fade_speed);

            } else {
              this.settings.$next_tip.fadeIn(this.settings.tip_animation_fade_speed);
            }
          }

          this.settings.$current_tip = this.settings.$next_tip;

        // skip non-existant targets
        } else if (this.settings.$li && this.settings.$target.length < 1) {

          this.show(init, is_prev);

        } else {

          this.end();

        }
      } else {

        this.settings.paused = true;

      }

    },

    is_phone : function () {
      return matchMedia(Foundation.media_queries.small).matches &&
        !matchMedia(Foundation.media_queries.medium).matches;
    },

    hide : function () {
      if (this.settings.modal && this.settings.expose) {
        this.un_expose();
      }

      if (!this.settings.modal) {
        $('.joyride-modal-bg').hide();
      }

      // Prevent scroll bouncing...wait to remove from layout
      this.settings.$current_tip.css('visibility', 'hidden');
      setTimeout($.proxy(function () {
        this.hide();
        this.css('visibility', 'visible');
      }, this.settings.$current_tip), 0);
      this.settings.post_step_callback(this.settings.$li.index(),
        this.settings.$current_tip);
    },

    set_li : function (init, is_prev) {
      if (init) {
        this.settings.$li = this.settings.$tip_content.eq(this.settings.start_offset);
        this.set_next_tip();
        this.settings.$current_tip = this.settings.$next_tip;
      } else {
        if (is_prev) {
          this.settings.$li = this.settings.$li.prev();
        } else {
          this.settings.$li = this.settings.$li.next();
        }
        this.set_next_tip();
      }

      this.set_target();
    },

    set_next_tip : function () {
      this.settings.$next_tip = $('.joyride-tip-guide').eq(this.settings.$li.index());
      this.settings.$next_tip.data('closed', '');
    },

    set_target : function () {
      var cl = this.settings.$li.attr(this.add_namespace('data-class')),
          id = this.settings.$li.attr(this.add_namespace('data-id')),
          $sel = function () {
            if (id) {
              return $(document.getElementById(id));
            } else if (cl) {
              return $('.' + cl).first();
            } else {
              return $('body');
            }
          };

      this.settings.$target = $sel();
    },

    scroll_to : function () {
      var window_half, tipOffset;

      window_half = $(window).height() / 2;
      tipOffset = Math.ceil(this.settings.$target.offset().top - window_half + this.settings.$next_tip.outerHeight());

      if (tipOffset != 0) {
        $('html, body').stop().animate({
          scrollTop : tipOffset
        }, this.settings.scroll_speed, 'swing');
      }
    },

    paused : function () {
      return ($.inArray((this.settings.$li.index() + 1), this.settings.pause_after) === -1);
    },

    restart : function () {
      this.hide();
      this.settings.$li = undefined;
      this.show('init');
    },

    pos_default : function (init) {
      var $nub = this.settings.$next_tip.find('.joyride-nub'),
          nub_width = Math.ceil($nub.outerWidth() / 2),
          nub_height = Math.ceil($nub.outerHeight() / 2),
          toggle = init || false;

      // tip must not be "display: none" to calculate position
      if (toggle) {
        this.settings.$next_tip.css('visibility', 'hidden');
        this.settings.$next_tip.show();
      }

      if (!/body/i.test(this.settings.$target.selector)) {
        var topAdjustment = this.settings.tip_settings.tipAdjustmentY ? parseInt(this.settings.tip_settings.tipAdjustmentY) : 0,
            leftAdjustment = this.settings.tip_settings.tipAdjustmentX ? parseInt(this.settings.tip_settings.tipAdjustmentX) : 0;

        if (this.bottom()) {
          if (this.rtl) {
            this.settings.$next_tip.css({
              top : (this.settings.$target.offset().top + nub_height + this.settings.$target.outerHeight() + topAdjustment),
              left : this.settings.$target.offset().left + this.settings.$target.outerWidth() - this.settings.$next_tip.outerWidth() + leftAdjustment});
          } else {
            this.settings.$next_tip.css({
              top : (this.settings.$target.offset().top + nub_height + this.settings.$target.outerHeight() + topAdjustment),
              left : this.settings.$target.offset().left + leftAdjustment});
          }

          this.nub_position($nub, this.settings.tip_settings.nub_position, 'top');

        } else if (this.top()) {
          if (this.rtl) {
            this.settings.$next_tip.css({
              top : (this.settings.$target.offset().top - this.settings.$next_tip.outerHeight() - nub_height + topAdjustment),
              left : this.settings.$target.offset().left + this.settings.$target.outerWidth() - this.settings.$next_tip.outerWidth()});
          } else {
            this.settings.$next_tip.css({
              top : (this.settings.$target.offset().top - this.settings.$next_tip.outerHeight() - nub_height + topAdjustment),
              left : this.settings.$target.offset().left + leftAdjustment});
          }

          this.nub_position($nub, this.settings.tip_settings.nub_position, 'bottom');

        } else if (this.right()) {

          this.settings.$next_tip.css({
            top : this.settings.$target.offset().top + topAdjustment,
            left : (this.settings.$target.outerWidth() + this.settings.$target.offset().left + nub_width + leftAdjustment)});

          this.nub_position($nub, this.settings.tip_settings.nub_position, 'left');

        } else if (this.left()) {

          this.settings.$next_tip.css({
            top : this.settings.$target.offset().top + topAdjustment,
            left : (this.settings.$target.offset().left - this.settings.$next_tip.outerWidth() - nub_width + leftAdjustment)});

          this.nub_position($nub, this.settings.tip_settings.nub_position, 'right');

        }

        if (!this.visible(this.corners(this.settings.$next_tip)) && this.settings.attempts < this.settings.tip_settings.tip_location_pattern.length) {

          $nub.removeClass('bottom')
            .removeClass('top')
            .removeClass('right')
            .removeClass('left');

          this.settings.tip_settings.tip_location = this.settings.tip_settings.tip_location_pattern[this.settings.attempts];

          this.settings.attempts++;

          this.pos_default();

        }

      } else if (this.settings.$li.length) {

        this.pos_modal($nub);

      }

      if (toggle) {
        this.settings.$next_tip.hide();
        this.settings.$next_tip.css('visibility', 'visible');
      }

    },

    pos_phone : function (init) {
      var tip_height = this.settings.$next_tip.outerHeight(),
          tip_offset = this.settings.$next_tip.offset(),
          target_height = this.settings.$target.outerHeight(),
          $nub = $('.joyride-nub', this.settings.$next_tip),
          nub_height = Math.ceil($nub.outerHeight() / 2),
          toggle = init || false;

      $nub.removeClass('bottom')
        .removeClass('top')
        .removeClass('right')
        .removeClass('left');

      if (toggle) {
        this.settings.$next_tip.css('visibility', 'hidden');
        this.settings.$next_tip.show();
      }

      if (!/body/i.test(this.settings.$target.selector)) {

        if (this.top()) {

            this.settings.$next_tip.offset({top : this.settings.$target.offset().top - tip_height - nub_height});
            $nub.addClass('bottom');

        } else {

          this.settings.$next_tip.offset({top : this.settings.$target.offset().top + target_height + nub_height});
          $nub.addClass('top');

        }

      } else if (this.settings.$li.length) {
        this.pos_modal($nub);
      }

      if (toggle) {
        this.settings.$next_tip.hide();
        this.settings.$next_tip.css('visibility', 'visible');
      }
    },

    pos_modal : function ($nub) {
      this.center();
      $nub.hide();

      this.show_modal();
    },

    show_modal : function () {
      if (!this.settings.$next_tip.data('closed')) {
        var joyridemodalbg =  $('.joyride-modal-bg');
        if (joyridemodalbg.length < 1) {
          var joyridemodalbg = $(this.settings.template.modal);
          joyridemodalbg.appendTo('body');
        }

        if (/pop/i.test(this.settings.tip_animation)) {
            joyridemodalbg.show();
        } else {
            joyridemodalbg.fadeIn(this.settings.tip_animation_fade_speed);
        }
      }
    },

    expose : function () {
      var expose,
          exposeCover,
          el,
          origCSS,
          origClasses,
          randId = 'expose-' + this.random_str(6);

      if (arguments.length > 0 && arguments[0] instanceof $) {
        el = arguments[0];
      } else if (this.settings.$target && !/body/i.test(this.settings.$target.selector)) {
        el = this.settings.$target;
      } else {
        return false;
      }

      if (el.length < 1) {
        if (window.console) {
          console.error('element not valid', el);
        }
        return false;
      }

      expose = $(this.settings.template.expose);
      this.settings.$body.append(expose);
      expose.css({
        top : el.offset().top,
        left : el.offset().left,
        width : el.outerWidth(true),
        height : el.outerHeight(true)
      });

      exposeCover = $(this.settings.template.expose_cover);

      origCSS = {
        zIndex : el.css('z-index'),
        position : el.css('position')
      };

      origClasses = el.attr('class') == null ? '' : el.attr('class');

      el.css('z-index', parseInt(expose.css('z-index')) + 1);

      if (origCSS.position == 'static') {
        el.css('position', 'relative');
      }

      el.data('expose-css', origCSS);
      el.data('orig-class', origClasses);
      el.attr('class', origClasses + ' ' + this.settings.expose_add_class);

      exposeCover.css({
        top : el.offset().top,
        left : el.offset().left,
        width : el.outerWidth(true),
        height : el.outerHeight(true)
      });

      if (this.settings.modal) {
        this.show_modal();
      }

      this.settings.$body.append(exposeCover);
      expose.addClass(randId);
      exposeCover.addClass(randId);
      el.data('expose', randId);
      this.settings.post_expose_callback(this.settings.$li.index(), this.settings.$next_tip, el);
      this.add_exposed(el);
    },

    un_expose : function () {
      var exposeId,
          el,
          expose,
          origCSS,
          origClasses,
          clearAll = false;

      if (arguments.length > 0 && arguments[0] instanceof $) {
        el = arguments[0];
      } else if (this.settings.$target && !/body/i.test(this.settings.$target.selector)) {
        el = this.settings.$target;
      } else {
        return false;
      }

      if (el.length < 1) {
        if (window.console) {
          console.error('element not valid', el);
        }
        return false;
      }

      exposeId = el.data('expose');
      expose = $('.' + exposeId);

      if (arguments.length > 1) {
        clearAll = arguments[1];
      }

      if (clearAll === true) {
        $('.joyride-expose-wrapper,.joyride-expose-cover').remove();
      } else {
        expose.remove();
      }

      origCSS = el.data('expose-css');

      if (origCSS.zIndex == 'auto') {
        el.css('z-index', '');
      } else {
        el.css('z-index', origCSS.zIndex);
      }

      if (origCSS.position != el.css('position')) {
        if (origCSS.position == 'static') {// this is default, no need to set it.
          el.css('position', '');
        } else {
          el.css('position', origCSS.position);
        }
      }

      origClasses = el.data('orig-class');
      el.attr('class', origClasses);
      el.removeData('orig-classes');

      el.removeData('expose');
      el.removeData('expose-z-index');
      this.remove_exposed(el);
    },

    add_exposed : function (el) {
      this.settings.exposed = this.settings.exposed || [];
      if (el instanceof $ || typeof el === 'object') {
        this.settings.exposed.push(el[0]);
      } else if (typeof el == 'string') {
        this.settings.exposed.push(el);
      }
    },

    remove_exposed : function (el) {
      var search, i;
      if (el instanceof $) {
        search = el[0]
      } else if (typeof el == 'string') {
        search = el;
      }

      this.settings.exposed = this.settings.exposed || [];
      i = this.settings.exposed.length;

      while (i--) {
        if (this.settings.exposed[i] == search) {
          this.settings.exposed.splice(i, 1);
          return;
        }
      }
    },

    center : function () {
      var $w = $(window);

      this.settings.$next_tip.css({
        top : ((($w.height() - this.settings.$next_tip.outerHeight()) / 2) + $w.scrollTop()),
        left : ((($w.width() - this.settings.$next_tip.outerWidth()) / 2) + $w.scrollLeft())
      });

      return true;
    },

    bottom : function () {
      return /bottom/i.test(this.settings.tip_settings.tip_location);
    },

    top : function () {
      return /top/i.test(this.settings.tip_settings.tip_location);
    },

    right : function () {
      return /right/i.test(this.settings.tip_settings.tip_location);
    },

    left : function () {
      return /left/i.test(this.settings.tip_settings.tip_location);
    },

    corners : function (el) {
      if (el.length === 0) {
         return [false, false, false, false];   
      }
      
      var w = $(window),
          window_half = w.height() / 2,
          //using this to calculate since scroll may not have finished yet.
          tipOffset = Math.ceil(this.settings.$target.offset().top - window_half + this.settings.$next_tip.outerHeight()),
          right = w.width() + w.scrollLeft(),
          offsetBottom =  w.height() + tipOffset,
          bottom = w.height() + w.scrollTop(),
          top = w.scrollTop();

      if (tipOffset < top) {
        if (tipOffset < 0) {
          top = 0;
        } else {
          top = tipOffset;
        }
      }

      if (offsetBottom > bottom) {
        bottom = offsetBottom;
      }

      return [
        el.offset().top < top,
        right < el.offset().left + el.outerWidth(),
        bottom < el.offset().top + el.outerHeight(),
        w.scrollLeft() > el.offset().left
      ];
    },

    visible : function (hidden_corners) {
      var i = hidden_corners.length;

      while (i--) {
        if (hidden_corners[i]) {
          return false;
        }
      }

      return true;
    },

    nub_position : function (nub, pos, def) {
      if (pos === 'auto') {
        nub.addClass(def);
      } else {
        nub.addClass(pos);
      }
    },

    startTimer : function () {
      if (this.settings.$li.length) {
        this.settings.automate = setTimeout(function () {
          this.hide();
          this.show();
          this.startTimer();
        }.bind(this), this.settings.timer);
      } else {
        clearTimeout(this.settings.automate);
      }
    },

    end : function (abort) {
      if (this.settings.cookie_monster) {
        $.cookie(this.settings.cookie_name, 'ridden', {expires : this.settings.cookie_expires, domain : this.settings.cookie_domain});
      }

      if (this.settings.timer > 0) {
        clearTimeout(this.settings.automate);
      }

      if (this.settings.modal && this.settings.expose) {
        this.un_expose();
      }

      // Unplug keystrokes listener
      $(this.scope).off('keyup.joyride')

      this.settings.$next_tip.data('closed', true);
      this.settings.riding = false;

      $('.joyride-modal-bg').hide();
      this.settings.$current_tip.hide();

      if (typeof abort === 'undefined' || abort === false) {
        this.settings.post_step_callback(this.settings.$li.index(), this.settings.$current_tip);
        this.settings.post_ride_callback(this.settings.$li.index(), this.settings.$current_tip);
      }

      $('.joyride-tip-guide').remove();
    },

    off : function () {
      $(this.scope).off('.joyride');
      $(window).off('.joyride');
      $('.joyride-close-tip, .joyride-next-tip, .joyride-modal-bg').off('.joyride');
      $('.joyride-tip-guide, .joyride-modal-bg').remove();
      clearTimeout(this.settings.automate);
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs['magellan-expedition'] = {
    name : 'magellan-expedition',

    version : '5.5.3',

    settings : {
      active_class : 'active',
      threshold : 0, // pixels from the top of the expedition for it to become fixes
      destination_threshold : 20, // pixels from the top of destination for it to be considered active
      throttle_delay : 30, // calculation throttling to increase framerate
      fixed_top : 0, // top distance in pixels assigend to the fixed element on scroll
      offset_by_height : true,  // whether to offset the destination by the expedition height. Usually you want this to be true, unless your expedition is on the side.
      duration : 700, // animation duration time
      easing : 'swing' // animation easing
    },

    init : function (scope, method, options) {
      Foundation.inherit(this, 'throttle');
      this.bindings(method, options);
    },

    events : function () {
      var self = this,
          S = self.S,
          settings = self.settings;

      // initialize expedition offset
      self.set_expedition_position();

      S(self.scope)
        .off('.magellan')
        .on('click.fndtn.magellan', '[' + self.add_namespace('data-magellan-arrival') + '] a[href*=#]', function (e) {
          var sameHost = ((this.hostname === location.hostname) || !this.hostname),
              samePath = self.filterPathname(location.pathname) === self.filterPathname(this.pathname),
              testHash = this.hash.replace(/(:|\.|\/)/g, '\\$1'),
              anchor = this;

          if (sameHost && samePath && testHash) {
            e.preventDefault();
            var expedition = $(this).closest('[' + self.attr_name() + ']'),
                settings = expedition.data('magellan-expedition-init'),
                hash = this.hash.split('#').join(''),
                target = $('a[name="' + hash + '"]');

            if (target.length === 0) {
              target = $('#' + hash);

            }

            // Account for expedition height if fixed position
            var scroll_top = target.offset().top - settings.destination_threshold + 1;
            if (settings.offset_by_height) {
              scroll_top = scroll_top - expedition.outerHeight();
            }
            $('html, body').stop().animate({
              'scrollTop' : scroll_top
            }, settings.duration, settings.easing, function () {
              if (history.pushState) {
                history.pushState(null, null, anchor.pathname + anchor.search + '#' + hash);
              } else {
                location.hash = anchor.pathname + anchor.search + '#' + hash;
              }
            });
          }
        })
        .on('scroll.fndtn.magellan', self.throttle(this.check_for_arrivals.bind(this), settings.throttle_delay));
    },

    check_for_arrivals : function () {
      var self = this;
      self.update_arrivals();
      self.update_expedition_positions();
    },

    set_expedition_position : function () {
      var self = this;
      $('[' + this.attr_name() + '=fixed]', self.scope).each(function (idx, el) {
        var expedition = $(this),
            settings = expedition.data('magellan-expedition-init'),
            styles = expedition.attr('styles'), // save styles
            top_offset, fixed_top;

        expedition.attr('style', '');
        top_offset = expedition.offset().top + settings.threshold;

        //set fixed-top by attribute
        fixed_top = parseInt(expedition.data('magellan-fixed-top'));
        if (!isNaN(fixed_top)) {
          self.settings.fixed_top = fixed_top;
        }

        expedition.data(self.data_attr('magellan-top-offset'), top_offset);
        expedition.attr('style', styles);
      });
    },

    update_expedition_positions : function () {
      var self = this,
          window_top_offset = $(window).scrollTop();

      $('[' + this.attr_name() + '=fixed]', self.scope).each(function () {
        var expedition = $(this),
            settings = expedition.data('magellan-expedition-init'),
            styles = expedition.attr('style'), // save styles
            top_offset = expedition.data('magellan-top-offset');

        //scroll to the top distance
        if (window_top_offset + self.settings.fixed_top >= top_offset) {
          // Placeholder allows height calculations to be consistent even when
          // appearing to switch between fixed/non-fixed placement
          var placeholder = expedition.prev('[' + self.add_namespace('data-magellan-expedition-clone') + ']');
          if (placeholder.length === 0) {
            placeholder = expedition.clone();
            placeholder.removeAttr(self.attr_name());
            placeholder.attr(self.add_namespace('data-magellan-expedition-clone'), '');
            expedition.before(placeholder);
          }
          expedition.css({position :'fixed', top : settings.fixed_top}).addClass('fixed');
        } else {
          expedition.prev('[' + self.add_namespace('data-magellan-expedition-clone') + ']').remove();
          expedition.attr('style', styles).css('position', '').css('top', '').removeClass('fixed');
        }
      });
    },

    update_arrivals : function () {
      var self = this,
          window_top_offset = $(window).scrollTop();

      $('[' + this.attr_name() + ']', self.scope).each(function () {
        var expedition = $(this),
            settings = expedition.data(self.attr_name(true) + '-init'),
            offsets = self.offsets(expedition, window_top_offset),
            arrivals = expedition.find('[' + self.add_namespace('data-magellan-arrival') + ']'),
            active_item = false;
        offsets.each(function (idx, item) {
          if (item.viewport_offset >= item.top_offset) {
            var arrivals = expedition.find('[' + self.add_namespace('data-magellan-arrival') + ']');
            arrivals.not(item.arrival).removeClass(settings.active_class);
            item.arrival.addClass(settings.active_class);
            active_item = true;
            return true;
          }
        });

        if (!active_item) {
          arrivals.removeClass(settings.active_class);
        }
      });
    },

    offsets : function (expedition, window_offset) {
      var self = this,
          settings = expedition.data(self.attr_name(true) + '-init'),
          viewport_offset = window_offset;

      return expedition.find('[' + self.add_namespace('data-magellan-arrival') + ']').map(function (idx, el) {
        var name = $(this).data(self.data_attr('magellan-arrival')),
            dest = $('[' + self.add_namespace('data-magellan-destination') + '=' + name + ']');
        if (dest.length > 0) {
          var top_offset = dest.offset().top - settings.destination_threshold;
          if (settings.offset_by_height) {
            top_offset = top_offset - expedition.outerHeight();
          }
          top_offset = Math.floor(top_offset);
          return {
            destination : dest,
            arrival : $(this),
            top_offset : top_offset,
            viewport_offset : viewport_offset
          }
        }
      }).sort(function (a, b) {
        if (a.top_offset < b.top_offset) {
          return -1;
        }
        if (a.top_offset > b.top_offset) {
          return 1;
        }
        return 0;
      });
    },

    data_attr : function (str) {
      if (this.namespace.length > 0) {
        return this.namespace + '-' + str;
      }

      return str;
    },

    off : function () {
      this.S(this.scope).off('.magellan');
      this.S(window).off('.magellan');
    },

    filterPathname : function (pathname) {
      pathname = pathname || '';
      return pathname
          .replace(/^\//,'')
          .replace(/(?:index|default).[a-zA-Z]{3,4}$/,'')
          .replace(/\/$/,'');
    },

    reflow : function () {
      var self = this;
      // remove placeholder expeditions used for height calculation purposes
      $('[' + self.add_namespace('data-magellan-expedition-clone') + ']', self.scope).remove();
    }
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.offcanvas = {
    name : 'offcanvas',

    version : '5.5.3',

    settings : {
      open_method : 'move',
      close_on_click : false
    },

    init : function (scope, method, options) {
      this.bindings(method, options);
    },

    events : function () {
      var self = this,
          S = self.S,
          move_class = '',
          right_postfix = '',
          left_postfix = '',
          top_postfix = '',
          bottom_postfix = '';

      if (this.settings.open_method === 'move') {
        move_class = 'move-';
        right_postfix = 'right';
        left_postfix = 'left';
        top_postfix = 'top';
        bottom_postfix = 'bottom';
      } else if (this.settings.open_method === 'overlap_single') {
        move_class = 'offcanvas-overlap-';
        right_postfix = 'right';
        left_postfix = 'left';
        top_postfix = 'top';
        bottom_postfix = 'bottom';
      } else if (this.settings.open_method === 'overlap') {
        move_class = 'offcanvas-overlap';
      }

      S(this.scope).off('.offcanvas')
        .on('click.fndtn.offcanvas', '.left-off-canvas-toggle', function (e) {
          self.click_toggle_class(e, move_class + right_postfix);
          if (self.settings.open_method !== 'overlap') {
            S('.left-submenu').removeClass(move_class + right_postfix);
          }
          $('.left-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.left-off-canvas-menu a', function (e) {
          var settings = self.get_settings(e);
          var parent = S(this).parent();

          if (settings.close_on_click && !parent.hasClass('has-submenu') && !parent.hasClass('back')) {
            self.hide.call(self, move_class + right_postfix, self.get_wrapper(e));
            parent.parent().removeClass(move_class + right_postfix);
          } else if (S(this).parent().hasClass('has-submenu')) {
            e.preventDefault();
            S(this).siblings('.left-submenu').toggleClass(move_class + right_postfix);
          } else if (parent.hasClass('back')) {
            e.preventDefault();
            parent.parent().removeClass(move_class + right_postfix);
          }
          $('.left-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        //end of left canvas
        .on('click.fndtn.offcanvas', '.right-off-canvas-toggle', function (e) {
          self.click_toggle_class(e, move_class + left_postfix);
          if (self.settings.open_method !== 'overlap') {
            S('.right-submenu').removeClass(move_class + left_postfix);
          }
          $('.right-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.right-off-canvas-menu a', function (e) {
          var settings = self.get_settings(e);
          var parent = S(this).parent();

          if (settings.close_on_click && !parent.hasClass('has-submenu') && !parent.hasClass('back')) {
            self.hide.call(self, move_class + left_postfix, self.get_wrapper(e));
            parent.parent().removeClass(move_class + left_postfix);
          } else if (S(this).parent().hasClass('has-submenu')) {
            e.preventDefault();
            S(this).siblings('.right-submenu').toggleClass(move_class + left_postfix);
          } else if (parent.hasClass('back')) {
            e.preventDefault();
            parent.parent().removeClass(move_class + left_postfix);
          }
          $('.right-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        //end of right canvas
        .on('click.fndtn.offcanvas', '.top-off-canvas-toggle', function (e) {
          self.click_toggle_class(e, move_class + bottom_postfix);
          if (self.settings.open_method !== 'overlap') {
            S('.top-submenu').removeClass(move_class + bottom_postfix);
          }
          $('.top-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.top-off-canvas-menu a', function (e) {
          var settings = self.get_settings(e);
          var parent = S(this).parent();

          if (settings.close_on_click && !parent.hasClass('has-submenu') && !parent.hasClass('back')) {
            self.hide.call(self, move_class + bottom_postfix, self.get_wrapper(e));
            parent.parent().removeClass(move_class + bottom_postfix);
          } else if (S(this).parent().hasClass('has-submenu')) {
            e.preventDefault();
            S(this).siblings('.top-submenu').toggleClass(move_class + bottom_postfix);
          } else if (parent.hasClass('back')) {
            e.preventDefault();
            parent.parent().removeClass(move_class + bottom_postfix);
          }
          $('.top-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        //end of top canvas
        .on('click.fndtn.offcanvas', '.bottom-off-canvas-toggle', function (e) {
          self.click_toggle_class(e, move_class + top_postfix);
          if (self.settings.open_method !== 'overlap') {
            S('.bottom-submenu').removeClass(move_class + top_postfix);
          }
          $('.bottom-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.bottom-off-canvas-menu a', function (e) {
          var settings = self.get_settings(e);
          var parent = S(this).parent();

          if (settings.close_on_click && !parent.hasClass('has-submenu') && !parent.hasClass('back')) {
            self.hide.call(self, move_class + top_postfix, self.get_wrapper(e));
            parent.parent().removeClass(move_class + top_postfix);
          } else if (S(this).parent().hasClass('has-submenu')) {
            e.preventDefault();
            S(this).siblings('.bottom-submenu').toggleClass(move_class + top_postfix);
          } else if (parent.hasClass('back')) {
            e.preventDefault();
            parent.parent().removeClass(move_class + top_postfix);
          }
          $('.bottom-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        //end of bottom
        .on('click.fndtn.offcanvas', '.exit-off-canvas', function (e) {
          self.click_remove_class(e, move_class + left_postfix);
          S('.right-submenu').removeClass(move_class + left_postfix);
          if (right_postfix) {
            self.click_remove_class(e, move_class + right_postfix);
            S('.left-submenu').removeClass(move_class + left_postfix);
          }
          $('.right-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.exit-off-canvas', function (e) {
          self.click_remove_class(e, move_class + left_postfix);
          $('.left-off-canvas-toggle').attr('aria-expanded', 'false');
          if (right_postfix) {
            self.click_remove_class(e, move_class + right_postfix);
            $('.right-off-canvas-toggle').attr('aria-expanded', 'false');
          }
        })
        .on('click.fndtn.offcanvas', '.exit-off-canvas', function (e) {
          self.click_remove_class(e, move_class + top_postfix);
          S('.bottom-submenu').removeClass(move_class + top_postfix);
          if (bottom_postfix) {
            self.click_remove_class(e, move_class + bottom_postfix);
            S('.top-submenu').removeClass(move_class + top_postfix);
          }
          $('.bottom-off-canvas-toggle').attr('aria-expanded', 'true');
        })
        .on('click.fndtn.offcanvas', '.exit-off-canvas', function (e) {
          self.click_remove_class(e, move_class + top_postfix);
          $('.top-off-canvas-toggle').attr('aria-expanded', 'false');
          if (bottom_postfix) {
            self.click_remove_class(e, move_class + bottom_postfix);
            $('.bottom-off-canvas-toggle').attr('aria-expanded', 'false');
          }
        });
    },

    toggle : function (class_name, $off_canvas) {
      $off_canvas = $off_canvas || this.get_wrapper();
      if ($off_canvas.is('.' + class_name)) {
        this.hide(class_name, $off_canvas);
      } else {
        this.show(class_name, $off_canvas);
      }
    },

    show : function (class_name, $off_canvas) {
      $off_canvas = $off_canvas || this.get_wrapper();
      $off_canvas.trigger('open.fndtn.offcanvas');
      $off_canvas.addClass(class_name);
    },

    hide : function (class_name, $off_canvas) {
      $off_canvas = $off_canvas || this.get_wrapper();
      $off_canvas.trigger('close.fndtn.offcanvas');
      $off_canvas.removeClass(class_name);
    },

    click_toggle_class : function (e, class_name) {
      e.preventDefault();
      var $off_canvas = this.get_wrapper(e);
      this.toggle(class_name, $off_canvas);
    },

    click_remove_class : function (e, class_name) {
      e.preventDefault();
      var $off_canvas = this.get_wrapper(e);
      this.hide(class_name, $off_canvas);
    },

    get_settings : function (e) {
      var offcanvas  = this.S(e.target).closest('[' + this.attr_name() + ']');
      return offcanvas.data(this.attr_name(true) + '-init') || this.settings;
    },

    get_wrapper : function (e) {
      var $off_canvas = this.S(e ? e.target : this.scope).closest('.off-canvas-wrap');

      if ($off_canvas.length === 0) {
        $off_canvas = this.S('.off-canvas-wrap');
      }
      return $off_canvas;
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  var noop = function () {};

  var Orbit = function (el, settings) {
    // Don't reinitialize plugin
    if (el.hasClass(settings.slides_container_class)) {
      return this;
    }

    var self = this,
        container,
        slides_container = el,
        number_container,
        bullets_container,
        timer_container,
        idx = 0,
        animate,
        timer,
        locked = false,
        adjust_height_after = false;

    self.slides = function () {
      return slides_container.children(settings.slide_selector);
    };

    self.slides().first().addClass(settings.active_slide_class);

    self.update_slide_number = function (index) {
      if (settings.slide_number) {
        number_container.find('span:first').text(parseInt(index) + 1);
        number_container.find('span:last').text(self.slides().length);
      }
      if (settings.bullets) {
        bullets_container.children().removeClass(settings.bullets_active_class);
        $(bullets_container.children().get(index)).addClass(settings.bullets_active_class);
      }
    };

    self.update_active_link = function (index) {
      var link = $('[data-orbit-link="' + self.slides().eq(index).attr('data-orbit-slide') + '"]');
      link.siblings().removeClass(settings.bullets_active_class);
      link.addClass(settings.bullets_active_class);
    };

    self.build_markup = function () {
      slides_container.wrap('<div class="' + settings.container_class + '"></div>');
      container = slides_container.parent();
      slides_container.addClass(settings.slides_container_class);

      if (settings.stack_on_small) {
        container.addClass(settings.stack_on_small_class);
      }

      if (settings.navigation_arrows) {
        container.append($('<a href="#"><span></span></a>').addClass(settings.prev_class));
        container.append($('<a href="#"><span></span></a>').addClass(settings.next_class));
      }

      if (settings.timer) {
        timer_container = $('<div>').addClass(settings.timer_container_class);
        timer_container.append('<span>');
        timer_container.append($('<div>').addClass(settings.timer_progress_class));
        timer_container.addClass(settings.timer_paused_class);
        container.append(timer_container);
      }

      if (settings.slide_number) {
        number_container = $('<div>').addClass(settings.slide_number_class);
        number_container.append('<span></span> ' + settings.slide_number_text + ' <span></span>');
        container.append(number_container);
      }

      if (settings.bullets) {
        bullets_container = $('<ol>').addClass(settings.bullets_container_class);
        container.append(bullets_container);
        bullets_container.wrap('<div class="orbit-bullets-container"></div>');
        self.slides().each(function (idx, el) {
          var bullet = $('<li>').attr('data-orbit-slide', idx).on('click', self.link_bullet);;
          bullets_container.append(bullet);
        });
      }

    };

    self._goto = function (next_idx, start_timer) {
      // if (locked) {return false;}
      if (next_idx === idx) {return false;}
      if (typeof timer === 'object') {timer.restart();}
      var slides = self.slides();

      var dir = 'next';
      locked = true;
      if (next_idx < idx) {dir = 'prev';}
      if (next_idx >= slides.length) {
        if (!settings.circular) {
          return false;
        }
        next_idx = 0;
      } else if (next_idx < 0) {
        if (!settings.circular) {
          return false;
        }
        next_idx = slides.length - 1;
      }

      var current = $(slides.get(idx));
      var next = $(slides.get(next_idx));

      current.css('zIndex', 2);
      current.removeClass(settings.active_slide_class);
      next.css('zIndex', 4).addClass(settings.active_slide_class);

      slides_container.trigger('before-slide-change.fndtn.orbit');
      settings.before_slide_change();
      self.update_active_link(next_idx);

      var callback = function () {
        var unlock = function () {
          idx = next_idx;
          locked = false;
          if (start_timer === true) {timer = self.create_timer(); timer.start();}
          self.update_slide_number(idx);
          slides_container.trigger('after-slide-change.fndtn.orbit', [{slide_number : idx, total_slides : slides.length}]);
          settings.after_slide_change(idx, slides.length);
        };
        if (slides_container.outerHeight() != next.outerHeight() && settings.variable_height) {
          slides_container.animate({'height': next.outerHeight()}, 250, 'linear', unlock);
        } else {
          unlock();
        }
      };

      if (slides.length === 1) {callback(); return false;}

      var start_animation = function () {
        if (dir === 'next') {animate.next(current, next, callback);}
        if (dir === 'prev') {animate.prev(current, next, callback);}
      };

      if (next.outerHeight() > slides_container.outerHeight() && settings.variable_height) {
        slides_container.animate({'height': next.outerHeight()}, 250, 'linear', start_animation);
      } else {
        start_animation();
      }
    };

    self.next = function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      self._goto(idx + 1);
    };

    self.prev = function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      self._goto(idx - 1);
    };

    self.link_custom = function (e) {
      e.preventDefault();
      var link = $(this).attr('data-orbit-link');
      if ((typeof link === 'string') && (link = $.trim(link)) != '') {
        var slide = container.find('[data-orbit-slide=' + link + ']');
        if (slide.index() != -1) {self._goto(slide.index());}
      }
    };

    self.link_bullet = function (e) {
      var index = $(this).attr('data-orbit-slide');
      if ((typeof index === 'string') && (index = $.trim(index)) != '') {
        if (isNaN(parseInt(index))) {
          var slide = container.find('[data-orbit-slide=' + index + ']');
          if (slide.index() != -1) {self._goto(slide.index() + 1);}
        } else {
          self._goto(parseInt(index));
        }
      }

    }

    self.timer_callback = function () {
      self._goto(idx + 1, true);
    }

    self.compute_dimensions = function () {
      var current = $(self.slides().get(idx));
      var h = current.outerHeight();
      if (!settings.variable_height) {
        self.slides().each(function(){
          if ($(this).outerHeight() > h) { h = $(this).outerHeight(); }
        });
      }
      slides_container.height(h);
    };

    self.create_timer = function () {
      var t = new Timer(
        container.find('.' + settings.timer_container_class),
        settings,
        self.timer_callback
      );
      return t;
    };

    self.stop_timer = function () {
      if (typeof timer === 'object') {
        timer.stop();
      }
    };

    self.toggle_timer = function () {
      var t = container.find('.' + settings.timer_container_class);
      if (t.hasClass(settings.timer_paused_class)) {
        if (typeof timer === 'undefined') {timer = self.create_timer();}
        timer.start();
      } else {
        if (typeof timer === 'object') {timer.stop();}
      }
    };

    self.init = function () {
      self.build_markup();
      if (settings.timer) {
        timer = self.create_timer();
        Foundation.utils.image_loaded(this.slides().children('img'), timer.start);
      }
      animate = new FadeAnimation(settings, slides_container);
      if (settings.animation === 'slide') {
        animate = new SlideAnimation(settings, slides_container);
      }

      container.on('click', '.' + settings.next_class, self.next);
      container.on('click', '.' + settings.prev_class, self.prev);

      if (settings.next_on_click) {
        container.on('click', '.' + settings.slides_container_class + ' [data-orbit-slide]', self.link_bullet);
      }

      container.on('click', self.toggle_timer);
      if (settings.swipe) {
        container.on('touchstart.fndtn.orbit', function (e) {
          if (!e.touches) {e = e.originalEvent;}
          var data = {
            start_page_x : e.touches[0].pageX,
            start_page_y : e.touches[0].pageY,
            start_time : (new Date()).getTime(),
            delta_x : 0,
            is_scrolling : undefined
          };
          container.data('swipe-transition', data);
          e.stopPropagation();
        })
        .on('touchmove.fndtn.orbit', function (e) {
          if (!e.touches) {
            e = e.originalEvent;
          }
          // Ignore pinch/zoom events
          if (e.touches.length > 1 || e.scale && e.scale !== 1) {
            return;
          }

          var data = container.data('swipe-transition');
          if (typeof data === 'undefined') {data = {};}

          data.delta_x = e.touches[0].pageX - data.start_page_x;

          if ( typeof data.is_scrolling === 'undefined') {
            data.is_scrolling = !!( data.is_scrolling || Math.abs(data.delta_x) < Math.abs(e.touches[0].pageY - data.start_page_y) );
          }

          if (!data.is_scrolling && !data.active) {
            e.preventDefault();
            var direction = (data.delta_x < 0) ? (idx + 1) : (idx - 1);
            data.active = true;
            self._goto(direction);
          }
        })
        .on('touchend.fndtn.orbit', function (e) {
          container.data('swipe-transition', {});
          e.stopPropagation();
        })
      }
      container.on('mouseenter.fndtn.orbit', function (e) {
        if (settings.timer && settings.pause_on_hover) {
          self.stop_timer();
        }
      })
      .on('mouseleave.fndtn.orbit', function (e) {
        if (settings.timer && settings.resume_on_mouseout) {
          timer.start();
        }
      });

      $(document).on('click', '[data-orbit-link]', self.link_custom);
      $(window).on('load resize', self.compute_dimensions);
      Foundation.utils.image_loaded(this.slides().children('img'), self.compute_dimensions);
      Foundation.utils.image_loaded(this.slides().children('img'), function () {
        container.prev('.' + settings.preloader_class).css('display', 'none');
        self.update_slide_number(0);
        self.update_active_link(0);
        slides_container.trigger('ready.fndtn.orbit');
      });
    };

    self.init();
  };

  var Timer = function (el, settings, callback) {
    var self = this,
        duration = settings.timer_speed,
        progress = el.find('.' + settings.timer_progress_class),
        start,
        timeout,
        left = -1;

    this.update_progress = function (w) {
      var new_progress = progress.clone();
      new_progress.attr('style', '');
      new_progress.css('width', w + '%');
      progress.replaceWith(new_progress);
      progress = new_progress;
    };

    this.restart = function () {
      clearTimeout(timeout);
      el.addClass(settings.timer_paused_class);
      left = -1;
      self.update_progress(0);
    };

    this.start = function () {
      if (!el.hasClass(settings.timer_paused_class)) {return true;}
      left = (left === -1) ? duration : left;
      el.removeClass(settings.timer_paused_class);
      start = new Date().getTime();
      progress.animate({'width' : '100%'}, left, 'linear');
      timeout = setTimeout(function () {
        self.restart();
        callback();
      }, left);
      el.trigger('timer-started.fndtn.orbit')
    };

    this.stop = function () {
      if (el.hasClass(settings.timer_paused_class)) {return true;}
      clearTimeout(timeout);
      el.addClass(settings.timer_paused_class);
      var end = new Date().getTime();
      left = left - (end - start);
      var w = 100 - ((left / duration) * 100);
      self.update_progress(w);
      el.trigger('timer-stopped.fndtn.orbit');
    };
  };

  var SlideAnimation = function (settings, container) {
    var duration = settings.animation_speed;
    var is_rtl = ($('html[dir=rtl]').length === 1);
    var margin = is_rtl ? 'marginRight' : 'marginLeft';
    var animMargin = {};
    animMargin[margin] = '0%';

    this.next = function (current, next, callback) {
      current.animate({marginLeft : '-100%'}, duration);
      next.animate(animMargin, duration, function () {
        current.css(margin, '100%');
        callback();
      });
    };

    this.prev = function (current, prev, callback) {
      current.animate({marginLeft : '100%'}, duration);
      prev.css(margin, '-100%');
      prev.animate(animMargin, duration, function () {
        current.css(margin, '100%');
        callback();
      });
    };
  };

  var FadeAnimation = function (settings, container) {
    var duration = settings.animation_speed;
    var is_rtl = ($('html[dir=rtl]').length === 1);
    var margin = is_rtl ? 'marginRight' : 'marginLeft';

    this.next = function (current, next, callback) {
      next.css({'margin' : '0%', 'opacity' : '0.01'});
      next.animate({'opacity' :'1'}, duration, 'linear', function () {
        current.css('margin', '100%');
        callback();
      });
    };

    this.prev = function (current, prev, callback) {
      prev.css({'margin' : '0%', 'opacity' : '0.01'});
      prev.animate({'opacity' : '1'}, duration, 'linear', function () {
        current.css('margin', '100%');
        callback();
      });
    };
  };

  Foundation.libs = Foundation.libs || {};

  Foundation.libs.orbit = {
    name : 'orbit',

    version : '5.5.3',

    settings : {
      animation : 'slide',
      timer_speed : 10000,
      pause_on_hover : true,
      resume_on_mouseout : false,
      next_on_click : true,
      animation_speed : 500,
      stack_on_small : false,
      navigation_arrows : true,
      slide_number : true,
      slide_number_text : 'of',
      container_class : 'orbit-container',
      stack_on_small_class : 'orbit-stack-on-small',
      next_class : 'orbit-next',
      prev_class : 'orbit-prev',
      timer_container_class : 'orbit-timer',
      timer_paused_class : 'paused',
      timer_progress_class : 'orbit-progress',
      slides_container_class : 'orbit-slides-container',
      preloader_class : 'preloader',
      slide_selector : '*',
      bullets_container_class : 'orbit-bullets',
      bullets_active_class : 'active',
      slide_number_class : 'orbit-slide-number',
      caption_class : 'orbit-caption',
      active_slide_class : 'active',
      orbit_transition_class : 'orbit-transitioning',
      bullets : true,
      circular : true,
      timer : true,
      variable_height : false,
      swipe : true,
      before_slide_change : noop,
      after_slide_change : noop
    },

    init : function (scope, method, options) {
      var self = this;
      this.bindings(method, options);
    },

    events : function (instance) {
      var orbit_instance = new Orbit(this.S(instance), this.S(instance).data('orbit-init'));
      this.S(instance).data(this.name + '-instance', orbit_instance);
    },

    reflow : function () {
      var self = this;

      if (self.S(self.scope).is('[data-orbit]')) {
        var $el = self.S(self.scope);
        var instance = $el.data(self.name + '-instance');
        instance.compute_dimensions();
      } else {
        self.S('[data-orbit]', self.scope).each(function (idx, el) {
          var $el = self.S(el);
          var opts = self.data_options($el);
          var instance = $el.data(self.name + '-instance');
          instance.compute_dimensions();
        });
      }
    }
  };

}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  var openModals = [];

  Foundation.libs.reveal = {
    name : 'reveal',

    version : '5.5.3',

    locked : false,

    settings : {
      animation : 'fadeAndPop',
      animation_speed : 250,
      close_on_background_click : true,
      close_on_esc : true,
      dismiss_modal_class : 'close-reveal-modal',
      multiple_opened : false,
      bg_class : 'reveal-modal-bg',
      root_element : 'body',
      open : function(){},
      opened : function(){},
      close : function(){},
      closed : function(){},
      on_ajax_error: $.noop,
      bg : $('.reveal-modal-bg'),
      css : {
        open : {
          'opacity' : 0,
          'visibility' : 'visible',
          'display' : 'block'
        },
        close : {
          'opacity' : 1,
          'visibility' : 'hidden',
          'display' : 'none'
        }
      }
    },

    init : function (scope, method, options) {
      $.extend(true, this.settings, method, options);
      this.bindings(method, options);
    },

    events : function (scope) {
      var self = this,
          S = self.S;

      S(this.scope)
        .off('.reveal')
        .on('click.fndtn.reveal', '[' + this.add_namespace('data-reveal-id') + ']:not([disabled])', function (e) {
          e.preventDefault();

          if (!self.locked) {
            var element = S(this),
                ajax = element.data(self.data_attr('reveal-ajax')),
                replaceContentSel = element.data(self.data_attr('reveal-replace-content'));

            self.locked = true;

            if (typeof ajax === 'undefined') {
              self.open.call(self, element);
            } else {
              var url = ajax === true ? element.attr('href') : ajax;
              self.open.call(self, element, {url : url}, { replaceContentSel : replaceContentSel });
            }
          }
        });

      S(document)
        .on('click.fndtn.reveal', this.close_targets(), function (e) {
          e.preventDefault();
          if (!self.locked) {
            var settings = S('[' + self.attr_name() + '].open').data(self.attr_name(true) + '-init') || self.settings,
                bg_clicked = S(e.target)[0] === S('.' + settings.bg_class)[0];

            if (bg_clicked) {
              if (settings.close_on_background_click) {
                e.stopPropagation();
              } else {
                return;
              }
            }

            self.locked = true;
            self.close.call(self, bg_clicked ? S('[' + self.attr_name() + '].open:not(.toback)') : S(this).closest('[' + self.attr_name() + ']'));
          }
        });

      if (S('[' + self.attr_name() + ']', this.scope).length > 0) {
        S(this.scope)
          // .off('.reveal')
          .on('open.fndtn.reveal', this.settings.open)
          .on('opened.fndtn.reveal', this.settings.opened)
          .on('opened.fndtn.reveal', this.open_video)
          .on('close.fndtn.reveal', this.settings.close)
          .on('closed.fndtn.reveal', this.settings.closed)
          .on('closed.fndtn.reveal', this.close_video);
      } else {
        S(this.scope)
          // .off('.reveal')
          .on('open.fndtn.reveal', '[' + self.attr_name() + ']', this.settings.open)
          .on('opened.fndtn.reveal', '[' + self.attr_name() + ']', this.settings.opened)
          .on('opened.fndtn.reveal', '[' + self.attr_name() + ']', this.open_video)
          .on('close.fndtn.reveal', '[' + self.attr_name() + ']', this.settings.close)
          .on('closed.fndtn.reveal', '[' + self.attr_name() + ']', this.settings.closed)
          .on('closed.fndtn.reveal', '[' + self.attr_name() + ']', this.close_video);
      }

      return true;
    },

    // PATCH #3: turning on key up capture only when a reveal window is open
    key_up_on : function (scope) {
      var self = this;

      // PATCH #1: fixing multiple keyup event trigger from single key press
      self.S('body').off('keyup.fndtn.reveal').on('keyup.fndtn.reveal', function ( event ) {
        var open_modal = self.S('[' + self.attr_name() + '].open'),
            settings = open_modal.data(self.attr_name(true) + '-init') || self.settings ;
        // PATCH #2: making sure that the close event can be called only while unlocked,
        //           so that multiple keyup.fndtn.reveal events don't prevent clean closing of the reveal window.
        if ( settings && event.which === 27  && settings.close_on_esc && !self.locked) { // 27 is the keycode for the Escape key
          self.close.call(self, open_modal);
        }
      });

      return true;
    },

    // PATCH #3: turning on key up capture only when a reveal window is open
    key_up_off : function (scope) {
      this.S('body').off('keyup.fndtn.reveal');
      return true;
    },

    open : function (target, ajax_settings) {
      var self = this,
          modal;

      if (target) {
        if (typeof target.selector !== 'undefined') {
          // Find the named node; only use the first one found, since the rest of the code assumes there's only one node
          modal = self.S('#' + target.data(self.data_attr('reveal-id'))).first();
        } else {
          modal = self.S(this.scope);

          ajax_settings = target;
        }
      } else {
        modal = self.S(this.scope);
      }

      var settings = modal.data(self.attr_name(true) + '-init');
      settings = settings || this.settings;


      if (modal.hasClass('open') && target !== undefined && target.attr('data-reveal-id') == modal.attr('id')) {
        return self.close(modal);
      }

      if (!modal.hasClass('open')) {
        var open_modal = self.S('[' + self.attr_name() + '].open');

        if (typeof modal.data('css-top') === 'undefined') {
          modal.data('css-top', parseInt(modal.css('top'), 10))
            .data('offset', this.cache_offset(modal));
        }

        modal.attr('tabindex','0').attr('aria-hidden','false');

        this.key_up_on(modal);    // PATCH #3: turning on key up capture only when a reveal window is open

        // Prevent namespace event from triggering twice
        modal.on('open.fndtn.reveal', function(e) {
          if (e.namespace !== 'fndtn.reveal') return;
        });

        modal.on('open.fndtn.reveal').trigger('open.fndtn.reveal');

        if (open_modal.length < 1) {
          this.toggle_bg(modal, true);
        }

        if (typeof ajax_settings === 'string') {
          ajax_settings = {
            url : ajax_settings
          };
        }

        var openModal = function() {
          if(open_modal.length > 0) {
            if(settings.multiple_opened) {
              self.to_back(open_modal);
            } else {
              self.hide(open_modal, settings.css.close);
            }
          }

          // bl: add the open_modal that isn't already in the background to the openModals array
          if(settings.multiple_opened) {
            openModals.push(modal);
          }

          self.show(modal, settings.css.open);
        };

        if (typeof ajax_settings === 'undefined' || !ajax_settings.url) {
          openModal();
        } else {
          var old_success = typeof ajax_settings.success !== 'undefined' ? ajax_settings.success : null;
          $.extend(ajax_settings, {
            success : function (data, textStatus, jqXHR) {
              if ( $.isFunction(old_success) ) {
                var result = old_success(data, textStatus, jqXHR);
                if (typeof result == 'string') {
                  data = result;
                }
              }

              if (typeof options !== 'undefined' && typeof options.replaceContentSel !== 'undefined') {
                modal.find(options.replaceContentSel).html(data);
              } else {
                modal.html(data);
              }

              self.S(modal).foundation('section', 'reflow');
              self.S(modal).children().foundation();

              openModal();
            }
          });

          // check for if user initalized with error callback
          if (settings.on_ajax_error !== $.noop) {
            $.extend(ajax_settings, {
              error : settings.on_ajax_error
            });
          }

          $.ajax(ajax_settings);
        }
      }
      self.S(window).trigger('resize');
    },

    close : function (modal) {
      var modal = modal && modal.length ? modal : this.S(this.scope),
          open_modals = this.S('[' + this.attr_name() + '].open'),
          settings = modal.data(this.attr_name(true) + '-init') || this.settings,
          self = this;

      if (open_modals.length > 0) {

        modal.removeAttr('tabindex','0').attr('aria-hidden','true');

        this.locked = true;
        this.key_up_off(modal);   // PATCH #3: turning on key up capture only when a reveal window is open

        modal.trigger('close.fndtn.reveal');

        if ((settings.multiple_opened && open_modals.length === 1) || !settings.multiple_opened || modal.length > 1) {
          self.toggle_bg(modal, false);
          self.to_front(modal);
        }

        if (settings.multiple_opened) {
          var isCurrent = modal.is(':not(.toback)');
          self.hide(modal, settings.css.close, settings);
          if(isCurrent) {
            // remove the last modal since it is now closed
            openModals.pop();
          } else {
            // if this isn't the current modal, then find it in the array and remove it
            openModals = $.grep(openModals, function(elt) {
              var isThis = elt[0]===modal[0];
              if(isThis) {
                // since it's not currently in the front, put it in the front now that it is hidden
                // so that if it's re-opened, it won't be .toback
                self.to_front(modal);
              }
              return !isThis;
            });
          }
          // finally, show the next modal in the stack, if there is one
          if(openModals.length>0) {
            self.to_front(openModals[openModals.length - 1]);
          }
        } else {
          self.hide(open_modals, settings.css.close, settings);
        }
      }
    },

    close_targets : function () {
      var base = '.' + this.settings.dismiss_modal_class;

      if (this.settings.close_on_background_click) {
        return base + ', .' + this.settings.bg_class;
      }

      return base;
    },

    toggle_bg : function (modal, state) {
      if (this.S('.' + this.settings.bg_class).length === 0) {
        this.settings.bg = $('<div />', {'class': this.settings.bg_class})
          .appendTo('body').hide();
      }

      var visible = this.settings.bg.filter(':visible').length > 0;
      if ( state != visible ) {
        if ( state == undefined ? visible : !state ) {
          this.hide(this.settings.bg);
        } else {
          this.show(this.settings.bg);
        }
      }
    },

    show : function (el, css) {
      // is modal
      if (css) {
        var settings = el.data(this.attr_name(true) + '-init') || this.settings,
            root_element = settings.root_element,
            context = this;

        if (el.parent(root_element).length === 0) {
          var placeholder = el.wrap('<div style="display: none;" />').parent();

          el.on('closed.fndtn.reveal.wrapped', function () {
            el.detach().appendTo(placeholder);
            el.unwrap().unbind('closed.fndtn.reveal.wrapped');
          });

          el.detach().appendTo(root_element);
        }

        var animData = getAnimationData(settings.animation);
        if (!animData.animate) {
          this.locked = false;
        }
        if (animData.pop) {
          css.top = $(window).scrollTop() - el.data('offset') + 'px';
          var end_css = {
            top: $(window).scrollTop() + el.data('css-top') + 'px',
            opacity: 1
          };

          return setTimeout(function () {
            return el
              .css(css)
              .animate(end_css, settings.animation_speed, 'linear', function () {
                context.locked = false;
                el.trigger('opened.fndtn.reveal');
              })
              .addClass('open');
          }, settings.animation_speed / 2);
        }

        css.top = $(window).scrollTop() + el.data('css-top') + 'px';

        if (animData.fade) {
          var end_css = {opacity: 1};

          return setTimeout(function () {
            return el
              .css(css)
              .animate(end_css, settings.animation_speed, 'linear', function () {
                context.locked = false;
                el.trigger('opened.fndtn.reveal');
              })
              .addClass('open');
          }, settings.animation_speed / 2);
        }

        return el.css(css).show().css({opacity : 1}).addClass('open').trigger('opened.fndtn.reveal');
      }

      var settings = this.settings;

      // should we animate the background?
      if (getAnimationData(settings.animation).fade) {
        return el.fadeIn(settings.animation_speed / 2);
      }

      this.locked = false;

      return el.show();
    },

    to_back : function(el) {
      el.addClass('toback');
    },

    to_front : function(el) {
      el.removeClass('toback');
    },

    hide : function (el, css) {
      // is modal
      if (css) {
        var settings = el.data(this.attr_name(true) + '-init'),
            context = this;
        settings = settings || this.settings;

        var animData = getAnimationData(settings.animation);
        if (!animData.animate) {
          this.locked = false;
        }
        if (animData.pop) {
          var end_css = {
            top: - $(window).scrollTop() - el.data('offset') + 'px',
            opacity: 0
          };

          return setTimeout(function () {
            return el
              .animate(end_css, settings.animation_speed, 'linear', function () {
                context.locked = false;
                el.css(css).trigger('closed.fndtn.reveal');
              })
              .removeClass('open');
          }, settings.animation_speed / 2);
        }

        if (animData.fade) {
          var end_css = {opacity : 0};

          return setTimeout(function () {
            return el
              .animate(end_css, settings.animation_speed, 'linear', function () {
                context.locked = false;
                el.css(css).trigger('closed.fndtn.reveal');
              })
              .removeClass('open');
          }, settings.animation_speed / 2);
        }

        return el.hide().css(css).removeClass('open').trigger('closed.fndtn.reveal');
      }

      var settings = this.settings;

      // should we animate the background?
      if (getAnimationData(settings.animation).fade) {
        return el.fadeOut(settings.animation_speed / 2);
      }

      return el.hide();
    },

    close_video : function (e) {
      var video = $('.flex-video', e.target),
          iframe = $('iframe', video);

      if (iframe.length > 0) {
        iframe.attr('data-src', iframe[0].src);
        iframe.attr('src', iframe.attr('src'));
        video.hide();
      }
    },

    open_video : function (e) {
      var video = $('.flex-video', e.target),
          iframe = video.find('iframe');

      if (iframe.length > 0) {
        var data_src = iframe.attr('data-src');
        if (typeof data_src === 'string') {
          iframe[0].src = iframe.attr('data-src');
        } else {
          var src = iframe[0].src;
          iframe[0].src = undefined;
          iframe[0].src = src;
        }
        video.show();
      }
    },

    data_attr : function (str) {
      if (this.namespace.length > 0) {
        return this.namespace + '-' + str;
      }

      return str;
    },

    cache_offset : function (modal) {
      var offset = modal.show().height() + parseInt(modal.css('top'), 10) + modal.scrollY;

      modal.hide();

      return offset;
    },

    off : function () {
      $(this.scope).off('.fndtn.reveal');
    },

    reflow : function () {}
  };

  /*
   * getAnimationData('popAndFade') // {animate: true,  pop: true,  fade: true}
   * getAnimationData('fade')       // {animate: true,  pop: false, fade: true}
   * getAnimationData('pop')        // {animate: true,  pop: true,  fade: false}
   * getAnimationData('foo')        // {animate: false, pop: false, fade: false}
   * getAnimationData(null)         // {animate: false, pop: false, fade: false}
   */
  function getAnimationData(str) {
    var fade = /fade/i.test(str);
    var pop = /pop/i.test(str);
    return {
      animate : fade || pop,
      pop : pop,
      fade : fade
    };
  }
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.slider = {
    name : 'slider',

    version : '5.5.3',

    settings : {
      start : 0,
      end : 100,
      step : 1,
      precision : 2,
      initial : null,
      display_selector : '',
      vertical : false,
      trigger_input_change : false,
      on_change : function () {}
    },

    cache : {},

    init : function (scope, method, options) {
      Foundation.inherit(this, 'throttle');
      this.bindings(method, options);
      this.reflow();
    },

    events : function () {
      var self = this;
      $(this.scope)
        .off('.slider')
        .on('mousedown.fndtn.slider touchstart.fndtn.slider pointerdown.fndtn.slider',
        '[' + self.attr_name() + ']:not(.disabled, [disabled]) .range-slider-handle', function (e) {
          if (!self.cache.active) {
            e.preventDefault();
            self.set_active_slider($(e.target));
          }
        })
        .on('mousemove.fndtn.slider touchmove.fndtn.slider pointermove.fndtn.slider', function (e) {
          if (!!self.cache.active) {
            e.preventDefault();
            if ($.data(self.cache.active[0], 'settings').vertical) {
              var scroll_offset = 0;
              if (!e.pageY) {
                scroll_offset = window.scrollY;
              }
              self.calculate_position(self.cache.active, self.get_cursor_position(e, 'y') + scroll_offset);
            } else {
              self.calculate_position(self.cache.active, self.get_cursor_position(e, 'x'));
            }
          }
        })
        .on('mouseup.fndtn.slider touchend.fndtn.slider pointerup.fndtn.slider', function (e) {
          if(!self.cache.active) {
            // if the user has just clicked into the slider without starting to drag the handle
            var slider = $(e.target).attr('role') === 'slider' ? $(e.target) : $(e.target).closest('.range-slider').find("[role='slider']");

            if (slider.length && (!slider.parent().hasClass('disabled') && !slider.parent().attr('disabled'))) {
              self.set_active_slider(slider);
              if ($.data(self.cache.active[0], 'settings').vertical) {
                var scroll_offset = 0;
                if (!e.pageY) {
                  scroll_offset = window.scrollY;
                }
                self.calculate_position(self.cache.active, self.get_cursor_position(e, 'y') + scroll_offset);
              } else {
                self.calculate_position(self.cache.active, self.get_cursor_position(e, 'x'));
              }
            }
          }
          self.remove_active_slider();
        })
        .on('change.fndtn.slider', function (e) {
          self.settings.on_change();
        });

      self.S(window)
        .on('resize.fndtn.slider', self.throttle(function (e) {
          self.reflow();
        }, 300));

      // update slider value as users change input value
      this.S('[' + this.attr_name() + ']').each(function () {
        var slider = $(this),
            handle = slider.children('.range-slider-handle')[0],
            settings = self.initialize_settings(handle);

        if (settings.display_selector != '') {
          $(settings.display_selector).each(function(){
            if ($(this).attr('value')) {
              $(this).off('change').on('change', function () {
                slider.foundation("slider", "set_value", $(this).val());
              });
            }
          });
        }
      });
    },

    get_cursor_position : function (e, xy) {
      var pageXY = 'page' + xy.toUpperCase(),
          clientXY = 'client' + xy.toUpperCase(),
          position;

      if (typeof e[pageXY] !== 'undefined') {
        position = e[pageXY];
      } else if (typeof e.originalEvent[clientXY] !== 'undefined') {
        position = e.originalEvent[clientXY];
      } else if (e.originalEvent.touches && e.originalEvent.touches[0] && typeof e.originalEvent.touches[0][clientXY] !== 'undefined') {
        position = e.originalEvent.touches[0][clientXY];
      } else if (e.currentPoint && typeof e.currentPoint[xy] !== 'undefined') {
        position = e.currentPoint[xy];
      }

      return position;
    },

    set_active_slider : function ($handle) {
      this.cache.active = $handle;
    },

    remove_active_slider : function () {
      this.cache.active = null;
    },

    calculate_position : function ($handle, cursor_x) {
      var self = this,
          settings = $.data($handle[0], 'settings'),
          handle_l = $.data($handle[0], 'handle_l'),
          handle_o = $.data($handle[0], 'handle_o'),
          bar_l = $.data($handle[0], 'bar_l'),
          bar_o = $.data($handle[0], 'bar_o');

      requestAnimationFrame(function () {
        var pct;

        if (Foundation.rtl && !settings.vertical) {
          pct = self.limit_to(((bar_o + bar_l - cursor_x) / bar_l), 0, 1);
        } else {
          pct = self.limit_to(((cursor_x - bar_o) / bar_l), 0, 1);
        }

        pct = settings.vertical ? 1 - pct : pct;

        var norm = self.normalized_value(pct, settings.start, settings.end, settings.step, settings.precision);

        self.set_ui($handle, norm);
      });
    },

    set_ui : function ($handle, value) {
      var settings = $.data($handle[0], 'settings'),
          handle_l = $.data($handle[0], 'handle_l'),
          bar_l = $.data($handle[0], 'bar_l'),
          norm_pct = this.normalized_percentage(value, settings.start, settings.end),
          handle_offset = norm_pct * (bar_l - handle_l) - 1,
          progress_bar_length = norm_pct * 100,
          $handle_parent = $handle.parent(),
          $hidden_inputs = $handle.parent().children('input[type=hidden]');

      if (Foundation.rtl && !settings.vertical) {
        handle_offset = -handle_offset;
      }

      handle_offset = settings.vertical ? -handle_offset + bar_l - handle_l + 1 : handle_offset;
      this.set_translate($handle, handle_offset, settings.vertical);

      if (settings.vertical) {
        $handle.siblings('.range-slider-active-segment').css('height', progress_bar_length + '%');
      } else {
        $handle.siblings('.range-slider-active-segment').css('width', progress_bar_length + '%');
      }

      $handle_parent.attr(this.attr_name(), value).trigger('change.fndtn.slider');

      $hidden_inputs.val(value);
      if (settings.trigger_input_change) {
          $hidden_inputs.trigger('change.fndtn.slider');
      }

      if (!$handle[0].hasAttribute('aria-valuemin')) {
        $handle.attr({
          'aria-valuemin' : settings.start,
          'aria-valuemax' : settings.end
        });
      }
      $handle.attr('aria-valuenow', value);

      if (settings.display_selector != '') {
        $(settings.display_selector).each(function () {
          if (this.hasAttribute('value')) {
            $(this).val(value);
          } else {
            $(this).text(value);
          }
        });
      }

    },

    normalized_percentage : function (val, start, end) {
      return Math.min(1, (val - start) / (end - start));
    },

    normalized_value : function (val, start, end, step, precision) {
      var range = end - start,
          point = val * range,
          mod = (point - (point % step)) / step,
          rem = point % step,
          round = ( rem >= step * 0.5 ? step : 0);
      return ((mod * step + round) + start).toFixed(precision);
    },

    set_translate : function (ele, offset, vertical) {
      if (vertical) {
        $(ele)
          .css('-webkit-transform', 'translateY(' + offset + 'px)')
          .css('-moz-transform', 'translateY(' + offset + 'px)')
          .css('-ms-transform', 'translateY(' + offset + 'px)')
          .css('-o-transform', 'translateY(' + offset + 'px)')
          .css('transform', 'translateY(' + offset + 'px)');
      } else {
        $(ele)
          .css('-webkit-transform', 'translateX(' + offset + 'px)')
          .css('-moz-transform', 'translateX(' + offset + 'px)')
          .css('-ms-transform', 'translateX(' + offset + 'px)')
          .css('-o-transform', 'translateX(' + offset + 'px)')
          .css('transform', 'translateX(' + offset + 'px)');
      }
    },

    limit_to : function (val, min, max) {
      return Math.min(Math.max(val, min), max);
    },

    initialize_settings : function (handle) {
      var settings = $.extend({}, this.settings, this.data_options($(handle).parent())),
          decimal_places_match_result;

      if (settings.precision === null) {
        decimal_places_match_result = ('' + settings.step).match(/\.([\d]*)/);
        settings.precision = decimal_places_match_result && decimal_places_match_result[1] ? decimal_places_match_result[1].length : 0;
      }

      if (settings.vertical) {
        $.data(handle, 'bar_o', $(handle).parent().offset().top);
        $.data(handle, 'bar_l', $(handle).parent().outerHeight());
        $.data(handle, 'handle_o', $(handle).offset().top);
        $.data(handle, 'handle_l', $(handle).outerHeight());
      } else {
        $.data(handle, 'bar_o', $(handle).parent().offset().left);
        $.data(handle, 'bar_l', $(handle).parent().outerWidth());
        $.data(handle, 'handle_o', $(handle).offset().left);
        $.data(handle, 'handle_l', $(handle).outerWidth());
      }

      $.data(handle, 'bar', $(handle).parent());
      return $.data(handle, 'settings', settings);
    },

    set_initial_position : function ($ele) {
      var settings = $.data($ele.children('.range-slider-handle')[0], 'settings'),
          initial = ((typeof settings.initial == 'number' && !isNaN(settings.initial)) ? settings.initial : Math.floor((settings.end - settings.start) * 0.5 / settings.step) * settings.step + settings.start),
          $handle = $ele.children('.range-slider-handle');
      this.set_ui($handle, initial);
    },

    set_value : function (value) {
      var self = this;
      $('[' + self.attr_name() + ']', this.scope).each(function () {
        $(this).attr(self.attr_name(), value);
      });
      if (!!$(this.scope).attr(self.attr_name())) {
        $(this.scope).attr(self.attr_name(), value);
      }
      self.reflow();
    },

    reflow : function () {
      var self = this;
      self.S('[' + this.attr_name() + ']').each(function () {
        var handle = $(this).children('.range-slider-handle')[0],
            val = $(this).attr(self.attr_name());
        self.initialize_settings(handle);

        if (val) {
          self.set_ui($(handle), parseFloat(val));
        } else {
          self.set_initial_position($(this));
        }
      });
    }
  };

}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.tab = {
    name : 'tab',

    version : '5.5.3',

    settings : {
      active_class : 'active',
      callback : function () {},
      deep_linking : false,
      scroll_to_content : true,
      is_hover : false
    },

    default_tab_hashes : [],

    init : function (scope, method, options) {
      var self = this,
          S = this.S;

  	  // Store the default active tabs which will be referenced when the
  	  // location hash is absent, as in the case of navigating the tabs and
  	  // returning to the first viewing via the browser Back button.
  	  S('[' + this.attr_name() + '] > .active > a', this.scope).each(function () {
  	    self.default_tab_hashes.push(this.hash);
  	  });

      this.bindings(method, options);
      this.handle_location_hash_change();
    },

    events : function () {
      var self = this,
          S = this.S;

      var usual_tab_behavior =  function (e, target) {
        var settings = S(target).closest('[' + self.attr_name() + ']').data(self.attr_name(true) + '-init');
        if (!settings.is_hover || Modernizr.touch) {
          // if user did not pressed tab key, prevent default action
          var keyCode = e.keyCode || e.which;
          if (keyCode !== 9) { 
            e.preventDefault();
            e.stopPropagation();
          }
          self.toggle_active_tab(S(target).parent());
          
        }
      };

      S(this.scope)
        .off('.tab')
        // Key event: focus/tab key
        .on('keydown.fndtn.tab', '[' + this.attr_name() + '] > * > a', function(e) {
          var keyCode = e.keyCode || e.which;
          // if user pressed tab key
          if (keyCode === 13 || keyCode === 32) { // enter or space
            var el = this;
            usual_tab_behavior(e, el);
          } 
        })
        // Click event: tab title
        .on('click.fndtn.tab', '[' + this.attr_name() + '] > * > a', function(e) {
          var el = this;
          usual_tab_behavior(e, el);
        })
        // Hover event: tab title
        .on('mouseenter.fndtn.tab', '[' + this.attr_name() + '] > * > a', function (e) {
          var settings = S(this).closest('[' + self.attr_name() + ']').data(self.attr_name(true) + '-init');
          if (settings.is_hover) {
            self.toggle_active_tab(S(this).parent());
          }
        });

      // Location hash change event
      S(window).on('hashchange.fndtn.tab', function (e) {
        e.preventDefault();
        self.handle_location_hash_change();
      });
    },

    handle_location_hash_change : function () {

      var self = this,
          S = this.S;

      S('[' + this.attr_name() + ']', this.scope).each(function () {
        var settings = S(this).data(self.attr_name(true) + '-init');
        if (settings.deep_linking) {
          // Match the location hash to a label
          var hash;
          if (settings.scroll_to_content) {
            hash = self.scope.location.hash;
          } else {
            // prefix the hash to prevent anchor scrolling
            hash = self.scope.location.hash.replace('fndtn-', '');
          }
          if (hash != '') {
            // Check whether the location hash references a tab content div or
            // another element on the page (inside or outside the tab content div)
            var hash_element = S(hash);
            if (hash_element.hasClass('content') && hash_element.parent().hasClass('tabs-content')) {
              // Tab content div
              self.toggle_active_tab($('[' + self.attr_name() + '] > * > a[href=' + hash + ']').parent());
            } else {
              // Not the tab content div. If inside the tab content, find the
              // containing tab and toggle it as active.
              var hash_tab_container_id = hash_element.closest('.content').attr('id');
              if (hash_tab_container_id != undefined) {
                self.toggle_active_tab($('[' + self.attr_name() + '] > * > a[href=#' + hash_tab_container_id + ']').parent(), hash);
              }
            }
          } else {
            // Reference the default tab hashes which were initialized in the init function
            for (var ind = 0; ind < self.default_tab_hashes.length; ind++) {
              self.toggle_active_tab($('[' + self.attr_name() + '] > * > a[href=' + self.default_tab_hashes[ind] + ']').parent());
            }
          }
        }
       });
     },

    toggle_active_tab : function (tab, location_hash) {
      var self = this,
          S = self.S,
          tabs = tab.closest('[' + this.attr_name() + ']'),
          tab_link = tab.find('a'),
          anchor = tab.children('a').first(),
          target_hash = '#' + anchor.attr('href').split('#')[1],
          target = S(target_hash),
          siblings = tab.siblings(),
          settings = tabs.data(this.attr_name(true) + '-init'),
          interpret_keyup_action = function (e) {
            // Light modification of Heydon Pickering's Practical ARIA Examples: http://heydonworks.com/practical_aria_examples/js/a11y.js

            // define current, previous and next (possible) tabs

            var $original = $(this);
            var $prev = $(this).parents('li').prev().children('[role="tab"]');
            var $next = $(this).parents('li').next().children('[role="tab"]');
            var $target;

            // find the direction (prev or next)

            switch (e.keyCode) {
              case 37:
                $target = $prev;
                break;
              case 39:
                $target = $next;
                break;
              default:
                $target = false
                  break;
            }

            if ($target.length) {
              $original.attr({
                'tabindex' : '-1',
                'aria-selected' : null
              });
              $target.attr({
                'tabindex' : '0',
                'aria-selected' : true
              }).focus();
            }

            // Hide panels

            $('[role="tabpanel"]')
              .attr('aria-hidden', 'true');

            // Show panel which corresponds to target

            $('#' + $(document.activeElement).attr('href').substring(1))
              .attr('aria-hidden', null);

          },
          go_to_hash = function(hash) {
            // This function allows correct behaviour of the browser's back button when deep linking is enabled. Without it
            // the user would get continually redirected to the default hash.
            var default_hash = settings.scroll_to_content ? self.default_tab_hashes[0] : 'fndtn-' + self.default_tab_hashes[0].replace('#', '');

            if (hash !== default_hash || window.location.hash) {
              window.location.hash = hash;
            }
          };

      // allow usage of data-tab-content attribute instead of href
      if (anchor.data('tab-content')) {
        target_hash = '#' + anchor.data('tab-content').split('#')[1];
        target = S(target_hash);
      }

      if (settings.deep_linking) {

        if (settings.scroll_to_content) {

          // retain current hash to scroll to content
          go_to_hash(location_hash || target_hash);

          if (location_hash == undefined || location_hash == target_hash) {
            tab.parent()[0].scrollIntoView();
          } else {
            S(target_hash)[0].scrollIntoView();
          }
        } else {
          // prefix the hashes so that the browser doesn't scroll down
          if (location_hash != undefined) {
            go_to_hash('fndtn-' + location_hash.replace('#', ''));
          } else {
            go_to_hash('fndtn-' + target_hash.replace('#', ''));
          }
        }
      }

      // WARNING: The activation and deactivation of the tab content must
      // occur after the deep linking in order to properly refresh the browser
      // window (notably in Chrome).
      // Clean up multiple attr instances to done once
      tab.addClass(settings.active_class).triggerHandler('opened');
      tab_link.attr({'aria-selected' : 'true',  tabindex : 0});
      siblings.removeClass(settings.active_class)
      siblings.find('a').attr({'aria-selected' : 'false'/*,  tabindex : -1*/});
      target.siblings().removeClass(settings.active_class).attr({'aria-hidden' : 'true'/*,  tabindex : -1*/});
      target.addClass(settings.active_class).attr('aria-hidden', 'false').removeAttr('tabindex');
      settings.callback(tab);
      target.triggerHandler('toggled', [target]);
      tabs.triggerHandler('toggled', [tab]);

      tab_link.off('keydown').on('keydown', interpret_keyup_action );
    },

    data_attr : function (str) {
      if (this.namespace.length > 0) {
        return this.namespace + '-' + str;
      }

      return str;
    },

    off : function () {},

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.tooltip = {
    name : 'tooltip',

    version : '5.5.3',

    settings : {
      additional_inheritable_classes : [],
      tooltip_class : '.tooltip',
      append_to : 'body',
      touch_close_text : 'Tap To Close',
      disable_for_touch : false,
      hover_delay : 200,
      fade_in_duration : 150,
      fade_out_duration : 150,
      show_on : 'all',
      tip_template : function (selector, content) {
        return '<span data-selector="' + selector + '" id="' + selector + '" class="'
          + Foundation.libs.tooltip.settings.tooltip_class.substring(1)
          + '" role="tooltip">' + content + '<span class="nub"></span></span>';
      }
    },

    cache : {},

    init : function (scope, method, options) {
      Foundation.inherit(this, 'random_str');
      this.bindings(method, options);
    },

    should_show : function (target, tip) {
      var settings = $.extend({}, this.settings, this.data_options(target));

      if (settings.show_on === 'all') {
        return true;
      } else if (this.small() && settings.show_on === 'small') {
        return true;
      } else if (this.medium() && settings.show_on === 'medium') {
        return true;
      } else if (this.large() && settings.show_on === 'large') {
        return true;
      }
      return false;
    },

    medium : function () {
      return matchMedia(Foundation.media_queries['medium']).matches;
    },

    large : function () {
      return matchMedia(Foundation.media_queries['large']).matches;
    },

    events : function (instance) {
      var self = this,
          S = self.S;

      self.create(this.S(instance));

      function _startShow(elt, $this, immediate) {
        if (elt.timer) {
          return;
        }

        if (immediate) {
          elt.timer = null;
          self.showTip($this);
        } else {
          elt.timer = setTimeout(function () {
            elt.timer = null;
            self.showTip($this);
          }.bind(elt), self.settings.hover_delay);
        }
      }

      function _startHide(elt, $this) {
        if (elt.timer) {
          clearTimeout(elt.timer);
          elt.timer = null;
        }

        self.hide($this);
      }

      $(this.scope)
        .off('.tooltip')
        .on('mouseenter.fndtn.tooltip mouseleave.fndtn.tooltip touchstart.fndtn.tooltip MSPointerDown.fndtn.tooltip',
          '[' + this.attr_name() + ']', function (e) {
          var $this = S(this),
              settings = $.extend({}, self.settings, self.data_options($this)),
              is_touch = false;

          if (Modernizr.touch && /touchstart|MSPointerDown/i.test(e.type) && S(e.target).is('a')) {
            return false;
          }

          if (/mouse/i.test(e.type) && self.ie_touch(e)) {
            return false;
          }
          
          if ($this.hasClass('open')) {
            if (Modernizr.touch && /touchstart|MSPointerDown/i.test(e.type)) {
              e.preventDefault();
            }
            self.hide($this);
          } else {
            if (settings.disable_for_touch && Modernizr.touch && /touchstart|MSPointerDown/i.test(e.type)) {
              return;
            } else if (!settings.disable_for_touch && Modernizr.touch && /touchstart|MSPointerDown/i.test(e.type)) {
              e.preventDefault();
              S(settings.tooltip_class + '.open').hide();
              is_touch = true;
              // close other open tooltips on touch
              if ($('.open[' + self.attr_name() + ']').length > 0) {
               var prevOpen = S($('.open[' + self.attr_name() + ']')[0]);
               self.hide(prevOpen);
              }
            }

            if (/enter|over/i.test(e.type)) {
              _startShow(this, $this);

            } else if (e.type === 'mouseout' || e.type === 'mouseleave') {
              _startHide(this, $this);
            } else {
              _startShow(this, $this, true);
            }
          }
        })
        .on('mouseleave.fndtn.tooltip touchstart.fndtn.tooltip MSPointerDown.fndtn.tooltip', '[' + this.attr_name() + '].open', function (e) {
          if (/mouse/i.test(e.type) && self.ie_touch(e)) {
            return false;
          }

          if ($(this).data('tooltip-open-event-type') == 'touch' && e.type == 'mouseleave') {
            return;
          } else if ($(this).data('tooltip-open-event-type') == 'mouse' && /MSPointerDown|touchstart/i.test(e.type)) {
            self.convert_to_touch($(this));
          } else {
            _startHide(this, $(this));
          }
        })
        .on('DOMNodeRemoved DOMAttrModified', '[' + this.attr_name() + ']:not(a)', function (e) {
          _startHide(this, S(this));
        });
    },

    ie_touch : function (e) {
      // How do I distinguish between IE11 and Windows Phone 8?????
      return false;
    },

    showTip : function ($target) {
      var $tip = this.getTip($target);
      if (this.should_show($target, $tip)) {
        return this.show($target);
      }
      return;
    },

    getTip : function ($target) {
      var selector = this.selector($target),
          settings = $.extend({}, this.settings, this.data_options($target)),
          tip = null;

      if (selector) {
        tip = this.S('span[data-selector="' + selector + '"]' + settings.tooltip_class);
      }

      return (typeof tip === 'object') ? tip : false;
    },

    selector : function ($target) {
      var dataSelector = $target.attr(this.attr_name()) || $target.attr('data-selector');

      if (typeof dataSelector != 'string') {
        dataSelector = this.random_str(6);
        $target
          .attr('data-selector', dataSelector)
          .attr('aria-describedby', dataSelector);
      }

      return dataSelector;
    },

    create : function ($target) {
      var self = this,
          settings = $.extend({}, this.settings, this.data_options($target)),
          tip_template = this.settings.tip_template;

      if (typeof settings.tip_template === 'string' && window.hasOwnProperty(settings.tip_template)) {
        tip_template = window[settings.tip_template];
      }

      var $tip = $(tip_template(this.selector($target), $('<div></div>').html($target.attr('title')).html())),
          classes = this.inheritable_classes($target);

      $tip.addClass(classes).appendTo(settings.append_to);

      if (Modernizr.touch) {
        $tip.append('<span class="tap-to-close">' + settings.touch_close_text + '</span>');
        $tip.on('touchstart.fndtn.tooltip MSPointerDown.fndtn.tooltip', function (e) {
          self.hide($target);
        });
      }

      $target.removeAttr('title').attr('title', '');
    },

    reposition : function (target, tip, classes) {
      var width, nub, nubHeight, nubWidth, objPos;

      tip.css('visibility', 'hidden').show();

      width = target.data('width');
      nub = tip.children('.nub');
      nubHeight = nub.outerHeight();
      nubWidth = nub.outerWidth();

      if (this.small()) {
        tip.css({'width' : '100%'});
      } else {
        tip.css({'width' : (width) ? width : 'auto'});
      }

      objPos = function (obj, top, right, bottom, left, width) {
        return obj.css({
          'top' : (top) ? top : 'auto',
          'bottom' : (bottom) ? bottom : 'auto',
          'left' : (left) ? left : 'auto',
          'right' : (right) ? right : 'auto'
        }).end();
      };
      
      var o_top = target.offset().top;
      var o_left = target.offset().left;
      var outerHeight = target.outerHeight();

      objPos(tip, (o_top + outerHeight + 10), 'auto', 'auto', o_left);

      if (this.small()) {
        objPos(tip, (o_top + outerHeight + 10), 'auto', 'auto', 12.5, $(this.scope).width());
        tip.addClass('tip-override');
        objPos(nub, -nubHeight, 'auto', 'auto', o_left);
      } else {
        
        if (Foundation.rtl) {
          nub.addClass('rtl');
          o_left = o_left + target.outerWidth() - tip.outerWidth();
        }

        objPos(tip, (o_top + outerHeight + 10), 'auto', 'auto', o_left);
        // reset nub from small styles, if they've been applied
        if (nub.attr('style')) {
          nub.removeAttr('style');
        }
        
        tip.removeClass('tip-override');
        
        var tip_outerHeight = tip.outerHeight();
        
        if (classes && classes.indexOf('tip-top') > -1) {
          if (Foundation.rtl) {
            nub.addClass('rtl');
          }
          objPos(tip, (o_top - tip_outerHeight), 'auto', 'auto', o_left)
            .removeClass('tip-override');
        } else if (classes && classes.indexOf('tip-left') > -1) {
          objPos(tip, (o_top + (outerHeight / 2) - (tip_outerHeight / 2)), 'auto', 'auto', (o_left - tip.outerWidth() - nubHeight))
            .removeClass('tip-override');
          nub.removeClass('rtl');
        } else if (classes && classes.indexOf('tip-right') > -1) {
          objPos(tip, (o_top + (outerHeight / 2) - (tip_outerHeight / 2)), 'auto', 'auto', (o_left + target.outerWidth() + nubHeight))
            .removeClass('tip-override');
          nub.removeClass('rtl');
        }
      }

      tip.css('visibility', 'visible').hide();
    },

    small : function () {
      return matchMedia(Foundation.media_queries.small).matches &&
        !matchMedia(Foundation.media_queries.medium).matches;
    },

    inheritable_classes : function ($target) {
      var settings = $.extend({}, this.settings, this.data_options($target)),
          inheritables = ['tip-top', 'tip-left', 'tip-bottom', 'tip-right', 'radius', 'round'].concat(settings.additional_inheritable_classes),
          classes = $target.attr('class'),
          filtered = classes ? $.map(classes.split(' '), function (el, i) {
            if ($.inArray(el, inheritables) !== -1) {
              return el;
            }
          }).join(' ') : '';

      return $.trim(filtered);
    },

    convert_to_touch : function ($target) {
      var self = this,
          $tip = self.getTip($target),
          settings = $.extend({}, self.settings, self.data_options($target));

      if ($tip.find('.tap-to-close').length === 0) {
        $tip.append('<span class="tap-to-close">' + settings.touch_close_text + '</span>');
        $tip.on('click.fndtn.tooltip.tapclose touchstart.fndtn.tooltip.tapclose MSPointerDown.fndtn.tooltip.tapclose', function (e) {
          self.hide($target);
        });
      }

      $target.data('tooltip-open-event-type', 'touch');
    },

    show : function ($target) {
      var $tip = this.getTip($target);
      if ($target.data('tooltip-open-event-type') == 'touch') {
        this.convert_to_touch($target);
      }

      this.reposition($target, $tip, $target.attr('class'));
      $target.addClass('open');
      $tip.fadeIn(this.settings.fade_in_duration);
    },

    hide : function ($target) {
      var $tip = this.getTip($target);

      $tip.fadeOut(this.settings.fade_out_duration, function () {
        $tip.find('.tap-to-close').remove();
        $tip.off('click.fndtn.tooltip.tapclose MSPointerDown.fndtn.tapclose');
        $target.removeClass('open');
      });
    },

    off : function () {
      var self = this;
      this.S(this.scope).off('.fndtn.tooltip');
      this.S(this.settings.tooltip_class).each(function (i) {
        $('[' + self.attr_name() + ']').eq(i).attr('title', $(this).text());
      }).remove();
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.topbar = {
    name : 'topbar',

    version : '5.5.3',

    settings : {
      index : 0,
      start_offset : 0,
      sticky_class : 'sticky',
      custom_back_text : true,
      back_text : 'Back',
      mobile_show_parent_link : true,
      is_hover : true,
      scrolltop : true, // jump to top when sticky nav menu toggle is clicked
      sticky_on : 'all',
      dropdown_autoclose: true
    },

    init : function (section, method, options) {
      Foundation.inherit(this, 'add_custom_rule register_media throttle');
      var self = this;

      self.register_media('topbar', 'foundation-mq-topbar');

      this.bindings(method, options);

      self.S('[' + this.attr_name() + ']', this.scope).each(function () {
        var topbar = $(this),
            settings = topbar.data(self.attr_name(true) + '-init'),
            section = self.S('section, .top-bar-section', this);
        topbar.data('index', 0);
        var topbarContainer = topbar.parent();
        if (topbarContainer.hasClass('fixed') || self.is_sticky(topbar, topbarContainer, settings) ) {
          self.settings.sticky_class = settings.sticky_class;
          self.settings.sticky_topbar = topbar;
          topbar.data('height', topbarContainer.outerHeight());
          topbar.data('stickyoffset', topbarContainer.offset().top);
        } else {
          topbar.data('height', topbar.outerHeight());
        }

        if (!settings.assembled) {
          self.assemble(topbar);
        }

        if (settings.is_hover) {
          self.S('.has-dropdown', topbar).addClass('not-click');
        } else {
          self.S('.has-dropdown', topbar).removeClass('not-click');
        }

        // Pad body when sticky (scrolled) or fixed.
        self.add_custom_rule('.f-topbar-fixed { padding-top: ' + topbar.data('height') + 'px }');

        if (topbarContainer.hasClass('fixed')) {
          self.S('body').addClass('f-topbar-fixed');
        }
      });

    },

    is_sticky : function (topbar, topbarContainer, settings) {
      var sticky     = topbarContainer.hasClass(settings.sticky_class);
      var smallMatch = matchMedia(Foundation.media_queries.small).matches;
      var medMatch   = matchMedia(Foundation.media_queries.medium).matches;
      var lrgMatch   = matchMedia(Foundation.media_queries.large).matches;

      if (sticky && settings.sticky_on === 'all') {
        return true;
      }
      if (sticky && this.small() && settings.sticky_on.indexOf('small') !== -1) {
        if (smallMatch && !medMatch && !lrgMatch) { return true; }
      }
      if (sticky && this.medium() && settings.sticky_on.indexOf('medium') !== -1) {
        if (smallMatch && medMatch && !lrgMatch) { return true; }
      }
      if (sticky && this.large() && settings.sticky_on.indexOf('large') !== -1) {
        if (smallMatch && medMatch && lrgMatch) { return true; }
      }

       return false;
    },

    toggle : function (toggleEl) {
      var self = this,
          topbar;

      if (toggleEl) {
        topbar = self.S(toggleEl).closest('[' + this.attr_name() + ']');
      } else {
        topbar = self.S('[' + this.attr_name() + ']');
      }

      var settings = topbar.data(this.attr_name(true) + '-init');

      var section = self.S('section, .top-bar-section', topbar);

      if (self.breakpoint()) {
        if (!self.rtl) {
          section.css({left : '0%'});
          $('>.name', section).css({left : '100%'});
        } else {
          section.css({right : '0%'});
          $('>.name', section).css({right : '100%'});
        }

        self.S('li.moved', section).removeClass('moved');
        topbar.data('index', 0);

        topbar
          .toggleClass('expanded')
          .css('height', '');
      }

      if (settings.scrolltop) {
        if (!topbar.hasClass('expanded')) {
          if (topbar.hasClass('fixed')) {
            topbar.parent().addClass('fixed');
            topbar.removeClass('fixed');
            self.S('body').addClass('f-topbar-fixed');
          }
        } else if (topbar.parent().hasClass('fixed')) {
          if (settings.scrolltop) {
            topbar.parent().removeClass('fixed');
            topbar.addClass('fixed');
            self.S('body').removeClass('f-topbar-fixed');

            window.scrollTo(0, 0);
          } else {
            topbar.parent().removeClass('expanded');
          }
        }
      } else {
        if (self.is_sticky(topbar, topbar.parent(), settings)) {
          topbar.parent().addClass('fixed');
        }

        if (topbar.parent().hasClass('fixed')) {
          if (!topbar.hasClass('expanded')) {
            topbar.removeClass('fixed');
            topbar.parent().removeClass('expanded');
            self.update_sticky_positioning();
          } else {
            topbar.addClass('fixed');
            topbar.parent().addClass('expanded');
            self.S('body').addClass('f-topbar-fixed');
          }
        }
      }
    },

    timer : null,

    events : function (bar) {
      var self = this,
          S = this.S;

      S(this.scope)
        .off('.topbar')
        .on('click.fndtn.topbar', '[' + this.attr_name() + '] .toggle-topbar', function (e) {
          e.preventDefault();
          self.toggle(this);
        })
        .on('click.fndtn.topbar contextmenu.fndtn.topbar', '.top-bar .top-bar-section li a[href^="#"],[' + this.attr_name() + '] .top-bar-section li a[href^="#"]', function (e) {
          var li = $(this).closest('li'),
              topbar = li.closest('[' + self.attr_name() + ']'),
              settings = topbar.data(self.attr_name(true) + '-init');

          if (settings.dropdown_autoclose && settings.is_hover) {
            var hoverLi = $(this).closest('.hover');
            hoverLi.removeClass('hover');
          }
          if (self.breakpoint() && !li.hasClass('back') && !li.hasClass('has-dropdown')) {
            self.toggle();
          }

        })
        .on('click.fndtn.topbar', '[' + this.attr_name() + '] li.has-dropdown', function (e) {
          var li = S(this),
              target = S(e.target),
              topbar = li.closest('[' + self.attr_name() + ']'),
              settings = topbar.data(self.attr_name(true) + '-init');

          if (target.data('revealId')) {
            self.toggle();
            return;
          }

          if (self.breakpoint()) {
            return;
          }

          if (settings.is_hover && !Modernizr.touch) {
            return;
          }

          e.stopImmediatePropagation();

          if (li.hasClass('hover')) {
            li
              .removeClass('hover')
              .find('li')
              .removeClass('hover');

            li.parents('li.hover')
              .removeClass('hover');
          } else {
            li.addClass('hover');

            $(li).siblings().removeClass('hover');

            if (target[0].nodeName === 'A' && target.parent().hasClass('has-dropdown')) {
              e.preventDefault();
            }
          }
        })
        .on('click.fndtn.topbar', '[' + this.attr_name() + '] .has-dropdown>a', function (e) {
          if (self.breakpoint()) {

            e.preventDefault();

            var $this = S(this),
                topbar = $this.closest('[' + self.attr_name() + ']'),
                section = topbar.find('section, .top-bar-section'),
                dropdownHeight = $this.next('.dropdown').outerHeight(),
                $selectedLi = $this.closest('li');

            topbar.data('index', topbar.data('index') + 1);
            $selectedLi.addClass('moved');

            if (!self.rtl) {
              section.css({left : -(100 * topbar.data('index')) + '%'});
              section.find('>.name').css({left : 100 * topbar.data('index') + '%'});
            } else {
              section.css({right : -(100 * topbar.data('index')) + '%'});
              section.find('>.name').css({right : 100 * topbar.data('index') + '%'});
            }

            topbar.css('height', $this.siblings('ul').outerHeight(true) + topbar.data('height'));
          }
        });

      S(window).off('.topbar').on('resize.fndtn.topbar', self.throttle(function () {
          self.resize.call(self);
      }, 50)).trigger('resize.fndtn.topbar').load(function () {
          // Ensure that the offset is calculated after all of the pages resources have loaded
          S(this).trigger('resize.fndtn.topbar');
      });

      S('body').off('.topbar').on('click.fndtn.topbar', function (e) {
        var parent = S(e.target).closest('li').closest('li.hover');

        if (parent.length > 0) {
          return;
        }

        S('[' + self.attr_name() + '] li.hover').removeClass('hover');
      });

      // Go up a level on Click
      S(this.scope).on('click.fndtn.topbar', '[' + this.attr_name() + '] .has-dropdown .back', function (e) {
        e.preventDefault();

        var $this = S(this),
            topbar = $this.closest('[' + self.attr_name() + ']'),
            section = topbar.find('section, .top-bar-section'),
            settings = topbar.data(self.attr_name(true) + '-init'),
            $movedLi = $this.closest('li.moved'),
            $previousLevelUl = $movedLi.parent();

        topbar.data('index', topbar.data('index') - 1);

        if (!self.rtl) {
          section.css({left : -(100 * topbar.data('index')) + '%'});
          section.find('>.name').css({left : 100 * topbar.data('index') + '%'});
        } else {
          section.css({right : -(100 * topbar.data('index')) + '%'});
          section.find('>.name').css({right : 100 * topbar.data('index') + '%'});
        }

        if (topbar.data('index') === 0) {
          topbar.css('height', '');
        } else {
          topbar.css('height', $previousLevelUl.outerHeight(true) + topbar.data('height'));
        }

        setTimeout(function () {
          $movedLi.removeClass('moved');
        }, 300);
      });

      // Show dropdown menus when their items are focused
      S(this.scope).find('.dropdown a')
        .focus(function () {
          $(this).parents('.has-dropdown').addClass('hover');
        })
        .blur(function () {
          $(this).parents('.has-dropdown').removeClass('hover');
        });
    },

    resize : function () {
      var self = this;
      self.S('[' + this.attr_name() + ']').each(function () {
        var topbar = self.S(this),
            settings = topbar.data(self.attr_name(true) + '-init');

        var stickyContainer = topbar.parent('.' + self.settings.sticky_class);
        var stickyOffset;

        if (!self.breakpoint()) {
          var doToggle = topbar.hasClass('expanded');
          topbar
            .css('height', '')
            .removeClass('expanded')
            .find('li')
            .removeClass('hover');

            if (doToggle) {
              self.toggle(topbar);
            }
        }

        if (self.is_sticky(topbar, stickyContainer, settings)) {
          if (stickyContainer.hasClass('fixed')) {
            // Remove the fixed to allow for correct calculation of the offset.
            stickyContainer.removeClass('fixed');

            stickyOffset = stickyContainer.offset().top;
            if (self.S(document.body).hasClass('f-topbar-fixed')) {
              stickyOffset -= topbar.data('height');
            }

            topbar.data('stickyoffset', stickyOffset);
            stickyContainer.addClass('fixed');
          } else {
            stickyOffset = stickyContainer.offset().top;
            topbar.data('stickyoffset', stickyOffset);
          }
        }

      });
    },

    breakpoint : function () {
      return !matchMedia(Foundation.media_queries['topbar']).matches;
    },

    small : function () {
      return matchMedia(Foundation.media_queries['small']).matches;
    },

    medium : function () {
      return matchMedia(Foundation.media_queries['medium']).matches;
    },

    large : function () {
      return matchMedia(Foundation.media_queries['large']).matches;
    },

    assemble : function (topbar) {
      var self = this,
          settings = topbar.data(this.attr_name(true) + '-init'),
          section = self.S('section, .top-bar-section', topbar);

      // Pull element out of the DOM for manipulation
      section.detach();

      self.S('.has-dropdown>a', section).each(function () {
        var $link = self.S(this),
            $dropdown = $link.siblings('.dropdown'),
            url = $link.attr('href'),
            $titleLi;

        if (!$dropdown.find('.title.back').length) {

          if (settings.mobile_show_parent_link == true && url) {
            $titleLi = $('<li class="title back js-generated"><h5><a href="javascript:void(0)"></a></h5></li><li class="parent-link hide-for-medium-up"><a class="parent-link js-generated" href="' + url + '">' + $link.html() +'</a></li>');
          } else {
            $titleLi = $('<li class="title back js-generated"><h5><a href="javascript:void(0)"></a></h5>');
          }

          // Copy link to subnav
          if (settings.custom_back_text == true) {
            $('h5>a', $titleLi).html(settings.back_text);
          } else {
            $('h5>a', $titleLi).html('&laquo; ' + $link.html());
          }
          $dropdown.prepend($titleLi);
        }
      });

      // Put element back in the DOM
      section.appendTo(topbar);

      // check for sticky
      this.sticky();

      this.assembled(topbar);
    },

    assembled : function (topbar) {
      topbar.data(this.attr_name(true), $.extend({}, topbar.data(this.attr_name(true)), {assembled : true}));
    },

    height : function (ul) {
      var total = 0,
          self = this;

      $('> li', ul).each(function () {
        total += self.S(this).outerHeight(true);
      });

      return total;
    },

    sticky : function () {
      var self = this;

      this.S(window).on('scroll', function () {
        self.update_sticky_positioning();
      });
    },

    update_sticky_positioning : function () {
      var klass = '.' + this.settings.sticky_class,
          $window = this.S(window),
          self = this;

      if (self.settings.sticky_topbar && self.is_sticky(this.settings.sticky_topbar,this.settings.sticky_topbar.parent(), this.settings)) {
        var distance = this.settings.sticky_topbar.data('stickyoffset') + this.settings.start_offset;
        if (!self.S(klass).hasClass('expanded')) {
          if ($window.scrollTop() > (distance)) {
            if (!self.S(klass).hasClass('fixed')) {
              self.S(klass).addClass('fixed');
              self.S('body').addClass('f-topbar-fixed');
            }
          } else if ($window.scrollTop() <= distance) {
            if (self.S(klass).hasClass('fixed')) {
              self.S(klass).removeClass('fixed');
              self.S('body').removeClass('f-topbar-fixed');
            }
          }
        }
      }
    },

    off : function () {
      this.S(this.scope).off('.fndtn.topbar');
      this.S(window).off('.fndtn.topbar');
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.alert = {
    name : 'alert',

    version : '5.5.3',

    settings : {
      callback : function () {}
    },

    init : function (scope, method, options) {
      this.bindings(method, options);
    },

    events : function () {
      var self = this,
          S = this.S;

      $(this.scope).off('.alert').on('click.fndtn.alert', '[' + this.attr_name() + '] .close', function (e) {
        var alertBox = S(this).closest('[' + self.attr_name() + ']'),
            settings = alertBox.data(self.attr_name(true) + '-init') || self.settings;

        e.preventDefault();
        if (Modernizr.csstransitions) {
          alertBox.addClass('alert-close');
          alertBox.on('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
            S(this).trigger('close.fndtn.alert').remove();
            settings.callback();
          });
        } else {
          alertBox.fadeOut(300, function () {
            S(this).trigger('close.fndtn.alert').remove();
            settings.callback();
          });
        }
      });
    },

    reflow : function () {}
  };
}(jQuery, window, window.document));


/* general useful javascript */

$.fn.serializeObject = function()
{
    var a = this.serializeArray();
    return tidy_form_object(a);
};

(function( $ ) {
	$.fn.expandableInfo = function()
	{
		return this.each(function(){

			var children = $(this).children();

			for (var i = children.length - 1; i >= 0; i--)
			{
				var child_content = $.trim( children[i].textContent || children[i].innerText );
				if (child_content.length<1)
				{
					// Element has no content, remove it
					$(children[i]).remove();
				};
			};

			children = $(this).children();

			if (children.length>1)
			{
				var more_info_link = $('<a>')
					.text('Read more')
					.addClass('more_info')
					.attr('href', '#')
					.data('hidden', true)
					.click(function(e){
						e.preventDefault();
						// Get all the siblings except the first one, that one never hides
						var togglable_items = $(this).siblings().not( $(this).siblings()[0] );

						togglable_items.slideToggle();
						$(this).text(
							'Read ' +
							($(this).text() == 'Read more'
								? 'less' : 'more' )
						);
					}
				);

				children.not(children[0]).hide();
				$(this).append(more_info_link);
			}
		});
	}

	$('#filtered_tours').tourFilter();

	$('.expandable_info').expandableInfo();
});

function is_array(variable)
{
	return typeof(variable.pop) == 'function';
}

/**
 * Ensure that the top of the given element is visible, scroll to it if it isn't
 * @param  {dom element/jQuery selector} elem Element you wish to check
 */
function ensure_in_view(elem)
{
	if (elem)
	{
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;

		if ( elemTop <= docViewTop || elemTop >= docViewBottom )
		{
			$("html, body").animate({scrollTop: (elemTop-20)}, 500);
		}
	}
}

function tidy_form_object(old_object)
{
	// this function converts objects of the form {"a[b]": c, "a[]": d} into {a: {b: c, 0: d}}
	if (typeof(old_object) != 'object')
	{
		return old_object;
	}
	var	new_object = {},
		is_object = typeof(old_object) == 'object' && !is_array(old_object);
	$.each(old_object, function(old_id, old_value){
		if (!is_object) {
			old_id = old_value['name'];
			old_value = old_value['value'];
		}
		var	new_id = old_id,
			new_value = typeof(old_value)=='object' && !is_array(old_value) ? tidy_form_object(old_value) : old_value;
		if (old_id && old_id.match && old_id.match(/\[.*\]/))
		{
			var	old_id_split = old_id.split(/\]/),
				old_id_frags = old_id_split.shift().split(/\[/),
				old_id_name = old_id_frags[0];
			new_object[old_id_name] = new_object[old_id_name] || {};
			var	old_id_key = old_id_frags[1] || (function(obj){
					var i = 0;
					while(true){
						if (!obj.hasOwnProperty(i)) return i; else i++;
					}
				})(new_object[old_id_name]);
			new_object[old_id_name][old_id_key + old_id_split.join(']')] = new_value;
			new_object[old_id_name] = tidy_form_object(new_object[old_id_name]);
		}
		else if(old_id)
		{
			new_object[new_id] = new_value;
		}
	});
	return new_object;
}

function str_to_fn(str)
{
	var fn;
	eval('fn = (' + str + ');');
	return fn;
}

// namespace cookie functions
window.cookies = {
    create: function(name, value, days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			var expires = "; expires=" + date.toGMTString();
		} else var expires = "";
		document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
    },
    read: function(name){
		var nameEQ = escape(name) + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
		}
		return null;
    },
    erase: function(name) {
		window.cookies.create(name, "", -1);
    }
};

/* end general useful javascript */






// random cookie testing
function are_cookies_enabled()
{
    var cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled)
    {
        document.cookie="testcookie";
        cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
    }
    return (cookieEnabled);
}

$(function(){
	if (!are_cookies_enabled())
	{
		$('body').prepend(
			$('<div>').text('Warning! Your browser does not allow cookies. The site may not work as expected').addClass('warning')
		);
	}
});




// namespace initialisation
window.init = {
    // general page init function
    general: function()
    {
		$('.font_size_change a').unbind('click.general').bind('click.general', function(e){
			var	body = $('body'),
			el = $(this);
			body[( el.hasClass('larger') ? 'add' : 'remove') + 'Class']('larger_font');
			body[( el.hasClass('smaller') ? 'add' : 'remove') + 'Class']('smaller_font');
			el.siblings('a').removeClass('active');
			cookies.create('body_font_size', el.attr('class').replace(' active', ''));
			el.addClass('active');
		});
		var	body_font_size = cookies.read('body_font_size');
		if (body_font_size)
		{
			$('.font_size_change a').filter('.' + body_font_size).trigger('click');
		}
		else
		{
			cookies.create('body_font_size', 'normal');
		}

		init.main_navigation(); // this fn not ready
		init.search_form();
		init.tabs_area();
		init.tabs_area_unified();

		init.homepage();
		init.email_bulletin();

		init.general_binds();

		init.speaker();

		init.tour_info_page();
		init.pseudo_justify();

		init.booking_request_select_tour();

		init.booking_request_select_cabin();
		init.booking_request_passenger_details();

		init.booking_journey();

		init.postcode_lookup();

		init.request_booking_by_post();
		
		init.faq_index();

		$(document).foundation();
    },
	general_binds: function()
	{
		var	ns = '.general_binds';
		$('a[href]').filter(function(){return this.href.match('#');}).unbind('click'+ns).bind('click'+ns, function(e){
			var	hash_id = this.href.split('#').pop(),
				target = $('#' + hash_id),
				tabs = target.closest('.tabs_area');
			if (tabs.length)
			{
				var	links = tabs.find('.tab_links').first().find('a'),
					link = links.filter('[href="#'+ hash_id +'"]');
				links.removeClass('active');
				link.addClass('active');
				e.preventDefault();
				tabs.find('.tab_container').first().children('li').hide();
				target.show();
				if (target.hasClass('scroll'))
				{
					$('body,html').delay(150).animate({scrollTop: link.offset().top - 8}, 500);
				}
			}
		});

		$('header .links .request').unbind('click'+ns).bind('click'+ns, function(e){
			e.preventDefault();
			window.popup.fn.request_callback();
		});

        $('.request_btn').unbind('click'+ns).bind('click'+ns, function(e){
            e.preventDefault();
            window.popup.fn.request_callback();
        });

		$('.email_subscribe').unbind('click'+ns).bind('click'+ns, function(e){
			e.preventDefault();
			window.popup.fn.email_subscribe();
		});

		$('.email_subscribe_btn').unbind('click'+ns).bind('click'+ns, function(e){

			var submit = $(this),
				form = submit.closest('form');
			e.preventDefault();

			var	url =  '/async_call.php?action=email_subscribe2&stage=submit&is_popup=false',
				method = 'post';
			$.ajax({
				url: url,
				type: method,
				data: form.serializeObject(),
				success: function(data)
				{
					console.log(data.form.action);

					var html = '';
					if(!data.process.status && data.messages)
					{
						html += "<div class='err_dis_section'><div class='heading'><h1>Please check the following to continue:</h1></div>";
						$.each( data.messages, function( i, item ) {
							html += "<div class='subscribe_result'><p class='title'>" + data.messages[i].title + "</p></div>";
						});
						html += "</div>";
					}

					if(data.process.status)
					{
						$.each( data.messages, function( i, item ) {
							html += "<h3 style='color: #3a945b;'>" + data.messages[i].title + "</h3>";
							html += "<h4 style='color: #3a945b;'>" + data.messages[i].message + "</h4>";
						});
						html += "</div>";
						
						form[0].reset(); // Reset form after success
					}

					$(".temp_errors").html(html);

				},
				dataType: "json"//set to JSON
			});
			e.preventDefault();
		});

		if($('.media_video').length)
		{
			$('.media_video').find('img').addClass('three_sixty_launch');
			$('.media_video').append('<span class="play-icon"><i class="fa fa-play" aria-hidden="true"></i></span>');
		}

		$('.media_video').bind('click', function(e){
			$(this).find('.three_sixty_launch').click();
		});

		$('.three_sixty_launch').unbind('click'+ns).bind('click'+ns, function(e){
			e.preventDefault();
			var swf_file = $(this).data('swf-file');
			var file_type = $(this).data('file-type');

			if($(window).width() < 864)
			{
				var port_width = $(window).width();
				var video_height = port_width*(3/4);

				window.popup.colorbox({
					iframe: true,
					href: '/async_call.php?action=three_sixty&swf_file=' + swf_file + '&file_type=' + file_type,
					width: port_width,
					height: video_height,
					fixed: true
				});
			}
			else
			{
				window.popup.colorbox({
					iframe: true,
					href: '/async_call.php?action=three_sixty&swf_file=' + swf_file + '&file_type=' + file_type,
					width: '70%',
					height: '70%',
					fixed: true
				});
			}

			/* window.popup.colorbox({
				iframe: true,
				href: '/async_call.php?action=three_sixty&swf_file=' + swf_file + '&file_type=' + file_type,
				width: '70%',
				height: '70%'
			}); */
			return false;
		});

		$('.send_to_friend').unbind('click'+ns).bind('click'+ns, function(e){
			var tour_title = $(this).data( "tourTitle" );
			var tour_id = $(this).data( "tourId" );
			window.popup.fn.send_to_friend({tour_title:tour_title,tour_id:tour_id});
		});

		if ($(window).width() < 864) {
			$('.for_dp .panel_latest_brochure').remove();
		}
		else {
			$('.for_mb .panel_latest_brochure').remove();
		}

		$('#order_brochure, .order_brochure').unbind('click'+ns).bind('click'+ns, function(e){
			window.popup.fn.brochures_order_in_print( $(this).data() );
		});

		$('#brochure_form_type_post').change(function(e) {

			if ($('.selected_brochures li').length == 0)
			{
				window.popup.fn.alert('Sorry, there is no brochure selected. Please select the brochure.');
				$(this).prop('checked', false);
				return false;
			}

			if ( $(this).is(':checked') )
			{
				var selected = new Array();
				$( ".selected_brochures li" ).each(function() {
					selected.push({
						  brochure_id: $(this).data('selected-id'),
						  brochure_name:  $(this).text().slice(0,-1),
						  brochure_url: ""
					});
				});

				window.popup.fn.brochures_order_in_print( selected );
				$('#brochure_form_type_post').prop('checked', false);
			}
		});

		$( ".booking_request_call_back" ).bind( "submit", function( event ) {
			event.preventDefault();
			window.popup.load_form('request_booking_callback', {width: 'auto', height: 'auto', data: {
				basket_id: basket_id,
				request_type:'booking',
				stage: 'request_callback',
				read_only: false
			}});
		});
		$('.hidden_search').each(function(i, e){
			var	form_wrapper = $(this),
				form = form_wrapper.find('form'),
				link = $('a[href="#'+ form.prop('id') +'"]');
			form_wrapper.hide();
			link.unbind('click'+ns).bind('click'+ns, function(e){
				e.preventDefault();
				var	show = !$(this).hasClass('active');
				link[(show ? 'add' : 'remove') + 'Class']('active');
				form_wrapper['slide' + (show ? 'Down' : 'Up')]();
			});
		});

		if ($('div.vessel_video').find('a.embed').length) {
			$("div.vessel_video a.embed").oembed();
		}

	},
	tour_tab_links: function()
	{
		var tour_tab_links = $('ul.tour_tab_links');
		tour_tab_links.each(function(){
			// For each set of tabs, we want to keep track of
			// which tab is active and it's associated content
			var $active, $content, $links = $(this).find('a');

			try
			{
				window.history.replaceState(active_tab, active_tab, window.location.pathname+window.location.search);
			}
			catch(e)
			{
				location.hash = location.hash || '!'+active_tab;
			}

			// If the location.hash matches one of the links, use that as the active tab.
			// If no match is found, use the first link as the initial active tab.
			$active = $( $links.filter('[href="'+location.hash+'"]')[0] || $links.filter('[data-tab='+active_tab+']')[0] || $links[0] );
			$active.addClass('active');
			$content = $('#tab_'+$active.data('tab'));

			// Hide the remaining content
			$links.not($active).each(function () {
				var $link = $(this);
				var tcontent = $('#tab_'+$link.data('tab'));

				if (tcontent.length < 1)
				{
					$link.parent().hide();
				}
				tcontent.hide();
			});

			// Bind the click event handler
			$(this).on('click', 'a', function(e){

				if (window.history.pushState)
				{
					window.history.pushState($(this).data('tab'), $(this).data('tab'), $(this).attr('href')+window.location.search);
				}
				else
				{
					location.hash = '!'+$(this).data('tab');
				}
				switch_tab($(this));
				// Prevent the anchor's default click action
				e.preventDefault();
			});

			// Bind the 'More Infomation' link to switch tabs
			$('.main_content #more_info_our_view').on('click', null, function(e){

				// If data-tag is set switch that tab
				if($(this).data('tab'))
				{
					$('#a_tab_'+$(this).data('tab')).click();
					// Prevent the anchor's default click action
					e.preventDefault();

				}
			});

			function switch_tab (target)
			{
				if (!target)
				{
					target = $links.filter('[data-tab=overview]');
				};
				// Make the old tab inactive.
				$active.removeClass('active');
				$content.hide();

				// Update the variables with the new link and content
				$active = target;
				$content = $('#tab_'+$active.data('tab'));

				// Make the tab active.
				$active.addClass('active');
				$content.show();

				//$content.find('.ui-widget-mediaslide').mediaslide('refresh');

				// Check that the top of the chosen tab is in view and scroll the view to the top of it if it isn't.
				ensure_in_view($content[0], true);
			}

			window.onpopstate = function(e) {
				if (e.state)
				{
					switch_tab($('a[data-tab='+e.state+']'));
				}
			}

			$(window).hashchange(function(){
				var tab = location.hash.split('!')[1];
				if (tab)
				{
					switch_tab($('a[data-tab='+tab+']'));
				};
			});
		});
	},
	main_navigation: function()
	{
                $(".main-nav-menu #main_navigation ul li").click(function () {
                    if($(this).hasClass('active')){
                        $(this).removeClass('active');
                    }else{
                        $('.main-nav-menu #main_navigation ul li').removeClass('active');
                        $(this).addClass('active');
                    }
				});

                //init
		        $('.main-nav-menu #main_navigation .inc-mobile-nav > ul').hide();
        		$('.main-nav-menu ul ul').parent().addClass("has-arrow");
				//main-menus
                $('html').click(function() {
                    $('.main-nav-dropdown').hide();
                });
                $('#main-nav-toggle').click(function() {
                	$('#sub-nav-toggle').removeClass('active');
                    $('.sub-nav-menu ul').hide();
                    $('.main-nav-menu #main_navigation > ul').slideToggle();
                    $('.main-nav-menu #main_navigation .inc-mobile-nav > ul').slideToggle();
                    $('.main-nav-menu #main_navigation').css('max-height',$(window).innerHeight()-100);
                    $('.main-nav-menu ul li ul').addClass('main-nav-dropdown');
                    $('.main-nav-menu li:contains("|")').addClass('hide-for-medium-down');
                });
                $('#main-nav-toggle').on('click', function() {
                    this.classList.toggle('active');
                });
    	},
	faq_index: function()
	{
		//limiting the paragraphs
		(function(){
			var showChar = 250;
			var ellipsestext = "...";
			var minimized_elements = $('.faq_ans');

				minimized_elements.each(function() {
					var content = $(this).html();
					if(content.length > showChar) {

						var c = content.substr(0, showChar);
						var h = content;
						var html = '<div class="truncate-text" style="display:block">' + c + '<span class="moreellipses">' + ellipsestext + '&nbsp;&nbsp;<a href="" class="moreless more">Read more...</a></span></div> <div class="truncate-text" style="display:none">' + h + '<p><a href="" class="moreless less">Read less</a></p></div>';
						$(this).html(html);
					}
				});

				$(".moreless").click(function(){
					var thisEl = $(this);
					if(thisEl.hasClass("less")) {
						thisEl.closest('.truncate-text').prev('.truncate-text').toggle();
						thisEl.closest('.truncate-text').slideToggle();
					} else {
						thisEl.closest('.truncate-text').toggle();
						thisEl.closest('.truncate-text').next('.truncate-text').fadeToggle();
					}
					return false;
				});
		}());
	},
	pseudo_justify: function()
	{
		var areas = $('#main_navigation > ul'),
			ie = $('body > #ie');
		if (ie.length && ie.attr('class').match(/(ie6|ie7)/))
		{
			areas.each(function(i, e) {
				var area = $(e),
					items = area.children(),
					area_x = area.width(),
					items_sum_x = 0,
					item_margin = 0,
					space_x = 2;
				items.each(function(ii, ee){
					items_sum_x += parseFloat($(this).outerWidth());
				});
				var free_space = area_x - items_sum_x;
				item_margin = (free_space / (items.length - 1)) - space_x;
				items.not(':last-child').css({marginRight: Math.floor(item_margin)});
			});
			if (!window.justify_resize_bound)
			{
				$(window).resize(function(){
					window.init.pseudo_justify();
				});
				window.justify_resize_bound = true;
			}
		}
	},
	// general bindings for various purposes
	email_bulletin: function()
	{
		$('#subscriber_form').bind('submit',function(e) {
			e.preventDefault();
			var data = $(this).serializeObject();
			$.post('/async_call.php', data, function(data){
				$('#subscribe_result').html(data);
			});
		});


	},
	tour_info_page: function()
	{
		var pages = $('#tour_info');
		pages.each(function(i, e){
			var page = $(e);
			page.find('#printMe').click(function(e) {
				window.print();
				e.preventDefault();
			});
			page.find('.request_brochure').bind('click', function(e){
				window.popup.fn.brochures_order_in_print( $(this).data() );
			});

			page.find('.truncate').CWTdotdotdot({
				height: 250,
				read_more: false
			});

			var infos = page.find('.overview_info,.itinerary');
			infos.each(function(){
				var info = $(this);

				info.find('.read_more_less').CWTdotdotdot();

				var top_photos = info.find('#landing_page_top_photos');
				if (top_photos.hasClass('show_map'))
				{
					top_photos.find('.magnify').bind('click', function(){
						console.log($(this).parent().data('media-id'));
						top_map = $(this).parent();
						var href = top_map.data('href');
						var media_id = top_map.data('media-id');
						var media_width = top_map.data('width');
						var media_height = top_map.data('height');
						console.log('href:'+href+'; media_id:'+ media_id + '; media_width:'+ media_width + '; media_height:'+ media_height);

						if(media_width > $(document).width()) {
							media_width = $(document).width()-25;
						}
						href = '/thumb.php?source_type=media_gallery&source_info=' + media_id + '&action=R.' + media_width + '.X';
						window.popup.colorbox({href: href, photo: true, scrolling: false });
					});

					top_photos.find('li.map-big, li.map-small').bind('mouseover', function(){
						$(this).find('p.map-over').css('display', 'block');
					}).bind('mouseout', function(){
						$(this).find('p.map-over').css('display', 'none');
					});

					/*var top_map = top_photos.find('.map-big');
					var top_map_small = top_photos.find('.map-small');
					if (top_photos.hasClass('map_size_strange'))
					{
						top_photos.bind('custom_resize', function(){
							var map = top_photos.children('.map'),
								imgs = top_photos.children('.img'),
								container_width = Math.floor(info.width()),
								img_padding = parseInt(imgs.css('marginLeft')) + parseInt(imgs.css('marginRight')),
								free_width = container_width - map.width() - (imgs.length * img_padding),
								width_per_img = Math.floor(free_width / 2);
							do
							{
								imgs.css({width: width_per_img});
								width_per_img--;
								var img_heights = imgs.add(map).map(function(){return $(this).offset().top;});
							} while (Math.max.apply(null, img_heights) != Math.min.apply(null, img_heights) && width_per_img >= 0);
						}).trigger('custom_resize');
						$(window).resize(function(){
							top_photos.trigger('custom_resize');
						});
					}
					top_map.find('.magnify').bind('click', function(){
						var href = top_map.data('href');
						window.popup.colorbox({href: href});
					});
					top_map_small.find('.magnify').bind('click', function(){
						var href = top_map_small.data('href');
						window.popup.colorbox({href: href});
					});*/
				}
			});
			init.tour_tab_links();
		});
	},
	tabs_area_unified: function()
	{
		var tab_areas = $('.tabs_area_unified');
		tab_areas.each(function(i, e){
			var tab_area = $(e),
				links = $('<ul>').addClass('tabs_area_unified_links'),
				selected_test = ':first-child';
			tab_area.prev('.tabs_area_unified_links').remove();

			tab_area.children('li').each(function(ii, ee){
				var	tab = $(ee),
					title = tab.children('.title'),
					link = $('<li>');
				link.text(title.text()).bind('click', function(e){
					var link = $(this);
					links.children('.active').removeClass('active');
					link.addClass('active');
					tab_area.children().hide();
					tab.show();
				});
				links.append(link);
				title.hide();
			});
			links.insertBefore(tab_area);
			links.children(selected_test).first().trigger('click');
		});
	},
    // search forms are iterable modules, so init them on an each basis
    search_form: function()
    {
		var	search_forms = $('.search_form');
		search_forms.each(function(i, search_form){
			var	form = $(search_form),
				speed = 1,
				v_hide = {
					height: 'toggle',
					lineHeight: 'toggle',
					paddingTop: 'toggle',
					paddingBottom: 'toggle',
					marginTop: 'toggle',
					marginBottom: 'toggle'
				};
			form.addClass('advanced').find('a.advanced').unbind('click.advanced').bind('click.advanced', function(e){
				e.preventDefault();
				if ($(this).text().indexOf('Show') != -1)
				{
					$(this).text($(this).text().replace('Show', 'Hide'));
				}
				else
				{
					$(this).text($(this).text().replace('Hide', 'Show'));
				}
				var	advanced = !form.hasClass('advanced');
				form[(advanced ? 'add' : 'remove') + 'Class']('advanced');
				form.find('li.advanced').not('.changed').css({opacity: advanced ? 0 : 1}).stop().animate($.extend({opacity: advanced ? 1 : 0}, v_hide), speed);
			}).trigger('click');

			form.submit(function( event ) {
				var tourtype = $(this).find('#product_sub_type_code').val();
				var regionname = $(this).find('#region_id').val();
 				dataLayer.push(
					{ 'event' : 'SearchBox', 'eventCategory' : 'Search box', 'eventAction' : tourtype, 'eventLabel': regionname }
				);
			});

		});
        $('.side_bar .search_form .toggle_search').click(function() {
        	$(this).toggleClass('active');
            $('.questions').slideToggle('fast');
   		 });
    },
    // for each .tabs_area, find the ul's inside that relate to the links and the containers and animate them
    tabs_area: function()
    {
		var	tabs_areas = $('.tabs_area');
		tabs_areas.each(function(i, tabs_area){
			var	area = $(tabs_area),
				links = area.find('ul.tab_links'),
				container = area.find('ul.tab_container');
			links.find('a').each(function(i, link){
				$(link).unbind('click.tabs_area').bind('click.tabs_area', function(e){
					e.preventDefault();
					var	areas = $(this).parents('.tabs_area'),
						area = areas.first(),
						level = areas.length,
						links = area.find('ul.tab_links').first(),
						container = area.find('ul.tab_container').first();
					links.find('a.active').filter(function(){return $(this).parents('.tabs_area').length == level;}).removeClass('active');
					$(this).addClass('active');
					container.children('li').hide();
					$('#' + this.href.split('#').pop()).show();
				});
			});
			if (window.location.hash && $(window.location.hash).closest('.tabs_area') == area) {
				links.find('a[href=' + window.location.hash.replace('#','') + ']').addClass('active');
			}
			if (links.find('a.active').length == 0) {
				links.find('a').first().addClass('active');
			}
			container.children('li').hide();
			links.find('a.active').trigger('click');
		});
    },
	homepage: function()
	{
		if (window.location.pathname == '/')
		{
			if(window.location.hash)
			{
				setTimeout(function() {
					window.scrollTo(0, 0);
				}, 1);
				var	hash_id = window.location.hash.split('#').pop(),
					target = $('#' + hash_id),
					link = $('.tabs_area .tab_links a[href^="#'+ hash_id +'"]');
				link.click();
				window.scrolling = true;
				$('body,html').scrollTop(0).delay(150).animate({scrollTop: link.offset().top - 8}, 750, function(){
					window.scrolling = false;
				}).scroll(function(e){
					if (window.scrolling)
					{
						e.preventDefault();
					}
				});
			}
		}
	},
	speaker: function()
	{
		if ($('div.speaker_video').find('a.embed').length) {
			$("div.speaker_video a.embed").oembed();
		}
	},

	booking_request_select_tour: function()
	{
		$('form#booking_search').submit(function() {
			//$(this).closest('.search_form').addClass('filter_panel');
			$('.form_select_tour').show();
			$('.disply_results').html('<img src="/images/ajax/ajax-loader.gif"/>');
			var data = $.extend({
				action: 'booking_search',
				read_only: false
			}, $(this).serializeObject());
			$.get('/async_call.php', data, function(result){
				$('.disply_results').html(result);
				$('.booking_select').bind( "click", function(e) {
					var cruise_package_id = $(this).data("selected-tour");
					$('#booking_select_tour').append('<input type="hidden" name="cruise_package_id" value="'+cruise_package_id+'" id="result_{$package.cruise_package_id}">');
				});
			});
			return false;
		});

		if ($('div.video_introduction').find('a.embed').length) {
			$("div.video_introduction a.embed").oembed();
		}
	},
	booking_request_select_cabin: function()
	{
		$('#category_selection_form_select, #booking_cabin_select').submit(function( event ) {
			var discount_reference = $('#discount_reference_date_select').val();
			$(this).find('#discount_reference').val(discount_reference);
		});
	},
	booking_request_passenger_details: function()
	{
		$('.referred_from').hide();
		var change_referred_from = function(select)
		{
			if ( select.val() == 'Other' )
			{
				$('.referred_from').show();
				var value = $(this).val();
			}
			else
			{
				$('.referred_from').hide();
			}
		}
		$('.preset_referred_from').change(function(){ change_referred_from($(this)); });
		change_referred_from($('.preset_referred_from'));
	},
	booking_journey: function()
	{
		$( ".date_of_issue" ).datepicker({
			maxDate:0,
			dateFormat:'dd/mm/yy'
		});
		$( ".date_of_expiry" ).datepicker({
			minDate: 1,
			dateFormat:'dd/mm/yy'
		});
	},
	postcode_lookup: function()
	{
		$( '.postcode_lookup_trigger' ).bind( 'click', function() {

			var form = $( this ).closest( "form" );
			var postcode = form.find('.postcode').val();

			$.post(
				"/async_call.php",
				{action:'get_address_list',lookup_postcode:postcode},
				function(data, textStatus)
				{
					 $('.postcode_address_list_container').html( data );
					 $('.postcode_address_list_container').show();

					$('.postcode_address_list').on( "change",function(){

						$('.postcode_address_list_container').hide();

						var selected = $(this).val();
						$.post(
							"/async_call.php",
							{action:'get_address',address:selected},
							function(data, textStatus)
							{
								form.find('[name=address1]').val(data.line1);
								form.find('[name=address2]').val(data.line2);
								form.find('[name=address3]').val(data.line3);
								form.find('[name=address4]').val(data.line4);
								form.find('[name=city]').val(data.post_town);
								form.find('[name=county]').val(data.county);
								form.find('[name=organisation_name]').val(data.organisation_name);
								form.find('[name=post_town]').val(data.post_town);
								form.find('[name=country]').val('GB');
							},
							"json"
						);
					});
				}
			);
		});

		// Postcode lookup for dynamic passengers
		$( '.postcode_lookup_trigger_pax' ).bind( 'click', function() {

			var pax_div = $( this ).closest( ".pax_address" );
			var pax_div_number = pax_div.attr('name');
			var postcode = pax_div.find('.postcode').val();

			$.post(
				"/async_call.php",
				{action:'get_address_list',lookup_postcode:postcode,pax_number:pax_div_number},
				function(data, textStatus)
				{
					$('.postcode_address_list_container' + pax_div_number).html( data );
					$('.postcode_address_list_container' + pax_div_number).show();

					$('.postcode_address_list' + pax_div_number).on( "change",function(){

						$('.postcode_address_list_container' + pax_div_number).hide();

						var selected = $(this).val();
						$.post(
							"/async_call.php",
							{action:'get_address',address:selected},
							function(data, textStatus)
							{
								pax_div.find('.pax_addr_' + pax_div_number + '_address1').val(data.line1);
								pax_div.find('.pax_addr_' + pax_div_number + '_address2').val(data.line2);
								pax_div.find('.pax_addr_' + pax_div_number + '_address3').val(data.line3);

								pax_div.find('.pax_addr_' + pax_div_number + '_city').val(data.post_town);
								pax_div.find('.pax_addr_' + pax_div_number + '_county').val(data.county);
								pax_div.find('.pax_addr_' + pax_div_number + '_country').val('GB');
							},
							"json"
						);
					});
				}
			);
		});
	},
	request_booking_by_post: function()
	{
		$( '#request_booking_form_post' ).submit(function( event )
		{
			var town = $(this).find('input[name=city]').val();
			var country = $(this).find('input[name=country]').val();

			dataLayer.push({
				'event' : 'FormByPost',
				'eventCategory' : 'Booking Form by Post',
				'eventAction' : 'Eqnuired',
				'eventLabel': town+'_'+country
				});

			//return false;
		});
	}
};

// namespace popup functions
window.popup = {
	defaults: {
		maxWidth: 900,
		maxHeight: 1200,
		minWidth: 200,
		minHeight: 200,
		fixed: false,
		close: '&times;',
		title: false
	},
	colorbox: function(opts)
	{
		// wrapper for the colorbox
		allopts = $.extend({}, popup.defaults, opts);
		return $.colorbox( allopts );
	},
	prepare_forms: function(scope)
	{
		scope.find('form').each(function(i, f){
			var	form = $(f);
			form.submit(function(e){
				var	url = form.attr('action') || '/async_call.php?action='+ action +'&stage=submit',
					method = form.attr('method') || 'post';
				e.preventDefault();
				$.ajax({
					url: url,
					type: method,
					data: form.serializeObject(),
					success: function(data)
					{
						window.popup.colorbox({html: data});
						window.popup.prepare_forms($('#cboxContent'));
                        if($(window).width() < 864) {
                            var port_width = $(window).width() - 30;
                            $('#cboxLoadedContent,#cboxContent').css('width',port_width);
                            $('#cboxContent').css('background','none');
                            $('#cboxClose').css('left',port_width-70);
                        }
					}
				});
			});
		});
	},
	// if you create a form as html output from an async_call, you can automatically make it ajaxify submit to its own colorbox with this function
	load_form: function(action, opts)
	{
		if (typeof(opts)!='object') opts = {};
		window.popup.colorbox(
			$.extend(opts,
			{
				href: '/async_call.php?action=' + action + '&' + $.param( opts ),
				type: 'get',
				data: opts,
				onComplete: function()
				{
					var cbox = $('#colorbox'),
					content = cbox.find('#cboxLoadedContent');
					popup.prepare_forms(content);
					if(typeof(opts.onComplete) == 'function' && !opts.completeOnce)
					{
						opts.completeOnce = true;
					}
				}
			})
		);
	},
	fn: {
		// each property of window.popup.fn (global window.popup.fn) calls a single lightbox
		request_callback: function(data)
		{
			window.popup.load_form('request_callback',{width: 'auto', height: 'auto', data: false});
		},
		email_subscribe: function(data)
		{
            if($(window).width() < 864) {
                var port_width = $(window).width() - 15;
                window.popup.load_form('email_subscribe',{width: port_width, height: 'auto', data: false});
            }else{
                window.popup.load_form('email_subscribe',{width: 'auto', height: 'auto', data: false});
			}
		},
		request_brochures: function(event)
		{
			var submit = $(this),
			form = submit.closest('form');
			if(form.find("#opt_out").is(":checked"))
			{
				dataLayer.push({
					'event' : 'Email_signup',
					'eventCategory' : 'Email signup',
					'eventAction' : 'Completed'
				});
			}

			if(form.find("#opt_out_post").is(":checked"))
			{
				dataLayer.push({
					'event' : 'FormByPost',
					'eventCategory' : 'Booking Form by Post',
					'eventAction' : 'Eqnuired'
					// , 'eventLabel': town+'_'+country
				});
			}
			event.preventDefault();

			var request_type = submit.find( "#request_type" ).val();
			window.popup.colorbox({
				href: '/async_call.php?' + form.serialize() + '&request_type=' + request_type
			});
		},
		send_to_friend: function(data)
		{
			window.popup.load_form('send_to_friend', {width: 300, height: 'auto', data: data});
		},
		brochures_order_in_print: function(data)
		{
			var pop_width = 500;
			if($(document).width() < 500) {
				pop_width = $(document).width()-15;
			}
			window.popup.load_form('brochures_order_in_print', {width: pop_width, height: false, data: data});
		},
		alert: function(html)
		{
			window.popup.colorbox({html:'<div class="styled_alert">' + html + '</div>'});
		}
	}
};

$(function(){
	init.general();
});

jQuery(document).ready(function() {

	$('.text.truncate').each(function ()
	{
		var next_element = 0;
		if($(this).text().length != 0)
		{
			if ($('.full_text_data').eq(next_element).text().trim().length == $(this).text().trim().length)
			{
				$(this).parent().find('.grid_result_link').last().hide();
			}
			++next_element;
		}
	});
});

window.onresize = function(event) {
    resizeDiv();
    $('.main-nav-menu #main_navigation').css('max-height',$(window).innerHeight()-100);
}

jQuery(document).ready(function() {
	$('.mobile_general_search,.phone_number').hide();

    $('.searchbox-icon').click(function() {
        $('.phone_number').hide();
        $('.mobile_general_search').slideToggle();
    });

    $('.phone_icon').click(function() {
        $('.mobile_general_search').hide();
        $('.phone_number').slideToggle();
    });

    $(".homepage-accord li >a").click(function(event) {
        var offset = $(this).offset();
		if ($(".homepage-accord li").hasClass("active")){
            var actcontentheight = $(".homepage-accord li.active .content").innerHeight();
            var contentheight = actcontentheight + 60;
            offset.top -= contentheight;
        }
        else {
            offset.top -= 60;
		}
        $('html, body').animate({
            scrollTop: offset.top
        });
    });

    //collapsing the tour ports
    $(".collapsable_tour_ports, .res_itenary_collapsable_btn").click(function () {
    	this.classList.toggle('active');
        $header = $(this);
        $content = $header.next();
        $content.slideToggle(500, function () {});
    });

	//collapsing the river grid
	$(".view_rivers").click(function () {
		this.classList.toggle('active');
		if ($(this).hasClass("active")){
			$(this).text("Hide all rivers");
			$(".rivers_hide").css('display','block');
		}
		else {
			$(this).text("View all rivers");
			$(".rivers_hide").css('display','none');
		}
		$header = $(this);
		$content = $header.next();
		$content.slideToggle(500, function () {});
	});

	//Truncating the description of search results grid.
	var showChar = 120;
	var ellipsestext = "...";
	var minimized_elements = $('div.tour_left div.description');

	minimized_elements.each(function() {
		var content = $(this).text();
		if(content.length > showChar) {

			var c = content.substr(0, showChar);
			var h = content;
			var html = '<div class="truncate-text" style="display:block"><p>' + c + '<span class="moreellipses">' + ellipsestext + '</span></p></div>';
			$(this).html(html);
		}
	});

    //collapsing the years
    $(".departure_date_links li span").click(function () {
        this.classList.toggle('active');
        if ($(this).hasClass("active")){
        	$(this).parent().css('display','block');
         }
        else {
            $(this).parent().css('display','inline-block');
         }
        $header = $(this);
        $content = $header.next();
        $content.slideToggle(500, function () {});
    });

	//Removing the side panel search form for Vessel & destination pages
	$('#vessel section div.panel_search_form li.submit_first').remove();
	$('#destinations section div.panel_search_form li.submit_first').remove();
	$('#destinations_sub section div.panel_search_form li.submit_first').remove();

    //limiting the paragraphs
    (function(){
        var showChar = 225;
        var ellipsestext = "...";
        var minimized_elements = $('.limiting_text');
        var imgLength = 0;

        if($(window).width() < 864){
            minimized_elements.each(function() {
                if($('.limiting_text').children().first().find('img,a,iframe')[0]){
                    imgLength = $('.limiting_text').children().first().find('img,a,iframe')[0].outerHTML.length;
                    showChar = 150 + imgLength;
				}else{
                    imgLength = 0;
				}

                var content = $(this).html();
                if(content.length > showChar) {
                    var c = content.substr(0, showChar);
                    var h = content;
                    var html = '<div class="truncate-text" style="display:block">' + c + '<span class="moreellipses">' + ellipsestext + '&nbsp;&nbsp;<a href="" class="moreless more">Read More</a></span></span></div><div class="truncate-text" style="display:none">' + h + '<a href="" class="moreless less">Read Less</a></span></div>';
                    $(this).html(html);
                }
            });

            $(".moreless").click(function(){
                var thisEl = $(this);
                if(thisEl.hasClass("less")) {
                    thisEl.closest('.truncate-text').prev('.truncate-text').toggle();
                    thisEl.closest('.truncate-text').slideToggle();
                } else {
                    thisEl.closest('.truncate-text').toggle();
                    thisEl.closest('.truncate-text').next('.truncate-text').fadeToggle();
                }
                return false;
            });
        }
    }());

    $('#scroll_top_inTour').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });

    if($(window).width() < 864){
        var video_ele = $('.limiting_text').children().first().find('a')[0];
        $('.res_charitableTrust_video').html(video_ele);
    }

});

//ZoomIn and ZoomOut of Deckplan Images
function hammerIt(elm) {
    hammertime = new Hammer(elm, {});
    hammertime.get('pinch').set({
        enable: true
    });
    var posX = 0,
        posY = 0,
        scale = 1,
        last_scale = 1,
        last_posX = 0,
        last_posY = 0,
        max_pos_x = 0,
        max_pos_y = 0,
        transform = "",
        el = elm;

    hammertime.on('doubletap pan pinch panend pinchend', function(ev) {
        if (ev.type == "doubletap") {
            transform =
                "translate3d(0, 0, 0) " +
                "scale3d(2, 2, 1) ";
            scale = 2;
            last_scale = 2;
            try {
                if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                    transform =
                        "translate3d(0, 0, 0) " +
                        "scale3d(1, 1, 1) ";
                    scale = 1;
                    last_scale = 1;
                }
            } catch (err) {}
            el.style.webkitTransform = transform;
            transform = "";
        }

        //pan
        if (scale != 1) {
            posX = last_posX + ev.deltaX;
            posY = last_posY + ev.deltaY;
            max_pos_x = Math.ceil((scale - 1) * el.clientWidth / 2);
            max_pos_y = Math.ceil((scale - 1) * el.clientHeight / 2);
            if (posX > max_pos_x) {
                posX = max_pos_x;
            }
            if (posX < -max_pos_x) {
                posX = -max_pos_x;
            }
            if (posY > max_pos_y) {
                posY = max_pos_y;
            }
            if (posY < -max_pos_y) {
                posY = -max_pos_y;
            }
        }

        //pinch
        if (ev.type == "pinch") {
            scale = Math.max(.999, Math.min(last_scale * (ev.scale), 4));
        }
        if(ev.type == "pinchend"){last_scale = scale;}

        //panend
        if(ev.type == "panend"){
            last_posX = posX < max_pos_x ? posX : max_pos_x;
            last_posY = posY < max_pos_y ? posY : max_pos_y;
        }

        if (scale != 1) {
            transform =
                "translate3d(" + posX + "px," + posY + "px, 0) " +
                "scale3d(" + scale + ", " + scale + ", 1)";
        }

        if (transform) {
            el.style.webkitTransform = transform;
        }
    });
}

document.addEventListener("DOMContentLoaded", function(event) {
    var myElement = document.querySelector('.styled_lists p img');
    if(myElement != null && myElement != undefined && myElement != ""){
        hammerIt(myElement);
    }
});




$(function(){
	var initGallery = function() {
		$('.slides:visible').each(function(){
			var slides = $(this);
			slides.anythingSlider({
				// *********** Appearance ***********
				// Theme name; choose from: minimalist-round, minimalist-square,
				// metallic, construction, cs-portfolio
				theme: 'default',
				// Set mode to "horizontal", "vertical" or "fade"
				// (only first letter needed); replaces vertical option
				mode: 'horizontal',
				// If true, the entire slider will expand to fit the parent element
				expand: true,
				// If true, solitary images/objects in the panel will expand to
				// fit the viewport
				resizeContents: true,
				// Set this value to a number and it will show that many slides at once
				showMultiple: false,
				// Anything other than "linear" or "swing" requires the easing plugin
				easing: "swing",

				// If true, builds the forwards and backwards buttons
				buildArrows: true,
				// If true, builds a list of anchor links to link to each panel
				buildNavigation: true,
				// If true, builds the start/stop button
				buildStartStop: false,

				// Append forward arrow to a HTML element
				// (jQuery Object, selector or HTMLNode), if not null
				appendFowardTo: null,
				// Append back arrow to a HTML element
				// (jQuery Object, selector or HTMLNode), if not null
				appendBackTo: null,
				// Append controls (navigation + start-stop) to a HTML element
				// (jQuery Object, selector or HTMLNode), if not null
				appendControlsTo: null,
				// Append navigation buttons to a HTML element
				// (jQuery Object, selector or HTMLNode), if not null
				appendNavigationTo: null,
				// Append start-stop button to a HTML element
				// (jQuery Object, selector or HTMLNode), if not null
				appendStartStopTo: null,

				// If true, side navigation arrows will slide out on
				// hovering & hide @ other times
				toggleArrows: false,
				// if true, slide in controls (navigation + play/stop button)
				// on hover and slide change, hide @ other times
				toggleControls: false,

				// Start button text
				startText: "Start",
				// Stop button text
				stopText: "Stop",
				// Link text used to move the slider forward
				// (hidden by CSS, replaced with arrow image)
				forwardText: "&raquo;",
				// Link text used to move the slider back
				// (hidden by CSS, replace with arrow image)
				backText: "&laquo;",
				// Class added to navigation & start/stop button
				// (text copied to title if it is hidden by a negative text indent)
				tooltipClass: 'tooltip',

				// if false, arrows will be visible, but not clickable.
				enableArrows: true,
				// if false, navigation links will still be visible, but not clickable.
				enableNavigation: true,
				// if false, the play/stop button will still be visible, but not
				// clickable. Previously "enablePlay"
				enableStartStop: true,
				// if false, keyboard arrow keys will not work for this slider.
				enableKeyboard: true,

				// *********** Navigation ***********
				// This sets the initial panel
				startPanel: 1,
				// Amount to go forward or back when changing panels.
				changeBy: 1,
				// Should links change the hashtag in the URL?
				hashTags: false,
				// if false, the slider will not wrap
				infiniteSlides: true,
				// Details at the top of the file on this use (advanced use)
				navigationFormatter: function(i, panel) {
					// This is the default format (show just the panel index number)
					var thumbnail_src = $(panel).data('src');
					var media_src = $(panel).data('media');
					if(media_src=='video')
					{
						return '<img width="89" height="62" src="'+thumbnail_src+'"><span class="play-icon"><i class="fa fa-play" aria-hidden="true"></i></span>';
					}
					else
					{
						return '<img width="89" height="62" src="'+thumbnail_src+'">';
					}

				},
				// Set this to the maximum number of visible navigation tabs;
				// false to disable
				navigationSize: 7,

				// *********** Slideshow options ***********
				// If true, the slideshow will start running; replaces "startStopped" option
				autoPlay: false,
				// If true, user changing slides will not stop the slideshow
				autoPlayLocked: false,
				// If true, starting a slideshow will delay advancing slides; if false, the slider will immediately advance to the next slide when slideshow starts
				autoPlayDelayed: false,
				// If true & the slideshow is active, the slideshow will pause on hover
				pauseOnHover: true,
				// If true & the slideshow is active, the  slideshow will stop on the last page. This also stops the rewind effect  when infiniteSlides is false.
				stopAtEnd: false,
				// If true, the slideshow will move right-to-left
				playRtl: false,

				// *********** Times ***********
				// How long between slideshow transitions in AutoPlay mode (in milliseconds)
				delay: 3000,
				// Resume slideshow after user interaction, only if autoplayLocked is true (in milliseconds).
				resumeDelay: 15000,
				// How long the slideshow transition takes (in milliseconds)
				animationTime: 600,
				// How long to pause slide animation before going to the desired slide (used if you want your "out" FX to show).
				delayBeforeAnimate  : 0,

				// *********** Callbacks ***********
				// Callback before the plugin initializes
				onBeforeInitialize: function(e, slider) {},
				// Callback when the plugin finished initializing
				onInitialized: function(e, slider) {},
				// Callback on slideshow start
				onShowStart: function(e, slider) {},
				// Callback after slideshow stops
				onShowStop: function(e, slider) {},
				// Callback when slideshow pauses
				onShowPause: function(e, slider) {},
				// Callback when slideshow unpauses - may not trigger
				// properly if user clicks on any controls
				onShowUnpause: function(e, slider) {},
				// Callback when slide initiates, before control animation
				onSlideInit: function(e, slider) {},
				// Callback before slide animates
				onSlideBegin: function(e, slider) {},
				// Callback when slide completes - no event variable!
				onSlideComplete: function(slider) {},

				// *********** Interactivity ***********
				// Event used to activate forward arrow functionality
				// (e.g. add jQuery mobile's "swiperight")
				clickForwardArrow: "click",
				// Event used to activate back arrow functionality
				// (e.g. add jQuery mobile's "swipeleft")
				clickBackArrow: "click",
				// Events used to activate navigation control functionality
				clickControls: "click focusin",
				// Event used to activate slideshow play/stop button
				clickSlideshow: "click",

				// *********** Video ***********
				// If true & the slideshow is active & a youtube video
				// is playing, it will pause the autoplay until the video
				// is complete
				resumeOnVideoEnd: true,
				// If true the video will resume playing (if previously
				// paused, except for YouTube iframe - known issue);
				// if false, the video remains paused.
				resumeOnVisible: true,
				// If your slider has an embedded object, the script will
				// automatically add a wmode parameter with this setting
				addWmodeToObject: "transparent",
				// return true if video is playing or false if not - used
				// by video extension
				isVideoPlaying: function(base) {
					return false;
				}
			});

			if ( slides.data( "slide-count") > 1 )
			{
				/*$( ".anythingSlider" ).hover(function() {
					$('.anythingControls').fadeIn( "slow" );
					$('.arrow').fadeIn("slow");
				}, function() {
					$('.anythingControls').fadeOut( "slow" );
					$('.arrow').fadeOut( "slow" );
				});*/
			}
		});

		$('.anythingControls').hide();
		//$('.arrow').hide();
	};
	
	if( typeof active_tab !== 'undefined' )
	{
		// When the page loads, initialise any currently visible sliders. But only if tabs exist!
		$('.active[data-tab]').data('slides-initialised', true);
		setTimeout(initGallery, 50);
	}
	else
	{
		setTimeout(initGallery, 50);
	}
	
	$('[data-tab]').on('click', function() {
		// Only initialise a slider if it hasn't been initialised before.
		if( !$(this).data('slides-initialised') )
		{
			$(this).data('slides-initialised', true);
			setTimeout(initGallery, 50);
		}
	});
});

$(document).ready(function(){
    resizeDiv();
});

function resizeDiv() {
    var imageHeight = $(".slide_image img").innerHeight();
    $(".slides li, .slider li, .anythingWindow, .anythingSlider").css('min-height',imageHeight);
     if ( $(window).width() < 641) {
		var carouselImgHeight = $('.slidesjs-slide img').innerHeight();
		$('.slidesjs-container').css({
			 'height': carouselImgHeight,
             'min-height': carouselImgHeight
		 });
	 }
}
jQuery(function($){

	$('body').on('click', 'a.add_shortlist', function(e){
		e.preventDefault();

		
		var tour_title =  $(this).closest('.voyage_or_tour').find('.tour_left h4 a').text();
			
		var add_link = $(this);
		$.ajax({
			url: add_link.attr('href')+'&js=1',
			complete: function(req, status) {
				if (status == 'success')
				{
					add_link.hide().parent().find('a.remove_shortlist').show();
					
					//Updating saved tours count
					var saved_tours_count = Number($('#saved_tours_count').html());
					saved_tours_count = saved_tours_count + 1;
					$('#saved_tours_count').html(saved_tours_count);

					dataLayer.push({
						'event' : 'SavedTours',
						'eventCategory' : 'Saved Tours', 
						'eventAction' : 'Save', 
						'eventLabel': tour_title
					});					
										
				}
				else
				{
					alert('An error occured while trying to add this sailing to your shortlist.\nPlease make sure you are connected to the internet and try again.');
				}
			}
		})
	});

	$('body').on('click', 'a.remove_shortlist', function(e){
		e.preventDefault();

		var remove_link = $(this);

		if (remove_link.hasClass('shortlist_page'))
		{
			$(this).closest('.tour').hide(500);
		}

		$.ajax({
			url: remove_link.attr('href')+'&js=1',
			complete: function(req, status) {
				if (status == 'success')
				{
					//Updating saved tours count
					var saved_tours_count = Number($('#saved_tours_count').html());
					saved_tours_count = saved_tours_count - 1;
					$('#saved_tours_count').html(saved_tours_count);
					
					if (remove_link.hasClass('shortlist_page'))
					{
						// remove the hidden field for this package in the refine search form
						$('#search_frm input[name="cruise_package_ids[]"][value='+remove_link.attr('rel')+']').remove();

						shortlist_item.animate(
							{opactiy: 0, height: 0},
							500,
							function(){
								shortlist_item.remove();
							}
						);
					}
					else
					{
						$('div.result_links[rel='+remove_link.attr('rel')+']')
							.find('a.add_shortlist').show()
							.parent().find('a.remove_shortlist').hide();
						remove_link.hide().parent().find('a.add_shortlist').show();
					}
				}
				else
				{
					alert('An error occured while trying to remove this sailing from your shortlist.<br>Please make sure you are connected to the internet and try again.');
				}
			}
		})
	});
});

jQuery(document).ready(function($) 
{
	function sync_middle_name_state()
	{
		var $tickbox = $(this);
		var $textfield = $('[name="' + $tickbox.attr('name').replace('no_middle_name', 'middle_name') + '"]');
		
		if ( $tickbox.is(':checked') )
		{
			$textfield.val('').attr('disabled', 'disabled');
		}
		else
		{
			$textfield.removeAttr('disabled', 'disabled');
		}
	}
	
	// When ticking the "no middle name" box, blank and disable the middle name field
	$('[name$="[no_middle_name]"]')
		.bind('click', sync_middle_name_state)
		// also run once on load, to handle state rendered in PHP/Smarty
		.each(sync_middle_name_state);
		
	$( "#passenger_details_form" ).submit(function( event ) 
	{
		if( $(this).find('input[type="opt_out"]').is(":checked") )
		{
			dataLayer.push({
				'event' : 'Email_signup',
				'eventCategory' : 'Email signup', 
				'eventAction' : 'Completed' 
			});	
		}

		if( $(this).find('input[type="opt_out_post"]').is(":checked") )
		{
			dataLayer.push({
				'event' : 'FormByPost',
				'eventCategory' : 'Booking Form by Post',
				'eventAction' : 'Eqnuired'
				// , 'eventLabel': town+'_'+country
			});
		}

	});


	// $("#contact_country option[value='GB']").insertBefore("#contact_country option[value='AF']");

	$('[id^=contact_country]').each(function() {
		$("#" + this.id + " option[value='GB']").insertBefore( "#" + this.id + " option[value='AF']");
	});

	$('[class^=pax_address_same]').click(function() {
		pax_addr_div_id = $(this).data("address_id");
		pax_id = $(this).data("pax_id");
		if($(this).is(":checked")) {
			$('.lead_address_check_'+pax_id).val('true');
			$('#' + pax_addr_div_id ).hide();
		}
		else {
			$('.lead_address_check_'+pax_id).val('false');
			$('#' + pax_addr_div_id ).show();
		}
	});

	$('[class^=pax_address_same]').each(function() {
		pax_addr_div_id = $(this).data("address_id");
		pax_id = $(this).data("pax_id");
		if($(this).is(":checked")) {
			$('.lead_address_check_'+pax_id).val('true');
			$('#' + pax_addr_div_id ).hide();
		}
		else {
			$('.lead_address_check_'+pax_id).val('false');
			$('#' + pax_addr_div_id ).show();
		}
	});

	/*$('#book_with_extension_checkbox').change(function(){
		switch ($(this).is(":checked"))
		{
			case true:
				$('.book_with_extension').show();
				break;
			case false:
				$('.book_with_extension').hide();
				break;
		}
	});


	$('#book_with_extension_checkbox').trigger('change');*/

	$('#book_with_extension_checkbox2').click(function(){
		$('.book_with_extension').show();
		$('#book_with_extension_checkbox2').hide();
	});

	// $( "#category_selection_form" ).submit(function( event )
	$( "#booking_remittance_form" ).submit(function( event )
	{
		if( $(this).find('input[type="opt_out"]').is(":checked") )
		{
			dataLayer.push({
				'event' : 'Email_signup',
				'eventCategory' : 'Email signup', 
				'eventAction' : 'Completed' 
			});	
		}

        if( $(this).find('input[type="opt_out_post"]').is(":checked") )
        {
            dataLayer.push({
                'event' : 'FormByPost',
                'eventCategory' : 'Booking Form by Post',
                'eventAction' : 'Eqnuired'
                // , 'eventLabel': town+'_'+country
            });
        }
	});


});

jQuery(document).ready(function($) 
{
	$( "#category_selection_form #number_of_adults, #category_selection_form select[name=cruise_package_id]" ).change(function() {
		if ( $(this).val() != '')
		{
			$(this).closest('form').submit();
		}
	});
	$( "#category_selection_form input[name=discount_reference]" ).change(function() {
		$('#booking_cabin_select  input[name=discount_reference]').val($(this).val());
	});
});

window.currency = {};
window.currency.symbol = '&pound;';

jQuery(document).ready(function($)
{
	$('.search_form').dynamicSearchForm();

	$('#new_search_tour').css({visibility:'hidden'});
	$('#new_search_btn').on('click.new_search_btn', function(){
		$('#new_search_tour').css({visibility:''});
		$(this).off('click.new_search_btn');
	});
});

(function($){
	$.fn.priceSlider = function($search_form, options){

		this.each(function(i,range){
			$range = $(range);
			var $slider = $range.find('.price_range');
			
			switch ( options.action )
			{
				case 'reset_slider':
					var values = [$range.data('original_min'), $range.data('original_max')];
					$slider.slider('option', 'min', values[0]);
					$slider.slider('option', 'max', values[1]);
					update_price_range($range, values[0], values[1]);
					$slider.slider('option', 'values', values);
					$range.find('input[name="price_range[min]"]').val(values[0]);
					$range.find('input[name="price_range[max]"]').val(values[1]);
				break;
				
				case 'update_range':
					var values = $slider.slider('option', 'values');
					for (var i = values.length - 1; i >= 0; i--)
					{
						if ( values[ i ] < options.min )
						{
							values[ i ] = options.min;
						}
						else if ( values[ i ] > options.max )
						{
							values[ i ] = options.max;
						}
					};
					$slider.slider('option', 'values', values);
					update_price_range($range, values[0], values[1]);
					$range.find('input[name="price_range[min]"]').val(values[0]);
					$range.find('input[name="price_range[max]"]').val(values[1]);
					$slider.slider('option', 'min', options.min);
					$slider.slider('option', 'max', options.max);
				break;
				
				default:
					var price_range_min = options.min;
					var price_range_max = options.max;
					
					$range.data('original_min', price_range_min);
					$range.data('original_max', price_range_max);
					
					$range.find('[name="price_range[min]""]').val(price_range_min);
					$range.find('[name="price_range[max]""]').val(price_range_max);

					$range.find('.price_range_min').text(pence_to_currency(price_range_min));
					$range.find('.price_range_max').text(pence_to_currency(price_range_max));

					$slider.slider({
						range: true,
						min: price_range_min,
						max: price_range_max,
						values : [price_range_min, price_range_max],
						step : 100,
						slide: function( event, ui ) {
							update_price_range($range, ui.values[0], ui.values[1]);
						},
						stop: function( event, ui ) {
							$range.find('input[name="price_range[min]"]').val(ui.values[0]);
							$range.find('input[name="price_range[max]"]').val(ui.values[1]);
							$search_form.data('last_element_changed', 'price_range');
							$search_form.dynamicSearchForm('run_filter', {can_retry: true});
						}
					});
					$slider.slider('option','slide')({},{values: $slider.slider('option','values')});
				break;
			}
		});

		function update_price_range($range, min, max)
		{
			var $slider = $range.find('.price_range');

			if($slider.hasClass('ui-slider'))
			{
				$range.find('.price_range_min').text(pence_to_currency(min));
				$range.find('.price_range_max').text(pence_to_currency(max));
				
				var	
					// Range between min and max values
					range = $slider.slider('option','max') - $slider.slider('option','min'),
					// Width of the whole slider
					slider_width = $slider.width(),
					// 0 to 1 rather than 0 to 100
					percentage_min = ( min - $slider.slider('option','min') ) / range,
					percentage_max = ( max - $slider.slider('option','min') ) / range,
					// Width of the prices that follow the slider handles
					min_counter_width = $range.find('.price_range_min').outerWidth(),
					max_counter_width = $range.find('.price_range_max').outerWidth(),
					min_pos = (slider_width * percentage_min) - (min_counter_width / 2),
					max_pos = (slider_width * percentage_max) - (max_counter_width / 2);
					//calcBuffer = (maxX_px - (minX_px + min_counter_width));

				//calcBuffer = (calcBuffer < 0) ? Math.abs(calcBuffer)/2 : 0;

				$range.find('.price_range_min').css({
					left: min_pos// - calcBuffer
				});
				$range.find('.price_range_max').css({
					left: max_pos// - calcBuffer
				});
			}
		}
	}
}(jQuery));



/**
 * Utility function to find the lowest and highest "key" in a hash-type object
 */
function min_max_key( object )
{
	var min, max;
	for ( key in object )
	{
		if ( typeof min == 'undefined' || key < min )
		{
			min = key;
		}
		if ( typeof max == 'undefined' || key > max )
		{
			max = key;
		}
	}
	return {min: min, max: max};
}

(function($){

	$.fn.dynamicSearchForm = function(action, params){

		this.each(function(){
			if ($(this).data('no-dynamism'))
			{
				search_form = $(this);
				
				search_form.find('select').select2({
					minimumResultsForSearch: 20,
					allowClear: true,
					//selectOnBlur: true,
				});

				return $(this);
			}
			
			switch(action)
			{
				case 'initialise_date_picker_widget':
					return initialise_date_picker_widget($(this), params);
				break;

				case 'run_filter':
					return run_filter($(this), params);
				break;

				case 'run_filter_on_single_element':
					return run_filter_on_single_element($(this), params);
				break;

				case 'reset_form':
					reset_form($(this));
				break;

				case 'block':
					return display_loading_graphic($(this));
				break;

				case 'unblock':
					return hide_loading_graphic($(this));
				break;

				default:
					return init($(this));
				break;
			}
		});
	}

	function init (search_forms) {
		// NOTE: this anonymous function also serves as a kind of namespace
		//	to keep the vars and functions below privately scoped.
		return search_forms.each(function(index, search_form){

			search_form = $(search_form);
			
			search_form.find('select')
				.select2({
					minimumResultsForSearch: 20,
					allowClear: true,
					selectOnBlur: true
				})
				.on('select2-opening', function(e){
					// When user clicks on a dropdown find out what the dropdown would have in it should it have Any selected and populate 
					// it with those results before opening the dropdown.
					// The data-loading bit is just to stop it doing this infinitely if the dropdown doesn't have more options after the ajax 
					// has happened.
					if ( !$(this).data('loading') )
					{
						e.preventDefault();
						$(this).data('loading', true);
						search_form.dynamicSearchForm('run_filter_on_single_element', {can_retry: true, element: $(this)});
                        $('.select2-search input').prop('focus',false);
					}
					else
					{
						$(this).data('loading', false);
                        $('.select2-search input').prop('focus',false);
					}
				}
			);

			search_form.data('block_count', 0);
			
			$('#countries_select').hide();
			
			// Update whole form upon any element change
			search_form.find('select, input[type=radio], input[type=checkbox]').bind('change', function(){
				
				var dropdown = $(this);
				
				search_form.data('last_element_changed', dropdown.prop('name'));
				
				if ( dropdown.prop('name')=='cruise_line_id' )
				{
					// If we just changed the cruise line then unselect the ship because 
					// it will no longer be valid
					search_form.find('[name=cruise_ship_id]').val('');
				}
				if ( dropdown.hasClass('region') )
				{
					// If we just changed the region then unselect the country because 
					// it will no longer be valid
					search_form.find('select.country').val('');
					if ( dropdown.val() )
					{
						search_form.find('select.country').closest('li').show();
					}
					else
					{
						search_form.find('select.country').closest('li').hide();
					}
				}
				search_form.dynamicSearchForm('run_filter', {can_retry: true});
			});
			
			search_form.find('.reset_button').bind(
				'click', 
				function()
				{
					search_form.dynamicSearchForm('reset_form');
					return false;
				}
			).show();
			
			// Initialize from date
			search_form.dynamicSearchForm('initialise_date_picker_widget', {
				fieldId: 'display_departure_year_month_day',
				hiddenFieldId: 'departure_year_month_day',
				minDate: new Date(),
				beforeShowDay: function(date)
				{

					//enable every date, remove line to enable filter
					return [true, ''];

					var date_statistic_arrays = search_form.data('date_statistic_arrays');
					// Initially let everything be valid
					if ( typeof date_statistic_arrays != 'object' )
					{
						return [true, ''];
					}
					
					// date is after the to date so can't be valid
					if( search_form.find('.display_to_year_month_day').val() &&  date >= new Date( search_form.find('.display_to_year_month_day').val() ) )
					{
						return [false, ''];
					}

					var is_valid = 
						typeof date_statistic_arrays[ date.getFullYear() ] == 'object'
						&& typeof date_statistic_arrays[ date.getFullYear() ][ date.getMonth()+1 ] == 'object'
						&& typeof date_statistic_arrays[ date.getFullYear() ][ date.getMonth()+1 ][ date.getDate() ] == 'number'
						&& date_statistic_arrays[ date.getFullYear() ][ date.getMonth()+1 ][ date.getDate() ] > 0;
					
					return [is_valid, ''];
				}
			});

			// Initialize to date
			// search_form.dynamicSearchForm('initialise_date_picker_widget', {
			// 	fieldId: 'display_to_year_month_day',
			// 	hiddenFieldId: 'to_year_month_day',
			// 	minDate:+2,
			// 	beforeShowDay: function(date)
			// 	{
			// 		if( $('.departure_year_month_day').val() )
			// 		{
			// 			var is_valid = date >= parseISO8601( $('.departure_year_month_day').val() );
			// 		}
			// 		else
			// 		{
			// 			var is_valid = true;
			// 		}

			// 		return [is_valid, ''];
			// 	}
			// });

			search_form.find('.result_count').show();
			
			var hide_disabled = search_form.data('hide-disabled');
			if ( hide_disabled )
			{
				search_form.find('.filter_check_boxes :checkbox').each(function(i, checkbox){
					var $checkbox = $(checkbox);
					if ( ! $checkbox.prop('checked') )
					{
						$checkbox.closest('label').hide();
					}
				});
			}


			// Immediately filter the options down to stuff that's available
			//	we could do this in PHP, so that non-JS users got a bit of filtering 
			//	(call Search::get_search_form_filtered(array()) instead of Site_Search::get_search_form()]
			//	but we probably don't want the performance hit when loading the home page
			search_form.dynamicSearchForm('run_filter', {can_retry: true, first_run: true});
		});
	}
	
	function run_filter( search_form, params ){
		
		if (search_form.data('interval'))
		{
			clearInterval(search_form.data('interval'));
		}
		
		if (params.first_run)
		{
			var delay_time = 0;
		}
		else
		{
			var delay_time = search_form.data('delay') || 0;
		}

		search_form.data('interval', setInterval(function()
		{
			clearInterval(search_form.data('interval'));

			if ( search_form.hasClass('filter_panel') )
			{
				filter_results(search_form, params.can_retry, params.first_run);
			}
			else
			{
				filter_dropdowns(search_form, params.can_retry, params.first_run);
			}
		}, delay_time));

		return search_form;
	}

	function run_filter_on_single_element( search_form, params ){
		
		var element = params.element;
		var select2 = element.parent().find('.select2-container');
		
		// if the element has 2 or less, not disabled options (one of them will be the "Any" option)
		if ( !search_form.hasClass('filter_panel') && element.val() )
		{
			display_dropdown_loading_graphic(select2);
			
			var pending_ajax_request = search_form.data('pending_ajax_request');

			// Cancel any existing AJAX requests to avoid race conditions
			if ( typeof pending_ajax_request == 'object' && !pending_ajax_request.responseText )
			{
				hide_dropdown_loading_graphic(select2);
				pending_ajax_request.abort();
			}
			
			var search_form_values = search_form.serializeObject();
			
			switch ( element.prop('name') )
			{
				case 'manual_offer_tags[]':
					$.each(search_form_values['manual_offer_tags[]'], function(index, value){
						if (value == element.val())
						{
							search_form_values['manual_offer_tags[]'][index] = null;
						}
						if (element.hasClass('region') && search_form.find('select.country').val() && value == search_form.find('select.country').val())
						{
							search_form_values['manual_offer_tags[]'][index] = null;
						}
					});
				break;
				
				default:
					search_form_values[ element.prop('name') ] = null;
			}
			
			if ( search_form.find('.price_range').data('original_min') == search_form_values['price_range[min]'] )
			{
				search_form_values['price_range[min]'] = null;
			}
			if ( search_form.find('.price_range').data('original_max') == search_form_values['price_range[max]'] )
			{
				search_form_values['price_range[max]'] = null;
			}

			// Special case for cruise line
			// If we're changing the cruise line then obviously any ship
			// selected will be invalid.
			if ( element.prop('name') == 'cruise_line_id' )
			{
				search_form_values['cruise_ship_id'] = null;
			}
			search_form.data('pending_ajax_request', $.ajax({
				url: '/async_call.php?action=search_filters',
				data: search_form_values,
				dataType: 'json',
				error: function(jqXHR, textStatus)
				{
					hide_dropdown_loading_graphic(select2);
					if ( params.can_retry )
					{
						search_form.dynamicSearchForm('run_filter_on_single_element', {can_retry: false, element: element});
					}
				},
				success: function(response)
				{
					if ( typeof response == 'object' && typeof response.error == 'undefined' )
					{
						element.data('previous_selection', element.val()).bind('blur', function(){
							if ($(this).val()=='')
							{
								$(this).val($(this).data('previous_selection'));
							}
							$(this).data('previous_selection', undefined).unbind('blur');
						});

						switch ( element.prop('id') )
						{
							case 'cruise_ship_entity_list':
								search_form.find('select.cruise_ship_entity_list').repopulateDropdown( response.ship_entity_codes, response.all_presets.cruise_ships, 'entity_code', 'name', true );
							break;
							case 'region_id':
								search_form.find('select.region').repopulateDropdown( response.manual_offer_tags, response.all_presets.region_pages);
							break;
							case 'country_id':
								if (response.all_presets.country_pages)
								{
									search_form.find('select.country').closest('li').show();
									search_form.find('select.country').repopulateDropdown( response.manual_offer_tags, response.all_presets.country_pages);
								}
								else
								{
									search_form.find('select.country').hide();
								}
							break;
							case 'duration':
								search_form.find('.duration select').repopulateDropdown( response.durations, response.all_presets.durations, undefined, undefined, true );
							break;
							case 'product_sub_type_code':
								search_form.find('select#product_sub_type_code').repopulateDropdown( response.manual_offer_tags, response.all_presets.voyages_and_tours );
							break;
							case 'speaker_id':
								search_form.find('select#speaker_id').repopulateDropdown( response.speakers, response.all_presets.speakers );
							break;
						}
					}
					else
					{
						if ( params.can_retry )
						{
							search_form.dynamicSearchForm('run_filter_on_single_element', {can_retry: false, element: element});
						}
					}
					hide_dropdown_loading_graphic(select2);
					
					element.select2('open');
				}
			}));
		}
		else
		{
			element.select2('open');
		}
		
		return search_form;
	}
	
	
	function display_dropdown_loading_graphic (select2)
	{
		select2.find('.select2-chosen').addClass('loading');
		select2
			.data('block_count', (select2.data('block_count')||0)+1)
			.block({
				message: null,
				overlayCSS: {opacity: 0},
			});
	}
	
	function hide_dropdown_loading_graphic (select2)
	{
		select2.data('block_count', select2.data('block_count')-1);
		
		if (select2.data('block_count')<1)
		{
			select2.find('.select2-chosen').removeClass('loading');
			select2.unblock({
				fadeOut: 0
			});
		};
	}


	function filter_results (search_form, can_retry, first_run) {
		var $search_form = $(search_form);
		var pending_ajax_request = $search_form.data('pending_ajax_request');

		// Cancel any existing AJAX requests to avoid race conditions
		if ( typeof pending_ajax_request == 'object' && !pending_ajax_request.responseText )
		{
			hide_loading_graphic($search_form);
			pending_ajax_request.abort();
		}
		
		$('.disply_results').html('<img src="/images/ajax/ajax-loader.gif"/>');
		var data = $.extend({
			action: 'booking_search',
			read_only: false
		}, $(this).serializeObject());
		$search_form.data('pending_ajax_request', $.get('/async_call.php', data, function(result){
			$('.disply_results').html(result);
			$('.booking_select').bind( "click", function(e) {
				var cruise_package_id = $(this).data("selected-tour");
				$('#booking_select_tour').append('<input type="hidden" name="cruise_package_id" value="'+cruise_package_id+'" id="result_{$package.cruise_package_id}">');
			});
		}));

	}

	function filter_dropdowns ( search_form, can_retry, first_run ){

		return search_form.each(function(index, search_form){

			var $search_form = $(search_form);
			var pending_ajax_request = $search_form.data('pending_ajax_request');

			// Cancel any existing AJAX requests to avoid race conditions
			if ( typeof pending_ajax_request == 'object' && !pending_ajax_request.responseText )
			{
				hide_loading_graphic($search_form);
				pending_ajax_request.abort();
			}
			
			display_loading_graphic($search_form);
			
			$search_form.data('pending_ajax_request', $.ajax({
				url: '/async_call.php?action=search_filters',
				data: $search_form.serialize(),
				dataType: 'json',
				error: function(jqXHR, textStatus)
				{
					if (textStatus != 'abort')
					{
						display_error_message( search_form, can_retry );
					}
				},
				success: function(response)
				{
					if ( typeof response != 'object' || typeof response.error != 'undefined' )
					{
						display_error_message( search_form, can_retry );
					}
					else
					{
						update_search_form($search_form, response, first_run);

						$search_form.find('.search_filter_errors').hide();
					}
					hide_loading_graphic($search_form);
				}
			}));
		});
	}

	function update_search_form ($search_form, stats, first_run) 
	{
		$search_form.find('select.cruise_ship_entity_list').repopulateDropdown( stats.ship_entity_codes, stats.all_presets.cruise_ships, 'entity_code', 'name' );
		$search_form.find('select.region').repopulateDropdown( stats.manual_offer_tags, stats.all_presets.region_pages);
		if (stats.all_presets.country_pages)
		{
			$search_form.find('select.country').closest('li').show();
			$search_form.find('select.country').repopulateDropdown( stats.manual_offer_tags, stats.all_presets.country_pages);
		}
		else
		{
			$search_form.find('select.country').hide();
		}
		$search_form.find('.duration select').repopulateDropdown( stats.durations, stats.all_presets.durations );
		$search_form.find('select#product_sub_type_code').repopulateDropdown( stats.manual_offer_tags, stats.all_presets.voyages_and_tours );
		$search_form.find('select#speaker_id').repopulateDropdown( stats.speakers, stats.all_presets.speakers );
		
		set_calendar_limits( $search_form, min_max_key(stats.statistics.departure_timestamps) );

		// Save departure dates to variable visible to widget callback
		$search_form.data('date_statistic_arrays', stats.statistics.departure_date_parts);
		
		var price_range_min = Math.floor(stats.min_price/100)*100;
		var price_range_max = Math.ceil(stats.max_price/100)*100;
		if (first_run)
		{
			// Initialise the price slider
			$search_form.find('.price_range_slider').show().priceSlider($search_form, {
				min: price_range_min,
				max: price_range_max
			});
		}
		else if ($search_form.data('last_element_changed')!='price_range')
		{
			// Update the price slider
			$search_form.find('.price_range_slider').priceSlider($search_form, {
				action: 'update_range',
				min: price_range_min,
				max: price_range_max
			});
		}

		if ( $search_form.find('.result_count ins')[0] )
		{
			$({count: $search_form.find('.result_count ins').html()}).animate(
				{count: stats.statistics.total_clusters}, 
				{
					duration: 500,
					step: function(){
						$search_form.find('.result_count ins').html(Math.ceil(this.count));
					},
					complete: function(){
						// animation complete
						// this is just to make sure that the count actually displays
						//  the correct count since 
						$search_form.find('.result_count ins').html(stats.statistics.total_clusters);
					}
				}
			);
		}
	}
	
	function get_offer_type_options (stats)
	{
		// This is a bit of a hack but it's the quickest way to get this done.
		// Only display Cruise-Only and Fly-Cruise offer types in the dropdown.
		var offer_types = new Array();
		for(var i in stats.all_presets.offer_types)
		{
			var offer_type_id = stats.all_presets.offer_types[i]['offer_type_id'];
			if (offer_type_id==1 || offer_type_id==2)
			{
				offer_types.push(stats.all_presets.offer_types[i]);
			};
		}
		
		return offer_types;
	}
	
	function get_ship_options($search_form, stats, first_run)
	{
		var cruise_ships = [];

		$search_form.find('.filter_check_boxes :checkbox').each(function(i, checkbox){
			var $checkbox = $(checkbox);

			if ( ( first_run && $search_form.find('.filter_check_boxes :checkbox:checked').length==1 ) || parseInt($search_form.find('select.cruise_ship_id').val())>0 )
			{
				if ( stats.statistics.cruise_line_ids && stats.statistics.cruise_line_ids[$checkbox.val()] )
				{
					var cruise_line_name = $checkbox.parent().html().replace(/<[^>]+>/, '');
					$search_form.find('.cruise_line_name').html(cruise_line_name).slideDown();
					$search_form.find('.select_deselect, .filter_check_boxes').slideUp();
				}
			}
			else
			{
				$search_form.find('.cruise_line_name').slideUp();
				$search_form.find('.select_deselect, .filter_check_boxes').slideDown();
			}

			if ($checkbox.prop('checked'))
			{
				for(var i in stats.all_presets.cruise_lines)
				{
					if (stats.all_presets.cruise_lines[i].id == $checkbox.val())
					{
						cruise_ships = $.merge(cruise_ships, stats.all_presets.cruise_lines[i].ships);
					};
				}
			}
		});

		if ($search_form.find('[name=cruise_line_id]').val())
		{
			for(var i in stats.all_presets.cruise_lines)
			{
				if (stats.all_presets.cruise_lines[i].id == $search_form.find('[name=cruise_line_id]').val())
				{
					cruise_ships = stats.all_presets.cruise_lines[i].ships;
				};
			}
		};

		if (cruise_ships.length<1)
		{
			cruise_ships = stats.all_presets.cruise_ships;
		}

		return cruise_ships;
	}

	function get_country_options($search_form, stats, first_run)
	{
		var cruise_ships = [];


		if ($search_form.find('select.region').val())
		{
			for(var i in stats.all_presets.cruise_lines)
			{
				if (stats.all_presets.cruise_lines[i].id == $search_form.find('[name=cruise_line_id]').val())
				{
					cruise_ships = stats.all_presets.cruise_lines[i].ships;
				};
			}
		};

		if (cruise_ships.length<1)
		{
			cruise_ships = stats.all_presets.cruise_ships;
		}

		return cruise_ships;
	}

	function initialise_date_picker_widget(search_form, params)
	{
		var datepicker_field = search_form.find("."+params.fieldId);
		
		datepicker_field.prop('readonly', true).css({
			'cursor': 'pointer',
			'background': '#fff'
		});

		if ( datepicker_field.val()!='' )
		{
			var current_value = parseISO8601( datepicker_field.val() );
		}

		$('<input type="hidden" class="'+params.hiddenFieldId+'" name="'+params.hiddenFieldId+'" />')
			.insertAfter(datepicker_field)
			.val(datepicker_field.val());
		var date = new Date();
		date.setDate(date.getDate() + 4);

		$.datepicker.setDefaults($.extend({showMonthAfterYear: false}));
		$.datepicker.regional[ "en" ];
		datepicker_field.datepicker({
			changeMonth: false,
			changeYear: false,
			closeText: 'Clear &#10006;',
			numberOfMonths: 1,
			showButtonPanel: true,
			currentText: '',
			dateFormat: 'dd-mm-yy',
			altFormat: 'yy-mm-dd',
			altField: "."+params.hiddenFieldId,
			gotoCurrent: true,
			showOn: 'button',
			showOtherMonths: true,

			beforeShow: function(input, inst)
			{
				$(input).data('previous_value', $(input).val());
				setTimeout(function() {
					// Rebind the click even on the clost button to make a clear button
					// has to happen in a timeout because the datepicker hasn't actually displayed yet
					var close_button = $(input).datepicker('widget').find('.ui-datepicker-close');
					close_button.unbind('click').bind('click', function(e){
						$.datepicker._clearDate( input );
					});
				}, 1);
			},
			// Disable unavailable dates
			beforeShowDay: params.beforeShowDay,
			// Update display as soon as user clicks
			//onSelect: update_calendar_display,
			// Re-filter as soon as the calendar's closed
			onClose: function(dateText, inst){
				search_form.removeData('active');
				if ( typeof inst.input.data('previous_value') !== 'undefined' && inst.input.val() == inst.input.data('previous_value') )
				{
					// If nothing has changed then don't filter the form.
					return false;
				}
				run_filter(search_form, true);
			},
			// Initial filtering
			minDate: params.minDate,
			//maxDate: params.maxDate,
			firstDay: 1, // Start day in Monday.
			yearRange: '-0:+3',
		});
		if ( current_value )
		{
			datepicker_field.datepicker('setDate', current_value);
		}
		
		datepicker_field.bind('click', function(){
			var element = $(this);
			
			if ( element.val().length )
			{
				element.addClass('loading');
				
				var pending_ajax_request = search_form.data('pending_ajax_request');

				// Cancel any existing AJAX requests to avoid race conditions
				if ( typeof pending_ajax_request == 'object' && !pending_ajax_request.responseText )
				{
					pending_ajax_request.abort();
				}
				
				var search_form_values = search_form.serializeObject();
				
				search_form_values[ params.hiddenFieldId ] = null;
				search_form_values[ element.prop('name') ] = null;
				
				search_form.data('pending_ajax_request', $.ajax({
					url: '/async_call.php?action=search_filters',
					data: search_form_values,
					dataType: 'json',
					error: function(jqXHR, textStatus)
					{
						element.removeClass('loading');
					},
					success: function(response)
					{
						if ( typeof response == 'object' && typeof response.error == 'undefined' )
						{
							// Save departure dates to variable visible to widget callback
						//	search_form.data('date_statistic_arrays', response.statistics.departure_date_parts);
						//	set_calendar_limits( search_form, min_max_key(response.statistics.departure_timestamps) );
						}
						element.removeClass('loading');
						element.datepicker('show');
					}
				}));
			}
			else
			{
				element.datepicker('show');
			}
		});
	}

	function update_calendar_display(dateText, inst){
		if(inst.input)
		{
			var search_form = inst.input.closest('.search_form');
		}
		else
		{
			var search_form = $(inst[0]).closest('.search_form');
		}

		var selected_departure_date = search_form.find('.display_departure_year_month_day').datepicker('getDate');
		var search_from = $.datepicker.formatDate('yy-mm-dd', selected_departure_date );

		//var selected_to_date = search_form.find('.display_to_year_month_day').datepicker('getDate');
		//var search_to = $.datepicker.formatDate('yy-mm-dd', selected_to_date );
		
		search_form.find('.display_to_year_month_day').datepicker('option', 'defaultDate', parseISO8601( search_form.find('.departure_year_month_day').val() ) );

		search_form.removeData('active');
	}
	
	function set_calendar_limits( search_form, timestamp_limits )
	{
		/*
		if (search_form.find('.display_departure_year_month_day')[0])
		{
			// Convert Unix timestamps into JS objects
			var min_date = new Date(timestamp_limits.min*1000);
			var max_date = new Date(timestamp_limits.max*1000);
			
			// Compensate for timezone offset (the timestamps are UTC, but JS uses local time)
			min_date.setMinutes(min_date.getMinutes() + min_date.getTimezoneOffset());
			max_date.setMinutes(max_date.getMinutes() + max_date.getTimezoneOffset());
			
			// Limit range of calendar widget
			search_form.find('.display_departure_year_month_day').datepicker('option', 'minDate', min_date);
			search_form.find('.display_departure_year_month_day').datepicker('option', 'maxDate', max_date);

			// set the min to date to whatever is selected in the departure date
			if(search_form.find('.display_departure_year_month_day').val())
			{
				search_form.find('.display_to_year_month_day').datepicker('option', 'minDate', parseISO8601( search_form.find('.display_departure_year_month_day').val() ));
			}
			
			// Ensure display is up to date
			update_calendar_display(null, search_form);
		}
		*/
	}
	
	function display_error_message( search_form, can_retry )
	{
		search_form = $(search_form);
		search_form.find('.search_filter_errors').show();
		
		hide_loading_graphic(search_form);
		
		// Avoid infinite loops on error
		if ( can_retry )
		{
			reset_form(search_form);
		}
	}
	
	function reset_form(search_form)
	{

		display_loading_graphic(search_form);
		// Select the "any" option for all drop-downs
		search_form.find('select').val('');

		search_form.find('input[type=radio]:checked').prop('checked', false);
		search_form.find('input[type=radio][value=""]').prop('checked', true);

		search_form.data( 'user_interaction_count', 0 );
		
		var price_range = search_form.find('.price_range_slider');
		var slider = price_range.find('.price_range');
		price_range.priceSlider(search_form, {
			action: 'reset_slider',
		});
		
		search_form.find('select.country').val('').closest('li').hide();
		search_form.find('[name^=manual_offer_tags]').val('');
		
		if (search_form.find('.display_departure_year_month_day').length)
		{
			// ... and the datepicker
			search_form.find('.display_departure_year_month_day').datepicker('setDate', null);
			//search_form.find('.display_to_year_month_day').datepicker('setDate', null);
			//update_calendar_display(null, search_form);
		}		
		
		var search_form_id = $(search_form).attr('id');
		if (search_form_id == 'booking_search')
		{
			$('.disply_results').hide();
		}
		
		// Make sure nothing is filtered - but don't keep trying infinitely
		run_filter(search_form, false);
		
		// clear search values saved in the session
		$.ajax({
			url: '/async_call.php?action=clear_search_filters&read_only=false',
			error: function()
			{
				display_error_message( search_form, false );
			},
			success: function(){
				hide_loading_graphic(search_form);
			}
		});
	}

	function display_loading_graphic(search_form)
	{
		search_form.data('block_count', search_form.data('block_count')+1);
		// Using jquery.blockui.js
		search_form.block({
			message: '<img src="/images/ajax/ajax-loader.gif" alt="Please Wait" />',
			css: { border: '1px solid #264E72', padding: '10px' },
			overlayCSS: {opacity: 0},
			fadeIn: 0
		});
		search_form.fadeTo(0, .5);
	}
	
	function hide_loading_graphic(search_form)
	{
		search_form.data('block_count', search_form.data('block_count')-1);
		if (search_form.data('block_count')<1)
		{
			search_form.unblock({
				fadeOut: 0
			});
			search_form.fadeTo(250, 1);
		};
	}
}(jQuery));
	


(function($){
}(jQuery));

(function($){
	$.fn.repopulateDropdown = function(new_values, all_values, value_key_name, display_key_name){
		return this.each(function(){
			var $dropdown = $(this);
			var $search_form = $dropdown.closest('form');

			var current_value = $dropdown.val();
			// Remove all but the "Any" option
			$dropdown.find('option:gt(0)').remove();
			// Populate with new values

			$.each(all_values, function(key, item)
			{
				var option_value;
				if ( typeof value_key_name == 'undefined' )
				{
					option_value = key;
				}
				else
				{
					option_value = item[ value_key_name ];
				}
				
				var option_display;
				if ( typeof display_key_name == 'undefined' )
				{
					option_display = item;
				}
				else
				{
					option_display = item[ display_key_name ];
				}
				
				var selected = (current_value==option_value);
				var $option = $( new Option(option_display, option_value, selected, selected) );
				
				var disable_me = true;
				if ( typeof display_key_name == 'undefined' )
				{
					$.each(new_values, function(new_key, new_item)
					{
						if(key==new_key)
						{
							disable_me = false;
						}
					});
				}
				else
				{
					$.each(new_values, function(new_key, new_item)
					{
						if(new_item[value_key_name]==item[value_key_name])
						{
							disable_me = false;
						}
					});
				}
				
				if ( disable_me )
				{
					var hide_disabled = $search_form.data('hide-disabled');
					if ( ! hide_disabled )
					{
						function shadeRGBColor(color, percent) {
							var f=color.split(","),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=parseInt(f[0].slice(4)),G=parseInt(f[1]),B=parseInt(f[2]);
							return "rgb("+(Math.round((t-R)*p)+R)+","+(Math.round((t-G)*p)+G)+","+(Math.round((t-B)*p)+B)+")";
						}
						$option.prop('disabled', true).css(
							'color', 
							shadeRGBColor($option.css('color'), .7)
						);
						$dropdown.append($option);
					}
				}
				else
				{
					$dropdown.append($option);
				}
			});
			
			// Re-select the previously selected value (if possible)
			$dropdown.val( current_value ).blur();
			// Update the fancy select styling replacement span
			if ( $dropdown.find('option:selected')[0] )
			{
				var selected = $dropdown.find('option:selected');
			}
			else
			{
				var selected = $dropdown.find('option').eq(0);
			}
			$dropdown.prev().find('.select2-chosen').html( selected.html() );
		});
	}
}(jQuery));

function pence_to_currency(pence, dp)
{
	if (typeof(dp)=='undefined')
	{
		dp = 0;
	}
	return $('<div/>').html(window.currency.symbol).text() + Number(parseFloat(pence)/100).toFixed(dp);
}

function parseISO8601(dateStringInRange) 
{
	var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
		date = new Date(NaN), month,
		parts = isoExp.exec(dateStringInRange);

	if(parts) 
	{
		month = +parts[2];
		date.setFullYear(parts[1], month - 1, parts[3]);
		if(month != date.getMonth() + 1)
		{
			date.setTime(NaN);
		}
	}
	return date;
}


$.fn.serializeObject = function() {
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name])
		{
			if (!o[this.name].push)
			{
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		}
		else
		{
			o[this.name] = this.value || '';
		}
	});
	return o;
};
$(function(){
	
	$('.email_brochure_wrapper').hide();
	$('.post_brochure_wrapper').hide();

	/* $('.brochure_form_type').change(function(e)
	{
		if ( $(this).is(':checked') )
		{
			var value = $(this).val();
			if(value == 'post')
			{
				$('.email_brochure_wrapper').hide();
				$('.post_brochure_wrapper').show();
				$('#brochure_form_type_email').removeAttr('checked');
			}			
			if(value == 'email')
			{
				$('.post_brochure_wrapper').hide();
				$('.email_brochure_wrapper').show();
				$('#brochure_form_type_post').removeAttr('checked');
			}			
		}
		else
		{
			$('.email_brochure_wrapper').hide();
			$('.post_brochure_wrapper').hide();
		}
	});	*/
	
	$("#brochure_request_form_old .tabbed_nav ul li a").click(function(e) {
		$('.tabbed_nav ul li a').removeClass('selected');
		$(this).addClass('selected');
		e.preventDefault();
		
		var brochure_type = $(this).data('brochure-type');
		
		var selected = [];
		$( ".selected_brochures li" ).each(function() {				
			 selected.push($(this).data('selected-id'));
		});
		
		$.get('/async_call.php', {action: 'brochure-type', brochure_type : brochure_type, selected : selected }, function(data){
			$('.grid_layout').html(data);
		});
	});

	// $('.select_this_brochure').live("click", function(e) {
	$('.brochure_actions').on('click', '.select_this_brochure', function(e) {
	var brochure_check = $(this).parent().find('.brochures_selected');
		if(brochure_check.prop("checked") || brochure_check.is(':checked'))
		{
			brochure_check.prop('checked', false);
		}
		else {
			brochure_check.prop('checked', true);
		}

		var brochure_name = $(this).data("name"),
			brochure_id = $(this).data("brochure-id");

		if(brochure_check.prop("checked") || brochure_check.is(':checked'))
		{
			if ($('.selected_brochures li').length >= 5)
			{
				window.popup.fn.alert('Sorry, there is a maximum of 5 brochures per request.');
				return false;
			}
			$(".selected_brochures").append('<li class="s_b" data-selected-id="'+brochure_id+'">'+brochure_name+'<a class="removed_selected" style="float:right;" >X</a></li>');
			$(this).removeClass('rgb_text_post').addClass('rgb_text_selected').html('Post');
		}
		else
		{
			$( ".selected_brochures li" ).each(function() {

				if( $(this).data('selected-id') == brochure_id )
				{
					$(this).remove();
				}

			});
			$(this).removeClass('rgb_text_selected').addClass('rgb_text_post').html('Post');
		}

		if ($('.selected_brochures li').length > 0)
		{
			$('#brochure_selected_side_bar').find('h3').text('Selected Brochures');
		} else {
			$('#brochure_selected_side_bar').find('h3').text('Please Select Brochure(s)');
		}
	});
	
	// $(".brochures_selected").live("click",function() {
	$('.brochure_actions').on('click', '.brochures_selected', function(e) {
		var brochure_name = $(this).data("name"),
			brochure_id = $(this).val();
		
		if($(this).prop("checked"))
		{
			if ($('.selected_brochures li').length >= 5)
			{
				window.popup.fn.alert('Sorry, there is a maximum of 5 brochures per request.');
				return false;
			}
			$(".selected_brochures").append('<li class="s_b" data-selected-id="'+brochure_id+'">'+brochure_name+'<a class="removed_selected" style="float:right;" >X</a></li>');
		}
		else
		{	
			$( ".selected_brochures li" ).each(function() {
			
				if( $(this).data('selected-id') == brochure_id )
				{
					$(this).remove();
				}
				
			});					
		}
	});
	
	// $('.removed_selected').live("click",function(e) {
	$('.selected_brochures').on('click', '.removed_selected', function(e) {
		var brochure_id = $(this).parent().data('selected-id');
		$(this).parent().remove();
		
		$( ".brochures_selected" ).each(function() {				
			if( $(this).data('brochure-id') == brochure_id )
			{
				$(this).removeAttr("checked");
				$(this).closest('.brochure_actions').find('.select_this_brochure').removeClass('rgb_text_selected').addClass('rgb_text_post').html('Post');
			}				
		});						
		
		var selected = new Array();	
		$( ".selected_brochures li" ).each(function() {				
			 selected.push($(this).data('selected-id'));
		});

		if ($('.selected_brochures li').length == 0)
		{
			$('#brochure_selected_side_bar').find('h3').text('Please Select Brochure(s)');
		}

	});

	$('#add_extra_recipient').click(function(e) {
		$('#send_to_friend').val('true');
		$(this).text('Send to another friend');
		$('#email_address').attr('placeholder',' From Email Address');
		$('#email_title').hide();
		$('#email_first_name').hide();
		$('#email_last_name').hide();
		$('#email_address').after($('<input>').attr('type','text').addClass('extra_email_address').attr('name','extra_email_address[]').attr('placeholder',' To Email Address'));
		$('#email_message_text').show();
	});
	
	$('#terms_conditions_span').click(function(){
		$('#terms_conditions').slideToggle('fast');
		if($(this).text() == 'View Terms and Conditions'){
			$(this).text('Hide Terms and Conditions');
		} else {
			$(this).text('View Terms and Conditions');
		}
	});
	
	$('.submit_button').click(function() {

		var action = $(this).data('action');
		var request_brochure_list = '';
		$( "li.s_b" ).each(function( index ) {
			request_brochure_list += $(this).clone().find('a').remove().end().text()+', ';
		});

		if(typeof request_brochure_list!='undefined')
		{
			dataLayer.push({
				'event' : 'Brochure_download',
				'eventCategory' : 'Brochure download',
				'eventAction' : action.replace( '_brochure', '' ),
				'eventLabel':request_brochure_list
			});
		}
		else
		{
			dataLayer.push({
				'event' : 'Brochure_download',
				'eventCategory' : 'Brochure download',
				'eventAction' : action.replace( '_brochure', '' )

			});
		}

		$('#request_type').val($(this).data('action'));
	});
	
	$('#brochure_request_form').submit( window.popup.fn.request_brochures );
/* Auto scrolling forms are a pain for low resolutions and large forms

	var sidebar	= $(".side_bar"), 
		$window		= $(window),
		offset		= sidebar.offset(),
		topPadding	= 15,
		main		= $('.main_content'),
		wScrollTop	= $window.scrollTop();



	$window.scroll(function(e) {
		if (main.outerHeight(true) > sidebar.outerHeight(true) || wScrollTop > $window.scrollTop())
		{
			var newMarginTop = $window.scrollTop() - offset.top + topPadding;
			sidebar.stop().animate({
				marginTop: Math.max(newMarginTop, 0)
			}, 800);
		}
		wScrollTop	= $window.scrollTop();
	});
*/
});

!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});